  (function () {

    var rentalPageConfig = window.PlayforceRentalConfig || {};
    var rentalEditRequestedGroupId = '';
    var rentalEditModeActive = false;
    var rentalEditOriginalItems = [];
    var rentalEditMainItem = null;
    var rentalEditQuantity = 1;
    var rentalEditLoadedCart = null;
    var rentalEditCachedSnapshot = null;
    var rentalEditFastPathApplied = false;
    var rentalEditRestoredCellularMode = false;
    var rentalEditConnectivityTouchedByUser = false;
    var rentalEditHydrating = false;
    /* Edit Rental schedule preservation:
       keep the exact active-cart date/timing selection while the checkout
       reservation is still alive. Current-time rules take over as soon as
       the customer changes the rental date or delivery timing. */
    var rentalEditSavedSchedule = null;
    var rentalEditScheduleTouchedByUser = false;
    var rentalEditSummaryOriginalOpacity = '';
    var rentalInitialValidationPromise = null;
    var RENTAL_EDIT_CACHE_PREFIX = 'playforceRentalEditCacheV1:';
    var RENTAL_EDIT_CACHE_MAX_AGE_MS = 15 * 60 * 1000;

    try {
      rentalEditRequestedGroupId = String(
        new URLSearchParams(window.location.search || '').get('edit_rental') || ''
      ).trim();
    } catch (error) {
      rentalEditRequestedGroupId = '';
    }

    var securityDepositDescriptionByVariantId = rentalPageConfig.securityDepositDescriptionByVariantId || {};
    var initialSecurityDepositStockByVariantId = rentalPageConfig.securityDepositInitialStockByVariantId || {};
    var initialPlayTimeStatusLoaded = rentalPageConfig.playTimeInitialLoaded === true;
    var initialPlayTimeSameDayEnabled = initialPlayTimeStatusLoaded && rentalPageConfig.playTimeSameDayEnabled === true;
    var initialServerRenderedAtMs = Number(rentalPageConfig.serverRenderedAtMs || 0);

    /* ============================================================
       RENTAL TEST CONTROLS — TEMPORARY
       Set RENTAL_TEST_CONTROLS_ENABLED to false to hide/disable the
       entire testing panel without removing any code.
       ============================================================ */
    var RENTAL_TEST_CONTROLS_ENABLED = false;
    var rentalTestSameDayCheckoutAllowed = false;
    var rentalTestSingaporeMinutes = null;
    var rentalTestDocumentsBypassAllowed = false;

    var securityDepositProductHandleCandidatesByVariantId = {
      '47526006063291': ['security-deposit'],
      '47994120241339': ['security-deposit-business-i5', 'security-deposit-i5'],
      '47994120339643': ['security-deposit-business-i7', 'security-deposit-i7'],
      '48111443509435': ['security-deposit-ultra-5-ryzen-5-new', 'security-deposit-ultra-5'],
      '48111444099259': ['security-deposit-ultra-7-ryzen-7-new', 'security-deposit-ultra-7'],
      '48000206274747': ['security-deposit-gtx-1650'],
      '48000206700731': ['security-deposit-rtx-2060'],
      '48000207061179': ['security-deposit-rtx-3050'],
      '48000207388859': ['security-deposit-rtx-3060', 'security-deposit-rtx-3060-below'],
      '48000136282299': ['security-deposit-rtx-3070'],
      '48000145031355': ['security-deposit-rtx-3080'],
      '47939105030331': ['security-deposit-rtx-4050'],
      '47939105980603': ['security-deposit-rtx-4060'],
      '47939106078907': ['security-deposit-rtx-4070'],
      '48205548290235': ['security-deposit-rtx-5050'],
      '48221763272891': ['security-deposit-rtx-5080'],
      '48311258677435': ['security-deposit-rtx-5060'],
      '48311254745275': ['security-deposit-rtx-5070'],
      '67652399628475': ['security-deposit-gtx-1650'],
      '67652404412603': ['security-deposit-rtx-2060'],
      '67652407722171': ['security-deposit-rtx-3050'],
      '67652410114235': ['security-deposit-rtx-3060', 'security-deposit-rtx-3060-below'],
      '67652373119163': ['security-deposit-rtx-3070'],
      '67652377706683': ['security-deposit-rtx-3080'],
      '67652381933755': ['security-deposit-rtx-4050'],
      '67652384620731': ['security-deposit-rtx-4060'],
      '67652387537083': ['security-deposit-rtx-4070'],
      '67652389175483': ['security-deposit-rtx-5050'],
      '67652391436475': ['security-deposit-rtx-5060'],
      '67652393009339': ['security-deposit-rtx-5070'],
      '67652395598011': ['security-deposit-rtx-5080'],
      '48220729606331': ['security-deposit-imac-m1'],
      '47939187343547': ['security-deposit-macbook-air-m1'],
      '47939187605691': ['security-deposit-macbook-air-m2'],
      '47939187671227': ['security-deposit-macbook-air-m4'],
      '47939188719803': ['security-deposit-macbook-pro-m1'],
      '47939189276859': ['security-deposit-macbook-pro-m2'],
      '47939190161595': ['security-deposit-macbook-pro-m1-pro'],
      '47939191931067': ['security-deposit-macbook-pro-m2-pro'],
      '47939192258747': ['security-deposit-macbook-pro-m3-pro'],
      '48000175931579': ['security-deposit-macbook-pro-m3-max'],
      '47939193307323': ['security-deposit-macbook-pro-m4-pro'],
      '48220744155323': ['security-deposit-macbook-pro-m5-pro', 'security-deposit-m5-pro'],
      '48012018843835': ['security-deposit-ipad-8th'],
      '47940834984123': ['security-deposit-ipad-9th'],
      '48011984797883': ['security-deposit-ipad-10th'],
      '48221678796987': ['security-deposit-ipad-11th'],
      '47940837474491': ['security-deposit-ipad-air-m1', 'security-deposit-ipad-air-5th'],
      '48221653827771': ['security-deposit-ipad-air-m4'],
      '47940838621371': ['security-deposit-ipad-pro-m1', 'security-deposit-ipad-m1'],
      '47940843143355': ['security-deposit-ipad-pro-m2', 'security-deposit-ipad-m2'],
      '48199708836027': ['security-deposit-ipad-8th-cellular'],
      '48199708967099': ['security-deposit-ipad-9th-cellular'],
      '48199708999867': ['security-deposit-ipad-10th-cellular'],
      '48221681189051': ['security-deposit-ipad-11th-cellular'],
      '48199709163707': ['security-deposit-ipad-air-m1-cellular', 'security-deposit-ipad-air-5th-cellular'],
      '48221655466171': ['security-deposit-ipad-air-m4-cellular'],
      '48199710081211': ['security-deposit-ipad-pro-m1-cellular', 'security-deposit-ipad-m1-cellular'],
      '48199710212283': ['security-deposit-ipad-pro-m2-cellular', 'security-deposit-ipad-m2-cellular']
    };

    var securityDepositLeadDaysByVariantId = {};
    var securityDepositLeadDaysRequestByVariantId = {};
    var securityDepositProductCatalogPromise = null;
    var deviceReservationHiddenByVariantId = {};
    var deviceReservationHideRequestByVariantId = {};

    function stripSecurityDepositDescriptionHtml(value) {
      var html = String(value || '');
      if (!html) return '';

      var temporary = document.createElement('div');
      temporary.innerHTML = html;
      return String(temporary.textContent || temporary.innerText || '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function parseSecurityDepositLeadDays(description) {
      var text = stripSecurityDepositDescriptionHtml(description);
      var match = text.match(/\bday\s*[:=\-]?\s*(\d{1,3})\b/i);

      if (!match) return 0;

      var days = parseInt(match[1], 10);
      if (!isFinite(days) || days < 0) return 0;

      return Math.min(days, 365);
    }

    function normaliseSecurityDepositProductPayload(payload) {
      if (!payload || typeof payload !== 'object') return null;
      return payload.product && typeof payload.product === 'object'
        ? payload.product
        : payload;
    }

    function productContainsSecurityDepositVariant(productData, variantId) {
      if (!productData || !Array.isArray(productData.variants)) return false;

      return productData.variants.some(function (variant) {
        return String(variant && variant.id) === String(variantId);
      });
    }

    function readSecurityDepositDescriptionFromProduct(productData) {
      if (!productData) return '';
      return productData.body_html || productData.description || '';
    }

    function fetchSecurityDepositProductByHandle(handle, variantId) {
      if (!handle) return Promise.resolve(null);

      return fetch('/products/' + encodeURIComponent(handle) + '.json?rental_deposit_day=' + Date.now(), {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Cache-Control': 'no-cache'
        },
        cache: 'no-store'
      })
        .then(function (response) {
          if (typeof setTrustedNowFromResponse === 'function') {
            setTrustedNowFromResponse(response);
          }

          if (!response.ok) return null;
          return response.json();
        })
        .then(function (payload) {
          var productData = normaliseSecurityDepositProductPayload(payload);
          return productContainsSecurityDepositVariant(productData, variantId)
            ? productData
            : null;
        })
        .catch(function () {
          return null;
        });
    }

    function fetchSecurityDepositFromHandleCandidates(variantId) {
      var candidates = securityDepositProductHandleCandidatesByVariantId[String(variantId)] || [];
      var index = 0;

      function tryNextCandidate() {
        if (index >= candidates.length) return Promise.resolve(null);

        var handle = candidates[index];
        index += 1;

        return fetchSecurityDepositProductByHandle(handle, variantId)
          .then(function (productData) {
            return productData || tryNextCandidate();
          });
      }

      return tryNextCandidate();
    }

    function loadSecurityDepositProductCatalog() {
      if (securityDepositProductCatalogPromise) return securityDepositProductCatalogPromise;

      var pageSize = 250;
      var maxPages = 12;

      function fetchProductPage(page) {
        return fetch(
          '/products.json?limit=' + pageSize +
          '&page=' + page +
          '&rental_deposit_day=' + Date.now(),
          {
            method: 'GET',
            headers: {
              'Accept': 'application/json',
              'Cache-Control': 'no-cache'
            },
            cache: 'no-store'
          }
        )
          .then(function (response) {
            if (typeof setTrustedNowFromResponse === 'function') {
              setTrustedNowFromResponse(response);
            }

            if (!response.ok) return [];
            return response.json();
          })
          .then(function (payload) {
            if (Array.isArray(payload)) return payload;
            return payload && Array.isArray(payload.products) ? payload.products : [];
          })
          .catch(function () {
            return [];
          });
      }

      function loadPages(page, collected) {
        if (page > maxPages) return Promise.resolve(collected);

        return fetchProductPage(page).then(function (products) {
          var next = collected.concat(products);

          if (products.length < pageSize) {
            return next;
          }

          return loadPages(page + 1, next);
        });
      }

      securityDepositProductCatalogPromise = loadPages(1, []);

      return securityDepositProductCatalogPromise;
    }

    function findSecurityDepositInProductCatalog(variantId) {
      return loadSecurityDepositProductCatalog()
        .then(function (products) {
          return products.find(function (productData) {
            return productContainsSecurityDepositVariant(productData, variantId);
          }) || null;
        });
    }

    function slugifyDeviceReservationHandlePart(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function getDeviceReservationHandleCandidatesForVariantId(variantId) {
      var key = String(variantId || '');
      var labels = [];
      var candidates = [];

      function addLabel(label) {
        var normalised = String(label || '').trim();
        if (!normalised || labels.indexOf(normalised) !== -1) return;
        labels.push(normalised);
      }

      function collectFromMap(map) {
        if (!map || typeof map !== 'object') return;

        Object.keys(map).forEach(function (label) {
          var config = map[label];
          if (
            config &&
            config.reservationVariantId &&
            String(config.reservationVariantId) === key
          ) {
            addLabel(label);
          }
        });
      }

      collectFromMap(businessLaptopSecurityDepositMap);
      collectFromMap(gamingSecurityDepositMap);
      collectFromMap(macbookSecurityDepositMap);

      /* Business tier keys are intentionally short, so include the actual
         customer-facing Device Reservation title handles as first choices. */
      var businessHandleByVariantId = {
        '67640468603067': 'device-reservation-i5-ryzen-5',
        '67641723748539': 'device-reservation-i7-ryzen-7',
        '67641809109179': 'device-reservation-ultra-5-ryzen-5-new',
        '67641879888059': 'device-reservation-ultra-7-ryzen-7-new',
        '67641926123707': 'device-reservation-lg-gram-16'
      };

      if (businessHandleByVariantId[key]) {
        candidates.push(businessHandleByVariantId[key]);
      }

      labels.forEach(function (label) {
        var slug = slugifyDeviceReservationHandlePart(label);
        if (!slug) return;

        var handle = 'device-reservation-' + slug;
        if (candidates.indexOf(handle) === -1) {
          candidates.push(handle);
        }
      });

      return candidates;
    }

    function fetchDeviceReservationProductByHandle(handle, variantId) {
      if (!handle) return Promise.resolve(null);

      return fetch(
        '/products/' + encodeURIComponent(handle) +
        '.json?rental_reservation_hide=' + Date.now(),
        {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Cache-Control': 'no-cache'
          },
          cache: 'no-store'
        }
      )
        .then(function (response) {
          if (typeof setTrustedNowFromResponse === 'function') {
            setTrustedNowFromResponse(response);
          }

          if (!response.ok) return null;
          return response.json();
        })
        .then(function (payload) {
          var productData = normaliseSecurityDepositProductPayload(payload);

          return productContainsSecurityDepositVariant(productData, variantId)
            ? productData
            : null;
        })
        .catch(function () {
          return null;
        });
    }

    function fetchDeviceReservationProductByVariantId(variantId) {
      var candidates = getDeviceReservationHandleCandidatesForVariantId(variantId);
      var index = 0;

      function tryNextCandidate() {
        if (index >= candidates.length) {
          return findSecurityDepositInProductCatalog(variantId);
        }

        var handle = candidates[index];
        index += 1;

        return fetchDeviceReservationProductByHandle(handle, variantId)
          .then(function (productData) {
            return productData || tryNextCandidate();
          });
      }

      return tryNextCandidate();
    }

    function deviceReservationDescriptionHasHideFlag(description) {
      var text = stripSecurityDepositDescriptionHtml(description);
      return /\bhide\b/i.test(text);
    }

    function loadDeviceReservationHideFlagForVariantId(variantId) {
      var key = String(variantId || '');
      if (!key) return Promise.resolve(false);

      if (Object.prototype.hasOwnProperty.call(deviceReservationHiddenByVariantId, key)) {
        return Promise.resolve(deviceReservationHiddenByVariantId[key] === true);
      }

      if (deviceReservationHideRequestByVariantId[key]) {
        return deviceReservationHideRequestByVariantId[key];
      }

      deviceReservationHideRequestByVariantId[key] = fetchDeviceReservationProductByVariantId(key)
        .then(function (productData) {
          if (!productData) {
            deviceReservationHiddenByVariantId[key] = false;
            return false;
          }

          var description = readSecurityDepositDescriptionFromProduct(productData);
          var hidden = deviceReservationDescriptionHasHideFlag(description);

          deviceReservationHiddenByVariantId[key] = hidden;

          return hidden;
        })
        .catch(function (error) {
          console.error('Device reservation hide flag lookup error:', error);
          deviceReservationHiddenByVariantId[key] = false;
          return false;
        });

      return deviceReservationHideRequestByVariantId[key];
    }

    function deviceReservationIsHidden(variantId) {
      return deviceReservationHiddenByVariantId[String(variantId || '')] === true;
    }

    function cacheSecurityDepositLeadDays(variantId, description) {
      var key = String(variantId);
      var normalisedDescription = stripSecurityDepositDescriptionHtml(description);
      securityDepositDescriptionByVariantId[key] = normalisedDescription;
      securityDepositLeadDaysByVariantId[key] = parseSecurityDepositLeadDays(normalisedDescription);
      return securityDepositLeadDaysByVariantId[key];
    }

    function loadSecurityDepositLeadDaysForVariantId(variantId) {
      var key = String(variantId || '');
      if (!key) return Promise.resolve(0);

      if (Object.prototype.hasOwnProperty.call(securityDepositLeadDaysByVariantId, key)) {
        return Promise.resolve(securityDepositLeadDaysByVariantId[key]);
      }

      if (securityDepositDescriptionByVariantId[key]) {
        return Promise.resolve(cacheSecurityDepositLeadDays(key, securityDepositDescriptionByVariantId[key]));
      }

      if (securityDepositLeadDaysRequestByVariantId[key]) {
        return securityDepositLeadDaysRequestByVariantId[key];
      }

      securityDepositLeadDaysRequestByVariantId[key] = fetchSecurityDepositFromHandleCandidates(key)
        .then(function (productData) {
          if (productData) return productData;
          return findSecurityDepositInProductCatalog(key);
        })
        .then(function (productData) {
          var description = readSecurityDepositDescriptionFromProduct(productData);
          return cacheSecurityDepositLeadDays(key, description);
        })
        .catch(function (error) {
          console.error('Security deposit Day setting lookup error:', error);
          return cacheSecurityDepositLeadDays(key, 'Day 0');
        });

      return securityDepositLeadDaysRequestByVariantId[key];
    }

    function getSecurityDepositLeadDaysForVariantId(variantId) {
      var key = String(variantId || '');

      if (Object.prototype.hasOwnProperty.call(securityDepositLeadDaysByVariantId, key)) {
        return securityDepositLeadDaysByVariantId[key];
      }

      return parseSecurityDepositLeadDays(securityDepositDescriptionByVariantId[key] || '');
    }

    function getSelectedSecurityDepositLeadDays() {
      var config = getSecurityDepositConfig();
      return config && config.variantId
        ? getSecurityDepositLeadDaysForVariantId(config.variantId)
        : 0;
    }

    function loadSelectedSecurityDepositLeadDays() {
      var config = getSecurityDepositConfig();
      if (!config || !config.variantId) return Promise.resolve(0);

      var requestedVariantId = String(config.variantId);

      return loadSecurityDepositLeadDaysForVariantId(requestedVariantId)
        .then(function (days) {
          var currentConfig = getSecurityDepositConfig();
          if (currentConfig && String(currentConfig.variantId) === requestedVariantId) {
            /*
             * Do not clear a valid same-day date while the parallel PlayTime
             * revalidation is still in flight. During submit/edit validation,
             * loadPlayTimeAvailability() temporarily sets playTimeStatusLoaded
             * to false; a cached deposit lead-day lookup can finish first.
             * Clearing at that moment incorrectly treats today as unavailable.
             *
             * Once PlayTime finishes, its own refresh runs with clear=true and
             * will still remove today when same-day rental is genuinely closed.
             */
            refreshPlayTimeDependentUi(!!playTimeStatusLoaded);
          }
          return days;
        });
    }

    var weekendSurchargeVariantId = 47525588238523;
    var earlyDeliveryVariantId = 47541269823675;
    var standardUrgentChargeVariantId = 47943771488443;
    var priorityUrgentChargeVariantId = 47943772995771;
    var standardReturnExtensionVariantId = 47943792853179;
    var priorityReturnExtensionVariantId = 47943796097211;
    var memoryAddonVariantId = 47939116859579;
    var officeAddonVariantId = 47939117285563;
    var appleMouseAddonVariantId = 48226709143739;
    var appleMouseAddonStockStatus = null;
    var appleMouseAddonStockRequestSequence = 0;
    var hdmiAddonVariantId = 48028946235579;

    var pencilAddonVariantPriority = [
      {
        key: 'gen-1',
        label: 'Pencil Gen 1',
        variantId: 47943499776187,
        compatibleModels: [
          'ipad 8th',
          'ipad 9th',
          'ipad 10th',
          'ipad a16'
        ]
      },
      {
        key: 'gen-2',
        label: 'Pencil Gen 2',
        variantId: 48199696548027,
        compatibleModels: [
          'ipad mini 6',
          'ipad air m1',
          'ipad pro m1',
          'ipad pro m2'
        ]
      },
      {
        key: 'usb-c',
        label: 'Pencil USB-C',
        variantId: 48199699824827,
        compatibleModels: [
          'ipad 10th',
          'ipad a16',
          'ipad mini 6',
          'ipad mini a17 pro',
          'ipad air m1',
          'ipad air m2',
          'ipad air m3',
          'ipad air m4',
          'ipad pro m1',
          'ipad pro m2',
          'ipad pro m4',
          'ipad pro m5'
        ]
      }
    ];
    var pencilAddonVariantId = 0;
    var selectedPencilAddonConfig = null;
    var pencilAddonStockStatusByVariantId = {};
    var pencilAddonStockRequestSequence = 0;
    var defaultSecurityDepositVariantId = 47526006063291;

    var weekendSurchargeCents = null;
    var earlyDeliverySurchargeCents = null;
    var standardUrgentChargeCents = null;
    var priorityUrgentChargeCents = null;
    var standardReturnExtensionCents = null;
    var priorityReturnExtensionCents = null;
    var memoryAddonCents = null;
    var officeAddonCents = null;
    var appleMouseAddonCents = null;
    var hdmiAddonCents = null;
    var pencilAddonCents = null;

    var BUSINESS_REDUCED_DEPOSIT_MIN_DAYS = 30;

    var businessLaptopSecurityDepositMap = {
      i5: {
        variantId: 67640465031355,
        reducedVariantId: 67640461656251,
        reservationVariantId: 67640468603067
      },
      i7: {
        variantId: 67641303498939,
        reducedVariantId: 67641325420731,
        reservationVariantId: 67641723748539
      },
      ultra5: {
        variantId: 48111443509435,
        reducedVariantId: 67641772802235,
        reservationVariantId: 67641809109179
      },
      ultra7: {
        variantId: 48111444099259,
        reducedVariantId: 67641843351739,
        reservationVariantId: 67641879888059
      },
      surfacePro11: {
        variantId: 48292528193723
      },
      lgGram16: {
        variantId: 48292582523067,
        reducedVariantId: 67641908986043,
        reservationVariantId: 67641926123707
      }
    };

    function hasStandaloneBusinessTierWord(text, word) {
      return new RegExp('(^|[^a-z0-9])' + word + '([^a-z0-9]|$)', 'i').test(text);
    }

    function getBusinessLaptopSecurityDepositConfig(searchText) {
      var text = String(searchText || '').toLowerCase();
      var isNewTier = hasStandaloneBusinessTierWord(text, 'new');

      if (text.indexOf('lg gram 16') !== -1) {
        return businessLaptopSecurityDepositMap.lgGram16;
      }

      if (text.indexOf('surface pro 11') !== -1) {
        return businessLaptopSecurityDepositMap.surfacePro11;
      }

      if (text.indexOf('ultra 7') !== -1 || (text.indexOf('ryzen 7') !== -1 && isNewTier)) {
        return businessLaptopSecurityDepositMap.ultra7;
      }

      if (text.indexOf('ultra 5') !== -1 || (text.indexOf('ryzen 5') !== -1 && isNewTier)) {
        return businessLaptopSecurityDepositMap.ultra5;
      }

      if (hasStandaloneBusinessTierWord(text, 'i7') || text.indexOf('ryzen 7') !== -1) {
        return businessLaptopSecurityDepositMap.i7;
      }

      if (hasStandaloneBusinessTierWord(text, 'i5') || text.indexOf('ryzen 5') !== -1) {
        return businessLaptopSecurityDepositMap.i5;
      }

      return null;
    }

    function getSelectedBusinessLaptopTierConfig() {
      var productTitle = String(rentalPageConfig.productTitle || '').toLowerCase();
      if (productTitle.indexOf('business laptop rental') === -1) return null;

      var searchText = (getSelectedProcessorText() + ' ' + getSelectedOptionText()).toLowerCase();
      return getBusinessLaptopSecurityDepositConfig(searchText);
    }

    function getSelectedMacbookTierConfig() {
      var productTitle = String(rentalPageConfig.productTitle || '').toLowerCase();
      if (productTitle.indexOf('macbook rental') === -1) return null;

      var searchText = (
        productTitle + ' ' +
        getSelectedProcessorText() + ' ' +
        getSelectedOptionText()
      ).toLowerCase();

      var matchedKey = Object.keys(macbookSecurityDepositMap)
        .sort(function (a, b) { return b.length - a.length; })
        .find(function (modelName) {
          return searchText.indexOf(modelName) !== -1;
        });

      return matchedKey ? macbookSecurityDepositMap[matchedKey] : null;
    }

    function getSelectedDynamicDepositConfig() {
      return getSelectedBusinessLaptopTierConfig() ||
        getSelectedGamingTierConfig() ||
        getSelectedMacbookTierConfig();
    }

    function reducedDepositApplies(config) {
      return !!(
        config &&
        config.reducedVariantId &&
        getSelectedRentalDurationDays() >= BUSINESS_REDUCED_DEPOSIT_MIN_DAYS
      );
    }

    function getBusinessLaptopRentalUnitConfigForOptionText(optionText) {
      var productTitle = String(rentalPageConfig.productTitle || '').toLowerCase();
      if (productTitle.indexOf('business laptop rental') === -1) return null;

      var config = getBusinessLaptopSecurityDepositConfig(optionText);
      if (!config || !config.reservationVariantId) return null;

      return {
        variantId: config.reservationVariantId
      };
    }

    function getMacbookRentalUnitConfigForOptionText(optionText) {
      var productTitle = String(rentalPageConfig.productTitle || '').toLowerCase();
      if (productTitle.indexOf('macbook rental') === -1) return null;

      var combinedSearchText = (productTitle + ' ' + String(optionText || '')).toLowerCase();
      var matchedKey = Object.keys(macbookSecurityDepositMap)
        .sort(function (a, b) { return b.length - a.length; })
        .find(function (modelName) {
          return combinedSearchText.indexOf(modelName) !== -1;
        });

      if (!matchedKey) return null;

      var config = macbookSecurityDepositMap[matchedKey];
      if (!config || !config.reservationVariantId) return null;

      return { variantId: config.reservationVariantId };
    }

    function getSelectedBusinessLaptopRentalUnitConfig() {
      var config = getSelectedBusinessLaptopTierConfig();
      if (!config || !config.reservationVariantId) return null;

      return {
        variantId: config.reservationVariantId
      };
    }

    function getSelectedRentalUnitConfig() {
      var config = getSelectedDynamicDepositConfig();
      if (!config || !config.reservationVariantId) return null;

      return {
        variantId: config.reservationVariantId
      };
    }

    var gamingSecurityDepositMap = {
      'gtx 1650': {
        variantId: 48000206274747,
        reducedVariantId: 67652399628475,
        reservationVariantId: 67652415881403
      },
      'rtx 2060': {
        variantId: 48000206700731,
        reducedVariantId: 67652404412603,
        reservationVariantId: 67652425810107
      },
      'rtx 3050': {
        variantId: 48000207061179,
        reducedVariantId: 67652407722171,
        reservationVariantId: 67652428660923
      },
      'rtx 3060': {
        variantId: 48000207388859,
        reducedVariantId: 67652410114235,
        reservationVariantId: 67652469817531
      },
      'rtx 3070': {
        variantId: 48000136282299,
        reducedVariantId: 67652373119163,
        reservationVariantId: 67652473094331
      },
      'rtx 3080': {
        variantId: 48000145031355,
        reducedVariantId: 67652377706683,
        reservationVariantId: 67652473258171
      },
      'rtx 4050': {
        variantId: 47939105030331,
        reducedVariantId: 67652381933755,
        reservationVariantId: 67652473290939
      },
      'rtx 4060': {
        variantId: 47939105980603,
        reducedVariantId: 67652384620731,
        reservationVariantId: 67652473389243
      },
      'rtx 4070': {
        variantId: 47939106078907,
        reducedVariantId: 67652387537083,
        reservationVariantId: 67652473454779
      },
      'rtx 5050': {
        variantId: 48205548290235,
        reducedVariantId: 67652389175483,
        reservationVariantId: 67652473618619
      },
      'rtx 5060': {
        variantId: 48311258677435,
        reducedVariantId: 67652391436475,
        reservationVariantId: 67652473684155
      },
      'rtx 5070': {
        variantId: 48311254745275,
        reducedVariantId: 67652393009339,
        reservationVariantId: 67652474372283
      },
      'rtx 5080': {
        variantId: 48221763272891,
        reducedVariantId: 67652395598011,
        reservationVariantId: 67652474405051
      }
    };

    function getSelectedGamingTierConfig() {
      var productTitle = String(rentalPageConfig.productTitle || '').toLowerCase();
      if (productTitle.indexOf('gaming laptop rental') === -1) return null;

      var searchText = (
        productTitle + ' ' +
        getSelectedProcessorText() + ' ' +
        getSelectedOptionText()
      ).toLowerCase();

      var matchedKey = Object.keys(gamingSecurityDepositMap)
        .sort(function (a, b) { return b.length - a.length; })
        .find(function (graphicsName) {
          return searchText.indexOf(graphicsName) !== -1;
        });

      return matchedKey ? gamingSecurityDepositMap[matchedKey] : null;
    }

    function getGamingRentalUnitConfigForOptionText(optionText) {
      var productTitle = String(rentalPageConfig.productTitle || '').toLowerCase();
      if (productTitle.indexOf('gaming laptop rental') === -1) return null;

      var searchText = String(optionText || '').toLowerCase();
      var matchedKey = Object.keys(gamingSecurityDepositMap)
        .sort(function (a, b) { return b.length - a.length; })
        .find(function (graphicsName) {
          return searchText.indexOf(graphicsName) !== -1;
        });

      if (!matchedKey) return null;

      var config = gamingSecurityDepositMap[matchedKey];
      if (!config || !config.reservationVariantId) return null;

      return { variantId: config.reservationVariantId };
    }

    var macbookSecurityDepositMap = {
      'imac m1': { variantId: 48220729606331, reducedVariantId: 67642264027323, reservationVariantId: 67642302005435 },
      'macbook air m1': { variantId: 47939187343547, reducedVariantId: 67642217332923, reservationVariantId: 67642268188859 },
      'macbook air m2': { variantId: 47939187605691, reducedVariantId: 67642220806331, reservationVariantId: 67642271563963 },
      'macbook air m3': { variantId: 48198540329147, reducedVariantId: 67642223788219, reservationVariantId: 67642273497275 },
      'macbook air m4': { variantId: 47939187671227, reducedVariantId: 67642227720379, reservationVariantId: 67642276413627 },
      'macbook air m5': { variantId: 48198543212731, reducedVariantId: 67642232733883, reservationVariantId: 67642280575163 },

      'macbook pro m3 max': { variantId: 48000175931579, reducedVariantId: 67642254098619, reservationVariantId: 67642299613371 },
      'm3 max': { variantId: 48000175931579, reducedVariantId: 67642254098619, reservationVariantId: 67642299613371 },

      'macbook pro m1 pro': { variantId: 47939190161595, reducedVariantId: 67642246758587, reservationVariantId: 67642287849659 },
      'macbook pro m2 pro': { variantId: 47939191931067, reducedVariantId: 67642249019579, reservationVariantId: 67642289750203 },
      'm2 pro': { variantId: 47939191931067, reducedVariantId: 67642249019579, reservationVariantId: 67642289750203 },

      'macbook pro m3 pro': { variantId: 47939192258747, reducedVariantId: 67642251706555, reservationVariantId: 67642294698171 },
      'm3 pro': { variantId: 47939192258747, reducedVariantId: 67642251706555, reservationVariantId: 67642294698171 },

      'macbook pro m4 pro': { variantId: 47939193307323, reducedVariantId: 67642260979899, reservationVariantId: 67642296893627 },
      'm4 pro': { variantId: 47939193307323, reducedVariantId: 67642260979899, reservationVariantId: 67642296893627 },

      'macbook pro m5 pro': { variantId: 48220744155323, reducedVariantId: 67642308690107, reservationVariantId: 67642306298043 },
      'm5 pro': { variantId: 48220744155323, reducedVariantId: 67642308690107, reservationVariantId: 67642306298043 },

      'macbook pro m1': { variantId: 47939188719803, reducedVariantId: 67642237485243, reservationVariantId: 67642283032763 },
      'macbook pro m2': { variantId: 47939189276859, reducedVariantId: 67642241548475, reservationVariantId: 67642285064379 }
    };

    var ipadSecurityDepositMap = {
      'ipad air m4 cellular': { variantId: 48221655466171 },
      'ipad air m1 cellular': { variantId: 48199709163707 },
      'ipad air 5th cellular': { variantId: 48199709163707 },
      'ipad air 5 cellular': { variantId: 48199709163707 },
      'ipad pro m1 cellular': { variantId: 48199710081211 },
      'ipad m1 cellular': { variantId: 48199710081211 },
      'ipad pro m2 cellular': { variantId: 48199710212283 },
      'ipad m2 cellular': { variantId: 48199710212283 },
      'ipad 11th cellular': { variantId: 48221681189051 },
      'ipad 10th cellular': { variantId: 48199708999867 },
      'ipad 9th cellular': { variantId: 48199708967099 },
      'ipad 8th cellular': { variantId: 48199708836027 },
      'ipad air m4': { variantId: 48221653827771 },
      'ipad air m1': { variantId: 47940837474491 },
      'ipad air 5th': { variantId: 47940837474491 },
      'ipad air 5': { variantId: 47940837474491 },
      'ipad pro m1': { variantId: 47940838621371 },
      'ipad m1': { variantId: 47940838621371 },
      'ipad pro m2': { variantId: 47940843143355 },
      'ipad m2': { variantId: 47940843143355 },
      'ipad 11th': { variantId: 48221678796987 },
      'ipad 10th': { variantId: 48011984797883 },
      'ipad 9th': { variantId: 47940834984123 },
      'ipad 8th': { variantId: 48012018843835 }
    };

    var rentalTermsAgree = document.getElementById('RentalTermsAgree');
    var rentalTermsToggle = document.getElementById('RentalTermsToggle');
    var rentalTermsBox = document.getElementById('RentalTermsBox');
    var deliveryTimeInput = document.getElementById('RentalDeliveryTime');
    var rentalDeliveryTimeLabel = document.getElementById('RentalDeliveryTimeLabel');
    var returnTimeInput = document.getElementById('RentalReturnTime');
    var rentalReturnTimeLabel = document.getElementById('RentalReturnTimeLabel');

    /* Priority 3: keep the customer's schedule while they reselect the rental
       date range. The calendar temporarily becomes incomplete after the first
       date click, so the selects are rebuilt with dependency placeholders. A
       separate retained value prevents that temporary state from erasing an
       otherwise still-valid delivery/return choice. */
    var retainedRentalDeliveryTimeValue = '';
    var retainedRentalReturnTimeValue = '';
    var startPreview = document.getElementById('RentalStartPreview');
    var endPreview = document.getElementById('RentalEndPreview');
    var endInfoWrap = document.getElementById('RentalEndInfoWrap');
    var returnNote = document.getElementById('RentalReturnNote');
    var rentalPriceMobilePeriod = document.getElementById('RentalPriceMobilePeriod');
    var rentalPriceMobileTimingRows = document.getElementById('RentalPriceMobileTimingRows');
    var rentalPriceMobileStart = document.getElementById('RentalPriceMobileStart');
    var rentalPriceMobileEnd = document.getElementById('RentalPriceMobileEnd');
    var mainImage = document.getElementById('RentalMainImage');
    var rentalGalleryMain = document.querySelector('.rental-gallery-main');
    var thumbs = document.querySelectorAll('.rental-thumb');
    var optionInputs = document.querySelectorAll('.rental-option-radio');
    var rentalPeriodSelect = document.getElementById('RentalPeriodSelect');
    var rentalProcessorSelect = document.getElementById('RentalProcessorSelect');

    function updateRentalProcessorFieldLabel() {
      if (!rentalProcessorSelect) return;

      var productTitle = String(rentalPageConfig.productTitle || '').toLowerCase();
      var displayLabel = 'Processor';

      if (productTitle.indexOf('gaming laptop rental') !== -1) {
        displayLabel = 'Graphics Card';
      } else if (
        productTitle.indexOf('ipad rental') !== -1 ||
        productTitle.indexOf('macbook rental') !== -1
      ) {
        displayLabel = 'Model';
      }

      var processorGroup = rentalProcessorSelect.closest(
        '.rental-option-group--processor-dropdown'
      );
      var processorLabel = processorGroup
        ? processorGroup.querySelector('.rental-option-group-title')
        : null;

      if (processorLabel) {
        processorLabel.textContent = displayLabel;
      }

      rentalProcessorSelect.setAttribute('aria-label', 'Select ' + displayLabel);
    }

    updateRentalProcessorFieldLabel();

    // Calendar-beta pricing variants share the live Shopify product, but the
    // legacy rental UI must not expose or use them. Keep this test deliberately
    // broad enough for names such as "CAL Base 1 Day" and "CAL | Days 2-7".
    function isCalendarPricingRentalPeriod(value) {
      return /^cal(?:\s|\||-)/i.test(String(value || '').trim());
    }

    function removeCalendarPricingRentalPeriodControls() {
      if (!rentalPeriodSelect) return;

      var periodPosition = rentalPeriodSelect.getAttribute('data-option-position');

      // Remove CAL values from the native/select dropdown. This is necessary
      // even if the Liquid template still renders the new Shopify variants.
      Array.prototype.slice.call(rentalPeriodSelect.options).forEach(function (option) {
        if (isCalendarPricingRentalPeriod(option.value)) {
          option.remove();
        }
      });

      // Remove the matching card/radio controls from the legacy period UI so
      // they cannot be selected or restored by later UI refreshes.
      Array.prototype.slice.call(optionInputs).forEach(function (input) {
        if (input.getAttribute('data-option-position') !== periodPosition) return;
        if (!isCalendarPricingRentalPeriod(input.value)) return;

        var card = input.closest('.rental-option-card');
        if (card && card.parentNode) {
          card.parentNode.removeChild(card);
        } else if (input.parentNode) {
          input.parentNode.removeChild(input);
        }
      });

      // optionInputs was a static NodeList, so refresh it after removing CAL
      // controls. All downstream legacy logic now sees legacy periods only.
      optionInputs = document.querySelectorAll('.rental-option-radio');
    }
    var rentalProcessorClosedDisplay = null;
    var rentalProcessorClosedDisplayLabel = null;
    var rentalProcessorNativePickerExpanded = false;
    var rentalProcessorSelectOriginalOverlayStyles = null;

    function removeLegacyRentalPeriodPriceNote() {
      Array.prototype.forEach.call(
        document.querySelectorAll('#RentalPeriodSelectedPrice, [data-rental-period-price-note]'),
        function (note) {
          if (note && note.parentNode) note.parentNode.removeChild(note);
        }
      );

      if (!rentalPeriodSelect || !rentalPeriodSelect.parentNode) return;

      Array.prototype.forEach.call(rentalPeriodSelect.parentNode.children, function (child) {
        if (!child || child === rentalPeriodSelect) return;

        var noteText = String(child.textContent || '')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();

        if (noteText.indexOf('rental price:') === 0) {
          if (child.parentNode) child.parentNode.removeChild(child);
        }
      });
    }

    removeLegacyRentalPeriodPriceNote();

    if (rentalPeriodSelect && rentalPeriodSelect.parentNode && window.MutationObserver) {
      var rentalPeriodPriceNoteObserver = new MutationObserver(function () {
        removeLegacyRentalPeriodPriceNote();
      });

      rentalPeriodPriceNoteObserver.observe(rentalPeriodSelect.parentNode, {
        childList: true
      });
    }

    // Calendar beta keeps CAL pricing variants available internally.

    var rentalPeriodOriginalOptions = rentalPeriodSelect
      ? Array.prototype.map.call(rentalPeriodSelect.options, function (option) {
          return {
            option: option,
            originallyDisabled: !!option.disabled,
            originalText: option.textContent
          };
        })
      : [];
    var allVariants = Array.isArray(rentalPageConfig.allVariants) ? rentalPageConfig.allVariants : [];

    function isIpadRentalPage() {
      return String(rentalPageConfig.productTitle || '').toLowerCase().indexOf('ipad rental') !== -1;
    }

    function getRentalProcessorOptionIndex() {
      if (!rentalProcessorSelect) return -1;

      var position = parseInt(rentalProcessorSelect.getAttribute('data-option-position'), 10);
      return Number.isFinite(position) && position > 0 ? position - 1 : -1;
    }

    function normaliseIpadProcessorValue(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
    }

    function isIpadCellularProcessorValue(value) {
      return /\bcellular\b/i.test(String(value || ''));
    }

    function getBaseIpadProcessorValue(value) {
      return String(value || '')
        .replace(/\s+cellular\s*$/i, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function getRawSelectedProcessorValue() {
      var optionPosition = rentalProcessorSelect
        ? rentalProcessorSelect.getAttribute('data-option-position')
        : '';
      var checked = Array.prototype.find.call(optionInputs, function (input) {
        return input.getAttribute('data-option-position') === optionPosition &&
          input.checked &&
          !isIpadCellularProcessorValue(input.value);
      });

      if (checked && checked.value) return String(checked.value).trim();
      if (rentalProcessorSelect && rentalProcessorSelect.value) {
        return getBaseIpadProcessorValue(rentalProcessorSelect.value);
      }

      return '';
    }

    function findIpadProcessorValue(targetValue) {
      var processorIndex = getRentalProcessorOptionIndex();
      var targetKey = normaliseIpadProcessorValue(targetValue);
      var matchedValue = '';

      if (processorIndex < 0 || !targetKey) return '';

      allVariants.some(function (variant) {
        if (!variant || !Array.isArray(variant.options)) return false;

        var candidate = String(variant.options[processorIndex] || '').trim();
        if (normaliseIpadProcessorValue(candidate) !== targetKey) return false;

        matchedValue = candidate;
        return true;
      });

      return matchedValue;
    }

    function getCellularIpadProcessorValue(baseValue) {
      var base = getBaseIpadProcessorValue(baseValue);
      return base ? findIpadProcessorValue(base + ' Cellular') : '';
    }

    function getEffectiveIpadProcessorValue() {
      var baseValue = getRawSelectedProcessorValue();

      if (!isIpadRentalPage() || !cellularAddonInput || !cellularAddonInput.checked) {
        return baseValue;
      }

      return getCellularIpadProcessorValue(baseValue) || baseValue;
    }

    function getRawSelectedOptions() {
      var selected = [];
      var groups = document.querySelectorAll('.rental-option-group[data-option-position]');

      groups.forEach(function (group) {
        var checked = group.querySelector('.rental-option-radio:checked');
        selected.push(checked ? checked.value : null);
      });

      return selected;
    }

    function hideInternalIpadCellularProcessorOptions() {
      if (!isIpadRentalPage() || !rentalProcessorSelect) return;

      var processorPosition = rentalProcessorSelect.getAttribute('data-option-position');

      Array.prototype.slice.call(rentalProcessorSelect.options).forEach(function (option) {
        if (isIpadCellularProcessorValue(option.value)) {
          option.remove();
        }
      });

      Array.prototype.forEach.call(optionInputs, function (input) {
        if (input.getAttribute('data-option-position') !== processorPosition) return;
        if (!isIpadCellularProcessorValue(input.value)) return;

        input.setAttribute('data-internal-cellular-processor', 'true');
        input.setAttribute('tabindex', '-1');

        var card = input.closest('.rental-option-card');
        if (card) {
          card.hidden = true;
          card.style.display = 'none';
          card.setAttribute('aria-hidden', 'true');
        }
      });
    }

    var variantIdInput = document.getElementById('RentalVariantId');
    var basePriceLabelEl = document.getElementById('RentalBasePriceLabel');
    var basePriceEl = document.getElementById('RentalBasePrice');
    var rentalChargesTotalEl = document.getElementById('RentalChargesTotalPrice');
    var totalPriceEl = document.getElementById('RentalTotalPrice');
    var mobileSummaryJump = document.getElementById('RentalMobileSummaryJump');
    var mobileSummaryJumpRentalCost = document.getElementById('RentalMobileSummaryJumpRentalCost');
    var mobileSummaryJumpDeposit = document.getElementById('RentalMobileSummaryJumpDeposit');
    var mobileSummaryJumpSuppressedForValidation = false;
    var priceBoxEl = document.querySelector('.rental-price-box');
    var rentalOptionsField = document.querySelector('.rental-field--options');
    var rentalTermsField = document.querySelector('.rental-terms-field');
    var rentalFormWrap = document.querySelector('.rental-form-wrap');
    var rentalDetails = document.querySelector('.rental-details');
    var rentalInfoPanels = document.querySelector('.rental-info-panels');
    var rentalMobileTitle = document.querySelector('.rental-title-mobile');
    var rentalProductPage = document.querySelector('.rental-product-page');

    var priceBoxOriginalParent = priceBoxEl ? priceBoxEl.parentNode : null;
    var priceBoxOriginalNextSibling = priceBoxEl ? priceBoxEl.nextSibling : null;
    var surchargeRow = document.getElementById('WeekendSurchargeRow');
    var earlyDeliveryRow = document.getElementById('EarlyDeliveryRow');
    var priorityUrgentChargeRow = document.getElementById('PriorityUrgentChargeRow');
    var standardUrgentChargeRow = document.getElementById('StandardUrgentChargeRow');
    var standardReturnExtensionRow = document.getElementById('StandardReturnExtensionRow');
    var priorityReturnExtensionRow = document.getElementById('PriorityReturnExtensionRow');
    var memoryAddonRow = document.getElementById('MemoryAddonRow');
    var officeAddonRow = document.getElementById('OfficeAddonRow');
    var appleMouseAddonRow = document.getElementById('AppleMouseAddonRow');
    var hdmiAddonRow = document.getElementById('HdmiAddonRow');
    var cellularAddonRow = document.getElementById('CellularAddonRow');
    var pencilAddonRow = document.getElementById('PencilAddonRow');
    var memoryAddonInput = document.getElementById('GamingAddon32GB');
    var officeAddonInput = document.getElementById('GamingAddonOffice');
    var appleMouseAddonInput = document.getElementById('MacbookAddonAppleMouse');
    var hdmiAddonInput = document.getElementById('BusinessAddonHdmiPort');
    var cellularAddonInput = document.getElementById('IpadAddonCellular');
    var pencilAddonInput = document.getElementById('IpadAddonPencil');
    var securityDepositValueEl = document.getElementById('SecurityDepositValue');
    var securityDepositReducedBadge = document.getElementById('SecurityDepositReducedBadge');
    var securityDepositSubtext = document.getElementById('SecurityDepositSubtext');
    var surchargeAppliedInput = document.getElementById('WeekendSurchargeApplied');
    var surchargeAmountInput = document.getElementById('WeekendSurchargeAmount');
    var startDateInput = document.getElementById('RentalStartDate');
    var rentalStartDateLabel = document.getElementById('RentalStartDateLabel');
    var rentalStartDateDisplay = document.getElementById('RentalStartDateDisplay');
    var rentalStartDateDisplayText = document.getElementById('RentalStartDateDisplayText');
    var rentalMobileCalendar = document.getElementById('RentalMobileCalendar');
    var rentalMobileCalendarTitle = document.getElementById('RentalMobileCalendarTitle');
    var rentalMobileCalendarGrid = document.getElementById('RentalMobileCalendarGrid');
    var rentalMobileCalendarPrev = document.getElementById('RentalMobileCalendarPrev');
    var rentalMobileCalendarNext = document.getElementById('RentalMobileCalendarNext');
    var rentalMobileCalendarClose = document.getElementById('RentalMobileCalendarClose');
    var rentalMobileCalendarDone = document.getElementById('RentalMobileCalendarDone');
    var rentalCalendarSelectionStart = document.getElementById('RentalCalendarSelectionStart');
    var rentalCalendarSelectionEnd = document.getElementById('RentalCalendarSelectionEnd');
    var rentalCalendarSelectionStartValue = document.getElementById('RentalCalendarSelectionStartValue');
    var rentalCalendarSelectionEndValue = document.getElementById('RentalCalendarSelectionEndValue');
    var rentalMobileCalendarViewDate = null;
    /* Mobile-only explicit date-summary reselection modes.
       - Return Date: keep Start Date fixed and replace only Return Date.
       - Start Date: let the customer choose a new Start Date; after the new
         start is chosen, clear the old Return Date so a fresh Return Date
         must be selected against the new rental period. */
    var rentalCalendarReturnReselectMode = false;
    var rentalCalendarStartReselectMode = false;

    var useCustomRentalDatePicker = true;
    var dateError = document.getElementById('RentalDateError');
    var submitButton = document.getElementById('RentalSubmitButton');
    var rentalForm = document.getElementById('RentalProductForm');
    var rentalNotes = document.getElementById('RentalNotes');
    var proceedToDocumentsButton = document.getElementById('RentalProceedToDocumentsButton');
    var proceedToDocumentsWrap = document.getElementById('RentalProceedToDocumentsWrap');
    var rentalReviewStageActive = false;
    var rentalReviewBackButton = null;
    var rentalFinalActions = null;
    var rentalWhatsappButton = null;
    var rentalQuantityInput = rentalForm
      ? rentalForm.querySelector('input[name="quantity"]')
      : document.querySelector('#RentalProductForm input[name="quantity"]');
    var jotformSubmittedInput = document.getElementById('JotformSubmitted');
    var documentsReusedFromActiveRentalCart = false;
    var documentsSubmittedOnCurrentPage = false;
    var rentalEditDocumentsReusableConfirmed = false;
    var rentalEditDocumentValidationComplete = false;
    var rentalEditPageActions = null;
    var rentalEditWhatsappButton = null;
    var rentalEditUpdateButton = null;
    /* Document verification is intentionally independent from the 20-minute
       device/timeslot reservation. A successful upload gets one fixed 4-hour
       validity window that never extends when availability is refreshed or the
       rental is edited. */
    var RENTAL_DOCUMENT_VALIDITY_MINUTES = 240;
    var RENTAL_DOCUMENT_LEGACY_SESSION_MINUTES = 20;
    var RENTAL_DOCUMENT_GRACE_MINUTES = 30;
    var RENTAL_DOCUMENT_SUBMITTED_AT_KEY = 'playforceRentalDocumentSubmittedAt';
    var RENTAL_DOCUMENT_VALID_UNTIL_KEY = 'playforceRentalDocumentValidUntil';
    var RENTAL_DOCUMENT_GRACE_UNTIL_KEY = 'playforceRentalDocumentGraceUntil';
    var rentalDocumentSubmittedAtMs = 0;
    var rentalDocumentValidUntilMs = 0;
    var rentalDocumentTimestampPromise = null;
    var rentalDocumentRequiresFreshUpload = false;
    var jotformStatusNote = document.getElementById('JotformStatusNote');
    var requiredDocumentsHeading = document.getElementById('RentalRequiredDocumentsHeading');
    var requiredDocumentsStepNote = document.querySelector('.rental-step-note--documents');
    var rentalOptionsStepTitle = document.getElementById('RentalOptionsStepTitle');
    var rentalOptionsStepNote = document.querySelector('.rental-step-heading--options .rental-step-note');
    var requiredDocumentsPanel = document.getElementById('RentalRequiredDocumentsPanel');
    var documentsStepSection = document.getElementById('RentalDocumentsStepSection');
    var uploadDocumentsPanel = document.getElementById('RentalUploadDocumentsPanel');
    var requiredDocumentsOriginalParent = requiredDocumentsPanel ? requiredDocumentsPanel.parentNode : null;
    var requiredDocumentsOriginalNextSibling = requiredDocumentsPanel ? requiredDocumentsPanel.nextSibling : null;
    var rentalTermsOriginalParent = rentalTermsField ? rentalTermsField.parentNode : null;
    var rentalTermsOriginalNextSibling = rentalTermsField ? rentalTermsField.nextSibling : null;
    var submitButtonOriginalParent = submitButton ? submitButton.parentNode : null;
    var submitButtonOriginalNextSibling = submitButton ? submitButton.nextSibling : null;
    var mobileStandaloneReviewHost = null;
    var mobileFinalConfirmationCard = null;
    var mobileReviewLayoutApplied = false;
    var compatibilityPanel = document.querySelector('.rental-compatibility-panel');
    var rentalIncludesList = document.getElementById('RentalIncludesList');
    var rentalPortsList = document.getElementById('RentalPortsList');
    var compatibilitySelectedOptionEl = document.getElementById('RentalCompatibilitySelectedOption');
    var rentalProductTitle = String(rentalPageConfig.productTitle || '').toLowerCase();

    function renderRentalEditHydrationNote(locked) {
      if (!rentalOptionsStepNote) return;

      if (!locked) {
        rentalOptionsStepNote.textContent = 'Your existing rental is loaded below.';
        return;
      }

      // Reuse the exact calendar weekend-surcharge text colour so the loading
      // state is immediately noticeable without introducing another warning red.
      rentalOptionsStepNote.innerHTML =
        '<span class="rental-calendar-selected-cost-weekend" style="display:inline-flex;align-items:center;gap:7px;">' +
          '<span aria-hidden="true" style="display:inline-flex;width:13px;height:13px;flex:0 0 13px;">' +
            '<svg viewBox="0 0 16 16" width="13" height="13" focusable="false" aria-hidden="true" style="display:block;">' +
              '<circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" stroke-width="2" opacity="0.28"></circle>' +
              '<path d="M8 2a6 6 0 0 1 6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">' +
                '<animateTransform attributeName="transform" type="rotate" from="0 8 8" to="360 8 8" dur="0.7s" repeatCount="indefinite"></animateTransform>' +
              '</path>' +
            '</svg>' +
          '</span>' +
          '<span>Your saved rental is currently being loaded...</span>' +
        '</span>';
    }

    function ensureRentalEditHydrationDimStyles() {
      if (document.getElementById('RentalEditHydrationDimStyles')) return;

      var style = document.createElement('style');
      style.id = 'RentalEditHydrationDimStyles';
      style.textContent = [
        /* Deliberate loading treatment for every visible Step 1 control. */
        '#RentalProductForm[data-rental-edit-loading="true"] #RentalProcessorSelect,',
        '#RentalProductForm[data-rental-edit-loading="true"] #RentalPeriodSelect,',
        '#RentalProductForm[data-rental-edit-loading="true"] #RentalDeliveryTime,',
        '#RentalProductForm[data-rental-edit-loading="true"] #RentalReturnTime,',
        '#RentalProductForm[data-rental-edit-loading="true"] #RentalNotes,',
        '#RentalProductForm[data-rental-edit-loading="true"] #RentalStartDateDisplay,',
        '#RentalProductForm[data-rental-edit-loading="true"] #RentalCalendarRangeSummary,',
        '#RentalProductForm[data-rental-edit-loading="true"] .rental-processor-closed-display,',
        '#RentalProductForm[data-rental-edit-loading="true"] .rental-option-card,',
        '#RentalProductForm[data-rental-edit-loading="true"] .rental-addon-card {',
          'opacity:0.74 !important;',
          'filter:grayscale(0.18);',
          'transition:opacity .18s ease, filter .18s ease, background-color .18s ease, border-color .18s ease;',
        '}',

        /* Make the locked state read as intentionally unavailable, not washed out. */
        '#RentalProductForm[data-rental-edit-loading="true"] #RentalProcessorSelect,',
        '#RentalProductForm[data-rental-edit-loading="true"] #RentalPeriodSelect,',
        '#RentalProductForm[data-rental-edit-loading="true"] #RentalDeliveryTime,',
        '#RentalProductForm[data-rental-edit-loading="true"] #RentalReturnTime,',
        '#RentalProductForm[data-rental-edit-loading="true"] #RentalNotes,',
        '#RentalProductForm[data-rental-edit-loading="true"] #RentalStartDateDisplay,',
        '#RentalProductForm[data-rental-edit-loading="true"] .rental-processor-closed-display {',
          'background-color:#f3f5f7 !important;',
          'border-color:#d9dee6 !important;',
          'color:#7f8998 !important;',
          '-webkit-text-fill-color:#7f8998 !important;',
          'cursor:wait !important;',
        '}',
        '#RentalProductForm[data-rental-edit-loading="true"] #RentalNotes::placeholder {',
          'color:#99a2af !important;',
          'opacity:1 !important;',
        '}',
        '#RentalProductForm[data-rental-edit-loading="true"] .rental-addon-card,',
        '#RentalProductForm[data-rental-edit-loading="true"] .rental-option-card {',
          'background-color:#f5f6f8 !important;',
          'border-color:#dde2e9 !important;',
          'cursor:wait !important;',
        '}',

        /* Do not style the underlying checkbox/radio inputs here. The theme
           already hides them; leaving their native hiding rules untouched
           prevents the little square boxes from appearing. */

        '#RentalProductForm:not([data-rental-edit-loading="true"]) #RentalProcessorSelect,',
        '#RentalProductForm:not([data-rental-edit-loading="true"]) #RentalPeriodSelect,',
        '#RentalProductForm:not([data-rental-edit-loading="true"]) #RentalDeliveryTime,',
        '#RentalProductForm:not([data-rental-edit-loading="true"]) #RentalReturnTime,',
        '#RentalProductForm:not([data-rental-edit-loading="true"]) #RentalNotes,',
        '#RentalProductForm:not([data-rental-edit-loading="true"]) #RentalStartDateDisplay,',
        '#RentalProductForm:not([data-rental-edit-loading="true"]) #RentalCalendarRangeSummary,',
        '#RentalProductForm:not([data-rental-edit-loading="true"]) .rental-processor-closed-display,',
        '#RentalProductForm:not([data-rental-edit-loading="true"]) .rental-option-card,',
        '#RentalProductForm:not([data-rental-edit-loading="true"]) .rental-addon-card {',
          'transition:opacity .18s ease, filter .18s ease, background-color .18s ease, border-color .18s ease;',
        '}'
      ].join('');

      document.head.appendChild(style);
    }

    function setRentalEditHydrationLocked(locked) {
      if (!rentalEditRequestedGroupId) return;

      ensureRentalEditHydrationDimStyles();

      rentalEditHydrating = !!locked;

      // Lock the whole rental form without changing the controls' own disabled
      // state. This is important because stock/availability checks may disable
      // individual processors or extras while Edit Rental is loading.
      if (rentalForm) {
        if (locked) {
          rentalForm.setAttribute('aria-busy', 'true');
          rentalForm.setAttribute('data-rental-edit-loading', 'true');

          if ('inert' in rentalForm) {
            rentalForm.inert = true;
          } else {
            rentalForm.style.pointerEvents = 'none';
          }
        } else {
          rentalForm.removeAttribute('aria-busy');
          rentalForm.removeAttribute('data-rental-edit-loading');

          if ('inert' in rentalForm) {
            rentalForm.inert = false;
          } else {
            rentalForm.style.removeProperty('pointer-events');
          }
        }
      }

      if (priceBoxEl) {
        if (locked) {
          priceBoxEl.setAttribute('aria-busy', 'true');
        } else {
          priceBoxEl.removeAttribute('aria-busy');
        }
      }

      renderRentalEditHydrationNote(locked);
    }

    function finishRentalEditHydration() {
      if (!rentalEditModeActive) {
        setRentalEditHydrationLocked(false);
        return;
      }

      // Re-sync the dependent UI one final time while the form is still locked.
      // The customer only gets control after processor, extras, date range,
      // delivery/return options and pricing are all settled.
      preserveRestoredIpadConnectivityForEdit();
      updateIpadCellularModeAvailability();
      /* rebuildDeliveryOptions()/rebuildReturnOptions() now preserve the exact
         active-cart schedule until the customer changes the date/delivery. */
      rebuildDeliveryOptions();
      rebuildReturnOptions();
      syncRentalPeriodSelectFromRadio();
      syncRentalPeriodSelectDisabledOptions();
      syncRentalProcessorSelectFromRadio();
      syncRentalProcessorSelectDisabledOptions();
      updateSelectedCards();
      updateAddonCards();
      updateRentalInfoPanels();
      updateRentalEndInfo();
      updateTotal();
      setRentalStartDateDisplayText();

      setRentalEditHydrationLocked(false);
      setLoadingState(false);
    }

    /* Mask the Jotform footer branding inside the embedded document uploader.
       The iframe is cross-origin, so the Playforce page overlays its own white
       footer mask and pulls the verification notice upward over that area. */
    function ensureRentalJotformFooterMask() {
      var jotformFrame = document.getElementById('RentalJotform');
      if (!jotformFrame) return;

      var jotformUploadWrap = jotformFrame.closest('.rental-doc-upload');
      if (!jotformUploadWrap) return;

      var styleId = 'RentalJotformFooterMaskStyles';
      if (!document.getElementById(styleId)) {
        var maskStyles = document.createElement('style');
        maskStyles.id = styleId;
        maskStyles.textContent = [
          '.rental-doc-upload{position:relative!important;overflow:hidden!important;background:#fff!important;}',
          '.rental-jotform-footer-mask{position:absolute;left:0;right:0;bottom:0;height:62px;background:#fff;z-index:4;pointer-events:none;}',
          '#RentalUploadDocumentsPanel .rental-doc-status{position:relative;z-index:5;margin-top:-56px!important;margin-left:14px!important;margin-right:14px!important;padding:12px 8px 10px!important;background:#fff;}',
          '#RentalUploadDocumentsPanel .rental-documents-pill-content{padding-bottom:8px!important;}',
          '@media (max-width:749px){.rental-jotform-footer-mask{height:58px;}#RentalUploadDocumentsPanel .rental-doc-status{margin-top:-52px!important;padding-top:10px!important;padding-bottom:8px!important;}}'
        ].join('');
        document.head.appendChild(maskStyles);
      }

      if (!jotformUploadWrap.querySelector('.rental-jotform-footer-mask')) {
        var footerMask = document.createElement('div');
        footerMask.className = 'rental-jotform-footer-mask';
        footerMask.setAttribute('aria-hidden', 'true');
        jotformUploadWrap.appendChild(footerMask);
      }
    }

    var liveVariantPriceCentsById = {};
    var liveVariantPriceRequestById = {};

    function normaliseVariantId(value) {
      var numericId = Number(value);
      return Number.isFinite(numericId) && numericId > 0 ? String(Math.trunc(numericId)) : '';
    }


    /* Step 2 is intentionally always expanded on the review page.
       The inner Upload Documents / Document Upload Guide pills remain independently collapsible. */
    function ensureRequiredDocumentsStepLockedOpen() {
      if (!requiredDocumentsPanel) return;

      var stepIsVisible = !!(
        rentalReviewStageActive ||
        !documentsStepSection ||
        documentsStepSection.hidden === false
      );

      /* On Page 1, keep the hidden Step 2 details element closed.
         The older overview/documents accordion script treats an open
         Required Documents panel as mutually exclusive with the overview.
         Leaving it open while hidden caused the mobile overview to jerk
         open and immediately close again. */
      if (!stepIsVisible) {
        requiredDocumentsPanel.open = false;
        requiredDocumentsPanel.removeAttribute('data-rental-non-collapsible');

        var inactiveSummary = requiredDocumentsPanel.querySelector('.rental-documents-summary');
        if (inactiveSummary) {
          inactiveSummary.removeAttribute('tabindex');
          inactiveSummary.setAttribute('aria-expanded', 'false');
        }
        return;
      }

      requiredDocumentsPanel.open = true;
      requiredDocumentsPanel.setAttribute('data-rental-non-collapsible', 'true');

      var stepSummary = requiredDocumentsPanel.querySelector('.rental-documents-summary');
      if (stepSummary) {
        stepSummary.setAttribute('tabindex', '-1');
        stepSummary.setAttribute('aria-expanded', 'true');

        if (stepSummary.getAttribute('data-rental-lock-bound') !== 'true') {
          stepSummary.setAttribute('data-rental-lock-bound', 'true');

          stepSummary.addEventListener('click', function (event) {
            if (!rentalReviewStageActive) return;
            event.preventDefault();
            requiredDocumentsPanel.open = true;
          }, true);

          stepSummary.addEventListener('keydown', function (event) {
            if (!rentalReviewStageActive) return;
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              requiredDocumentsPanel.open = true;
            }
          }, true);
        }
      }

      if (requiredDocumentsPanel.getAttribute('data-rental-toggle-lock-bound') !== 'true') {
        requiredDocumentsPanel.setAttribute('data-rental-toggle-lock-bound', 'true');
        requiredDocumentsPanel.addEventListener('toggle', function () {
          if (!rentalReviewStageActive) return;

          if (!requiredDocumentsPanel.open) {
            requiredDocumentsPanel.open = true;
          }

          var activeSummary = requiredDocumentsPanel.querySelector('.rental-documents-summary');
          if (activeSummary) {
            activeSummary.setAttribute('aria-expanded', 'true');
          }
        });
      }

      var styleId = 'RentalReviewStepLockedStyles';
      if (!document.getElementById(styleId)) {
        var stepStyles = document.createElement('style');
        stepStyles.id = styleId;
        stepStyles.textContent = [
          '#RentalRequiredDocumentsPanel[data-rental-non-collapsible="true"] > .rental-documents-summary{cursor:default!important;}',
          '#RentalRequiredDocumentsPanel[data-rental-non-collapsible="true"] > .rental-documents-summary .rental-documents-chevron{display:none!important;}',
          '.rental-review-back-btn{font-size:0.90rem!important;}',
          '@media (max-width:749px){.rental-review-back-btn{font-size:0.86rem!important;}}'
        ].join('');
        document.head.appendChild(stepStyles);
      }
    }

    function parseLiveVariantPriceCents(variantData) {
      if (!variantData || typeof variantData !== 'object') return null;

      var rawPrice = variantData.price;

      if (typeof rawPrice === 'number') {
        return Number.isFinite(rawPrice) && rawPrice >= 0 ? Math.round(rawPrice) : null;
      }

      var priceText = String(rawPrice == null ? '' : rawPrice).replace(/,/g, '').trim();
      if (!priceText || !/^-?\d+(?:\.\d+)?$/.test(priceText)) return null;

      var numericPrice = Number(priceText);
      if (!Number.isFinite(numericPrice) || numericPrice < 0) return null;

      return priceText.indexOf('.') !== -1
        ? Math.round(numericPrice * 100)
        : Math.round(numericPrice);
    }

    function syncKnownLivePriceVariable(variantId, cents) {
      var key = normaliseVariantId(variantId);

      if (key === normaliseVariantId(weekendSurchargeVariantId)) weekendSurchargeCents = cents;
      if (key === normaliseVariantId(earlyDeliveryVariantId)) earlyDeliverySurchargeCents = cents;
      if (key === normaliseVariantId(standardUrgentChargeVariantId)) standardUrgentChargeCents = cents;
      if (key === normaliseVariantId(priorityUrgentChargeVariantId)) priorityUrgentChargeCents = cents;
      if (key === normaliseVariantId(standardReturnExtensionVariantId)) standardReturnExtensionCents = cents;
      if (key === normaliseVariantId(priorityReturnExtensionVariantId)) priorityReturnExtensionCents = cents;
      if (key === normaliseVariantId(memoryAddonVariantId)) memoryAddonCents = cents;
      if (key === normaliseVariantId(officeAddonVariantId)) officeAddonCents = cents;
      if (key === normaliseVariantId(appleMouseAddonVariantId)) appleMouseAddonCents = cents;
      if (key === normaliseVariantId(hdmiAddonVariantId)) hdmiAddonCents = cents;
      if (key === normaliseVariantId(pencilAddonVariantId)) pencilAddonCents = cents;
    }

    function cacheLiveVariantPrice(variantId, cents) {
      var key = normaliseVariantId(variantId);
      var numericCents = Number(cents);

      if (!key || !Number.isFinite(numericCents) || numericCents < 0) return null;

      liveVariantPriceCentsById[key] = Math.round(numericCents);
      syncKnownLivePriceVariable(key, liveVariantPriceCentsById[key]);
      return liveVariantPriceCentsById[key];
    }

    function getLiveVariantPriceCents(variantId) {
      var key = normaliseVariantId(variantId);
      if (!key || !Object.prototype.hasOwnProperty.call(liveVariantPriceCentsById, key)) {
        return null;
      }

      return liveVariantPriceCentsById[key];
    }

    function fetchLiveVariantPrice(variantId, forceRefresh) {
      var key = normaliseVariantId(variantId);
      if (!key) return Promise.reject(new Error('Invalid Shopify variant ID.'));

      if (!forceRefresh && Object.prototype.hasOwnProperty.call(liveVariantPriceCentsById, key)) {
        return Promise.resolve(liveVariantPriceCentsById[key]);
      }

      if (!forceRefresh && liveVariantPriceRequestById[key]) {
        return liveVariantPriceRequestById[key];
      }

      var request = fetch('/variants/' + encodeURIComponent(key) + '.js?rental_live_price=' + Date.now(), {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Cache-Control': 'no-cache'
        },
        cache: 'no-store'
      })
        .then(function (response) {
          setTrustedNowFromResponse(response);

          if (!response.ok) {
            throw new Error('Unable to read Shopify variant ' + key + '.');
          }

          return response.json();
        })
        .then(function (variantData) {
          if (!variantData || normaliseVariantId(variantData.id) !== key) {
            throw new Error('Shopify returned the wrong variant for ' + key + '.');
          }

          var cents = parseLiveVariantPriceCents(variantData);
          if (!Number.isFinite(cents)) {
            throw new Error('Shopify variant ' + key + ' returned an invalid price.');
          }

          return cacheLiveVariantPrice(key, cents);
        })
        .finally(function () {
          delete liveVariantPriceRequestById[key];
        });

      liveVariantPriceRequestById[key] = request;
      return request;
    }

    function uniqueVariantIds(values) {
      var seen = {};

      return (values || []).map(normaliseVariantId).filter(function (variantId) {
        if (!variantId || seen[variantId]) return false;
        seen[variantId] = true;
        return true;
      });
    }

    function loadLiveVariantPrices(variantIds, forceRefresh) {
      var ids = uniqueVariantIds(variantIds);

      return Promise.all(ids.map(function (variantId) {
        return fetchLiveVariantPrice(variantId, !!forceRefresh);
      }));
    }

    function loadLiveVariantPricesBestEffort(variantIds, forceRefresh) {
      var ids = uniqueVariantIds(variantIds);

      return Promise.all(ids.map(function (variantId) {
        return fetchLiveVariantPrice(variantId, !!forceRefresh).catch(function (error) {
          console.error('Live Shopify price lookup failed for variant ' + variantId + ':', error);
          return null;
        });
      }));
    }

    function setRentalPriceRowValue(row, variantId) {
      if (!row) return;

      var valueElement = row.querySelector('.rental-price-value');
      if (!valueElement) return;

      var cents = getLiveVariantPriceCents(variantId);
      valueElement.textContent = Number.isFinite(cents) ? formatMoney(cents) : 'Loading…';
    }

    function syncLiveVariantPriceRows() {
      setRentalPriceRowValue(surchargeRow, weekendSurchargeVariantId);
      setRentalPriceRowValue(earlyDeliveryRow, earlyDeliveryVariantId);
      setRentalPriceRowValue(priorityUrgentChargeRow, priorityUrgentChargeVariantId);
      setRentalPriceRowValue(standardUrgentChargeRow, standardUrgentChargeVariantId);
      setRentalPriceRowValue(standardReturnExtensionRow, standardReturnExtensionVariantId);
      setRentalPriceRowValue(priorityReturnExtensionRow, priorityReturnExtensionVariantId);
      setRentalPriceRowValue(memoryAddonRow, memoryAddonVariantId);
      setRentalPriceRowValue(officeAddonRow, officeAddonVariantId);
      setRentalPriceRowValue(appleMouseAddonRow, appleMouseAddonVariantId);
      setRentalPriceRowValue(hdmiAddonRow, hdmiAddonVariantId);
      if (cellularAddonRow) cellularAddonRow.style.display = 'none';
      setRentalPriceRowValue(pencilAddonRow, pencilAddonVariantId);
      syncReturnTimingOptionPrices();
    }

    function getInitialLivePriceVariantIds() {
      var ids = [
        variantIdInput ? variantIdInput.value : '',
        weekendSurchargeVariantId,
        earlyDeliveryVariantId,
        standardUrgentChargeVariantId,
        priorityUrgentChargeVariantId,
        standardReturnExtensionVariantId,
        priorityReturnExtensionVariantId
      ];

      if (memoryAddonInput) ids.push(memoryAddonVariantId);
      if (officeAddonInput) ids.push(officeAddonVariantId);
      if (appleMouseAddonInput) ids.push(appleMouseAddonVariantId);
      if (hdmiAddonInput) ids.push(hdmiAddonVariantId);
      if (pencilAddonInput) {
        pencilAddonVariantPriority.forEach(function (config) {
          ids.push(config.variantId);
        });
      }

      var depositConfig = getSecurityDepositConfig();
      if (depositConfig && depositConfig.variantId) ids.push(depositConfig.variantId);

      var selectedBusinessTierConfig = getSelectedDynamicDepositConfig();
      if (selectedBusinessTierConfig) {
        if (selectedBusinessTierConfig.variantId) {
          ids.push(selectedBusinessTierConfig.variantId);
        }
        if (selectedBusinessTierConfig.reducedVariantId) {
          ids.push(selectedBusinessTierConfig.reducedVariantId);
        }
      }

      ids = ids.concat(getSelectedModelRentalPeriodVariantIds());

      return uniqueVariantIds(ids);
    }

    function getRequiredLivePriceVariantIdsForCurrentSelection() {
      var ids = [
        variantIdInput ? variantIdInput.value : ''
      ];
      var depositConfig = getSecurityDepositConfig();

      if (depositConfig && depositConfig.variantId) ids.push(depositConfig.variantId);
      if (weekendApplied()) ids.push(weekendSurchargeVariantId);
      if (earlyDeliveryApplied()) ids.push(earlyDeliveryVariantId);
      if (priorityUrgentChargeApplied()) ids.push(priorityUrgentChargeVariantId);
      if (standardUrgentChargeApplied()) ids.push(standardUrgentChargeVariantId);
      if (standardReturnExtensionApplied()) ids.push(standardReturnExtensionVariantId);
      if (priorityReturnExtensionApplied()) ids.push(priorityReturnExtensionVariantId);
      if (memoryAddonApplied()) ids.push(memoryAddonVariantId);
      if (officeAddonApplied()) ids.push(officeAddonVariantId);
      if (appleMouseAddonApplied()) ids.push(appleMouseAddonVariantId);
      if (hdmiAddonApplied()) ids.push(hdmiAddonVariantId);
      if (pencilAddonApplied()) ids.push(pencilAddonVariantId);

      ids = ids.concat(getSelectedModelRentalPeriodVariantIds());

      return uniqueVariantIds(ids);
    }

    function applySelectedRentalVariantLivePrice() {
      if (!variantIdInput) return;

      var cents = getLiveVariantPriceCents(variantIdInput.value);
      if (Number.isFinite(cents)) {
        setBasePrice(cents);
      }
    }

    function refreshUiAfterLiveVariantPrices() {
      var selectedPeriodWasHidden = applyMinimumRentalPeriodRule();

      syncRentalPeriodSelectFromRadio();
      syncRentalPeriodSelectDisabledOptions();
      updateSelectedCards();

      if (!selectedPeriodWasHidden) {
        applySelectedRentalVariantLivePrice();
      }

      syncLiveVariantPriceRows();
      rebuildDeliveryOptions();
      updateRentalEndInfo();
      updateTotal();
    }

    function loadInitialLiveVariantPrices() {
      return loadLiveVariantPricesBestEffort(getInitialLivePriceVariantIds(), false)
        .then(function () {
          refreshUiAfterLiveVariantPrices();
        });
    }

    function loadSelectedVariantAndDepositPrices(forceRefresh) {
      var ids = [variantIdInput ? variantIdInput.value : ''];
      var depositConfig = getSecurityDepositConfig();

      if (depositConfig && depositConfig.variantId) ids.push(depositConfig.variantId);

      var selectedBusinessTierConfig = getSelectedDynamicDepositConfig();
      if (selectedBusinessTierConfig) {
        if (selectedBusinessTierConfig.variantId) {
          ids.push(selectedBusinessTierConfig.variantId);
        }
        if (selectedBusinessTierConfig.reducedVariantId) {
          ids.push(selectedBusinessTierConfig.reducedVariantId);
        }
      }

      ids = ids.concat(getSelectedModelRentalPeriodVariantIds());

      return loadLiveVariantPrices(uniqueVariantIds(ids), !!forceRefresh)
        .then(function () {
          refreshUiAfterLiveVariantPrices();
        });
    }

    function getSelectedOptions() {
      var selected = getRawSelectedOptions();
      var processorIndex = getRentalProcessorOptionIndex();

      if (isIpadRentalPage() && processorIndex >= 0) {
        var effectiveProcessor = getEffectiveIpadProcessorValue();
        if (effectiveProcessor) selected[processorIndex] = effectiveProcessor;
      }

      return selected;
    }

    function findMatchingVariant() {
      var selectedOptions = getSelectedOptions();

      return allVariants.find(function (variant) {
        return variant.options.every(function (optionValue, index) {
          return optionValue === selectedOptions[index];
        });
      });
    }

    function updateSelectedCards() {
      document.querySelectorAll('.rental-option-card').forEach(function (card) {
        card.classList.remove('is-selected');
      });

      document.querySelectorAll('.rental-option-radio:checked').forEach(function (input) {
        var card = input.closest('.rental-option-card');
        if (card) card.classList.add('is-selected');
      });
    }

    function updateAddonCards() {
      document.querySelectorAll('.rental-addon-card').forEach(function (card) {
        var input = card.querySelector('.rental-addon-checkbox');
        card.classList.toggle('is-selected', !!(input && input.checked));
      });

      if (isIpadRentalPage() && cellularAddonInput) {
        var cellularTitle = getCellularAddonTitleElement();
        if (cellularTitle) cellularTitle.textContent = 'Cellular';
      }
    }

    function dispatchRentalInputChange(input) {
      if (!input) return;

      if (typeof Event === 'function') {
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      var event = document.createEvent('Event');
      event.initEvent('change', true, true);
      input.dispatchEvent(event);
    }

    function normaliseMinimumRentalPeriodText(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
    }

    function getRentalPeriodComparableDays(value) {
      if (isCalendarPricingRentalPeriod(value)) return 0;

      var text = normaliseMinimumRentalPeriodText(value);
      var match = text.match(/(\d+)\s*(day|week|month)s?/i);

      if (!match) return 0;

      var amount = parseInt(match[1], 10);
      if (!isFinite(amount) || amount < 1) return 0;

      if (match[2].toLowerCase() === 'week') return amount * 7;
      if (match[2].toLowerCase() === 'month') return amount * 30;
      return amount;
    }

    function getSelectedProcessorDisplayValue() {
      var optionPosition = rentalProcessorSelect
        ? rentalProcessorSelect.getAttribute('data-option-position')
        : '';
      var checked = Array.prototype.find.call(optionInputs, function (input) {
        return input.getAttribute('data-option-position') === optionPosition && input.checked;
      });

      if (checked && checked.value) return String(checked.value).trim();

      if (rentalProcessorSelect && rentalProcessorSelect.value) {
        return String(rentalProcessorSelect.value).trim();
      }

      return '';
    }

    function getRentalOptionIndexFromSelect(selectElement) {
      if (!selectElement) return -1;

      var position = parseInt(selectElement.getAttribute('data-option-position'), 10);
      return Number.isFinite(position) && position > 0 ? position - 1 : -1;
    }

    function getSelectedModelRentalPeriodVariants() {
      var periodIndex = getRentalOptionIndexFromSelect(rentalPeriodSelect);
      var selectedOptions = getSelectedOptions();
      var recordsByPeriod = {};

      if (periodIndex < 0) return [];

      allVariants.forEach(function (variant) {
        if (!variant || !Array.isArray(variant.options)) return;

        var matchesSelectedModel = variant.options.every(function (optionValue, index) {
          if (index === periodIndex) return true;

          var selectedValue = selectedOptions[index];
          return !selectedValue || optionValue === selectedValue;
        });

        if (!matchesSelectedModel) return;

        var period = String(variant.options[periodIndex] || '').trim();
        if (isCalendarPricingRentalPeriod(period)) return;

        var days = getRentalPeriodComparableDays(period);
        var variantId = normaliseVariantId(variant.id);

        if (!period || !days || !variantId) return;

        var key = normaliseMinimumRentalPeriodText(period);
        if (!recordsByPeriod[key]) {
          recordsByPeriod[key] = {
            variant: variant,
            variantId: variantId,
            period: period,
            days: days
          };
        }
      });

      return Object.keys(recordsByPeriod)
        .map(function (key) { return recordsByPeriod[key]; })
        .sort(function (a, b) { return a.days - b.days; });
    }

    function getSelectedModelRentalPeriodVariantIds() {
      return getSelectedModelRentalPeriodVariants().map(function (record) {
        return record.variantId;
      });
    }

    function getRentalPeriodVariantPriceCents(record) {
      if (!record) return null;

      var livePrice = getLiveVariantPriceCents(record.variantId);
      if (Number.isFinite(livePrice)) return livePrice;

      return parseLiveVariantPriceCents(record.variant);
    }

    function getSelectedMinimumRentalPeriodRule() {
      var selectedModel = getSelectedProcessorDisplayValue();
      var records = getSelectedModelRentalPeriodVariants();

      if (!selectedModel || records.length < 2) return null;

      var firstPrice = getRentalPeriodVariantPriceCents(records[0]);
      if (!Number.isFinite(firstPrice)) return null;

      var longestMatchingIndex = 0;

      for (var index = 1; index < records.length; index += 1) {
        var currentPrice = getRentalPeriodVariantPriceCents(records[index]);

        if (!Number.isFinite(currentPrice)) return null;
        if (currentPrice !== firstPrice) break;

        longestMatchingIndex = index;
      }

      if (longestMatchingIndex === 0) return null;

      var minimumRecord = records[longestMatchingIndex];

      return {
        model: selectedModel,
        minimumPeriod: minimumRecord.period,
        minimumDays: minimumRecord.days,
        matchingPriceCents: firstPrice
      };
    }

    function applyMinimumRentalPeriodRule() {
      if (!rentalPeriodSelect) return false;

      removeLegacyRentalPeriodPriceNote();

      var periodRecords = getSelectedModelRentalPeriodVariants();
      var periodRecordByKey = {};

      periodRecords.forEach(function (record) {
        periodRecordByKey[normaliseMinimumRentalPeriodText(record.period)] = record;
      });

      var rule = getSelectedMinimumRentalPeriodRule();
      var minimumDays = rule && rule.minimumDays ? rule.minimumDays : 0;
      var selectedPeriodWasHidden = false;
      var optionPosition = getRentalPeriodSelectPosition();
      var selectedPeriodValue = rentalPeriodSelect.value;

      Array.prototype.forEach.call(optionInputs, function (input) {
        if (input.getAttribute('data-option-position') !== optionPosition) return;

        if (!input.hasAttribute('data-minimum-period-original-disabled')) {
          input.setAttribute(
            'data-minimum-period-original-disabled',
            input.disabled ? 'true' : 'false'
          );
        }

        var periodDays = getRentalPeriodComparableDays(input.value);
        var hideForMinimum = minimumDays > 0 && periodDays > 0 && periodDays < minimumDays;
        var originallyDisabled = input.getAttribute('data-minimum-period-original-disabled') === 'true';
        var card = input.closest('.rental-option-card');

        if (hideForMinimum && input.checked) {
          input.checked = false;
          selectedPeriodWasHidden = true;
        }

        input.disabled = originallyDisabled || hideForMinimum;
        input.setAttribute('data-minimum-period-hidden', hideForMinimum ? 'true' : 'false');

        if (card) {
          card.hidden = hideForMinimum;
          card.style.display = hideForMinimum ? 'none' : '';
          card.setAttribute('aria-hidden', hideForMinimum ? 'true' : 'false');
        }
      });

      rentalPeriodSelect.innerHTML = '';
      rentalPeriodOriginalOptions.forEach(function (optionRecord) {
        var option = optionRecord.option;
        var periodDays = getRentalPeriodComparableDays(option.value);
        var hideForMinimum = minimumDays > 0 && periodDays > 0 && periodDays < minimumDays;
        var periodRecord = periodRecordByKey[normaliseMinimumRentalPeriodText(option.value)];
        var livePriceCents = getRentalPeriodVariantPriceCents(periodRecord);
        var isDetectedMinimum = !!(
          rule &&
          periodRecord &&
          periodRecord.days === rule.minimumDays
        );
        var baseOptionText = String(optionRecord.originalText || option.value || '').trim();

        if (isDetectedMinimum) {
          option.textContent = baseOptionText + ' — Minimum for this model';
        } else {
          option.textContent = baseOptionText;
        }

        if (hideForMinimum) {
          if (option.value === selectedPeriodValue) selectedPeriodWasHidden = true;
          return;
        }

        option.disabled = !!optionRecord.originallyDisabled;
        rentalPeriodSelect.appendChild(option);
      });

      var replacementPeriodValue = '';

      if (selectedPeriodWasHidden) {
        var replacementInput = rule && rule.minimumPeriod
          ? findRentalPeriodRadioByValue(rule.minimumPeriod)
          : null;

        if (
          !replacementInput ||
          replacementInput.disabled ||
          replacementInput.getAttribute('data-minimum-period-hidden') === 'true'
        ) {
          replacementInput = Array.prototype.find.call(optionInputs, function (input) {
            return input.getAttribute('data-option-position') === optionPosition &&
              !input.disabled &&
              input.getAttribute('data-minimum-period-hidden') !== 'true';
          });
        }

        if (replacementInput) {
          replacementInput.checked = true;
          replacementPeriodValue = replacementInput.value;
          rentalPeriodSelect.value = replacementPeriodValue;

          var replacementVariant = findMatchingVariant();
          if (replacementVariant) {
            if (variantIdInput) variantIdInput.value = replacementVariant.id;

            var replacementLivePrice = getLiveVariantPriceCents(replacementVariant.id);
            if (basePriceEl) {
              setBasePrice(
                Number.isFinite(replacementLivePrice)
                  ? replacementLivePrice
                  : replacementVariant.price
              );
            }
          }
        } else {
          rentalPeriodSelect.value = '';
          if (variantIdInput) variantIdInput.value = '';
          if (basePriceEl) setBasePrice(0);
        }
      } else if (selectedPeriodValue) {
        rentalPeriodSelect.value = selectedPeriodValue;
      }

      var existingMinimumNote = document.getElementById('RentalMinimumPeriodNote');
      if (existingMinimumNote && existingMinimumNote.parentNode) {
        existingMinimumNote.parentNode.removeChild(existingMinimumNote);
      }

      return selectedPeriodWasHidden && !replacementPeriodValue;
    }

    function getRentalPeriodSelectPosition() {
      return rentalPeriodSelect ? rentalPeriodSelect.getAttribute('data-option-position') : '';
    }

    function findRentalPeriodRadioByValue(value) {
      var optionPosition = getRentalPeriodSelectPosition();

      return Array.prototype.find.call(optionInputs, function (input) {
        return input.getAttribute('data-option-position') === optionPosition && input.value === value;
      });
    }

    function syncRentalPeriodSelectFromRadio() {
      if (!rentalPeriodSelect) return;

      var optionPosition = getRentalPeriodSelectPosition();
      var checked = Array.prototype.find.call(optionInputs, function (input) {
        return input.getAttribute('data-option-position') === optionPosition && input.checked;
      });

      if (checked) {
        rentalPeriodSelect.value = checked.value;
      }
    }

    function syncRentalPeriodSelectDisabledOptions() {
      if (!rentalPeriodSelect) return;

      Array.prototype.forEach.call(rentalPeriodSelect.options, function (option) {
        var matchingRadio = findRentalPeriodRadioByValue(option.value);
        option.disabled = !!(matchingRadio && matchingRadio.disabled);
      });
    }

    function handleRentalPeriodSelectChange() {
      if (!rentalPeriodSelect) return;

      var matchingRadio = findRentalPeriodRadioByValue(rentalPeriodSelect.value);
      if (!matchingRadio || matchingRadio.disabled) {
        syncRentalPeriodSelectFromRadio();
        return;
      }

      matchingRadio.checked = true;
      dispatchRentalInputChange(matchingRadio);
    }

    function ensureLegacyRentalPeriodSelection() {
      if (!rentalPeriodSelect) return;

      var optionPosition = getRentalPeriodSelectPosition();
      var checked = Array.prototype.find.call(optionInputs, function (input) {
        return input.getAttribute('data-option-position') === optionPosition &&
          input.checked &&
          !isCalendarPricingRentalPeriod(input.value);
      });

      if (checked) {
        rentalPeriodSelect.value = checked.value;
        return;
      }

      var fallbackOption = Array.prototype.find.call(rentalPeriodSelect.options, function (option) {
        return !option.disabled && !isCalendarPricingRentalPeriod(option.value);
      });

      if (!fallbackOption) return;

      rentalPeriodSelect.value = fallbackOption.value;

      var fallbackRadio = findRentalPeriodRadioByValue(fallbackOption.value);
      if (fallbackRadio) fallbackRadio.checked = true;
    }

    function getRentalProcessorSelectPosition() {
      return rentalProcessorSelect ? rentalProcessorSelect.getAttribute('data-option-position') : '';
    }

    function findRentalProcessorRadioByValue(value) {
      var optionPosition = getRentalProcessorSelectPosition();

      return Array.prototype.find.call(optionInputs, function (input) {
        return input.getAttribute('data-option-position') === optionPosition && input.value === value;
      });
    }

    function syncRentalProcessorSelectFromRadio() {
      if (!rentalProcessorSelect) return;

      var optionPosition = getRentalProcessorSelectPosition();
      var checked = Array.prototype.find.call(optionInputs, function (input) {
        return input.getAttribute('data-option-position') === optionPosition && input.checked;
      });

      if (checked) {
        rentalProcessorSelect.value = checked.value;
      }

      updateRentalProcessorClosedDisplay();
    }

    function syncRentalProcessorSelectDisabledOptions() {
      if (!rentalProcessorSelect) return;

      Array.prototype.forEach.call(rentalProcessorSelect.options, function (option) {
        var matchingRadio = findRentalProcessorRadioByValue(option.value);
        var unavailable = !!(matchingRadio && matchingRadio.disabled);
        var hiddenByReservationFlag = !!(
          matchingRadio &&
          matchingRadio.getAttribute('data-rental-reservation-hidden') === 'true'
        );
        var isCustomerFacingIpadProcessor = !!(
          isIpadRentalPage() &&
          String(option.value || '').trim() &&
          !isIpadCellularProcessorValue(option.value)
        );
        var hideUnavailableIpadProcessor = isCustomerFacingIpadProcessor && unavailable;
        var shouldHideOption = hideUnavailableIpadProcessor || hiddenByReservationFlag;

        option.disabled = unavailable;
        option.setAttribute('aria-disabled', unavailable ? 'true' : 'false');

        option.hidden = shouldHideOption;
        if (shouldHideOption) {
          option.style.display = 'none';
          option.setAttribute('aria-hidden', 'true');
        } else if (!isIpadCellularProcessorValue(option.value)) {
          option.style.removeProperty('display');
          option.removeAttribute('aria-hidden');
        }
      });

      updateProcessorAvailabilityNote();
    }

    function handleRentalProcessorSelectChange() {
      if (!rentalProcessorSelect) return;

      updateRentalProcessorClosedDisplay();

      var matchingRadio = findRentalProcessorRadioByValue(rentalProcessorSelect.value);
      if (!matchingRadio || matchingRadio.disabled) {
        syncRentalProcessorSelectFromRadio();
        return;
      }

      matchingRadio.checked = true;
      dispatchRentalInputChange(matchingRadio);
    }

    function getTapPoint(event) {
      var touch = event.changedTouches && event.changedTouches.length
        ? event.changedTouches[0]
        : null;

      return {
        x: touch ? touch.clientX : event.clientX,
        y: touch ? touch.clientY : event.clientY
      };
    }

    var cellularUnavailableNoticeTimer = null;
    var memoryUnavailableNoticeTimer = null;

    function showCellularUnavailableNotice() {
      if (!cellularAddonInput || !isIpadRentalPage()) return;

      var card = cellularAddonInput.closest('.rental-addon-card');
      var addonList = card ? card.closest('.rental-addon-list') : null;
      if (!addonList) return;

      var notice = document.getElementById('IpadCellularUnavailableNotice');

      if (!notice) {
        notice = document.createElement('div');
        notice.id = 'IpadCellularUnavailableNotice';
        notice.setAttribute('role', 'status');
        notice.setAttribute('aria-live', 'polite');
        notice.textContent = 'Cellular is unavailable for this iPad model.';
        notice.style.marginTop = '8px';
        notice.style.fontSize = '12px';
        notice.style.lineHeight = '1.4';
        notice.style.fontWeight = '500';
        notice.style.color = '#b42318';
        notice.style.opacity = '0';
        notice.style.transition = 'opacity 160ms ease';
        addonList.insertAdjacentElement('afterend', notice);
      }

      if (cellularUnavailableNoticeTimer) {
        window.clearTimeout(cellularUnavailableNoticeTimer);
        cellularUnavailableNoticeTimer = null;
      }

      notice.hidden = false;
      window.requestAnimationFrame(function () {
        notice.style.opacity = '1';
      });

      cellularUnavailableNoticeTimer = window.setTimeout(function () {
        notice.style.opacity = '0';

        window.setTimeout(function () {
          notice.hidden = true;
        }, 180);
      }, 2600);
    }

    function getBusinessMemoryUnavailableNoticeText() {
      var businessProcessorText = String(getSelectedProcessorText() || '').toLowerCase();

      if (businessProcessorText.indexOf('lg gram 16') !== -1) {
        return '32GB Memory is unavailable for LG Gram 16.';
      }

      if (
        businessProcessorText.indexOf('ultra 5') !== -1 ||
        (businessProcessorText.indexOf('ryzen 5') !== -1 &&
          /(^|[^a-z0-9])new([^a-z0-9]|$)/i.test(businessProcessorText))
      ) {
        return '32GB Memory is unavailable for Ultra 5/Ryzen 5 (New) model.';
      }

      return '32GB Memory is unavailable for i5/Ryzen 5 model.';
    }

    function showMemoryUnavailableNotice() {
      if (!memoryAddonInput || rentalProductTitle.indexOf('business laptop rental') === -1) return;

      var card = memoryAddonInput.closest('.rental-addon-card');
      var addonList = card ? card.closest('.rental-addon-list') : null;
      if (!addonList) return;

      var notice = document.getElementById('BusinessMemoryUnavailableNotice');

      if (!notice) {
        notice = document.createElement('div');
        notice.id = 'BusinessMemoryUnavailableNotice';
        notice.setAttribute('role', 'status');
        notice.setAttribute('aria-live', 'polite');
        notice.style.marginTop = '8px';
        notice.style.fontSize = '12px';
        notice.style.lineHeight = '1.4';
        notice.style.fontWeight = '500';
        notice.style.color = '#b42318';
        notice.style.opacity = '0';
        notice.style.transition = 'opacity 160ms ease';
        addonList.insertAdjacentElement('afterend', notice);
      }

      notice.textContent = getBusinessMemoryUnavailableNoticeText();

      if (memoryUnavailableNoticeTimer) {
        window.clearTimeout(memoryUnavailableNoticeTimer);
        memoryUnavailableNoticeTimer = null;
      }

      notice.hidden = false;
      window.requestAnimationFrame(function () {
        notice.style.opacity = '1';
      });

      memoryUnavailableNoticeTimer = window.setTimeout(function () {
        notice.style.opacity = '0';

        window.setTimeout(function () {
          notice.hidden = true;
        }, 180);
      }, 2600);
    }

    function bindRentalCardSingleTap(card, input, isCheckbox) {
      if (!card || !input || card.getAttribute('data-rental-tap-bound') === 'true') return;

      var startPoint = null;
      var lastTouchActivation = 0;
      var lastUnavailableNotice = 0;

      function rememberTapStart(event) {
        startPoint = getTapPoint(event);
      }

      function movedTooMuch(event) {
        if (!startPoint) return false;

        var point = getTapPoint(event);
        if (typeof point.x !== 'number' || typeof point.y !== 'number') return false;

        return Math.abs(point.x - startPoint.x) > 12 || Math.abs(point.y - startPoint.y) > 12;
      }

      function activateCard(event) {
        var now = Date.now();

        if (event.type === 'click' && now - lastTouchActivation < 700) {
          event.preventDefault();
          return;
        }

        if ((event.type === 'pointerup' || event.type === 'touchend') && movedTooMuch(event)) {
          return;
        }

        if (event.cancelable) {
          event.preventDefault();
        }

        if (input.disabled || card.classList.contains('is-rental-stock-unavailable')) {
          if (
            isCheckbox &&
            input === cellularAddonInput &&
            isIpadRentalPage() &&
            input.disabled
          ) {
            if (event.type === 'pointerup' || event.type === 'touchend') {
              lastTouchActivation = now;
            }

            if (now - lastUnavailableNotice >= 700) {
              lastUnavailableNotice = now;
              showCellularUnavailableNotice();
            }
          } else if (
            isCheckbox &&
            input === memoryAddonInput &&
            rentalProductTitle.indexOf('business laptop rental') !== -1 &&
            input.disabled
          ) {
            if (event.type === 'pointerup' || event.type === 'touchend') {
              lastTouchActivation = now;
            }

            if (now - lastUnavailableNotice >= 700) {
              lastUnavailableNotice = now;
              showMemoryUnavailableNotice();
            }
          }
          return;
        }

        if (event.type === 'pointerup' || event.type === 'touchend') {
          lastTouchActivation = now;
        }

        if (isCheckbox) {
          if (input.getAttribute('data-cellular-forced') === 'true') {
            return;
          }

          input.checked = !input.checked;
          updateAddonCards();
          dispatchRentalInputChange(input);
          return;
        }

        if (!input.checked) {
          input.checked = true;
          dispatchRentalInputChange(input);
        }
      }

      card.setAttribute('data-rental-tap-bound', 'true');

      if (window.PointerEvent) {
        card.addEventListener('pointerdown', rememberTapStart, { passive: true });
        card.addEventListener('pointerup', activateCard);
      } else {
        card.addEventListener('touchstart', rememberTapStart, { passive: true });
        card.addEventListener('touchend', activateCard, { passive: false });
      }

      card.addEventListener('click', activateCard);
    }

    function bindRentalCardTapHandlers() {
      document.querySelectorAll('.rental-option-card').forEach(function (card) {
        bindRentalCardSingleTap(card, card.querySelector('.rental-option-radio'), false);
      });

      document.querySelectorAll('.rental-addon-card').forEach(function (card) {
        bindRentalCardSingleTap(card, card.querySelector('.rental-addon-checkbox'), true);
      });
    }

    function formatMoney(cents) {
      var numericCents = Number(cents);
      if (!Number.isFinite(numericCents)) numericCents = 0;

      return '$' + (numericCents / 100).toLocaleString('en-SG', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }

    function formatFinalRentalTotalMoney(cents) {
      var numericCents = Number(cents);
      if (!Number.isFinite(numericCents)) numericCents = 0;

      return 'S$' + (numericCents / 100).toLocaleString('en-SG', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }

    function formatCompactMoney(cents) {
      var numericCents = Number(cents);
      if (!Number.isFinite(numericCents)) return '';

      var amount = numericCents / 100;
      return '$' + amount.toLocaleString('en-SG', {
        minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
        maximumFractionDigits: 2
      });
    }

    function stripDeliveryChargeSuffix(value) {
      return String(value || '')
        .replace(/\s*\((?:Early Delivery|Priority Urgent Delivery|Standard Urgent Delivery|Priority Urgent Charge|Standard Urgent Charge)(?:\s+\+\$[\d,]+(?:\.\d{1,2})?)?\)\s*$/i, '')
        .trim();
    }

    function formatTimingOptionChargeLabel(baseLabel, chargeLabel, cents) {
      var price = formatCompactMoney(cents);
      return baseLabel + ' (' + chargeLabel + (price ? ' +' + price : '') + ')';
    }

    function syncReturnTimingOptionPrices() {
      if (!returnTimeInput) return;

      Array.prototype.forEach.call(returnTimeInput.options, function (option) {
        if (option.value === '9pm–11pm') {
          option.textContent = formatTimingOptionChargeLabel(
            '9pm–11pm',
            'Extended-Hours Return',
            priorityReturnExtensionCents
          );
        }
      });
    }

    function getBasePrice() {
      return parseInt(basePriceEl.getAttribute('data-base-price'), 10) || 0;
    }

    function setBasePrice(cents) {
      basePriceEl.setAttribute('data-base-price', String(cents));
      basePriceEl.textContent = formatMoney(cents);
      removeLegacyRentalPeriodPriceNote();
    }

    /*
      PlayTime is the single operational-control source for rental timing.

      Shopify product description fields:
      Same-day rental closed: yes / no
      Same-day order cutoff: null / HH:MM
      Weekend rentals closed: yes / no
      Weekend same-day order cutoff: null / HH:MM
      Blocked rental dates: null / 'DD-MMM-YYYY to DD-MMM-YYYY'

      Blocked date ranges are inclusive and apply to rental START dates only.
      Rentals may span across or return on blocked dates.
    */
    var playTimeConfig = {
      loaded: false,
      sameDayClosed: false,
      sameDayOrderCutoffMinutes: null,
      weekendRentalsClosed: false,
      weekendSameDayOrderCutoffMinutes: null,
      blockedRentalRanges: []
    };


    function ensurePlayTimeBlockedCalendarStyles() {
      if (document.getElementById('PlayTimeBlockedCalendarStyles')) return;

      var style = document.createElement('style');
      style.id = 'PlayTimeBlockedCalendarStyles';
      style.textContent = [
        '.rental-mobile-calendar-day.is-blocked{',
          'pointer-events:auto!important;',
          'cursor:not-allowed!important;',
        '}',

        /*
          A blocked Start Date that sits inside an already-selected rental
          range must still look like part of that rental period. Only the date
          and its price are softened; the range background is untouched.
        */
        '.rental-mobile-calendar-day.is-preserved-range-blocked .rental-calendar-date-number,',
        '.rental-mobile-calendar-day.is-preserved-range-blocked .rental-calendar-price-preview{',
          'opacity:.42!important;',
        '}',

        '#RentalCalendarSelectedCost.rental-calendar-selected-cost-blocked,',
        '#RentalCalendarSelectedCostMobile.rental-calendar-selected-cost-blocked{',
          'color:#c62828!important;',
          'font-weight:600;',
          'line-height:1.45;',
          'text-align:center;',
          'white-space:pre-line;',
          'display:block!important;',
          'padding:8px 14px 10px;',
          'min-height:46px;',
          'box-sizing:border-box;',
        '}'
      ].join('');

      document.head.appendChild(style);
    }

    var playTimeBlockedStartWarningMessage = '';

    function clearPlayTimeBlockedStartWarning() {
      playTimeBlockedStartWarningMessage = '';

      [rentalCalendarSelectedCost, rentalCalendarSelectedCostMobile].forEach(
        function (target) {
          if (!target) return;
          target.classList.remove('rental-calendar-selected-cost-blocked');
        }
      );
    }

    function renderPlayTimeBlockedStartWarning() {
      if (!playTimeBlockedStartWarningMessage) return false;

      [rentalCalendarSelectedCost, rentalCalendarSelectedCostMobile].forEach(
        function (target) {
          if (!target) return;

          target.textContent = playTimeBlockedStartWarningMessage;
          target.classList.add('rental-calendar-selected-cost-blocked');
          target.hidden = false;
        }
      );

      if (dateError) {
        dateError.textContent = '';
        dateError.hidden = true;
      }

      return true;
    }

    function getPlayTimeBlockedCalendarMessage(dateString) {
      var range = getPlayTimeBlockedRangeForDate(dateString);
      var label = formatPlayTimeBlockedRangeLabel(range);

      if (label) {
        return 'Start dates ' + label + ' are blocked.\nPick another starting date.';
      }

      return 'This start date is blocked.\nPick another starting date.';
    }

    function getPlayTimeBlockedRangeForDate(dateString) {
      if (
        !dateString ||
        !playTimeConfig ||
        !Array.isArray(playTimeConfig.blockedRentalRanges)
      ) {
        return null;
      }

      for (var index = 0; index < playTimeConfig.blockedRentalRanges.length; index += 1) {
        var range = playTimeConfig.blockedRentalRanges[index];
        if (!range || !range.start || !range.end) continue;

        if (dateString >= range.start && dateString <= range.end) {
          return range;
        }
      }

      return null;
    }

    function formatPlayTimeBlockedRangeLabel(range) {
      if (!range || !range.start || !range.end) return '';

      var startParts = String(range.start).split('-');
      var endParts = String(range.end).split('-');
      if (startParts.length !== 3 || endParts.length !== 3) return '';

      var monthNames = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];

      var startYear = Number(startParts[0]);
      var startMonth = Number(startParts[1]);
      var startDay = Number(startParts[2]);
      var endYear = Number(endParts[0]);
      var endMonth = Number(endParts[1]);
      var endDay = Number(endParts[2]);

      if (
        !startYear || !startMonth || !startDay ||
        !endYear || !endMonth || !endDay
      ) {
        return '';
      }

      if (startYear === endYear && startMonth === endMonth) {
        if (startDay === endDay) {
          return startDay + ' ' + monthNames[startMonth - 1];
        }

        return startDay + '–' + endDay + ' ' + monthNames[startMonth - 1];
      }

      if (startYear === endYear) {
        return (
          startDay + ' ' + monthNames[startMonth - 1] +
          '–' +
          endDay + ' ' + monthNames[endMonth - 1]
        );
      }

      return (
        startDay + ' ' + monthNames[startMonth - 1] + ' ' + startYear +
        '–' +
        endDay + ' ' + monthNames[endMonth - 1] + ' ' + endYear
      );
    }

    function getPlayTimeSelectedRangeBlockedStartMessage(dateString) {
      var range = getPlayTimeBlockedRangeForDate(dateString);
      var label = formatPlayTimeBlockedRangeLabel(range);

      if (!label) {
        return getPlayTimeBlockedCalendarMessage(dateString);
      }

      return (
        'Start dates ' + label + ' are blocked.\n' +
        'Pick another starting date.'
      );
    }

    function showPlayTimeBlockedCalendarMessage(customMessage) {
      playTimeBlockedStartWarningMessage =
        customMessage || getPlayTimeBlockedCalendarMessage();

      if (renderPlayTimeBlockedStartWarning()) {
        return;
      }

      showRentalStartDateError(playTimeBlockedStartWarningMessage);
    }

    ensurePlayTimeBlockedCalendarStyles();

    function getRentalStartDateMaxString() {
      var singaporeNow = getSingaporeNowParts();
      return singaporeNow.year + '-12-31';
    }

    function isDateWithinPlayTimeBlockedRange(dateString) {
      if (!dateString || !playTimeConfig || !Array.isArray(playTimeConfig.blockedRentalRanges)) {
        return false;
      }

      for (var index = 0; index < playTimeConfig.blockedRentalRanges.length; index += 1) {
        var range = playTimeConfig.blockedRentalRanges[index];
        if (!range || !range.start || !range.end) continue;

        if (dateString >= range.start && dateString <= range.end) {
          return true;
        }
      }

      return false;
    }

    function isRentalStartDateBlocked(dateString) {
      return isDateWithinPlayTimeBlockedRange(dateString);
    }


    function isWeekend(dateString) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(String(dateString || ''))) return false;

      var parts = String(dateString).split('-');
      var date = new Date(Date.UTC(
        Number(parts[0]),
        Number(parts[1]) - 1,
        Number(parts[2])
      ));
      var day = date.getUTCDay();

      return day === 0 || day === 6;
    }

    function weekendRentalStartClosed(dateString) {
      return !!(
        playTimeConfig &&
        playTimeConfig.loaded &&
        playTimeConfig.weekendRentalsClosed &&
        isWeekend(dateString)
      );
    }

    function rentalStartDateOperationallyBlocked(dateString) {
      return isRentalStartDateBlocked(dateString) || weekendRentalStartClosed(dateString);
    }

    function getRentalStartDateInvalidReason(dateString) {
      if (!dateString) return 'empty';

      var selected = parseLocalDate(dateString);
      var minDate = parseLocalDate(getRentalStartDateMinimumString());
      var maxDate = parseLocalDate(getRentalStartDateMaxString());
      if (!selected || !minDate || !maxDate) return 'invalid';

      if (selected < minDate) {
        /* An active Edit Rental is reopening a slot that is already reserved
           in the cart. Do not invalidate that saved start date merely because
           the clock crossed a same-day / next-day cutoff after it was added.
           Manual PlayTime closures, blocked dates and an expired cart still
           fail closed through rentalEditStoredStartDateMayRemain(). */
        if (rentalEditStoredStartDateMayRemain(dateString)) {
          // Continue into the blocked-date / weekend checks below.
        } else {
          if (dateString === getSingaporeTodayString()) {
            return getPlayTimeSameDayClosureReason() || 'same-day-closed';
          }

          return 'past';
        }
      }

      if (selected > maxDate) return 'out-of-year';
      if (isRentalStartDateBlocked(dateString)) return 'blocked';
      if (weekendRentalStartClosed(dateString)) return 'weekend-closed';

      return '';
    }

    function getRentalStartDateErrorMessage(dateString) {
      var reason = getRentalStartDateInvalidReason(dateString);

      if (reason === 'blocked') {
        return 'This rental start date has been blocked out. Please choose another available date.';
      }

      if (reason === 'out-of-year') {
        return 'Please choose a rental start date within this calendar year.';
      }

      if (reason === 'same-day-unavailable') {
        
        if (getSelectedSecurityDepositLeadDays() > 0) return '';
        return 'Same-day rental is currently unavailable online. Please select the next available date or contact us on WhatsApp.';
      }

      if (reason === 'same-day-manually-closed') {
        if (getSelectedSecurityDepositLeadDays() > 0) return '';
        return 'Same-day rental is unavailable today. Please select the next day.';
      }

      if (reason === 'same-day-cutoff') {
        if (getSelectedSecurityDepositLeadDays() > 0) return '';
        return 'Same-day order cutoff has passed. Please select the next day.';
      }

      if (reason === 'weekend-same-day-cutoff') {
        if (getSelectedSecurityDepositLeadDays() > 0) return '';
        return 'Weekend same-day order cutoff has passed. Please select the next available date.';
      }

      if (reason === 'weekend-closed') {
        return 'Weekend rental starts are unavailable. Please choose another available date.';
      }

      if (reason === 'same-day-closed') {
        
        if (getSelectedSecurityDepositLeadDays() > 0) return '';
        return 'Same-day rental is only available before 5pm. Please select the next day.';
      }

      if (reason === 'past') {
        return 'Please choose a valid rental start date.';
      }

      if (reason === 'empty') {
        return '';
      }

      if (reason === 'invalid') {
        return 'Please choose a valid rental start date.';
      }

      return '';
    }

    function showRentalStartDateError(message) {
      if (!dateError) return;
      dateError.textContent = message || 'Please choose a valid rental start date.';
      dateError.hidden = false;
    }

    function isInvalidDate(dateString) {
      return !!getRentalStartDateInvalidReason(dateString);
    }

    function getTomorrowString() {
      return getRentalStartDateMinimumString();
    }

    function isIOSDatePickerDevice() {
      var userAgent = window.navigator.userAgent || '';
      var platform = window.navigator.platform || '';
      var maxTouchPoints = window.navigator.maxTouchPoints || 0;

      return /iPad|iPhone|iPod/i.test(userAgent) || (platform === 'MacIntel' && maxTouchPoints > 1);
    }

    function getMonthStart(date) {
      return new Date(date.getFullYear(), date.getMonth(), 1);
    }

    function sameCalendarDay(firstDate, secondDate) {
      if (!firstDate || !secondDate) return false;
      return firstDate.getFullYear() === secondDate.getFullYear()
        && firstDate.getMonth() === secondDate.getMonth()
        && firstDate.getDate() === secondDate.getDate();
    }

    function setRentalStartDateDisplayText() {
      if (!rentalStartDateDisplayText || !startDateInput) return;

      var selectedDate = parseLocalDate(startDateInput.value);
      rentalStartDateDisplayText.textContent = selectedDate
        ? formatDisplayDate(selectedDate)
        : 'Select rental start date';
    }

    function rentalCalendarMobileFullscreenMode() {
      return !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
    }

    function formatRentalCalendarHeaderDate(date) {
      if (!date) return '';
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return String(date.getDate()).padStart(2, '0') + ' ' + months[date.getMonth()] + ' ' + date.getFullYear();
    }

    function updateRentalCalendarMobileSelectionSummary() {
      var startDate = parseLocalDate(startDateInput ? startDateInput.value : '');
      var endDate = parseLocalDate(rentalEndDateInput ? rentalEndDateInput.value : '');
      var selectingEnd = !!(
        startDate &&
        !rentalCalendarStartReselectMode &&
        (!endDate || rentalCalendarReturnReselectMode)
      );

      if (rentalCalendarSelectionStartValue) {
        rentalCalendarSelectionStartValue.textContent = startDate ? formatRentalCalendarHeaderDate(startDate) : 'Select date';
        rentalCalendarSelectionStartValue.classList.toggle('is-placeholder', !startDate);
      }

      if (rentalCalendarSelectionEndValue) {
        rentalCalendarSelectionEndValue.textContent = endDate ? formatRentalCalendarHeaderDate(endDate) : 'Select date';
        rentalCalendarSelectionEndValue.classList.toggle('is-placeholder', !endDate);
      }

      if (rentalCalendarSelectionStart) {
        rentalCalendarSelectionStart.classList.toggle('is-active', !selectingEnd);

        var canReselectStartDate = !!(
          rentalCalendarMobileFullscreenMode() &&
          startDate
        );

        rentalCalendarSelectionStart.classList.toggle('is-reselectable', canReselectStartDate);
        if (canReselectStartDate) {
          rentalCalendarSelectionStart.setAttribute('role', 'button');
          rentalCalendarSelectionStart.setAttribute('tabindex', '0');
          rentalCalendarSelectionStart.setAttribute('aria-label', 'Reselect rental start date');
          rentalCalendarSelectionStart.style.cursor = 'pointer';
        } else {
          rentalCalendarSelectionStart.removeAttribute('role');
          rentalCalendarSelectionStart.removeAttribute('tabindex');
          rentalCalendarSelectionStart.removeAttribute('aria-label');
          rentalCalendarSelectionStart.style.cursor = '';
        }
      }

      if (rentalCalendarSelectionEnd) {
        rentalCalendarSelectionEnd.classList.toggle('is-active', selectingEnd);

        var canReselectReturnDate = !!(
          rentalCalendarMobileFullscreenMode() &&
          startDate &&
          endDate
        );

        rentalCalendarSelectionEnd.classList.toggle('is-reselectable', canReselectReturnDate);
        if (canReselectReturnDate) {
          rentalCalendarSelectionEnd.setAttribute('role', 'button');
          rentalCalendarSelectionEnd.setAttribute('tabindex', '0');
          rentalCalendarSelectionEnd.setAttribute('aria-label', 'Reselect return date');
          rentalCalendarSelectionEnd.style.cursor = 'pointer';
        } else {
          rentalCalendarSelectionEnd.removeAttribute('role');
          rentalCalendarSelectionEnd.removeAttribute('tabindex');
          rentalCalendarSelectionEnd.removeAttribute('aria-label');
          rentalCalendarSelectionEnd.style.cursor = '';
        }
      }

      if (rentalMobileCalendarDone) {
        var rangeComplete = !!(startDate && endDate);
        rentalMobileCalendarDone.hidden = !rangeComplete;
        rentalMobileCalendarDone.disabled = !rangeComplete;
        rentalMobileCalendarDone.classList.toggle('is-disabled', !rangeComplete);
      }
    }

    function setRentalMobileCalendarOpen(isOpen) {
      if (!rentalMobileCalendar || !rentalStartDateDisplay) return;

      if (isOpen) {
        rentalMobileCalendar.hidden = false;
        rentalStartDateDisplay.setAttribute('aria-expanded', 'true');
        if (rentalCalendarMobileFullscreenMode()) {
          document.body.classList.add('rental-calendar-mobile-open');
          window.setTimeout(function () {
            rentalMobileCalendar.scrollTop = 0;
          }, 0);
        }
        updateRentalCalendarMobileSelectionSummary();
        renderRentalMobileCalendar();
      } else {
        rentalMobileCalendar.hidden = true;
        rentalStartDateDisplay.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('rental-calendar-mobile-open');
        rentalCalendarReturnReselectMode = false;
        rentalCalendarStartReselectMode = false;
        updateRentalCalendarMobileSelectionSummary();
      }
    }

    function enterRentalCalendarReturnReselectMode() {
      if (!rentalCalendarMobileFullscreenMode()) return;

      var startDate = parseLocalDate(startDateInput ? startDateInput.value : '');
      var endDate = parseLocalDate(rentalEndDateInput ? rentalEndDateInput.value : '');
      if (!startDate || !endDate) return;

      rentalCalendarStartReselectMode = false;
      rentalCalendarReturnReselectMode = true;
      if (dateError) dateError.hidden = true;

      if (rentalMobileCalendar && rentalMobileCalendar.hidden) {
        prepareRentalCalendarView();
        setRentalMobileCalendarOpen(true);
        return;
      }

      updateRentalCalendarMobileSelectionSummary();
      renderRentalMobileCalendar();
    }

    function enterRentalCalendarStartReselectMode() {
      if (!rentalCalendarMobileFullscreenMode()) return;

      var startDate = parseLocalDate(startDateInput ? startDateInput.value : '');
      if (!startDate) return;

      rentalCalendarReturnReselectMode = false;
      rentalCalendarStartReselectMode = true;
      if (dateError) dateError.hidden = true;

      if (rentalMobileCalendar && rentalMobileCalendar.hidden) {
        prepareRentalCalendarView();
        setRentalMobileCalendarOpen(true);
        return;
      }

      updateRentalCalendarMobileSelectionSummary();
      renderRentalMobileCalendar();
    }

    function setupCustomRentalDatePicker() {
      if (!useCustomRentalDatePicker || !startDateInput || !rentalStartDateDisplay || !rentalMobileCalendar) return;

      var root = document.querySelector('.rental-product-page');
      if (root) {
        root.classList.add('is-custom-rental-datepicker');
      }

      rentalStartDateDisplay.hidden = false;
      startDateInput.setAttribute('aria-hidden', 'true');
      startDateInput.setAttribute('tabindex', '-1');
      setRentalStartDateDisplayText();
      updateRentalCalendarMobileSelectionSummary();
      renderRentalMobileCalendar();
    }

    function prepareRentalCalendarView() {
      refreshRentalStartDateMinimum(true);

      var calendarDefaultDate = parseLocalDate(startDateInput.value) || parseLocalDate(getTomorrowString());
      var calendarMaxDate = parseLocalDate(getRentalStartDateMaxString());

      if (calendarDefaultDate && calendarMaxDate && calendarDefaultDate > calendarMaxDate) {
        calendarDefaultDate = calendarMaxDate;
      }

      rentalMobileCalendarViewDate = getMonthStart(calendarDefaultDate);
    }

    function openRentalStartDateCalendar() {
      if (!useCustomRentalDatePicker || !rentalMobileCalendar) return;

      prepareRentalCalendarView();
      setRentalMobileCalendarOpen(true);

      if (rentalStartDateDisplay) {
        rentalStartDateDisplay.focus({ preventScroll: true });
      }
    }

    function toggleRentalStartDateCalendar() {
      if (!useCustomRentalDatePicker || !rentalMobileCalendar) return;

      prepareRentalCalendarView();
      setRentalMobileCalendarOpen(rentalMobileCalendar.hidden);
    }

    function renderRentalMobileCalendar() {
      if (!useCustomRentalDatePicker || !startDateInput || !rentalMobileCalendarGrid || !rentalMobileCalendarTitle) return;

      var minDate = parseLocalDate(getTomorrowString());
      var maxDate = parseLocalDate(getRentalStartDateMaxString());
      var selectedDate = parseLocalDate(startDateInput.value);
      var noAvailableDates = !!(minDate && maxDate && minDate > maxDate);
      var minMonthStart = getMonthStart(noAvailableDates ? maxDate : minDate);
      var maxMonthStart = getMonthStart(maxDate);
      var preferredDate = selectedDate || (noAvailableDates ? maxDate : minDate);

      if (!rentalMobileCalendarViewDate) {
        rentalMobileCalendarViewDate = getMonthStart(preferredDate);
      }

      rentalMobileCalendarViewDate = getMonthStart(rentalMobileCalendarViewDate);

      if (rentalMobileCalendarViewDate < minMonthStart) {
        rentalMobileCalendarViewDate = minMonthStart;
      }

      if (rentalMobileCalendarViewDate > maxMonthStart) {
        rentalMobileCalendarViewDate = maxMonthStart;
      }

      var viewYear = rentalMobileCalendarViewDate.getFullYear();
      var viewMonth = rentalMobileCalendarViewDate.getMonth();
      var monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];

      rentalMobileCalendarTitle.textContent = monthNames[viewMonth] + ' ' + viewYear;
      rentalMobileCalendarGrid.innerHTML = '';

      var firstDay = new Date(viewYear, viewMonth, 1);
      var leadingEmptyDays = firstDay.getDay();
      var daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();

      for (var blankIndex = 0; blankIndex < leadingEmptyDays; blankIndex += 1) {
        var blankCell = document.createElement('span');
        blankCell.className = 'rental-mobile-calendar-empty';
        rentalMobileCalendarGrid.appendChild(blankCell);
      }

      for (var dayNumber = 1; dayNumber <= daysInMonth; dayNumber += 1) {
        (function (day) {
          var dayDate = new Date(viewYear, viewMonth, day);
          dayDate.setHours(0, 0, 0, 0);

          var dayDateString = formatDateProperty(dayDate);
          var invalidReason = noAvailableDates ? 'unavailable' : getRentalStartDateInvalidReason(dayDateString);
          var disabled = !!invalidReason;
          var selected = selectedDate && sameCalendarDay(dayDate, selectedDate);
          var dayButton = document.createElement('button');

          dayButton.type = 'button';
          dayButton.className = 'rental-mobile-calendar-day';
          dayButton.textContent = String(day);

          if (disabled) {
            dayButton.setAttribute('aria-disabled', 'true');
            dayButton.setAttribute('tabindex', '-1');
            dayButton.classList.add('is-disabled');

            if (invalidReason === 'blocked') {
              dayButton.classList.add('is-blocked');
              dayButton.setAttribute('aria-label', dayDateString + ' blocked out');
            } else if (invalidReason === 'past') {
              dayButton.classList.add('is-past');
              dayButton.setAttribute('aria-label', dayDateString + ' unavailable');
            } else if (invalidReason === 'out-of-year') {
              dayButton.classList.add('is-out-of-year');
              dayButton.setAttribute('aria-label', dayDateString + ' outside this calendar year');
            }

            dayButton.addEventListener('click', function () {
              var blockedMessage = invalidReason === 'unavailable'
                ? 'There are no available rental start dates left within this calendar year.'
                : getRentalStartDateErrorMessage(dayDateString);
              showRentalStartDateError(blockedMessage);
            });
          } else {
            dayButton.addEventListener('click', function () {
              clearPlayTimeBlockedStartWarning();
              startDateInput.value = dayDateString;
              setRentalStartDateDisplayText();
              setRentalMobileCalendarOpen(false);
              if (dateError) dateError.hidden = true;
              dispatchRentalInputChange(startDateInput);
            });
          }

          if (selected) {
            dayButton.classList.add('is-selected');
            dayButton.setAttribute('aria-current', 'date');
          }

          rentalMobileCalendarGrid.appendChild(dayButton);
        })(dayNumber);
      }

      if (rentalMobileCalendarGrid) {
        rentalMobileCalendarGrid.onmouseleave = function () {
          if (!selectingEnd || !rentalCalendarSupportsHoverPreview()) return;
          clearRentalCalendarHoverPreview();
          updateRentalCalendarInstruction();
        };
      }

      if (rentalMobileCalendarPrev) {
        var previousMonthStart = new Date(viewYear, viewMonth - 1, 1);
        var previousDisabled = noAvailableDates || previousMonthStart < minMonthStart;
        rentalMobileCalendarPrev.disabled = previousDisabled;
        rentalMobileCalendarPrev.classList.toggle('is-disabled', previousDisabled);
      }

      if (rentalMobileCalendarNext) {
        var nextMonthStart = new Date(viewYear, viewMonth + 1, 1);
        var nextDisabled = noAvailableDates || nextMonthStart > maxMonthStart;
        rentalMobileCalendarNext.disabled = nextDisabled;
        rentalMobileCalendarNext.classList.toggle('is-disabled', nextDisabled);
      }
    }

    function changeRentalCalendarMonth(monthOffset) {
      if (!rentalMobileCalendarViewDate) {
        var defaultCalendarDate = parseLocalDate(startDateInput.value) || parseLocalDate(getTomorrowString());
        var maxCalendarDate = parseLocalDate(getRentalStartDateMaxString());
        if (defaultCalendarDate && maxCalendarDate && defaultCalendarDate > maxCalendarDate) {
          defaultCalendarDate = maxCalendarDate;
        }
        rentalMobileCalendarViewDate = getMonthStart(defaultCalendarDate);
      }

      rentalMobileCalendarViewDate = new Date(
        rentalMobileCalendarViewDate.getFullYear(),
        rentalMobileCalendarViewDate.getMonth() + monthOffset,
        1
      );

      renderRentalMobileCalendar();
    }

    function refreshRentalStartDateMinimum(clearInvalidValue) {
      if (!startDateInput) return '';

      var minDateString = getTomorrowString();
      var maxDateString = getRentalStartDateMaxString();

      startDateInput.setAttribute('min', minDateString);
      startDateInput.min = minDateString;
      startDateInput.setAttribute('max', maxDateString);
      startDateInput.max = maxDateString;
      startDateInput.setAttribute('step', '1');

      if (clearInvalidValue && startDateInput.value && isInvalidDate(startDateInput.value)) {
        startDateInput.value = '';
      }

      return minDateString;
    }

    function rejectInvalidRentalStartDateSelection() {
      if (!startDateInput || !startDateInput.value || !isInvalidDate(startDateInput.value)) {
        return false;
      }

      var errorMessage = getRentalStartDateErrorMessage(startDateInput.value);
      startDateInput.value = '';
      setRentalStartDateDisplayText();

      if (errorMessage) {
        showRentalStartDateError(errorMessage);
      } else if (dateError) {
        dateError.textContent = '';
        dateError.hidden = true;
      }

      if (submitButton) {
        submitButton.disabled = false;
        submitButton.classList.remove('is-disabled');
      }

      return true;
    }

    function weekendApplied() {
      var selectedDate = startDateInput ? startDateInput.value : '';
      return !!(selectedDate && !isInvalidDate(selectedDate) && isWeekend(selectedDate));
    }

    var playTimeVariantId = 48122982531259;
    var playTimeProductHandle = 'playtime';
    var playTimeSameDayEnabled = initialPlayTimeSameDayEnabled;
    var playTimeStatusLoaded = initialPlayTimeStatusLoaded;
    var trustedNowBaseMs = initialServerRenderedAtMs > 0 ? initialServerRenderedAtMs : 0;
    var trustedPerformanceBaseMs = trustedNowBaseMs > 0 ? performance.now() : 0;

    function rentalPlayTimeTestingOverrideEnabled() {
      return !!(RENTAL_TEST_CONTROLS_ENABLED && rentalTestSameDayCheckoutAllowed);
    }

    function getEffectivePlayTimeSameDayCutoff() {
      var today = getSingaporeTodayString();
      var weekendToday = isWeekend(today);

      /*
        Weekend cutoff overrides the general same-day cutoff when supplied.
        If weekend cutoff is null, the general same-day cutoff still applies.
      */
      if (
        weekendToday &&
        Number.isFinite(playTimeConfig.weekendSameDayOrderCutoffMinutes)
      ) {
        return {
          minutes: playTimeConfig.weekendSameDayOrderCutoffMinutes,
          reason: 'weekend-same-day-cutoff'
        };
      }

      if (Number.isFinite(playTimeConfig.sameDayOrderCutoffMinutes)) {
        return {
          minutes: playTimeConfig.sameDayOrderCutoffMinutes,
          reason: 'same-day-cutoff'
        };
      }

      return {
        minutes: null,
        reason: ''
      };
    }

    function getPlayTimeSameDayClosureReason() {
      if (rentalPlayTimeTestingOverrideEnabled()) return '';

      if (!playTimeStatusLoaded || !playTimeSameDayEnabled || !playTimeConfig.loaded) {
        return 'same-day-unavailable';
      }

      if (playTimeConfig.sameDayClosed) {
        return 'same-day-manually-closed';
      }

      if (
        playTimeConfig.weekendRentalsClosed &&
        isWeekend(getSingaporeTodayString())
      ) {
        return 'weekend-closed';
      }

      var cutoff = getEffectivePlayTimeSameDayCutoff();
      if (
        Number.isFinite(cutoff.minutes) &&
        getCurrentSingaporeMinutes() >= cutoff.minutes
      ) {
        return cutoff.reason;
      }

      if (getCurrentSingaporeMinutes() >= (17 * 60)) {
        return 'same-day-closed';
      }

      return '';
    }

    function rentalSameDayCheckoutFeatureEnabled() {
      return !getPlayTimeSameDayClosureReason();
    }

    function rentalDocumentBypassTestingEnabled() {
      return !!(
        RENTAL_TEST_CONTROLS_ENABLED &&
        rentalTestDocumentsBypassAllowed
      );
    }

    var nextDayCutoffHourSingapore = 19;
    var nextDayCutoffMinuteSingapore = 0;

    var originalDeliveryOptions = deliveryTimeInput
      ? Array.prototype.map.call(deliveryTimeInput.options, function (option) {
          return {
            value: option.value,
            text: option.textContent
          };
        })
      : [];

    var originalReturnOptions = returnTimeInput
      ? Array.prototype.map.call(returnTimeInput.options, function (option) {
          return {
            value: option.value,
            text: option.textContent
          };
        })
      : [];

    function setTrustedNowFromResponse(response) {
      if (!response || !response.headers) return;

      var serverDateHeader = response.headers.get('Date');
      var serverNowMs = Date.parse(serverDateHeader || '');

      if (!isNaN(serverNowMs)) {
        trustedNowBaseMs = serverNowMs;
        trustedPerformanceBaseMs = performance.now();
      }
    }

    function getTrustedNowMs() {
      if (trustedNowBaseMs && trustedPerformanceBaseMs) {
        return trustedNowBaseMs + (performance.now() - trustedPerformanceBaseMs);
      }

      return Date.now();
    }

    function getAvailabilityNowMs() {
      
      var leadDays = getSelectedSecurityDepositLeadDays();
      return getTrustedNowMs() + (leadDays * 24 * 60 * 60 * 1000);
    }

    function getSingaporeNowParts() {

      var singaporeNow = new Date(getAvailabilityNowMs() + (8 * 60 * 60 * 1000));
      var hour = singaporeNow.getUTCHours();
      var minute = singaporeNow.getUTCMinutes();

      if (
        RENTAL_TEST_CONTROLS_ENABLED &&
        rentalTestSameDayCheckoutAllowed &&
        Number.isFinite(rentalTestSingaporeMinutes)
      ) {
        hour = Math.floor(rentalTestSingaporeMinutes / 60);
        minute = rentalTestSingaporeMinutes % 60;
      }

      return {
        year: singaporeNow.getUTCFullYear(),
        month: singaporeNow.getUTCMonth() + 1,
        day: singaporeNow.getUTCDate(),
        hour: hour,
        minute: minute
      };
    }

    function getSingaporeReferencePartsForLeadDays(leadDays) {
      var referenceDate = new Date(
        getTrustedNowMs() +
        (Math.max(0, Number(leadDays) || 0) * 24 * 60 * 60 * 1000) +
        (8 * 60 * 60 * 1000)
      );
      var hour = referenceDate.getUTCHours();
      var minute = referenceDate.getUTCMinutes();

      if (
        RENTAL_TEST_CONTROLS_ENABLED &&
        rentalTestSameDayCheckoutAllowed &&
        Number.isFinite(rentalTestSingaporeMinutes)
      ) {
        hour = Math.floor(rentalTestSingaporeMinutes / 60);
        minute = rentalTestSingaporeMinutes % 60;
      }

      return {
        year: referenceDate.getUTCFullYear(),
        month: referenceDate.getUTCMonth() + 1,
        day: referenceDate.getUTCDate(),
        hour: hour,
        minute: minute
      };
    }

    /* ============================================================
       RENTAL TEST CONTROLS UI — TEMPORARY
       Search "RENTAL TEST CONTROLS" to remove this entire feature.
       ============================================================ */
    function parseRentalTestSingaporeTime(value) {
      var digits = String(value || '').replace(/\D/g, '').slice(0, 4);
      if (digits.length !== 4) return null;

      var hour = parseInt(digits.slice(0, 2), 10);
      var minute = parseInt(digits.slice(2, 4), 10);

      if (!Number.isFinite(hour) || !Number.isFinite(minute)) return null;
      if (hour < 0 || hour > 23 || minute < 0 || minute > 59) return null;

      return (hour * 60) + minute;
    }

    function formatRentalTestTime(minutes) {
      if (!Number.isFinite(minutes)) return '';
      var hour = Math.floor(minutes / 60);
      var minute = minutes % 60;
      return String(hour).padStart(2, '0') + String(minute).padStart(2, '0');
    }

    function getCurrentRealSingaporeTimeForTesting() {
      var now = new Date(getTrustedNowMs() + (8 * 60 * 60 * 1000));
      return (now.getUTCHours() * 60) + now.getUTCMinutes();
    }

    function refreshRentalUiAfterTestingChange() {
      if (typeof refreshPlayTimeDependentUi === 'function') {
        refreshPlayTimeDependentUi(true);
      }
      if (typeof rebuildReturnOptions === 'function') {
        rebuildReturnOptions();
      }
      if (typeof updateTotal === 'function') {
        updateTotal();
      }
      if (typeof updateRentalEndInfo === 'function') {
        updateRentalEndInfo();
      }
    }

    function initialiseRentalTestControls() {
      if (!RENTAL_TEST_CONTROLS_ENABLED || document.getElementById('RentalTestControls')) return;

      var style = document.createElement('style');
      style.id = 'RentalTestControlsStyles';
      style.textContent = [
        '#RentalTestControls{position:fixed;left:16px;bottom:16px;z-index:2147483646;width:292px;max-width:calc(100vw - 32px);padding:12px 13px;border:1px solid rgba(16,42,92,.18);border-radius:12px;background:rgba(255,255,255,.97);box-shadow:0 10px 30px rgba(14,35,76,.18);font-family:inherit;color:#102a5c;pointer-events:auto!important;touch-action:manipulation;}',
        '#RentalTestControls *{box-sizing:border-box;}',
        '#RentalTestControls .rental-test-title{margin:0 0 9px;font-size:11px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;color:#6c7890;}',
        '#RentalTestControls .rental-test-row{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:7px 0;font-size:12px;font-weight:700;line-height:1.3;}',
        '#RentalTestControls .rental-test-row + .rental-test-row{border-top:1px solid rgba(16,42,92,.08);}',
        '#RentalTestControls .rental-test-switch{position:relative;display:inline-flex;align-items:center;justify-content:center;flex:0 0 42px;width:42px;height:26px;margin:0;padding:0;border:0;background:transparent;-webkit-appearance:none;appearance:none;cursor:pointer;pointer-events:auto!important;touch-action:manipulation;-webkit-tap-highlight-color:transparent;}',
        '#RentalTestControls .rental-test-slider{position:absolute;inset:2px 0;border-radius:999px;background:#cbd3df;pointer-events:none;transition:.18s ease;}',
        '#RentalTestControls .rental-test-slider:before{content:"";position:absolute;width:16px;height:16px;left:3px;top:3px;border-radius:50%;background:#fff;box-shadow:0 1px 4px rgba(0,0,0,.2);transition:.18s ease;}',
        '#RentalTestControls .rental-test-switch.is-on .rental-test-slider{background:#1550ad;}',
        '#RentalTestControls .rental-test-switch.is-on .rental-test-slider:before{transform:translateX(20px);}',
        '#RentalTestControls .rental-test-time{display:none;margin:3px 0 7px;padding:8px 9px;border-radius:9px;background:#f5f8fc;}',
        '#RentalTestControls.is-sameday-on .rental-test-time{display:block;}',
        '#RentalTestControls .rental-test-time-label{display:block;margin-bottom:5px;font-size:11px;font-weight:700;color:#5d6980;}',
        '#RentalTestControls .rental-test-time-input{width:92px;height:34px;padding:0 8px;border:1px solid #bec8d7;border-radius:7px;background:#fff;color:#102a5c;font:700 13px/1 inherit;letter-spacing:.08em;}',
        '#RentalTestControls .rental-test-time-input.is-invalid{border-color:#c62828;outline:1px solid #c62828;}',
        '#RentalTestControls .rental-test-time-note{display:inline-block;margin-left:7px;font-size:10px;font-weight:600;color:#768197;}',
        '@media(max-width:749px){#RentalTestControls{left:10px;bottom:10px;width:270px;max-width:calc(100vw - 20px);padding:10px 11px;}#RentalTestControls .rental-test-row{font-size:11px;}}'
      ].join('');
      document.head.appendChild(style);

      var panel = document.createElement('div');
      panel.id = 'RentalTestControls';
      panel.setAttribute('aria-label', 'Rental testing controls');
      panel.innerHTML =
        '<div class="rental-test-title">Testing Controls</div>' +
        '<div class="rental-test-row">' +
          '<span>Same-day checkout allowed</span>' +
          '<button type="button" class="rental-test-switch" id="RentalTestSameDayToggle" role="switch" aria-checked="false" aria-label="Toggle same-day checkout testing">' +
            '<span class="rental-test-slider" aria-hidden="true"></span>' +
          '</button>' +
        '</div>' +
        '<div class="rental-test-time" id="RentalTestTimeWrap">' +
          '<label class="rental-test-time-label" for="RentalTestTimeInput">Simulated SG Time (24-hour)</label>' +
          '<input class="rental-test-time-input" id="RentalTestTimeInput" type="text" inputmode="numeric" autocomplete="off" maxlength="5" placeholder="1400">' +
          '<span class="rental-test-time-note">e.g. 1400 = 2pm</span>' +
        '</div>' +
        '<div class="rental-test-row">' +
          '<span>Without submission of documents allowed</span>' +
          '<button type="button" class="rental-test-switch" id="RentalTestDocumentsToggle" role="switch" aria-checked="false" aria-label="Toggle document submission bypass testing">' +
            '<span class="rental-test-slider" aria-hidden="true"></span>' +
          '</button>' +
        '</div>';

      document.body.appendChild(panel);

      var sameDayToggle = document.getElementById('RentalTestSameDayToggle');
      var documentsToggle = document.getElementById('RentalTestDocumentsToggle');
      var timeInput = document.getElementById('RentalTestTimeInput');

      panel.addEventListener('click', function (event) {
        event.stopPropagation();
      });

      panel.addEventListener('touchstart', function (event) {
        event.stopPropagation();
      }, { passive: true });

      function applyTestingTime() {
        var parsed = parseRentalTestSingaporeTime(timeInput.value);
        var valid = Number.isFinite(parsed);

        timeInput.classList.toggle('is-invalid', !valid);

        if (valid) {
          rentalTestSingaporeMinutes = parsed;
          timeInput.value = formatRentalTestTime(parsed);
        }

        return valid;
      }

      sameDayToggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        rentalTestSameDayCheckoutAllowed = !rentalTestSameDayCheckoutAllowed;
        sameDayToggle.classList.toggle('is-on', rentalTestSameDayCheckoutAllowed);
        sameDayToggle.setAttribute('aria-checked', rentalTestSameDayCheckoutAllowed ? 'true' : 'false');
        panel.classList.toggle('is-sameday-on', rentalTestSameDayCheckoutAllowed);

        if (rentalTestSameDayCheckoutAllowed) {
          if (!Number.isFinite(parseRentalTestSingaporeTime(timeInput.value))) {
            rentalTestSingaporeMinutes = getCurrentRealSingaporeTimeForTesting();
            timeInput.value = formatRentalTestTime(rentalTestSingaporeMinutes);
          } else {
            applyTestingTime();
          }
        } else {
          rentalTestSingaporeMinutes = null;
          timeInput.classList.remove('is-invalid');
        }

        refreshRentalUiAfterTestingChange();
      });

      timeInput.addEventListener('input', function () {
        var cleaned = String(timeInput.value || '').replace(/[^\d:]/g, '').slice(0, 5);
        if (timeInput.value !== cleaned) timeInput.value = cleaned;

        var parsed = parseRentalTestSingaporeTime(cleaned);
        var complete = String(cleaned).replace(/\D/g, '').length === 4;

        if (!complete) {
          timeInput.classList.remove('is-invalid');
          return;
        }

        if (!Number.isFinite(parsed)) {
          timeInput.classList.add('is-invalid');
          return;
        }

        rentalTestSingaporeMinutes = parsed;
        timeInput.classList.remove('is-invalid');

        if (rentalTestSameDayCheckoutAllowed) {
          refreshRentalUiAfterTestingChange();
        }
      });

      timeInput.addEventListener('change', function () {
        if (!applyTestingTime()) return;
        if (rentalTestSameDayCheckoutAllowed) {
          refreshRentalUiAfterTestingChange();
        }
      });

      timeInput.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        if (!applyTestingTime()) return;
        timeInput.blur();
        if (rentalTestSameDayCheckoutAllowed) {
          refreshRentalUiAfterTestingChange();
        }
      });

      documentsToggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        rentalTestDocumentsBypassAllowed = !rentalTestDocumentsBypassAllowed;
        documentsToggle.classList.toggle('is-on', rentalTestDocumentsBypassAllowed);
        documentsToggle.setAttribute('aria-checked', rentalTestDocumentsBypassAllowed ? 'true' : 'false');
      });
    }

    function formatSingaporeReferenceDateString(leadDays, additionalDays) {
      var reference = getSingaporeReferencePartsForLeadDays(leadDays);
      var date = new Date(Date.UTC(
        reference.year,
        reference.month - 1,
        reference.day + (additionalDays || 0)
      ));

      return date.getUTCFullYear() + '-' +
        String(date.getUTCMonth() + 1).padStart(2, '0') + '-' +
        String(date.getUTCDate()).padStart(2, '0');
    }

    function getFirstSelectableRentalDateForLeadDays(leadDays) {
      var reference = getSingaporeReferencePartsForLeadDays(leadDays);
      var referenceMinutes = (reference.hour * 60) + reference.minute;

      var startOffsetDays = rentalSameDayCheckoutFeatureEnabled() && referenceMinutes < (17 * 60)
        ? 0
        : 1;
      var candidateDate = formatSingaporeReferenceDateString(leadDays, startOffsetDays);
      var candidate = parseLocalDate(candidateDate);
      var referenceYearEnd = new Date(reference.year, 11, 31);

      while (candidate && candidate <= referenceYearEnd && rentalStartDateOperationallyBlocked(candidateDate)) {
        candidate.setDate(candidate.getDate() + 1);
        candidateDate = candidate.getFullYear() + '-' +
          String(candidate.getMonth() + 1).padStart(2, '0') + '-' +
          String(candidate.getDate()).padStart(2, '0');
      }

      return candidate && candidate <= referenceYearEnd ? candidateDate : '';
    }

    function formatSecurityDepositAvailabilityDate(dateString) {
      var date = parseLocalDate(dateString);
      var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      if (!date) return '';

      return String(date.getDate()) + ' ' + monthNames[date.getMonth()];
    }

    function getProcessorOptionBaseLabel(option) {
      if (!option) return '';

      if (isIpadRentalPage() && String(option.value || '').trim()) {
        option.dataset.rentalBaseLabel = getBaseIpadProcessorValue(option.value);
        return option.dataset.rentalBaseLabel;
      }

      if (!option.dataset.rentalBaseLabel) {
        option.dataset.rentalBaseLabel = String(option.textContent || '')
          .replace(/\s+—\s+(?:(?:Available from|Earliest start)\s+.+|Unavailable|(?:Cellular|Wi-?Fi)\s+only(?:,\s+earliest start\s+.+)?|Wi-?Fi\s+(?:available(?: now)?|from\s+[^·]+|unavailable)\s+·\s+Cellular\s+(?:available(?: now)?|from\s+.+|unavailable)|WiFi:\s*[^·]+\s+·\s+Cellular:\s*.+)$/i, '')
          .trim();
      }

      return option.dataset.rentalBaseLabel;
    }

    function isRentalProcessorMobileLabelMode() {
      if (!window.matchMedia) return window.innerWidth <= 749;
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function captureRentalProcessorOverlayStyles() {
      if (!rentalProcessorSelect || rentalProcessorSelectOriginalOverlayStyles) return;

      var parent = rentalProcessorSelect.parentElement;
      rentalProcessorSelectOriginalOverlayStyles = {
        selectPosition: rentalProcessorSelect.style.position || '',
        selectZIndex: rentalProcessorSelect.style.zIndex || '',
        selectOpacity: rentalProcessorSelect.style.opacity || '',
        selectColor: rentalProcessorSelect.style.color || '',
        selectWebkitTextFillColor: rentalProcessorSelect.style.webkitTextFillColor || '',
        selectBackgroundColor: rentalProcessorSelect.style.backgroundColor || '',
        selectCaretColor: rentalProcessorSelect.style.caretColor || '',
        selectPointerEvents: rentalProcessorSelect.style.pointerEvents || '',
        selectCursor: rentalProcessorSelect.style.cursor || '',
        parentPosition: parent ? (parent.style.position || '') : ''
      };
    }

    function restoreRentalProcessorOverlayStyles() {
      if (!rentalProcessorSelect || !rentalProcessorSelectOriginalOverlayStyles) return;

      var parent = rentalProcessorSelect.parentElement;
      rentalProcessorSelect.style.position = rentalProcessorSelectOriginalOverlayStyles.selectPosition;
      rentalProcessorSelect.style.zIndex = rentalProcessorSelectOriginalOverlayStyles.selectZIndex;
      rentalProcessorSelect.style.opacity = rentalProcessorSelectOriginalOverlayStyles.selectOpacity;
      rentalProcessorSelect.style.color = rentalProcessorSelectOriginalOverlayStyles.selectColor;
      rentalProcessorSelect.style.webkitTextFillColor = rentalProcessorSelectOriginalOverlayStyles.selectWebkitTextFillColor;
      rentalProcessorSelect.style.backgroundColor = rentalProcessorSelectOriginalOverlayStyles.selectBackgroundColor;
      rentalProcessorSelect.style.caretColor = rentalProcessorSelectOriginalOverlayStyles.selectCaretColor;
      rentalProcessorSelect.style.pointerEvents = rentalProcessorSelectOriginalOverlayStyles.selectPointerEvents;
      rentalProcessorSelect.style.cursor = rentalProcessorSelectOriginalOverlayStyles.selectCursor;

      if (parent) {
        parent.style.position = rentalProcessorSelectOriginalOverlayStyles.parentPosition;
      }
    }

    function positionRentalProcessorClosedDisplay() {
      if (!rentalProcessorClosedDisplay || !rentalProcessorSelect) return;

      var parent = rentalProcessorSelect.parentElement;
      if (!parent) return;

      captureRentalProcessorOverlayStyles();

      var parentStyle = window.getComputedStyle(parent);
      if (parentStyle.position === 'static') {
        parent.style.position = 'relative';
      }

      var mobileMode = isRentalProcessorMobileLabelMode();
      var selectRect = rentalProcessorSelect.getBoundingClientRect();
      var parentRect = parent.getBoundingClientRect();
      var selectStyle = window.getComputedStyle(rentalProcessorSelect);
      var inset = mobileMode ? 0 : 2;

      rentalProcessorClosedDisplay.style.left = (selectRect.left - parentRect.left + inset) + 'px';
      rentalProcessorClosedDisplay.style.top = (selectRect.top - parentRect.top + inset) + 'px';
      rentalProcessorClosedDisplay.style.width = Math.max(0, selectRect.width - (inset * 2)) + 'px';
      rentalProcessorClosedDisplay.style.height = Math.max(0, selectRect.height - (inset * 2)) + 'px';
      rentalProcessorClosedDisplay.style.paddingLeft = selectStyle.paddingLeft || '16px';
      rentalProcessorClosedDisplay.style.paddingRight = '18px';
      rentalProcessorClosedDisplay.style.backgroundColor =
        selectStyle.backgroundColor && selectStyle.backgroundColor !== 'rgba(0, 0, 0, 0)'
          ? selectStyle.backgroundColor
          : '#ffffff';
      rentalProcessorClosedDisplay.style.borderRadius = selectStyle.borderRadius || '14px';
      rentalProcessorClosedDisplay.style.fontFamily = selectStyle.fontFamily;
      rentalProcessorClosedDisplay.style.fontSize = selectStyle.fontSize;
      rentalProcessorClosedDisplay.style.fontWeight = selectStyle.fontWeight;
      rentalProcessorClosedDisplay.style.letterSpacing = selectStyle.letterSpacing;
      rentalProcessorClosedDisplay.style.color = selectStyle.color;
      rentalProcessorClosedDisplay.style.border = mobileMode ? selectStyle.border : '0';
      rentalProcessorClosedDisplay.style.boxShadow = mobileMode ? selectStyle.boxShadow : 'none';

      var overlayArrow = rentalProcessorClosedDisplay.querySelector('.rental-processor-closed-display__arrow');

      if (mobileMode) {
        
        rentalProcessorClosedDisplay.style.zIndex = '2';
        rentalProcessorClosedDisplay.style.border = '0';
        rentalProcessorClosedDisplay.style.boxShadow = 'none';
        if (overlayArrow) overlayArrow.style.display = 'none';

        rentalProcessorSelect.style.position = 'relative';
        rentalProcessorSelect.style.zIndex = '3';
        rentalProcessorSelect.style.opacity = rentalProcessorSelectOriginalOverlayStyles.selectOpacity || '1';
        rentalProcessorSelect.style.color = 'transparent';
        rentalProcessorSelect.style.webkitTextFillColor = 'transparent';
        rentalProcessorSelect.style.backgroundColor = 'transparent';
        rentalProcessorSelect.style.caretColor = 'transparent';
        rentalProcessorSelect.style.pointerEvents = 'auto';
        rentalProcessorSelect.style.cursor = 'pointer';
      } else {
        if (overlayArrow) overlayArrow.style.display = '';
        rentalProcessorClosedDisplay.style.zIndex = '2';
        rentalProcessorSelect.style.position = rentalProcessorSelectOriginalOverlayStyles.selectPosition;
        rentalProcessorSelect.style.zIndex = rentalProcessorSelectOriginalOverlayStyles.selectZIndex;
        rentalProcessorSelect.style.opacity = rentalProcessorSelectOriginalOverlayStyles.selectOpacity;
        rentalProcessorSelect.style.color = rentalProcessorSelectOriginalOverlayStyles.selectColor;
        rentalProcessorSelect.style.webkitTextFillColor = rentalProcessorSelectOriginalOverlayStyles.selectWebkitTextFillColor;
        rentalProcessorSelect.style.backgroundColor = rentalProcessorSelectOriginalOverlayStyles.selectBackgroundColor;
        rentalProcessorSelect.style.caretColor = rentalProcessorSelectOriginalOverlayStyles.selectCaretColor;
        rentalProcessorSelect.style.pointerEvents = rentalProcessorSelectOriginalOverlayStyles.selectPointerEvents;
        rentalProcessorSelect.style.cursor = rentalProcessorSelectOriginalOverlayStyles.selectCursor;
      }
    }

    function shouldUseRentalProcessorClosedDisplay() {
      return !!(isIpadRentalPage() && rentalProcessorSelect);
    }

    function removeRentalProcessorClosedDisplay() {
      if (rentalProcessorClosedDisplay && rentalProcessorClosedDisplay.parentNode) {
        rentalProcessorClosedDisplay.parentNode.removeChild(rentalProcessorClosedDisplay);
      }

      restoreRentalProcessorOverlayStyles();
      rentalProcessorClosedDisplay = null;
      rentalProcessorClosedDisplayLabel = null;
    }

    function ensureRentalProcessorClosedDisplay() {
      if (!isIpadRentalPage() || !rentalProcessorSelect || !rentalProcessorSelect.parentElement) {
        removeRentalProcessorClosedDisplay();
        return null;
      }

      if (rentalProcessorClosedDisplay && rentalProcessorClosedDisplay.parentNode) {
        positionRentalProcessorClosedDisplay();
        return rentalProcessorClosedDisplay;
      }

      var overlay = document.createElement('span');
      overlay.className = 'rental-processor-closed-display';
      overlay.setAttribute('aria-hidden', 'true');
      overlay.style.position = 'absolute';
      overlay.style.pointerEvents = 'none';
      overlay.style.display = 'flex';
      overlay.style.alignItems = 'center';
      overlay.style.justifyContent = 'space-between';
      overlay.style.gap = '12px';
      overlay.style.boxSizing = 'border-box';
      overlay.style.overflow = 'hidden';

      var label = document.createElement('span');
      label.className = 'rental-processor-closed-display__label';
      label.style.minWidth = '0';
      label.style.overflow = 'hidden';
      label.style.textOverflow = 'ellipsis';
      label.style.whiteSpace = 'nowrap';

      var arrow = document.createElement('span');
      arrow.className = 'rental-processor-closed-display__arrow';
      arrow.style.flex = '0 0 auto';
      arrow.style.width = '0';
      arrow.style.height = '0';
      arrow.style.borderLeft = '5px solid transparent';
      arrow.style.borderRight = '5px solid transparent';
      arrow.style.borderTop = '6px solid currentColor';
      arrow.style.opacity = '0.55';

      overlay.appendChild(label);
      overlay.appendChild(arrow);
      rentalProcessorSelect.parentElement.appendChild(overlay);

      rentalProcessorClosedDisplay = overlay;
      rentalProcessorClosedDisplayLabel = label;
      positionRentalProcessorClosedDisplay();

      return overlay;
    }

    function shouldUseNativeRentalProcessorCompactLabel() {
      return false;
    }

    function restoreRentalProcessorFullOptionLabels() {
      if (!rentalProcessorSelect || !isIpadRentalPage()) return;

      Array.prototype.forEach.call(rentalProcessorSelect.options, function (option) {
        var fullLabel = option.dataset.rentalFullLabel;
        if (fullLabel) option.textContent = fullLabel;
      });
    }

    function collapseSelectedRentalProcessorOptionLabel() {
      return;
    }

    function prepareNativeRentalProcessorPicker() {
      restoreRentalProcessorFullOptionLabels();
    }

    function closeNativeRentalProcessorPickerLabel() {
      rentalProcessorNativePickerExpanded = false;
      updateRentalProcessorClosedDisplay();
    }

    function updateRentalProcessorClosedDisplay() {
      
      removeRentalProcessorClosedDisplay();
    }

    function getSecurityDepositFirstSelectableDate(config) {
      if (!config || !config.variantId || !playTimeStatusLoaded) return '';

      var leadDays = getSecurityDepositLeadDaysForVariantId(config.variantId);
      return leadDays > 0
        ? getFirstSelectableRentalDateForLeadDays(leadDays)
        : '';
    }

    function getIpadModeAvailabilityState(available, config) {
      var leadDays = config && config.variantId
        ? getSecurityDepositLeadDaysForVariantId(config.variantId)
        : 0;
      var firstSelectableDate = '';

      if (available && leadDays > 0) {
        firstSelectableDate = getSecurityDepositFirstSelectableDate(config);
      }

      return {
        available: !!available,
        hasFutureDate: !!(available && leadDays > 0),
        firstSelectableDate: firstSelectableDate,
        formattedDate: firstSelectableDate
          ? formatSecurityDepositAvailabilityDate(firstSelectableDate)
          : ''
      };
    }

    function buildIpadConnectivityProcessorLabel(baseLabel, connectivity) {
      var wifiConfig = getSecurityDepositConfigForOptionText(
        connectivity.baseProcessor || baseLabel
      );
      var cellularConfig = getSecurityDepositConfigForOptionText(
        connectivity.cellularProcessor
      );
      var wifi = getIpadModeAvailabilityState(
        connectivity.wifiAvailable,
        wifiConfig
      );
      var cellular = getIpadModeAvailabilityState(
        connectivity.cellularAvailable,
        cellularConfig
      );

      if (
        (wifi.hasFutureDate && !wifi.formattedDate) ||
        (cellular.hasFutureDate && !cellular.formattedDate)
      ) {
        return baseLabel;
      }

      if (!wifi.available && !cellular.available) {
        return baseLabel + ' — Unavailable';
      }

      /*
       * Keep the iPad model dropdown clean.
       * Connectivity availability is already shown/disabled in the separate
       * Cellular option, so do not append "WiFi only" / "Cellular only".
       * Only show an earliest-start date when the model itself cannot start yet.
       */
      if (wifi.available && !cellular.available) {
        return wifi.hasFutureDate
          ? baseLabel + ' — Earliest start ' + wifi.formattedDate
          : baseLabel;
      }

      if (!wifi.available && cellular.available) {
        return cellular.hasFutureDate
          ? baseLabel + ' — Earliest start ' + cellular.formattedDate
          : baseLabel;
      }

      if (wifi.hasFutureDate && cellular.hasFutureDate) {
        var earliestDate = wifi.firstSelectableDate <= cellular.firstSelectableDate
          ? wifi.formattedDate
          : cellular.formattedDate;

        return baseLabel + ' — Earliest start ' + earliestDate;
      }

      /* At least one connectivity mode is available immediately. */
      return baseLabel;
    }

    function updateProcessorAvailabilityNote() {
      if (!rentalProcessorSelect) return;

      Array.prototype.forEach.call(rentalProcessorSelect.options, function (option) {
        var baseLabel = getProcessorOptionBaseLabel(option);

        if (!String(option.value || '').trim()) {
          option.textContent = baseLabel;
          option.removeAttribute('title');
          return;
        }

        if (isIpadRentalPage() && !isIpadCellularProcessorValue(option.value)) {
          var connectivity = getIpadConnectivityAvailability(option.value);

          option.textContent = buildIpadConnectivityProcessorLabel(baseLabel, connectivity);

          if (!connectivity.wifiAvailable && !connectivity.cellularAvailable) {
            
            option.textContent = baseLabel;
            option.disabled = true;
            option.hidden = true;
            option.style.display = 'none';
            option.setAttribute('aria-disabled', 'true');
            option.setAttribute('aria-hidden', 'true');
            option.removeAttribute('title');
          } else if (!connectivity.wifiAvailable) {
            option.hidden = false;
            option.style.removeProperty('display');
            option.removeAttribute('aria-hidden');
            option.setAttribute('title', 'Only the Cellular model is available for the selected rental date.');
          } else if (!connectivity.cellularAvailable) {
            option.hidden = false;
            option.style.removeProperty('display');
            option.removeAttribute('aria-hidden');
            option.setAttribute('title', 'Only the WiFi model is available for the selected rental date.');
          } else {
            option.hidden = false;
            option.style.removeProperty('display');
            option.removeAttribute('aria-hidden');
            option.removeAttribute('title');
          }
          return;
        }

        var config = getSecurityDepositConfigForOptionText(option.value);
        var firstSelectableDate = getSecurityDepositFirstSelectableDate(config);

        if (option.disabled) {
          option.textContent = baseLabel + ' — Unavailable';
          option.setAttribute('title', 'This model is currently unavailable');
          return;
        }

        option.removeAttribute('title');
        option.textContent = firstSelectableDate
          ? baseLabel + ' — Earliest start ' + formatSecurityDepositAvailabilityDate(firstSelectableDate)
          : baseLabel;
      });

      Array.prototype.forEach.call(rentalProcessorSelect.options, function (option) {
        option.dataset.rentalFullLabel = String(option.textContent || '').trim();
      });

      updateRentalProcessorClosedDisplay();
    }

    function loadProcessorSecurityDepositAvailabilityLabels() {
      if (!rentalProcessorSelect) return Promise.resolve([]);

      var loadRequests = [];
      var requestedVariantIds = {};

      function queueSecurityDepositDayLookup(config) {
        if (!config || !config.variantId) return;

        var variantId = String(config.variantId);
        if (requestedVariantIds[variantId]) return;

        requestedVariantIds[variantId] = true;
        loadRequests.push(
          loadSecurityDepositLeadDaysForVariantId(variantId).then(function () {
            updateProcessorAvailabilityNote();
          })
        );
      }

      Array.prototype.forEach.call(rentalProcessorSelect.options, function (option) {
        getProcessorOptionBaseLabel(option);
        queueSecurityDepositDayLookup(getSecurityDepositConfigForOptionText(option.value));

        if (isIpadRentalPage() && !isIpadCellularProcessorValue(option.value)) {
          var cellularProcessor = getCellularIpadProcessorValue(option.value);
          if (cellularProcessor) {
            queueSecurityDepositDayLookup(
              getSecurityDepositConfigForOptionText(cellularProcessor)
            );
          }
        }
      });

      updateProcessorAvailabilityNote();

      return Promise.all(loadRequests).then(function (results) {
        updateProcessorAvailabilityNote();
        return results;
      });
    }

    function formatSingaporeDateParts(offsetDays) {
      var now = getSingaporeNowParts();
      var date = new Date(Date.UTC(
        now.year,
        now.month - 1,
        now.day + (offsetDays || 0)
      ));

      return date.getUTCFullYear() + '-' +
        String(date.getUTCMonth() + 1).padStart(2, '0') + '-' +
        String(date.getUTCDate()).padStart(2, '0');
    }

    function getSingaporeTodayString() {
      return formatSingaporeDateParts(0);
    }

    function getSingaporeTomorrowString() {
      return formatSingaporeDateParts(1);
    }

    function getCurrentSingaporeMinutes() {
      var singaporeNow = getSingaporeNowParts();
      return (singaporeNow.hour * 60) + singaporeNow.minute;
    }

    function getPlayTimeSameDayTier() {
      if (!rentalSameDayCheckoutFeatureEnabled()) return '';

      var minutes = getCurrentSingaporeMinutes();

      if (minutes < (9 * 60)) {
        return 'before9';
      }

      if (minutes < (11 * 60)) {
        return 'morning';
      }

      if (minutes < (13 * 60)) {
        return 'midday';
      }

      if (minutes < (15 * 60)) {
        return 'afternoon';
      }

      if (minutes < (17 * 60)) {
        return 'late-afternoon';
      }

      return 'closed';
    }

    function playTimeAllowsTodayAsStartDate() {
      if (!rentalSameDayCheckoutFeatureEnabled()) return false;

      var tier = getPlayTimeSameDayTier();
      return ['before9', 'morning', 'midday', 'afternoon', 'late-afternoon'].indexOf(tier) !== -1 &&
        getCurrentSingaporeMinutes() < (17 * 60);
    }

    function getRentalStartDateMinimumString() {
      return playTimeAllowsTodayAsStartDate()
        ? getSingaporeTodayString()
        : getSingaporeTomorrowString();
    }

    function getPlayTimeControlledStartDateString() {
      var minutes = getCurrentSingaporeMinutes();

      if (minutes >= (17 * 60)) {
        return getSingaporeTomorrowString();
      }

      return getSingaporeTodayString();
    }

    function nextDayDeliveryRestrictionApplies() {
      if (!startDateInput || !startDateInput.value || rentalSameDayCheckoutFeatureEnabled()) return false;

      var currentMinutes = getCurrentSingaporeMinutes();
      var cutoffMinutes =
        (nextDayCutoffHourSingapore * 60) +
        nextDayCutoffMinuteSingapore;

      return (
        currentMinutes >= cutoffMinutes &&
        startDateInput.value === getSingaporeTomorrowString()
      );
    }

    function getPlayTimeDeliveryTier() {
      if (!startDateInput || !startDateInput.value || !rentalSameDayCheckoutFeatureEnabled()) return '';

      var selectedDate = startDateInput.value;
      var currentMinutes = getCurrentSingaporeMinutes();

      // Preserve the existing after-7pm restriction for tomorrow even though
      // same-day online rental itself closes earlier at 5pm.
      if (currentMinutes >= (19 * 60) && selectedDate === getSingaporeTomorrowString()) {
        return 'overnight';
      }

      if (selectedDate === getSingaporeTodayString()) {
        var tier = getPlayTimeSameDayTier();
        return tier === 'closed' ? '' : tier;
      }

      return '';
    }

    function isBlockedNextDaySlot(value) {
      return [
        'early',
        '9am–11am'
      ].indexOf(value) !== -1;
    }

    var playTimeDeliveryTierRules = {
      // After 7pm, tomorrow keeps the existing next-day urgent rule.
      overnight: {
        allowed: {
          '11am–1pm': 'priority',
          '1pm–3pm': 'standard',
          '3pm–5pm': '',
          '5pm–7pm': '',
          '7pm–9pm': '',
          '9pm–11pm': ''
        }
      },
      // Same-day booking before 9am.
      before9: {
        allowed: {
          '11am–1pm': 'priority',
          '1pm–3pm': 'standard',
          '3pm–5pm': '',
          '5pm–7pm': '',
          '7pm–9pm': '',
          '9pm–11pm': ''
        }
      },
      // Same-day booking from 9am to before 11am.
      morning: {
        allowed: {
          '1pm–3pm': 'priority',
          '3pm–5pm': 'standard',
          '5pm–7pm': '',
          '7pm–9pm': '',
          '9pm–11pm': ''
        }
      },
      // Same-day booking from 11am to before 1pm.
      midday: {
        allowed: {
          '3pm–5pm': 'priority',
          '5pm–7pm': 'standard',
          '7pm–9pm': '',
          '9pm–11pm': ''
        }
      },
      // Same-day booking from 1pm to before 3pm.
      afternoon: {
        allowed: {
          '5pm–7pm': 'priority',
          '7pm–9pm': 'standard',
          '9pm–11pm': ''
        }
      },
      // Same-day booking from 3pm to before 5pm.
      'late-afternoon': {
        allowed: {
          '7pm–9pm': 'priority',
          '9pm–11pm': 'standard'
        }
      }
    };

    function getPlayTimeChargeTypeForDelivery(value) {
      var tier = getPlayTimeDeliveryTier();
      if (!tier || !playTimeDeliveryTierRules[tier]) return null;
      if (!value) return '';

      var allowed = playTimeDeliveryTierRules[tier].allowed;
      if (!Object.prototype.hasOwnProperty.call(allowed, value)) {
        return 'blocked';
      }

      return allowed[value] || '';
    }

    function getDeliveryLabelWithCharge(item, chargeType) {
      if (!item || !item.value) {
        return item ? item.text : '';
      }

      if (item.value === 'early') {
        return formatTimingOptionChargeLabel(
          stripDeliveryChargeSuffix(item.text) || '8am–10am',
          'Early Delivery',
          earlyDeliverySurchargeCents
        );
      }

      if (chargeType === 'priority') {
        var priorityPrice = formatCompactMoney(priorityUrgentChargeCents);
        return item.value + ' (Priority Urgent Delivery' + (priorityPrice ? ' +' + priorityPrice : '') + ')';
      }

      if (chargeType === 'standard') {
        var standardPrice = formatCompactMoney(standardUrgentChargeCents);
        return item.value + ' (Standard Urgent Delivery' + (standardPrice ? ' +' + standardPrice : '') + ')';
      }

      if (chargeType === 'blocked') {
        return item.value + ' (Unavailable)';
      }

      return item.text;
    }

    function getRestrictedDeliveryLabel(item) {
      if (!item || !item.value) {
        return item ? item.text : '';
      }

      if (item.value === 'early') {
        return formatTimingOptionChargeLabel(
          stripDeliveryChargeSuffix(item.text) || '8am–10am',
          'Early Delivery',
          earlyDeliverySurchargeCents
        );
      }

      if (item.value === '11am–1pm') {
        var priorityPrice = formatCompactMoney(priorityUrgentChargeCents);
        return '11am–1pm (Priority Urgent Delivery' + (priorityPrice ? ' +' + priorityPrice : '') + ')';
      }

      if (item.value === '1pm–3pm') {
        var standardPrice = formatCompactMoney(standardUrgentChargeCents);
        return '1pm–3pm (Standard Urgent Delivery' + (standardPrice ? ' +' + standardPrice : '') + ')';
      }

      if (isBlockedNextDaySlot(item.value)) {
        return item.text + ' (Unavailable)';
      }

      return item.text;
    }

    function getSelectedDeliveryOption() {
      if (!deliveryTimeInput || deliveryTimeInput.selectedIndex < 0) return null;
      return deliveryTimeInput.options[deliveryTimeInput.selectedIndex] || null;
    }

    function selectedDeliveryOptionIsUnavailable() {
      var selectedOption = getSelectedDeliveryOption();
      return !!(selectedOption && selectedOption.disabled);
    }

    function priorityUrgentChargeApplied() {
      if (!deliveryTimeInput || selectedDeliveryOptionIsUnavailable()) return false;

      if (
        rentalEditSchedulePreservationActive() &&
        rentalEditSavedSchedule &&
        deliveryTimeInput.value === rentalEditSavedSchedule.deliveryTime
      ) {
        return rentalEditSavedSchedule.priorityUrgent === true;
      }

      if (getPlayTimeChargeTypeForDelivery(deliveryTimeInput.value) === 'priority') {
        return true;
      }

      return !!(
        nextDayDeliveryRestrictionApplies() &&
        deliveryTimeInput.value === '11am–1pm'
      );
    }

    function standardUrgentChargeApplied() {
      if (!deliveryTimeInput || selectedDeliveryOptionIsUnavailable()) return false;

      if (
        rentalEditSchedulePreservationActive() &&
        rentalEditSavedSchedule &&
        deliveryTimeInput.value === rentalEditSavedSchedule.deliveryTime
      ) {
        return rentalEditSavedSchedule.standardUrgent === true;
      }

      if (getPlayTimeChargeTypeForDelivery(deliveryTimeInput.value) === 'standard') {
        return true;
      }

      return !!(
        nextDayDeliveryRestrictionApplies() &&
        deliveryTimeInput.value === '1pm–3pm'
      );
    }

    function rebuildDeliveryOptions() {
      if (!deliveryTimeInput) return false;

      var livePreviousValue = String(deliveryTimeInput.value || '');
      if (livePreviousValue) {
        retainedRentalDeliveryTimeValue = livePreviousValue;
      }

      var preserveSavedSchedule = rentalEditSchedulePreservationActive();
      var previousValue = livePreviousValue || retainedRentalDeliveryTimeValue;

      if (
        preserveSavedSchedule &&
        !previousValue &&
        rentalEditSavedSchedule &&
        rentalEditSavedSchedule.deliveryTime
      ) {
        previousValue = rentalEditSavedSchedule.deliveryTime;
      }

      var hasSelectedRentalPeriod = calendarRentalRangeIsComplete();

      deliveryTimeInput.innerHTML = '';

      /* Delivery timing depends on the completed rental period. Keep the
         dropdown locked until both rental start and return dates are selected.

         Important: an incomplete range here can simply mean the customer has
         clicked the first date while RESELECTING an existing range. Do not
         discard the retained delivery timing during that temporary state. */
      if (!hasSelectedRentalPeriod) {
        var dependencyOption = document.createElement('option');
        dependencyOption.value = '';
        dependencyOption.textContent = 'Select rental period first';
        dependencyOption.selected = true;
        deliveryTimeInput.appendChild(dependencyOption);
        deliveryTimeInput.disabled = true;
        deliveryTimeInput.setAttribute('aria-disabled', 'true');
        clearRentalFieldPrompt(deliveryTimeInput);

        if (livePreviousValue) {
          updateRentalEndInfo();
          updateTotal();
        }

        return false;
      }

      deliveryTimeInput.disabled = false;
      deliveryTimeInput.setAttribute('aria-disabled', 'false');

      var restricted = nextDayDeliveryRestrictionApplies();
      var playTimeTier = getPlayTimeDeliveryTier();
      var preservingClosedSameDay = !!(
        preserveSavedSchedule &&
        rentalEditSavedSchedule &&
        rentalEditSavedSchedule.startDate === getSingaporeTodayString() &&
        !playTimeTier
      );

      originalDeliveryOptions.forEach(function (item) {
        var option = document.createElement('option');
        var isSavedDelivery = !!(
          preserveSavedSchedule &&
          rentalEditSavedSchedule &&
          item.value === rentalEditSavedSchedule.deliveryTime
        );
        var playTimeChargeType = playTimeTier ? getPlayTimeChargeTypeForDelivery(item.value) : null;

        /* If the active cart crossed a current-time cutoff, keep only its saved
           same-day delivery plus the placeholder. Do not expose brand-new
           same-day delivery choices after online same-day booking has closed. */
        if (preservingClosedSameDay && item.value && !isSavedDelivery) {
          return;
        }

        if (playTimeTier && playTimeChargeType === 'blocked' && !isSavedDelivery) {
          return;
        }

        if (!playTimeTier && restricted && isBlockedNextDaySlot(item.value) && !isSavedDelivery) {
          return;
        }

        option.value = item.value;

        if (!item.value) {
          option.textContent = 'Select delivery timeslot';
        } else if (isSavedDelivery) {
          var savedChargeType = rentalEditSavedSchedule.priorityUrgent
            ? 'priority'
            : (rentalEditSavedSchedule.standardUrgent ? 'standard' : '');
          option.textContent = getDeliveryLabelWithCharge(item, savedChargeType);
        } else {
          option.textContent = playTimeTier
            ? getDeliveryLabelWithCharge(item, playTimeChargeType)
            : (restricted ? getRestrictedDeliveryLabel(item) : getDeliveryLabelWithCharge(item, ''));
        }

        deliveryTimeInput.appendChild(option);
      });

      var previousStillAvailable = !!previousValue && Array.prototype.some.call(
        deliveryTimeInput.options,
        function (option) {
          return option.value === previousValue && !option.disabled;
        }
      );

      if (previousStillAvailable) {
        deliveryTimeInput.value = previousValue;
        retainedRentalDeliveryTimeValue = previousValue;
      } else {
        deliveryTimeInput.value = '';

        /* A completed new date range has proved the old delivery slot invalid.
           Clear the retained delivery only now — not during the temporary
           first-click/incomplete-range state. */
        if (previousValue) {
          retainedRentalDeliveryTimeValue = '';
          updateRentalEndInfo();
          updateTotal();
        }
      }

      return !!(restricted || playTimeTier);
    }

    function refreshPlayTimeDependentUi(clearInvalidDate) {
      updateProcessorAvailabilityNote();
      refreshRentalStartDateMinimum(!!clearInvalidDate);
      setRentalStartDateDisplayText();
      validateDateField();
      rebuildDeliveryOptions();
      rebuildReturnOptions();
      updateTotal();
      updateRentalEndInfo();

      if (useCustomRentalDatePicker) {
        renderRentalMobileCalendar();
      }
    }

    function parsePlayTimeCutoffMinutes(value, fieldName) {
      var text = String(value == null ? '' : value).trim().toLowerCase();

      if (!text || text === 'null') return null;

      var match = text.match(/^(\d{1,2}):(\d{2})$/);
      if (!match) {
        throw new Error('Invalid PlayTime ' + fieldName + '. Use null or HH:MM.');
      }

      var hour = parseInt(match[1], 10);
      var minute = parseInt(match[2], 10);

      if (hour < 0 || hour > 23 || minute < 0 || minute > 59) {
        throw new Error('Invalid PlayTime ' + fieldName + '. Use null or HH:MM.');
      }

      return (hour * 60) + minute;
    }

    function parsePlayTimeBlockedDate(value) {
      var text = String(value || '').trim();
      var match = text.match(/^(\d{1,2})-([A-Za-z]{3})-(\d{4})$/);

      if (!match) {
        throw new Error('Invalid PlayTime blocked date. Use DD-MMM-YYYY.');
      }

      var monthMap = {
        jan: 1, feb: 2, mar: 3, apr: 4, may: 5, jun: 6,
        jul: 7, aug: 8, sep: 9, oct: 10, nov: 11, dec: 12
      };
      var day = parseInt(match[1], 10);
      var month = monthMap[String(match[2]).toLowerCase()];
      var year = parseInt(match[3], 10);

      if (!month || day < 1 || day > 31) {
        throw new Error('Invalid PlayTime blocked date: ' + text);
      }

      var date = new Date(Date.UTC(year, month - 1, day));

      if (
        date.getUTCFullYear() !== year ||
        date.getUTCMonth() !== month - 1 ||
        date.getUTCDate() !== day
      ) {
        throw new Error('Invalid PlayTime blocked date: ' + text);
      }

      return (
        String(year).padStart(4, '0') + '-' +
        String(month).padStart(2, '0') + '-' +
        String(day).padStart(2, '0')
      );
    }

    function parsePlayTimeBlockedRentalRanges(value) {
      var text = String(value == null ? '' : value).trim();

      if (!text || text.toLowerCase() === 'null') {
        return [];
      }

      return text.split(',').map(function (rawRange) {
        var cleaned = String(rawRange || '')
          .trim()
          .replace(/^['"]|['"]$/g, '')
          .trim();

        var match = cleaned.match(
          /^(\d{1,2}-[A-Za-z]{3}-\d{4})\s+to\s+(\d{1,2}-[A-Za-z]{3}-\d{4})$/i
        );

        if (!match) {
          throw new Error(
            "Invalid PlayTime blocked range. Use 'DD-MMM-YYYY to DD-MMM-YYYY'."
          );
        }

        var start = parsePlayTimeBlockedDate(match[1]);
        var end = parsePlayTimeBlockedDate(match[2]);

        if (end < start) {
          throw new Error('Invalid PlayTime blocked range: end date is before start date.');
        }

        return {
          start: start,
          end: end
        };
      });
    }

    function getPlayTimeDescriptionText(bodyHtml) {
      var container = document.createElement('div');

      container.innerHTML = String(bodyHtml || '')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/(?:p|div|pre|code|li)>/gi, '\n');

      return String(container.textContent || container.innerText || '')
        .replace(/\u00a0/g, ' ')
        .replace(/\r/g, '')
        .trim();
    }

    function getPlayTimeConfigLineValue(descriptionText, fieldPattern) {
      var match = String(descriptionText || '').match(
        new RegExp('^\\s*' + fieldPattern + '\\s*:\\s*(.+?)\\s*$', 'im')
      );

      return match ? String(match[1] || '').trim() : '';
    }

    function parsePlayTimeYesNo(value, fieldName) {
      var text = String(value || '').trim().toLowerCase();

      if (text !== 'yes' && text !== 'no') {
        throw new Error('Invalid PlayTime ' + fieldName + '. Use yes or no.');
      }

      return text === 'yes';
    }

    function parsePlayTimeProductConfig(payload) {
      var product = payload && payload.product ? payload.product : payload;
      var descriptionText = getPlayTimeDescriptionText(
        product && product.body_html ? product.body_html : ''
      );

      var sameDayClosedValue = getPlayTimeConfigLineValue(
        descriptionText,
        'Same-day\\s+rental\\s+closed'
      );
      var sameDayCutoffValue = getPlayTimeConfigLineValue(
        descriptionText,
        'Same-day\\s+order\\s+cutoff'
      );
      var weekendClosedValue = getPlayTimeConfigLineValue(
        descriptionText,
        'Weekend\\s+rentals\\s+closed'
      );
      var weekendCutoffValue = getPlayTimeConfigLineValue(
        descriptionText,
        'Weekend\\s+same-day\\s+order\\s+cutoff'
      );
      var blockedDatesValue = getPlayTimeConfigLineValue(
        descriptionText,
        'Blocked\\s+rental\\s+dates'
      );

      if (
        !sameDayClosedValue ||
        !sameDayCutoffValue ||
        !weekendClosedValue ||
        !weekendCutoffValue ||
        !blockedDatesValue
      ) {
        throw new Error(
          'PlayTime description is missing one or more required rental-control fields.'
        );
      }

      return {
        sameDayClosed: parsePlayTimeYesNo(
          sameDayClosedValue,
          'Same-day rental closed'
        ),
        sameDayOrderCutoffMinutes: parsePlayTimeCutoffMinutes(
          sameDayCutoffValue,
          'Same-day order cutoff'
        ),
        weekendRentalsClosed: parsePlayTimeYesNo(
          weekendClosedValue,
          'Weekend rentals closed'
        ),
        weekendSameDayOrderCutoffMinutes: parsePlayTimeCutoffMinutes(
          weekendCutoffValue,
          'Weekend same-day order cutoff'
        ),
        blockedRentalRanges: parsePlayTimeBlockedRentalRanges(
          blockedDatesValue
        )
      };
    }

    function loadPlayTimeProductConfig() {
      return fetch('/products/' + encodeURIComponent(playTimeProductHandle) + '.json?rental_playtime_config=' + Date.now(), {
        method: 'GET',
        headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' },
        cache: 'no-store'
      })
        .then(function (response) {
          setTrustedNowFromResponse(response);
          if (!response.ok) throw new Error('Unable to read PlayTime product configuration.');
          return response.json();
        })
        .then(function (payload) {
          var config = parsePlayTimeProductConfig(payload);

          playTimeConfig.loaded = true;
          playTimeConfig.sameDayClosed = !!config.sameDayClosed;
          playTimeConfig.sameDayOrderCutoffMinutes =
            Number.isFinite(config.sameDayOrderCutoffMinutes)
              ? config.sameDayOrderCutoffMinutes
              : null;
          playTimeConfig.weekendRentalsClosed = !!config.weekendRentalsClosed;
          playTimeConfig.weekendSameDayOrderCutoffMinutes =
            Number.isFinite(config.weekendSameDayOrderCutoffMinutes)
              ? config.weekendSameDayOrderCutoffMinutes
              : null;
          playTimeConfig.blockedRentalRanges =
            Array.isArray(config.blockedRentalRanges)
              ? config.blockedRentalRanges.slice()
              : [];

          return config;
        })
        .catch(function (error) {
          playTimeConfig.loaded = false;
          playTimeConfig.sameDayClosed = true;
          playTimeConfig.sameDayOrderCutoffMinutes = null;
          playTimeConfig.weekendRentalsClosed = false;
          playTimeConfig.weekendSameDayOrderCutoffMinutes = null;
          playTimeConfig.blockedRentalRanges = [];
          console.error('PlayTime configuration check error:', error);
          return null;
        });
    }

    function loadPlayTimeVariantAvailability() {
      return fetch('/variants/' + encodeURIComponent(playTimeVariantId) + '.js?rental_playtime=' + Date.now(), {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Cache-Control': 'no-cache'
        },
        cache: 'no-store'
      })
        .then(function (response) {
          setTrustedNowFromResponse(response);

          if (!response.ok) {
            throw new Error('Unable to read PlayTime availability.');
          }

          return response.json();
        })
        .then(function (variant) {
          playTimeSameDayEnabled = !!(variant && variant.available);
          return playTimeSameDayEnabled;
        })
        .catch(function (error) {
          playTimeSameDayEnabled = false;
          console.error('PlayTime availability check error:', error);
          return false;
        });
    }

    function loadPlayTimeAvailability() {
      /* Do not temporarily turn a previously-loaded PlayTime state into
         "unavailable" while a refresh is in flight. During Update Rental the
         old code set playTimeStatusLoaded=false, so today's valid date could
         briefly render "Same-day rental is currently unavailable online"
         and dependent dropdowns could rebuild against a false closed state.

         On the initial page load playTimeStatusLoaded is already false when no
         server-rendered status exists, so the page still fails closed until the
         first request completes. On later refreshes we keep the last confirmed
         state visible, then settle the UI from the newly fetched result below. */
      return Promise.all([loadPlayTimeVariantAvailability(), loadPlayTimeProductConfig()])
        .then(function (results) {
          playTimeStatusLoaded = true;
          refreshPlayTimeDependentUi(true);
          return results[0] === true && playTimeConfig.loaded === true;
        });
    }

    function earlyDeliveryApplied() {
      return !!(deliveryTimeInput && deliveryTimeInput.value === 'early');
    }

    function getSelectedOptionText() {
      return getSelectedOptions()
        .filter(function (value) { return !!value; })
        .join(' ')
        .toLowerCase();
    }

    function getSelectedProcessorText() {
      if (isIpadRentalPage()) {
        return String(getEffectiveIpadProcessorValue() || getSelectedOptionText()).toLowerCase();
      }

      var processorText = '';
      var groups = document.querySelectorAll('.rental-option-group');

      groups.forEach(function (group) {
        var titleEl = group.querySelector('.rental-option-group-title');
        var checked = group.querySelector('.rental-option-radio:checked');

        if (!titleEl || !checked) return;

        var groupTitle = (titleEl.textContent || '').trim().toLowerCase();
        if (groupTitle.indexOf('processor') !== -1) {
          processorText = checked.value || '';
        }
      });

      return (processorText || getSelectedOptionText()).toLowerCase();
    }

    function setRentalInfoList(listEl, items) {
      if (!listEl) return;

      listEl.innerHTML = '';
      items.forEach(function (item) {
        var li = document.createElement('li');
        li.textContent = item;
        listEl.appendChild(li);
      });
    }

    function getSelectedCompatibilityOptionText() {
      if (isIpadRentalPage()) {
        return getEffectiveIpadProcessorValue();
      }

      var selectedOptions = [];
      var groups = document.querySelectorAll('.rental-option-group');

      groups.forEach(function (group) {
        var titleEl = group.querySelector('.rental-option-group-title');
        var checked = group.querySelector('.rental-option-radio:checked');

        if (!titleEl || !checked) return;

        var groupTitle = (titleEl.textContent || '').trim().toLowerCase();
        if (groupTitle.indexOf('rental period') !== -1 || groupTitle === 'period') {
          return;
        }

        if (checked.value) {
          selectedOptions.push(checked.value);
        }
      });

      if (selectedOptions.length) {
        return selectedOptions.join(' / ');
      }

      var matchedVariant = findMatchingVariant();
      if (matchedVariant && matchedVariant.title) {
        return matchedVariant.title.replace(/\s*\/\s*(?:CAL\s*(?:\|\s*)?Base\s*2\s*Days?|2 Day|3 Day|4 Day|5 Day|6 Day|1 Week|2 Week|3 Week|\d+ Month).*$/i, '').trim();
      }

      return '';
    }

    function selectedCompatibilityOptionIsBusinessI5(selectedText) {
      if (rentalProductTitle.indexOf('business laptop rental') === -1) return false;

      var text = (selectedText || '').toLowerCase();
      var isNewRyzen5Tier =
        text.indexOf('ryzen 5') !== -1 &&
        /(^|[^a-z0-9])new([^a-z0-9]|$)/i.test(text);

      if (text.indexOf('ultra 5') !== -1 || isNewRyzen5Tier) {
        return false;
      }

      return /(^|[^a-z0-9])i5([^a-z0-9]|$)/i.test(text) || text.indexOf('ryzen 5') !== -1;
    }

    function updateCompatibilityItemAvailability(selectedText) {
      var limitedKeysForBusinessI5 = [
        'python-coding',
        'visual-studio',
        'docker',
        'sql-database',
        'ubuntu'
      ];
      var shouldLimitDeveloperApps = selectedCompatibilityOptionIsBusinessI5(selectedText);
      var shouldLimitMacbookCustomOs =
        rentalProductTitle.indexOf('macbook rental') !== -1 ||
        /\bimac\b/i.test(String(selectedText || ''));

      document.querySelectorAll('.rental-compatibility-item').forEach(function (item) {
        var key = item.getAttribute('data-rental-compatibility');
        var isLimited =
          (shouldLimitDeveloperApps && limitedKeysForBusinessI5.indexOf(key) !== -1) ||
          (shouldLimitMacbookCustomOs && key === 'ubuntu');

        item.classList.toggle('is-compatibility-limited', isLimited);

        if (isLimited) {
          item.setAttribute('data-rental-compatibility-limited', 'true');
          item.setAttribute('aria-disabled', 'true');
          item.disabled = true;
        } else {
          item.removeAttribute('data-rental-compatibility-limited');
          item.removeAttribute('aria-disabled');
          item.disabled = false;
        }
      });
    }

    function updateBasePriceLabel(selectedText) {
      if (!basePriceLabelEl) return;

      var labelText = (selectedText || getSelectedCompatibilityOptionText() || '').trim();
      var rentalPeriod = (getSelectedRentalPeriod() || '').trim();
      var labelPrefix = rentalPeriod ? rentalPeriod + ' Rental' : 'Rental Price';

      basePriceLabelEl.textContent = labelText ? labelPrefix + ' - ' + labelText : labelPrefix;
    }

    function updateCompatibilitySelectedOption() {
      var selectedText = getSelectedCompatibilityOptionText();
      var displayText = selectedText;

      if (isIpadRentalPage()) {
        var ipadBaseSelection = getRawSelectedProcessorValue() ||
          getBaseIpadProcessorValue(selectedText);

        if (ipadBaseSelection) {
          displayText = ipadBaseSelection +
            (cellularAddonInput && cellularAddonInput.checked
              ? ' (Cellular)'
              : ' (Wi-Fi)');
        }
      }

      if (compatibilitySelectedOptionEl) {
        compatibilitySelectedOptionEl.textContent = displayText || '-';
      }

      updateBasePriceLabel(selectedText);
      updateCompatibilityItemAvailability(selectedText);
    }

    function getMacbookIncludes(processorText) {
      var text = processorText.toLowerCase();
      var firstLine = 'macOS';
      var coreLine = '';

      if (text.indexOf('imac m1') !== -1) {
        return ['macOS, 8GB, 256GB', '8C CPU, 8C GPU', 'Webcam & Microphone', 'Keyboard & Mouse', 'Charger & Bag'];
      }

      if (text.indexOf('macbook air m1') !== -1 || text.indexOf('air m1') !== -1) {
        firstLine = 'macOS, 8GB, 256GB';
        coreLine = '8C CPU, 7C GPU';
      } else if (text.indexOf('macbook air m2') !== -1 || text.indexOf('air m2') !== -1) {
        firstLine = 'macOS, 8GB, 256GB';
        coreLine = '8C CPU, 8C GPU';
      } else if (text.indexOf('macbook air m4') !== -1 || text.indexOf('air m4') !== -1) {
        firstLine = 'macOS, 16GB, 256GB';
        coreLine = '10C CPU, 8C GPU';
      } else if (text.indexOf('macbook air m3') !== -1 || text.indexOf('air m3') !== -1) {
        firstLine = 'macOS, 8GB, 256GB';
        coreLine = '8C CPU, 8C GPU';
      } else if (text.indexOf('macbook air m5') !== -1 || text.indexOf('air m5') !== -1) {
        firstLine = 'macOS, 16GB, 512GB';
        coreLine = '10C CPU, 8C GPU';
      } else if (text.indexOf('macbook pro m5 pro') !== -1 || text.indexOf('m5 pro') !== -1) {
        firstLine = 'macOS, 24GB, 1TB';
        coreLine = '15C CPU, 16C GPU';
      } else if (text.indexOf('macbook pro m3 max') !== -1 || text.indexOf('m3 max') !== -1) {
        firstLine = 'macOS, 48GB, 1TB';
        coreLine = '16C CPU, 40C GPU';
      } else if (text.indexOf('macbook pro m4 pro') !== -1 || text.indexOf('m4 pro') !== -1) {
        firstLine = 'macOS, 24GB, 512GB';
        coreLine = '12C CPU, 16C GPU';
      } else if (text.indexOf('macbook pro m3 pro') !== -1 || text.indexOf('m3 pro') !== -1) {
        firstLine = 'macOS, 18GB, 512GB';
        coreLine = '11C CPU, 14C GPU';
      } else if (text.indexOf('macbook pro m2 pro') !== -1 || text.indexOf('m2 pro') !== -1) {
        firstLine = 'macOS, 16GB, 512GB';
        coreLine = '12C CPU, 19C GPU';
      } else if (text.indexOf('macbook pro m1 pro') !== -1 || text.indexOf('m1 pro') !== -1) {
        firstLine = 'macOS, 16GB, 512GB';
        coreLine = '10C CPU, 16C GPU';
      } else if (text.indexOf('macbook pro m4') !== -1 || text.indexOf('macbook pro m5') !== -1 || text.indexOf('pro m4') !== -1 || text.indexOf('pro m5') !== -1) {
        firstLine = 'macOS, 16GB, 512GB';
      } else if (text.indexOf('macbook pro m3') !== -1 || text.indexOf('pro m3') !== -1) {
        firstLine = 'macOS, 8GB, 512GB';
      } else if (text.indexOf('macbook pro m2') !== -1 || text.indexOf('pro m2') !== -1) {
        firstLine = 'macOS, 8GB, 256GB';
        coreLine = '8C CPU, 10C GPU';
      } else if (text.indexOf('macbook pro m1') !== -1 || text.indexOf('pro m1') !== -1) {
        firstLine = 'macOS, 8GB, 256GB';
        coreLine = '8C CPU, 8C GPU';
      }

      return coreLine
        ? [firstLine, coreLine, 'Webcam & Microphone', 'Charger & Bag']
        : [firstLine, 'Webcam & Microphone', 'Charger & Bag'];
    }

    function getMacbookPorts(processorText) {
      var text = processorText.toLowerCase();

      if (text.indexOf('imac m1') !== -1) {
        return ['2x Thunderbolt USB-C', 'Headphone Jack'];
      }

      if (
        text.indexOf('macbook pro m1 pro') !== -1 ||
        text.indexOf('macbook pro m2 pro') !== -1 ||
        text.indexOf('macbook pro m3 pro') !== -1 ||
        text.indexOf('macbook pro m4 pro') !== -1 ||
        text.indexOf('macbook pro m5 pro') !== -1 ||
        text.indexOf('macbook pro m1 max') !== -1 ||
        text.indexOf('macbook pro m2 max') !== -1 ||
        text.indexOf('macbook pro m3 max') !== -1 ||
        text.indexOf('macbook pro m4 max') !== -1 ||
        text.indexOf('macbook pro m5 max') !== -1 ||
        text.indexOf('m1 pro') !== -1 ||
        text.indexOf('m2 pro') !== -1 ||
        text.indexOf('m3 pro') !== -1 ||
        text.indexOf('m4 pro') !== -1 ||
        text.indexOf('m5 pro') !== -1 ||
        text.indexOf('m1 max') !== -1 ||
        text.indexOf('m2 max') !== -1 ||
        text.indexOf('m3 max') !== -1 ||
        text.indexOf('m4 max') !== -1 ||
        text.indexOf('m5 max') !== -1
      ) {
        return ['3x Thunderbolt USB-C', 'HDMI Port', 'SDXC Card Slot', 'Headphone Jack'];
      }

      if (text.indexOf('macbook pro m4') !== -1 || text.indexOf('macbook pro m5') !== -1 || text.indexOf('pro m4') !== -1 || text.indexOf('pro m5') !== -1) {
        return ['3x Thunderbolt USB-C', 'HDMI Port', 'SDXC Card Slot', 'Headphone Jack'];
      }

      if (text.indexOf('macbook pro m3') !== -1 || text.indexOf('pro m3') !== -1) {
        return ['2x Thunderbolt USB-C', 'HDMI Port', 'SDXC Card Slot', 'Headphone Jack'];
      }

      return ['2x Thunderbolt USB-C', 'Headphone Jack'];
    }

    function updateRentalInfoPanels() {
      updateCompatibilitySelectedOption();

      var processorText = getSelectedProcessorText();

      if (rentalProductTitle.indexOf('macbook rental') !== -1) {
        var macbookIncludes = getMacbookIncludes(processorText);

        if (officeAddonApplied() && macbookIncludes.indexOf('Microsoft Office') === -1) {
          var macbookChargerIndex = macbookIncludes.findIndex(function (item) {
            return String(item || '').toLowerCase().indexOf('charger') !== -1;
          });

          if (macbookChargerIndex === -1) macbookChargerIndex = macbookIncludes.length;
          macbookIncludes.splice(macbookChargerIndex, 0, 'Microsoft Office');
        }

        setRentalInfoList(rentalIncludesList, macbookIncludes);
        setRentalInfoList(rentalPortsList, getMacbookPorts(processorText));
        return;
      }

      if (rentalProductTitle.indexOf('gaming laptop rental') !== -1) {
        var gamingProcessorText = String(processorText || '').toLowerCase();
        var gamingIncludes = ['Windows 11, 16GB, 512GB', 'Webcam & Microphone', 'Charger & Bag'];

        if (
          gamingProcessorText.indexOf('gtx 1650') !== -1 ||
          gamingProcessorText.indexOf('rtx 2060') !== -1
        ) {
          gamingIncludes = [
            'Windows 11, 16GB, 512GB',
            'Intel i7-10th Gen / Ryzen 7',
            'Webcam & Microphone',
            'Charger & Bag'
          ];
        } else if (
          gamingProcessorText.indexOf('rtx 3050') !== -1 ||
          gamingProcessorText.indexOf('rtx 3060') !== -1 ||
          gamingProcessorText.indexOf('rtx 3070') !== -1
        ) {
          gamingIncludes = [
            'Windows 11, 16GB, 512GB',
            'Intel i7-11th Gen / Ryzen 7',
            'Webcam & Microphone',
            'Charger & Bag'
          ];
        } else if (
          gamingProcessorText.indexOf('rtx 4050') !== -1 ||
          gamingProcessorText.indexOf('rtx 4060') !== -1 ||
          gamingProcessorText.indexOf('rtx 4070') !== -1
        ) {
          gamingIncludes = [
            'Windows 11, 16GB, 512GB',
            'Intel i7-12th Gen / Ryzen 7',
            'Webcam & Microphone',
            'Charger & Bag'
          ];
        } else if (gamingProcessorText.indexOf('rtx 5050') !== -1) {
          gamingIncludes = [
            'Windows 11, 16GB, 512GB',
            'Intel i5-13th Gen / Ryzen 5',
            'Webcam & Microphone',
            'Charger & Bag'
          ];
        } else if (gamingProcessorText.indexOf('rtx 5060') !== -1) {
          gamingIncludes = [
            'Windows 11, 16GB, 1TB',
            'Intel i7-13th Gen / Ryzen 7',
            'Webcam & Microphone',
            'Charger & Bag'
          ];
        } else if (gamingProcessorText.indexOf('rtx 5070') !== -1) {
          gamingIncludes = [
            'Windows 11, 32GB, 1TB',
            'Intel Ultra 9 / Ryzen 9',
            'Webcam & Microphone',
            'Charger & Bag'
          ];
        } else if (gamingProcessorText.indexOf('rtx 5080') !== -1) {
          gamingIncludes = [
            'Windows 11, 32GB, 1TB',
            'Intel Ultra 9 / Ryzen 9',
            'Webcam & Microphone',
            'Charger & Bag'
          ];
        }

        if (memoryAddonApplied() && gamingIncludes.length) {
          gamingIncludes[0] = String(gamingIncludes[0] || '').replace(/,\s*\d+GB,/, ', 32GB,');
        }

        if (officeAddonApplied() && gamingIncludes.indexOf('Microsoft Office') === -1) {
          var gamingChargerIndex = gamingIncludes.indexOf('Charger & Bag');
          if (gamingChargerIndex === -1) gamingChargerIndex = gamingIncludes.length;
          gamingIncludes.splice(gamingChargerIndex, 0, 'Microsoft Office');
        }

        setRentalInfoList(rentalIncludesList, gamingIncludes);
        setRentalInfoList(rentalPortsList, ['2x USB-A', '1x USB-C', 'HDMI Port', 'Headphone Jack']);
        return;
      }

      if (rentalProductTitle.indexOf('ipad rental') !== -1) {
        var ipadModelText = String(processorText || '').toLowerCase();
        var ipadPorts = (
          ipadModelText.indexOf('ipad 8th') !== -1 ||
          ipadModelText.indexOf('ipad 9th') !== -1
        )
          ? ['Lightning Port']
          : ['USB-C Port'];

        setRentalInfoList(rentalIncludesList, ['Charger & Bag']);
        setRentalInfoList(rentalPortsList, ipadPorts);
        return;
      }

      if (rentalProductTitle.indexOf('business laptop rental') !== -1) {
        var businessPorts = ['2x USB-A', '1x USB-C', 'Headphone Jack'];
        var businessProcessorText = String(processorText || '').toLowerCase();
        var businessIsNewTier = /(^|[^a-z0-9])new([^a-z0-9]|$)/i.test(businessProcessorText);
        var businessIncludes = ['Windows 11, 16GB, 512GB', 'Webcam & Microphone', 'Charger & Bag'];

        if (businessProcessorText.indexOf('lg gram 16') !== -1) {
          businessIncludes = [
            'Windows 11, 16GB, 1TB',
            'Intel Core Ultra 7',
            'Webcam & Microphone',
            'Charger & Bag'
          ];
        } else if (
          businessProcessorText.indexOf('surface pro 11') !== -1 ||
          businessProcessorText.indexOf('premium selection') !== -1
        ) {
          businessIncludes = [
            'Windows 11, 16GB, 256GB',
            'Snapdragon X Plus 10 Core',
            'Surface Keyboard',
            'Webcam & Microphone',
            'Charger & Bag'
          ];
        } else if (businessProcessorText.indexOf('ultra 7') !== -1 || (businessProcessorText.indexOf('ryzen 7') !== -1 && businessIsNewTier)) {
          businessIncludes = ['Windows 11, 16GB, 512GB', 'Core Ultra 7 / Ryzen 7 (New)', 'Webcam & Microphone', 'Charger & Bag'];
        } else if (businessProcessorText.indexOf('ultra 5') !== -1 || (businessProcessorText.indexOf('ryzen 5') !== -1 && businessIsNewTier)) {
          businessIncludes = ['Windows 11, 16GB, 512GB', 'Core Ultra 5 / Ryzen 5 (New)', 'Webcam & Microphone', 'Charger & Bag'];
        } else if (/(^|[^a-z0-9])i7([^a-z0-9]|$)/i.test(businessProcessorText) || businessProcessorText.indexOf('ryzen 7') !== -1) {
          businessIncludes = ['Windows 11, 16GB, 512GB', 'Intel i7-11th Gen / Ryzen 7', 'Webcam & Microphone', 'Charger & Bag'];
        } else if (/(^|[^a-z0-9])i5([^a-z0-9]|$)/i.test(businessProcessorText) || businessProcessorText.indexOf('ryzen 5') !== -1) {
          businessIncludes = ['Windows 11, 16GB, 256GB', 'Intel i5-11th Gen / Ryzen 5', 'Webcam & Microphone', 'Charger & Bag'];
        }

        if (memoryAddonApplied() && businessIncludes.length) {
          businessIncludes[0] = String(businessIncludes[0] || '').replace(/,\s*\d+GB,/, ', 32GB,');
        }

        if (officeAddonApplied() && businessIncludes.indexOf('Microsoft Office') === -1) {
          var businessChargerIndex = businessIncludes.indexOf('Charger & Bag');
          if (businessChargerIndex === -1) businessChargerIndex = businessIncludes.length;
          businessIncludes.splice(businessChargerIndex, 0, 'Microsoft Office');
        }

        if (hdmiAddonApplied()) {
          businessPorts = ['2x USB-A', '1x USB-C', 'HDMI Port', 'Headphone Jack'];
        }

        setRentalInfoList(rentalIncludesList, businessIncludes);
        setRentalInfoList(rentalPortsList, businessPorts);
        return;
      }

      setRentalInfoList(rentalIncludesList, ['Windows 11, 16GB, 512GB', 'Webcam & Microphone', 'Charger & Bag']);
      setRentalInfoList(rentalPortsList, ['2x USB-A', '1x USB-C', 'Headphone Jack']);
    }

    function attachLivePriceToVariantConfig(config) {
      if (!config || !config.variantId) return null;

      return {
        variantId: config.variantId,
        cents: getLiveVariantPriceCents(config.variantId)
      };
    }

    function getSecurityDepositConfig() {
      var productTitle = String(rentalPageConfig.productTitle || '').toLowerCase();
      var selectedOptionText = getSelectedOptionText();
      var matchedConfig = null;

      if (productTitle.indexOf('business laptop rental') !== -1) {
        var businessSearchText = (getSelectedProcessorText() + ' ' + selectedOptionText).toLowerCase();
        matchedConfig = getBusinessLaptopSecurityDepositConfig(businessSearchText) || businessLaptopSecurityDepositMap.i5;
      }

      if (!matchedConfig && productTitle.indexOf('gaming laptop rental') !== -1) {
        var matchedGraphicsKey = Object.keys(gamingSecurityDepositMap).find(function (graphicsName) {
          return selectedOptionText.indexOf(graphicsName) !== -1;
        });

        if (matchedGraphicsKey) {
          matchedConfig = gamingSecurityDepositMap[matchedGraphicsKey];
        }
      }

      if (!matchedConfig && productTitle.indexOf('macbook rental') !== -1) {
        var macbookSearchText = (productTitle + ' ' + selectedOptionText).toLowerCase();
        var matchedMacbookKey = Object.keys(macbookSecurityDepositMap)
          .sort(function (a, b) { return b.length - a.length; })
          .find(function (modelName) {
            return macbookSearchText.indexOf(modelName) !== -1;
          });

        if (matchedMacbookKey) {
          matchedConfig = macbookSecurityDepositMap[matchedMacbookKey];
        }
      }

      if (!matchedConfig && productTitle.indexOf('ipad rental') !== -1) {
        var ipadSearchText = (productTitle + ' ' + selectedOptionText).toLowerCase();
        var matchedIpadKey = Object.keys(ipadSecurityDepositMap)
          .sort(function (a, b) { return b.length - a.length; })
          .find(function (modelName) {
            return ipadSearchText.indexOf(modelName) !== -1;
          });

        if (matchedIpadKey) {
          matchedConfig = ipadSecurityDepositMap[matchedIpadKey];
        }
      }

      if (matchedConfig && reducedDepositApplies(matchedConfig)) {
        matchedConfig = {
          variantId: matchedConfig.reducedVariantId
        };
      }

      return attachLivePriceToVariantConfig(matchedConfig || {
        variantId: defaultSecurityDepositVariantId
      });
    }

    var securityDepositStockStatusByVariantId = {};

    function hydrateInitialSecurityDepositStockAvailability() {
      var hydratedCount = 0;

      Object.keys(initialSecurityDepositStockByVariantId).forEach(function (variantId) {
        var initialStatus = initialSecurityDepositStockByVariantId[variantId];
        if (!initialStatus || typeof initialStatus !== 'object') return;

        var availableQty = typeof initialStatus.availableQty === 'number'
          ? Math.max(Number(initialStatus.availableQty), 0)
          : null;

        if (typeof initialStatus.description === 'string') {
          cacheSecurityDepositLeadDays(variantId, initialStatus.description);
        }

        securityDepositStockStatusByVariantId[String(variantId)] = {
          variantId: String(variantId),
          available: initialStatus.available !== false,
          availableQty: availableQty,
          source: 'server-rendered'
        };

        hydratedCount += 1;
      });

      return hydratedCount;
    }

    function getSecurityDepositConfigForOptionText(optionText) {
      var productTitle = String(rentalPageConfig.productTitle || '').toLowerCase();
      var searchText = String(optionText || '').toLowerCase();
      var combinedSearchText = (productTitle + ' ' + searchText).toLowerCase();

      if (productTitle.indexOf('business laptop rental') !== -1) {
        return getBusinessLaptopSecurityDepositConfig(searchText);
      }

      if (productTitle.indexOf('gaming laptop rental') !== -1) {
        var matchedGraphicsKey = Object.keys(gamingSecurityDepositMap)
          .sort(function (a, b) { return b.length - a.length; })
          .find(function (graphicsName) {
            return searchText.indexOf(graphicsName) !== -1;
          });

        if (matchedGraphicsKey) {
          return gamingSecurityDepositMap[matchedGraphicsKey];
        }

        return null;
      }

      if (productTitle.indexOf('macbook rental') !== -1) {
        var matchedMacbookKey = Object.keys(macbookSecurityDepositMap)
          .sort(function (a, b) { return b.length - a.length; })
          .find(function (modelName) {
            return combinedSearchText.indexOf(modelName) !== -1;
          });

        if (matchedMacbookKey) {
          return macbookSecurityDepositMap[matchedMacbookKey];
        }

        return null;
      }

      if (productTitle.indexOf('ipad rental') !== -1) {
        var matchedIpadKey = Object.keys(ipadSecurityDepositMap)
          .sort(function (a, b) { return b.length - a.length; })
          .find(function (modelName) {
            return combinedSearchText.indexOf(modelName) !== -1;
          });

        if (matchedIpadKey) {
          return ipadSecurityDepositMap[matchedIpadKey];
        }

        return null;
      }

      return null;
    }

    function getDeviceReservationConfigForOptionText(optionText) {
      return getBusinessLaptopRentalUnitConfigForOptionText(optionText) ||
        getGamingRentalUnitConfigForOptionText(optionText) ||
        getMacbookRentalUnitConfigForOptionText(optionText);
    }

    function getRentalAvailabilityConfigForOptionText(optionText) {
      return getDeviceReservationConfigForOptionText(optionText) ||
        getSecurityDepositConfigForOptionText(optionText);
    }

    function getSelectedRentalAvailabilityConfig() {
      return getSelectedRentalUnitConfig() || getSecurityDepositConfig();
    }

    function getRelevantDeviceReservationVariantIds() {
      var ids = [];

      optionInputs.forEach(function (input) {
        var config = getDeviceReservationConfigForOptionText(input.value);
        if (!config || !config.variantId) return;

        var variantId = String(config.variantId);
        if (ids.indexOf(variantId) === -1) {
          ids.push(variantId);
        }
      });

      var selectedConfig = getSelectedRentalUnitConfig();
      if (selectedConfig && selectedConfig.variantId) {
        var selectedVariantId = String(selectedConfig.variantId);
        if (ids.indexOf(selectedVariantId) === -1) {
          ids.push(selectedVariantId);
        }
      }

      return ids;
    }

    function loadDeviceReservationHideFlags() {
      var variantIds = getRelevantDeviceReservationVariantIds();
      if (!variantIds.length) return Promise.resolve([]);

      return Promise.all(
        variantIds.map(function (variantId) {
          return loadDeviceReservationHideFlagForVariantId(variantId);
        })
      );
    }

    function getRelevantSecurityDepositVariantIds() {
      var ids = [];

      optionInputs.forEach(function (input) {
        var config = getRentalAvailabilityConfigForOptionText(input.value);
        if (!config || !config.variantId) return;

        var variantId = String(config.variantId);
        if (ids.indexOf(variantId) === -1) {
          ids.push(variantId);
        }
      });

      var selectedConfig = getSelectedRentalAvailabilityConfig();
      if (selectedConfig && selectedConfig.variantId) {
        var selectedVariantId = String(selectedConfig.variantId);
        if (ids.indexOf(selectedVariantId) === -1) {
          ids.push(selectedVariantId);
        }
      }

      return ids;
    }

    function fetchCartQuantitiesByVariantId() {
      return fetch('/cart.js?rental_stock_cart=' + Date.now(), {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Cache-Control': 'no-cache'
        },
        cache: 'no-store'
      })
        .then(function (response) {
          setTrustedNowFromResponse(response);

          if (!response.ok) {
            throw new Error('Unable to read the current rental cart quantities.');
          }
          return response.json();
        })
        .then(function (cart) {
          var quantitiesByVariantId = {};

          if (!cart || !Array.isArray(cart.items)) {
            return quantitiesByVariantId;
          }

          cart.items.forEach(function (item) {
            var itemProperties = item && item.properties ? item.properties : {};
            var itemGroupId = String(itemProperties['Rental group ID'] || '').trim();

            if (
              rentalEditModeActive &&
              rentalEditRequestedGroupId &&
              itemGroupId === rentalEditRequestedGroupId
            ) {
              return;
            }

            var variantId = String(item.variant_id || item.id || '');
            if (!variantId) return;

            quantitiesByVariantId[variantId] =
              (quantitiesByVariantId[variantId] || 0) + Number(item.quantity || 0);
          });

          return quantitiesByVariantId;
        })
        .catch(function () {
          return {};
        });
    }

    function fetchSecurityDepositVariantStatus(variantId, cartQuantitiesByVariantId) {
      return fetch('/variants/' + encodeURIComponent(variantId) + '.js?rental_stock=' + Date.now(), {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Cache-Control': 'no-cache'
        },
        cache: 'no-store'
      })
        .then(function (response) {
          setTrustedNowFromResponse(response);

          if (!response.ok) {
            throw new Error('Unable to read rental stock.');
          }
          return response.json();
        })
        .then(function (variant) {
          var available = variant.available !== false;
          var inventoryQuantity = typeof variant.inventory_quantity === 'number'
            ? variant.inventory_quantity
            : null;
          var inventoryManagement = variant.inventory_management || '';
          var inventoryPolicy = variant.inventory_policy || '';
          var quantityInCart = Number(cartQuantitiesByVariantId[String(variantId)] || 0);

          if (
            inventoryQuantity !== null &&
            inventoryManagement &&
            inventoryPolicy !== 'continue'
          ) {
            available = (inventoryQuantity - quantityInCart) > 0;
          }

          return {
            variantId: String(variantId),
            available: available,
            availableQty: inventoryQuantity === null
              ? null
              : Math.max(inventoryQuantity - quantityInCart, 0)
          };
        })
        .catch(function () {
          
          return {
            variantId: String(variantId),
            available: true,
            availableQty: null,
            unknown: true
          };
        });
    }

    function getRequestedAppleMouseQuantity() {
      var quantityInput = rentalForm
        ? rentalForm.querySelector('input[name="quantity"]')
        : document.querySelector('#RentalProductForm input[name="quantity"]');
      var quantity = parseInt(quantityInput ? quantityInput.value : '1', 10);

      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }

    function appleMouseStockCanFulfil(status, requiredQuantity) {
      if (!status || status.unknown || status.available === false) return false;

      if (typeof status.availableQty === 'number') {
        return status.availableQty >= requiredQuantity;
      }

      return status.available !== false;
    }

    function updateAppleMouseAddonAvailability() {
      if (!appleMouseAddonInput || rentalProductTitle.indexOf('macbook rental') === -1) return false;

      var wasChecked = !!appleMouseAddonInput.checked;
      var wasDisabled = !!appleMouseAddonInput.disabled;
      var requiredQuantity = getRequestedAppleMouseQuantity();
      var statusLoaded = !!appleMouseAddonStockStatus;
      var available = statusLoaded && appleMouseStockCanFulfil(
        appleMouseAddonStockStatus,
        requiredQuantity
      );
      var card = appleMouseAddonInput.closest('.rental-addon-card');
      var title = card ? card.querySelector('.rental-addon-title') : null;

      appleMouseAddonInput.disabled = !available;
      appleMouseAddonInput.setAttribute('aria-disabled', available ? 'false' : 'true');

      if (!available && appleMouseAddonInput.checked) {
        appleMouseAddonInput.checked = false;
      }

      if (card) {
        card.classList.toggle('is-rental-stock-unavailable', !available);
        card.setAttribute('aria-disabled', available ? 'false' : 'true');

        if (available) {
          card.removeAttribute('title');
        } else if (!statusLoaded) {
          card.setAttribute('title', 'Checking Apple Mouse availability.');
        } else {
          card.setAttribute('title', 'Apple Mouse is currently unavailable.');
        }
      }

      if (title) title.textContent = 'Apple Mouse';

      var stateChanged =
        wasChecked !== !!appleMouseAddonInput.checked ||
        wasDisabled !== !!appleMouseAddonInput.disabled;

      if (stateChanged) {
        updateAddonCards();
      }

      return stateChanged;
    }

    function fetchAppleMouseAddonVariantStatus(cartQuantitiesByVariantId) {
      return fetchSecurityDepositVariantStatus(appleMouseAddonVariantId, cartQuantitiesByVariantId)
        .then(function (status) {
          
          if (status && status.unknown) {
            status.available = false;
            status.availableQty = 0;
          }
          return status;
        });
    }

    function loadAppleMouseAddonStockAvailability(forcePriceRefresh) {
      if (!appleMouseAddonInput || rentalProductTitle.indexOf('macbook rental') === -1) {
        return Promise.resolve(null);
      }

      var requestSequence = ++appleMouseAddonStockRequestSequence;

      return Promise.all([
        fetchCartQuantitiesByVariantId(),
        loadLiveVariantPricesBestEffort([appleMouseAddonVariantId], !!forcePriceRefresh)
      ])
        .then(function (results) {
          var cartQuantitiesByVariantId = results[0] || {};
          return fetchAppleMouseAddonVariantStatus(cartQuantitiesByVariantId);
        })
        .then(function (status) {
          if (requestSequence !== appleMouseAddonStockRequestSequence) {
            return appleMouseAddonStockStatus;
          }

          appleMouseAddonStockStatus = status || {
            variantId: String(appleMouseAddonVariantId),
            available: false,
            availableQty: 0,
            unknown: true
          };

          updateAppleMouseAddonAvailability();
          syncLiveVariantPriceRows();
          updateTotal();

          return appleMouseAddonStockStatus;
        })
        .catch(function (error) {
          console.error('Apple Mouse stock availability check error:', error);

          if (requestSequence === appleMouseAddonStockRequestSequence) {
            appleMouseAddonStockStatus = {
              variantId: String(appleMouseAddonVariantId),
              available: false,
              availableQty: 0,
              unknown: true
            };
            updateAppleMouseAddonAvailability();
            updateTotal();
          }

          return null;
        });
    }

    function normalisePencilIpadModel(value) {
      var text = getBaseIpadProcessorValue(value)
        .toLowerCase()
        .replace(/[()]/g, ' ')
        .replace(/\b(?:wi-?fi|cellular)\b/g, ' ')
        .replace(/\b(?:model|version|only|from)\b/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

      if (/\bipad\s+air\s+(?:5|5th)(?:\s+gen(?:eration)?)?\b/.test(text) || /\bipad\s+air\b.*\bm1\b/.test(text)) {
        return 'ipad air m1';
      }
      if (/\bipad\s+mini\b.*\ba17\s+pro\b/.test(text)) return 'ipad mini a17 pro';
      if (/\bipad\s+mini\b.*\b6(?:th)?\b/.test(text)) return 'ipad mini 6';
      if (/\bipad\s+pro\b.*\bm1\b/.test(text)) return 'ipad pro m1';
      if (/\bipad\s+pro\b.*\bm2\b/.test(text)) return 'ipad pro m2';
      if (/\bipad\s+pro\b.*\bm4\b/.test(text)) return 'ipad pro m4';
      if (/\bipad\s+pro\b.*\bm5\b/.test(text)) return 'ipad pro m5';
      if (/\bipad\s+air\b.*\bm2\b/.test(text)) return 'ipad air m2';
      if (/\bipad\s+air\b.*\bm3\b/.test(text)) return 'ipad air m3';
      if (/\bipad\s+air\b.*\bm4\b/.test(text)) return 'ipad air m4';
      if (/\bipad\b.*\b(?:11(?:th)?|a16)\b/.test(text)) return 'ipad a16';
      if (/\bipad\b.*\b10(?:th)?\b/.test(text)) return 'ipad 10th';
      if (/\bipad\b.*\b9(?:th)?\b/.test(text)) return 'ipad 9th';
      if (/\bipad\b.*\b8(?:th)?\b/.test(text)) return 'ipad 8th';

      return text;
    }

    function getCompatiblePencilAddonConfigs(processorValue) {
      if (!isIpadRentalPage()) return [];

      var modelKey = normalisePencilIpadModel(processorValue || getRawSelectedProcessorValue());
      if (!modelKey) return [];

      var compatibleConfigs = pencilAddonVariantPriority.filter(function (config) {
        return config.compatibleModels.indexOf(modelKey) !== -1;
      });

      return compatibleConfigs;
    }

    function getRequestedPencilQuantity() {
      var quantityInput = rentalForm
        ? rentalForm.querySelector('input[name="quantity"]')
        : document.querySelector('#RentalProductForm input[name="quantity"]');
      var quantity = parseInt(quantityInput ? quantityInput.value : '1', 10);

      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }

    function pencilStockCanFulfil(status, requiredQuantity) {
      if (!status || status.unknown || status.available === false) return false;

      if (typeof status.availableQty === 'number') {
        return status.availableQty >= requiredQuantity;
      }

      return status.available !== false;
    }

    function getPreferredAvailablePencilAddonConfig(processorValue) {
      var requiredQuantity = getRequestedPencilQuantity();
      var compatibleConfigs = getCompatiblePencilAddonConfigs(processorValue);

      return compatibleConfigs.find(function (config) {
        var status = pencilAddonStockStatusByVariantId[String(config.variantId)];
        return pencilStockCanFulfil(status, requiredQuantity);
      }) || null;
    }

    function setSelectedPencilAddonConfig(config) {
      selectedPencilAddonConfig = config || null;
      pencilAddonVariantId = config ? Number(config.variantId) : 0;
      pencilAddonCents = config
        ? getLiveVariantPriceCents(config.variantId)
        : null;
    }

    function updatePencilAddonAvailability() {
      if (!pencilAddonInput || !isIpadRentalPage()) return false;

      var previousVariantId = Number(pencilAddonVariantId || 0);
      var wasChecked = !!pencilAddonInput.checked;
      var wasDisabled = !!pencilAddonInput.disabled;
      var compatibleConfigs = getCompatiblePencilAddonConfigs(getRawSelectedProcessorValue());
      var selectedConfig = getPreferredAvailablePencilAddonConfig(getRawSelectedProcessorValue());
      var card = pencilAddonInput.closest('.rental-addon-card');
      var title = card ? card.querySelector('.rental-addon-title') : null;
      var available = !!selectedConfig;
      var statusesLoaded = compatibleConfigs.length > 0 && compatibleConfigs.every(function (config) {
        return Object.prototype.hasOwnProperty.call(
          pencilAddonStockStatusByVariantId,
          String(config.variantId)
        );
      });

      setSelectedPencilAddonConfig(selectedConfig);

      pencilAddonInput.disabled = !available;
      pencilAddonInput.setAttribute('aria-disabled', available ? 'false' : 'true');

      if (!available && pencilAddonInput.checked) {
        pencilAddonInput.checked = false;
      }

      if (card) {
        card.classList.toggle('is-rental-stock-unavailable', !available);
        card.setAttribute('aria-disabled', available ? 'false' : 'true');

        if (available) {
          card.removeAttribute('title');
        } else if (!compatibleConfigs.length) {
          card.setAttribute('title', 'Pencil is not available for the selected iPad model.');
        } else if (!statusesLoaded) {
          card.setAttribute('title', 'Checking Pencil availability.');
        } else {
          card.setAttribute('title', 'Pencil is currently unavailable for the selected iPad model.');
        }
      }

      if (title) title.textContent = 'Pencil';

      var stateChanged =
        previousVariantId !== Number(pencilAddonVariantId || 0) ||
        wasChecked !== !!pencilAddonInput.checked ||
        wasDisabled !== !!pencilAddonInput.disabled;

      if (stateChanged) {
        updateAddonCards();
      }

      return stateChanged;
    }

    function fetchPencilAddonVariantStatus(variantId, cartQuantitiesByVariantId) {
      return fetchSecurityDepositVariantStatus(variantId, cartQuantitiesByVariantId)
        .then(function (status) {
          
          if (status && status.unknown) {
            status.available = false;
            status.availableQty = 0;
          }
          return status;
        });
    }

    function loadPencilAddonStockAvailability(forcePriceRefresh) {
      if (!pencilAddonInput || !isIpadRentalPage()) return Promise.resolve(null);

      var requestSequence = ++pencilAddonStockRequestSequence;
      var variantIds = pencilAddonVariantPriority.map(function (config) {
        return config.variantId;
      });

      return Promise.all([
        fetchCartQuantitiesByVariantId(),
        loadLiveVariantPricesBestEffort(variantIds, !!forcePriceRefresh)
      ])
        .then(function (results) {
          var cartQuantitiesByVariantId = results[0] || {};

          return Promise.all(variantIds.map(function (variantId) {
            return fetchPencilAddonVariantStatus(variantId, cartQuantitiesByVariantId);
          }));
        })
        .then(function (statuses) {
          if (requestSequence !== pencilAddonStockRequestSequence) {
            return selectedPencilAddonConfig;
          }

          statuses.forEach(function (status) {
            if (!status || !status.variantId) return;
            pencilAddonStockStatusByVariantId[String(status.variantId)] = status;
          });

          updatePencilAddonAvailability();
          syncLiveVariantPriceRows();
          updateTotal();

          return selectedPencilAddonConfig;
        })
        .catch(function (error) {
          console.error('Pencil stock availability check error:', error);
          updatePencilAddonAvailability();
          updateTotal();
          return null;
        });
    }

    function syncDeviceReservationHiddenSelectOptions() {
      document.querySelectorAll('select[data-option-position]').forEach(function (selectElement) {
        var optionPosition = selectElement.getAttribute('data-option-position');

        Array.prototype.forEach.call(selectElement.options || [], function (option) {
          var matchingRadio = Array.prototype.find.call(optionInputs, function (input) {
            return input.getAttribute('data-option-position') === optionPosition &&
              input.value === option.value;
          });

          var hiddenByReservationFlag = !!(
            matchingRadio &&
            matchingRadio.getAttribute('data-rental-reservation-hidden') === 'true'
          );

          if (hiddenByReservationFlag) {
            option.disabled = true;
            option.hidden = true;
            option.style.display = 'none';
            option.setAttribute('aria-disabled', 'true');
            option.setAttribute('aria-hidden', 'true');
          }
        });
      });
    }

    function markRentalOptionStockState(input, unavailable, hiddenByReservationFlag) {
      if (!input) return;

      var card = input.closest('.rental-option-card');
      if (!card) return;

      var wasHiddenByReservationFlag =
        input.getAttribute('data-rental-reservation-hidden') === 'true';
      var shouldHide = hiddenByReservationFlag === true;
      var shouldDisable = unavailable || shouldHide;

      input.disabled = shouldDisable;
      input.setAttribute(
        'data-rental-reservation-hidden',
        shouldHide ? 'true' : 'false'
      );

      card.classList.toggle('is-rental-stock-unavailable', unavailable && !shouldHide);
      card.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');

      if (shouldHide) {
        card.hidden = true;
        card.style.display = 'none';
        card.setAttribute('aria-hidden', 'true');
        card.removeAttribute('title');
        return;
      }

      if (wasHiddenByReservationFlag) {
        card.hidden = false;
        card.style.removeProperty('display');
        card.removeAttribute('aria-hidden');
      }

      if (unavailable) {
        card.setAttribute('title', 'This rental option is currently unavailable');
      } else {
        card.removeAttribute('title');
      }
    }

    function getCellularAddonTitleElement() {
      if (!cellularAddonInput) return null;
      var card = cellularAddonInput.closest('.rental-addon-card');
      return card ? card.querySelector('.rental-addon-title') : null;
    }

    function ipadCellularRentalVariantExists(baseProcessor) {
      if (!isIpadRentalPage()) return false;

      var cellularProcessor = getCellularIpadProcessorValue(baseProcessor);
      var processorIndex = getRentalProcessorOptionIndex();

      if (!cellularProcessor || processorIndex < 0) return false;

      return allVariants.some(function (variant) {
        return !!(
          variant &&
          Array.isArray(variant.options) &&
          variant.options[processorIndex] === cellularProcessor
        );
      });
    }

    function getIpadConnectivityAvailability(baseProcessor) {
      var baseValue = getBaseIpadProcessorValue(baseProcessor);
      var wifiConfig = baseValue
        ? getSecurityDepositConfigForOptionText(baseValue)
        : null;
      var cellularProcessor = baseValue
        ? getCellularIpadProcessorValue(baseValue)
        : '';
      var cellularConfig = cellularProcessor
        ? getSecurityDepositConfigForOptionText(cellularProcessor)
        : null;
      var wifiStatus = wifiConfig && wifiConfig.variantId
        ? securityDepositStockStatusByVariantId[String(wifiConfig.variantId)]
        : null;
      var cellularStatus = cellularConfig && cellularConfig.variantId
        ? securityDepositStockStatusByVariantId[String(cellularConfig.variantId)]
        : null;

      function stockStatusIsAvailable(status) {
        if (!status) return true;

        if (typeof status.availableQty === 'number' && status.availableQty <= 0) {
          return false;
        }

        return status.available !== false;
      }

      var wifiAvailable = stockStatusIsAvailable(wifiStatus);
      var cellularAvailable = !!(
        cellularProcessor &&
        cellularConfig &&
        cellularConfig.variantId &&
        ipadCellularRentalVariantExists(baseValue) &&
        stockStatusIsAvailable(cellularStatus)
      );

      return {
        baseProcessor: baseValue,
        cellularProcessor: cellularProcessor,
        wifiAvailable: wifiAvailable,
        cellularAvailable: cellularAvailable
      };
    }

    function preserveRestoredIpadConnectivityForEdit() {
      if (
        !rentalEditModeActive ||
        !rentalEditRestoredCellularMode ||
        rentalEditConnectivityTouchedByUser ||
        !cellularAddonInput ||
        !isIpadRentalPage()
      ) {
        return false;
      }

      var availability = getIpadConnectivityAvailability(getRawSelectedProcessorValue());

      // Keep the cart's saved Cellular mode while Edit Rental is hydrating,
      // but never force it when the newly selected model genuinely has no
      // Cellular inventory/configuration. Once the customer manually toggles
      // Connectivity, their choice becomes authoritative instead.
      if (!availability.cellularAvailable || cellularAddonInput.checked) {
        return false;
      }

      cellularAddonInput.checked = true;
      updateAddonCards();
      return true;
    }

    function updateIpadCellularModeAvailability() {
      if (!cellularAddonInput || !isIpadRentalPage()) return false;

      var availability = getIpadConnectivityAvailability(getRawSelectedProcessorValue());
      var forceCellular = !availability.wifiAvailable && availability.cellularAvailable;
      var wasChecked = !!cellularAddonInput.checked;
      var wasDisabled = !!cellularAddonInput.disabled;
      var wasForced = cellularAddonInput.getAttribute('data-cellular-forced') === 'true';
      var card = cellularAddonInput.closest('.rental-addon-card');
      var title = getCellularAddonTitleElement();

      if (forceCellular) {
        cellularAddonInput.checked = true;
        cellularAddonInput.disabled = false;
        cellularAddonInput.setAttribute('data-cellular-forced', 'true');
        cellularAddonInput.setAttribute('aria-disabled', 'true');
      } else {
        
        if (wasForced) {
          cellularAddonInput.checked = false;
        }

        cellularAddonInput.removeAttribute('data-cellular-forced');
        cellularAddonInput.disabled = !availability.cellularAvailable;
        cellularAddonInput.setAttribute(
          'aria-disabled',
          availability.cellularAvailable ? 'false' : 'true'
        );

        if (!availability.cellularAvailable && cellularAddonInput.checked) {
          cellularAddonInput.checked = false;
        }
      }

      if (card) {
        card.classList.toggle('is-rental-stock-unavailable', !availability.cellularAvailable);
        card.classList.toggle('is-cellular-only', forceCellular);
        card.setAttribute(
          'aria-disabled',
          forceCellular || !availability.cellularAvailable ? 'true' : 'false'
        );

        if (forceCellular) {
          card.setAttribute('title', 'Wi-Fi is unavailable for this model. Cellular has been selected.');
        } else if (availability.cellularAvailable) {
          card.removeAttribute('title');
        } else {
          card.setAttribute('title', 'Cellular is unavailable for this iPad model.');
        }
      }

      if (title) {
        
        title.textContent = 'Cellular';
      }

      var modeChanged =
        wasChecked !== !!cellularAddonInput.checked ||
        wasDisabled !== !!cellularAddonInput.disabled ||
        wasForced !== forceCellular;

      if (modeChanged) {
        updateAddonCards();
      }

      return modeChanged;
    }

    function applySecurityDepositStockStatusToOptions() {
      optionInputs.forEach(function (input) {
        if (
          isIpadRentalPage() &&
          !isIpadCellularProcessorValue(input.value) &&
          input.getAttribute('data-option-position') === getRentalProcessorSelectPosition()
        ) {
          var connectivity = getIpadConnectivityAvailability(input.value);

          markRentalOptionStockState(
            input,
            !connectivity.wifiAvailable && !connectivity.cellularAvailable
          );
          return;
        }

        var config = getRentalAvailabilityConfigForOptionText(input.value);

        if (!config || !config.variantId) {
          return;
        }

        var reservationConfig = getDeviceReservationConfigForOptionText(input.value);
        var hiddenByReservationFlag = !!(
          reservationConfig &&
          reservationConfig.variantId &&
          deviceReservationIsHidden(reservationConfig.variantId)
        );
        var status = securityDepositStockStatusByVariantId[String(config.variantId)];

        if (!status && !hiddenByReservationFlag) return;

        markRentalOptionStockState(
          input,
          !!(status && status.available === false),
          hiddenByReservationFlag
        );
      });

      document.querySelectorAll('.rental-option-group[data-option-position]').forEach(function (group) {
        var checked = group.querySelector('.rental-option-radio:checked');

        if (checked && checked.disabled) {
          var replacement = group.querySelector('.rental-option-radio:not(:disabled):not([data-internal-cellular-processor="true"])');

          if (replacement) {
            replacement.checked = true;
            replacement.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });

      var cellularModeChanged = updateIpadCellularModeAvailability();
      var restoredCellularMode = preserveRestoredIpadConnectivityForEdit();

      if (cellularModeChanged || restoredCellularMode) {
        refreshSelectedRentalConfiguration();
        return;
      }

      applyMinimumRentalPeriodRule();
      syncRentalPeriodSelectFromRadio();
      syncRentalPeriodSelectDisabledOptions();
      syncRentalProcessorSelectFromRadio();
      syncRentalProcessorSelectDisabledOptions();
      syncDeviceReservationHiddenSelectOptions();
      updateSelectedCards();
      updateTotal();
      updateRentalInfoPanels();
      updateRentalEndInfo();
    }

    function loadSecurityDepositStockAvailability() {
      var variantIds = getRelevantSecurityDepositVariantIds();
      if (!variantIds.length) return Promise.resolve([]);

      return Promise.all([
        fetchCartQuantitiesByVariantId()
          .then(function (cartQuantitiesByVariantId) {
            return Promise.all(
              variantIds.map(function (variantId) {
                return fetchSecurityDepositVariantStatus(variantId, cartQuantitiesByVariantId);
              })
            );
          }),
        loadDeviceReservationHideFlags()
      ])
        .then(function (results) {
          var statuses = results[0] || [];

          statuses.forEach(function (status) {
            securityDepositStockStatusByVariantId[String(status.variantId)] = status;
          });

          applySecurityDepositStockStatusToOptions();
        })
        .catch(function (error) {
          console.error('Rental stock availability check error:', error);
        });
    }

    function selectedRentalOptionIsAvailable() {
      var selectedConfig = getSelectedRentalAvailabilityConfig();

      if (!selectedConfig || !selectedConfig.variantId) {
        return true;
      }

      var status = securityDepositStockStatusByVariantId[String(selectedConfig.variantId)];

      if (status && status.available === false) {
        return false;
      }

      if (
        status &&
        typeof status.availableQty === 'number' &&
        status.availableQty < getRequestedRentalQuantity()
      ) {
        return false;
      }

      var selectedUnavailableInput = Array.prototype.some.call(optionInputs, function (input) {
        return input.checked && input.disabled;
      });

      return !selectedUnavailableInput;
    }

    function selectedGamingProcessorIncludes32GB() {
      if (!memoryAddonInput || rentalProductTitle.indexOf('gaming laptop rental') === -1) return false;

      var gamingProcessorText = String(getSelectedProcessorText() || '').toLowerCase();
      return gamingProcessorText.indexOf('rtx 5070') !== -1 ||
        gamingProcessorText.indexOf('rtx 5080') !== -1;
    }

    function selectedBusinessProcessorDisallows32GB() {
      if (!memoryAddonInput || rentalProductTitle.indexOf('business laptop rental') === -1) return false;

      var businessProcessorText = String(getSelectedProcessorText() || '').toLowerCase();
      return /(^|[^a-z0-9])i5([^a-z0-9]|$)/i.test(businessProcessorText) ||
        businessProcessorText.indexOf('ryzen 5') !== -1 ||
        businessProcessorText.indexOf('ultra 5') !== -1 ||
        businessProcessorText.indexOf('lg gram 16') !== -1;
    }

    function updateMemoryAddonAvailability() {
      if (!memoryAddonInput) return false;

      var gamingIncludes32GB = selectedGamingProcessorIncludes32GB();
      var businessDisallows32GB = selectedBusinessProcessorDisallows32GB();
      var unavailable = gamingIncludes32GB || businessDisallows32GB;
      var wasChecked = !!memoryAddonInput.checked;
      var wasDisabled = !!memoryAddonInput.disabled;
      var card = memoryAddonInput.closest('.rental-addon-card');
      var title = card ? card.querySelector('.rental-addon-title') : null;

      if (unavailable && memoryAddonInput.checked) {
        memoryAddonInput.checked = false;
      }

      memoryAddonInput.disabled = unavailable;
      memoryAddonInput.setAttribute('aria-disabled', unavailable ? 'true' : 'false');

      if (card) {
        card.classList.toggle('is-rental-stock-unavailable', unavailable);
        card.setAttribute('aria-disabled', unavailable ? 'true' : 'false');

        if (gamingIncludes32GB) {
          card.setAttribute('title', '32GB memory is already included with the selected graphics tier.');
        } else if (businessDisallows32GB) {
          card.setAttribute('title', '32GB memory is not available for the selected business laptop tier.');
        } else {
          card.removeAttribute('title');
        }
      }

      if (title) title.textContent = '32GB Memory';

      var stateChanged =
        wasChecked !== !!memoryAddonInput.checked ||
        wasDisabled !== !!memoryAddonInput.disabled;

      if (stateChanged) updateAddonCards();
      return stateChanged;
    }

    function memoryAddonApplied() {
      return !!(memoryAddonInput && memoryAddonInput.checked && !memoryAddonInput.disabled);
    }

    function officeAddonApplied() {
      return !!(officeAddonInput && officeAddonInput.checked);
    }

    function appleMouseAddonApplied() {
      return !!(appleMouseAddonInput && appleMouseAddonInput.checked);
    }

    function hdmiAddonApplied() {
      return !!(hdmiAddonInput && hdmiAddonInput.checked);
    }

    function cellularAddonApplied() {
      return !!(cellularAddonInput && cellularAddonInput.checked);
    }

    function pencilAddonApplied() {
      return !!(pencilAddonInput && pencilAddonInput.checked);
    }

    function standardReturnExtensionApplied() {
      // Retained for compatibility with legacy cart lines only. New calendar
      // rentals do not charge a standard return extension.
      return false;
    }

    function priorityReturnExtensionApplied() {
      return !!(returnTimeInput && returnTimeInput.value === '9pm–11pm');
    }

    function getRentalTimingSlotMinutes(value, isDelivery) {
      var key = String(value || '');
      var slots = {
        '9am–11am': { start: 9 * 60, end: 11 * 60 },
        '11am–1pm': { start: 11 * 60, end: 13 * 60 },
        '1pm–3pm': { start: 13 * 60, end: 15 * 60 },
        '3pm–5pm': { start: 15 * 60, end: 17 * 60 },
        '5pm–7pm': { start: 17 * 60, end: 19 * 60 },
        '7pm–9pm': { start: 19 * 60, end: 21 * 60 },
        '9pm–11pm': { start: 21 * 60, end: 23 * 60 }
      };

      if (isDelivery && key === 'early') {
        return { start: 8 * 60, end: 10 * 60 };
      }

      return slots[key] || null;
    }

    function selectedRentalDatesAreSameDay() {
      if (!startDateInput || !rentalEndDateInput) return false;
      return !!(startDateInput.value && rentalEndDateInput.value &&
        startDateInput.value === rentalEndDateInput.value);
    }

    function sameDayReturnCanFollowDeliveryValue(value) {
      if (!value) return true;

      var deliverySlot = getRentalTimingSlotMinutes(value, true);
      if (!deliverySlot) return false;

      // Operational rule: a same-day rental must be delivered by 7pm at the
      // latest. Deliveries from 7pm onwards do not leave enough time to
      // arrange a same-day collection, even though a later return slot exists.
      return deliverySlot.end <= (19 * 60);
    }

    function sameDayReturnOperationallyPossible() {
      if (!selectedRentalDatesAreSameDay()) return true;

      if (deliveryTimeInput && deliveryTimeInput.value) {
        return sameDayReturnCanFollowDeliveryValue(deliveryTimeInput.value);
      }

      // If no delivery slot has been chosen yet, determine whether the current
      // trusted Singapore-time delivery tier still contains at least one slot
      // that can support a same-day collection. This makes the return field
      // close immediately during the 3pm-5pm booking window, where the earliest
      // same-day delivery is 7pm-9pm.
      var tier = getPlayTimeDeliveryTier();
      if (!tier || !playTimeDeliveryTierRules[tier]) return true;

      var allowed = playTimeDeliveryTierRules[tier].allowed || {};
      return Object.keys(allowed).some(function (value) {
        return allowed[value] !== 'blocked' && sameDayReturnCanFollowDeliveryValue(value);
      });
    }

    function returnTimingIsAfterSelectedDelivery(value) {
      if (!selectedRentalDatesAreSameDay()) return true;
      if (!deliveryTimeInput || !deliveryTimeInput.value) return true;
      if (!sameDayReturnCanFollowDeliveryValue(deliveryTimeInput.value)) return false;

      var deliverySlot = getRentalTimingSlotMinutes(deliveryTimeInput.value, true);
      var returnSlot = getRentalTimingSlotMinutes(value, false);
      if (!deliverySlot || !returnSlot) return false;

      return returnSlot.start >= deliverySlot.end;
    }

    function appendNoSameDayReturnOption() {
      if (!returnTimeInput) return;

      var option = document.createElement('option');
      option.value = '';
      option.textContent = 'No timing available for same-day return — please select the next day';
      option.selected = true;
      returnTimeInput.appendChild(option);
    }

    function rebuildReturnOptions() {
      if (!returnTimeInput) return false;

      var livePreviousValue = String(returnTimeInput.value || '');
      if (livePreviousValue) {
        retainedRentalReturnTimeValue = livePreviousValue;
      }

      var previousValue = livePreviousValue || retainedRentalReturnTimeValue;
      var hasSelectedRentalPeriod = calendarRentalRangeIsComplete();
      var sameDayRental = selectedRentalDatesAreSameDay();
      var hasSelectedDelivery = !!(deliveryTimeInput && deliveryTimeInput.value);
      var sameDayReturnPossible = !sameDayRental || sameDayReturnOperationallyPossible();

      returnTimeInput.innerHTML = '';

      /* Return timing has two dependency states:
         1) no completed rental period yet -> wait for Rental Period
         2) rental period complete, but no delivery timing -> wait for Schedule Delivery

         Keep the retained return timing through either dependency state. The
         customer may simply be between the first and second date click, or the
         previous delivery may be awaiting restoration. */
      if (!hasSelectedRentalPeriod) {
        var rentalPeriodDependencyOption = document.createElement('option');
        rentalPeriodDependencyOption.value = '';
        rentalPeriodDependencyOption.textContent = 'Select rental period first';
        rentalPeriodDependencyOption.selected = true;
        returnTimeInput.appendChild(rentalPeriodDependencyOption);
        returnTimeInput.disabled = true;
        returnTimeInput.setAttribute('aria-disabled', 'true');
        clearRentalFieldPrompt(returnTimeInput);
        return false;
      }

      if (!hasSelectedDelivery) {
        var dependencyOption = document.createElement('option');
        dependencyOption.value = '';
        dependencyOption.textContent = 'Schedule Delivery first';
        dependencyOption.selected = true;
        returnTimeInput.appendChild(dependencyOption);
        returnTimeInput.disabled = true;
        returnTimeInput.setAttribute('aria-disabled', 'true');
        clearRentalFieldPrompt(returnTimeInput);
        return false;
      }

      if (sameDayRental && !sameDayReturnPossible) {
        appendNoSameDayReturnOption();
        returnTimeInput.disabled = true;
        returnTimeInput.setAttribute('aria-disabled', 'true');
        clearRentalFieldPrompt(returnTimeInput);
        retainedRentalReturnTimeValue = '';
        return true;
      }

      returnTimeInput.disabled = false;
      returnTimeInput.setAttribute('aria-disabled', 'false');

      originalReturnOptions.forEach(function (item) {
        if (item.value && sameDayRental && !returnTimingIsAfterSelectedDelivery(item.value)) {
          return;
        }

        var option = document.createElement('option');
        option.value = item.value;
        option.textContent = item.value ? item.text : 'Select return timeslot';
        returnTimeInput.appendChild(option);
      });

      syncReturnTimingOptionPrices();

      var previousStillAvailable = !!previousValue && Array.prototype.some.call(returnTimeInput.options, function (option) {
        return option.value === previousValue && !option.disabled;
      });

      if (previousStillAvailable) {
        returnTimeInput.value = previousValue;
        retainedRentalReturnTimeValue = previousValue;
      } else {
        returnTimeInput.value = '';
        if (previousValue) {
          retainedRentalReturnTimeValue = '';
          clearRentalFieldPrompt(returnTimeInput);
        }
      }

      return sameDayRental;
    }

    function sameDayReturnHasAvailableSlot() {
      if (!selectedRentalDatesAreSameDay() || !returnTimeInput) {
        return true;
      }

      if (!sameDayReturnOperationallyPossible()) return false;

      return Array.prototype.some.call(returnTimeInput.options, function (option) {
        return !!option.value;
      });
    }

    function updateSecurityDepositSummaryIndicator() {
      var selectedBusinessTierConfig = getSelectedDynamicDepositConfig();
      var reducedDepositApplied = reducedDepositApplies(selectedBusinessTierConfig);

      if (securityDepositReducedBadge) {
        securityDepositReducedBadge.hidden = !reducedDepositApplied;
      }

      if (securityDepositSubtext) {
        securityDepositSubtext.textContent = reducedDepositApplied
          ? BUSINESS_REDUCED_DEPOSIT_MIN_DAYS + ' day rate · Refunded within 3 business days'
          : 'Refunded within 3 business days';
      }
    }

    function updateTotal() {
      updateBasePriceLabel();
      syncLiveVariantPriceRows();
      updateSecurityDepositSummaryIndicator();

      var basePrice = getBasePrice();
      var applyWeekend = weekendApplied();
      var applyEarly = earlyDeliveryApplied();
      var applyPriorityUrgent = priorityUrgentChargeApplied();
      var applyStandardUrgent = standardUrgentChargeApplied();
      var applyStandardReturnExtension = standardReturnExtensionApplied();
      var applyPriorityReturnExtension = priorityReturnExtensionApplied();
      var applyMemoryAddon = memoryAddonApplied();
      var applyOfficeAddon = officeAddonApplied();
      var applyAppleMouseAddon = appleMouseAddonApplied();
      var applyHdmiAddon = hdmiAddonApplied();
      var applyPencilAddon = pencilAddonApplied();
      var securityDepositConfig = getSecurityDepositConfig();
      var securityDepositCents = securityDepositConfig ? securityDepositConfig.cents : null;

      if (memoryAddonRow) memoryAddonRow.style.display = applyMemoryAddon ? 'flex' : 'none';
      if (officeAddonRow) officeAddonRow.style.display = applyOfficeAddon ? 'flex' : 'none';
      if (appleMouseAddonRow) appleMouseAddonRow.style.display = applyAppleMouseAddon ? 'flex' : 'none';
      if (hdmiAddonRow) hdmiAddonRow.style.display = applyHdmiAddon ? 'flex' : 'none';
      if (cellularAddonRow) cellularAddonRow.style.display = 'none';
      if (pencilAddonRow) pencilAddonRow.style.display = applyPencilAddon ? 'flex' : 'none';

      if (surchargeRow) surchargeRow.style.display = applyWeekend ? 'flex' : 'none';
      if (earlyDeliveryRow) earlyDeliveryRow.style.display = applyEarly ? 'flex' : 'none';
      if (priorityUrgentChargeRow) priorityUrgentChargeRow.style.display = applyPriorityUrgent ? 'flex' : 'none';
      if (standardUrgentChargeRow) standardUrgentChargeRow.style.display = applyStandardUrgent ? 'flex' : 'none';
      if (standardReturnExtensionRow) {
        standardReturnExtensionRow.style.display = 'none';
      }
      if (priorityReturnExtensionRow) {
        priorityReturnExtensionRow.style.display = applyPriorityReturnExtension ? 'flex' : 'none';
      }

      if (surchargeAppliedInput) surchargeAppliedInput.value = applyWeekend ? 'Yes' : 'No';
      if (surchargeAmountInput) {
        surchargeAmountInput.value = applyWeekend && Number.isFinite(weekendSurchargeCents)
          ? formatMoney(weekendSurchargeCents)
          : (applyWeekend ? '' : formatMoney(0));
      }

      if (securityDepositValueEl) {
        securityDepositValueEl.textContent = Number.isFinite(securityDepositCents)
          ? formatMoney(securityDepositCents)
          : 'Loading…';
      }

      if (mobileSummaryJumpDeposit) {
        mobileSummaryJumpDeposit.textContent = Number.isFinite(securityDepositCents)
          ? formatMoney(securityDepositCents)
          : 'Loading…';
      }

      var requiredPrices = [securityDepositCents];
      if (applyWeekend) requiredPrices.push(weekendSurchargeCents);
      if (applyEarly) requiredPrices.push(earlyDeliverySurchargeCents);
      if (applyPriorityUrgent) requiredPrices.push(priorityUrgentChargeCents);
      if (applyStandardUrgent) requiredPrices.push(standardUrgentChargeCents);
      if (applyStandardReturnExtension) requiredPrices.push(standardReturnExtensionCents);
      if (applyPriorityReturnExtension) requiredPrices.push(priorityReturnExtensionCents);
      if (applyMemoryAddon) requiredPrices.push(memoryAddonCents);
      if (applyOfficeAddon) requiredPrices.push(officeAddonCents);
      if (applyAppleMouseAddon) requiredPrices.push(appleMouseAddonCents);
      if (applyHdmiAddon) requiredPrices.push(hdmiAddonCents);
      if (applyPencilAddon) requiredPrices.push(pencilAddonCents);

      var pricingReady = requiredPrices.every(function (cents) {
        return Number.isFinite(cents);
      });

      if (!pricingReady) {
        if (rentalChargesTotalEl) rentalChargesTotalEl.textContent = 'Loading…';
        if (totalPriceEl) totalPriceEl.textContent = 'Loading…';
        if (mobileSummaryJumpRentalCost) mobileSummaryJumpRentalCost.textContent = 'Loading…';
        return;
      }

      var total = basePrice
        + securityDepositCents
        + (applyWeekend ? weekendSurchargeCents : 0)
        + (applyEarly ? earlyDeliverySurchargeCents : 0)
        + (applyPriorityUrgent ? priorityUrgentChargeCents : 0)
        + (applyStandardUrgent ? standardUrgentChargeCents : 0)
        + (applyStandardReturnExtension ? standardReturnExtensionCents : 0)
        + (applyPriorityReturnExtension ? priorityReturnExtensionCents : 0)
        + (applyMemoryAddon ? memoryAddonCents : 0)
        + (applyOfficeAddon ? officeAddonCents : 0)
        + (applyAppleMouseAddon ? appleMouseAddonCents : 0)
        + (applyHdmiAddon ? hdmiAddonCents : 0)
        + (applyPencilAddon ? pencilAddonCents : 0);

      var rentalChargesTotal = total - securityDepositCents;

      if (rentalChargesTotalEl) rentalChargesTotalEl.textContent = formatMoney(rentalChargesTotal);
      if (totalPriceEl) totalPriceEl.textContent = formatFinalRentalTotalMoney(total);

      if (mobileSummaryJumpRentalCost) {
        mobileSummaryJumpRentalCost.textContent = formatMoney(rentalChargesTotal);
      }
    }

    function parseLocalDate(dateString) {
      if (!dateString) return null;
      var parts = dateString.split('-');
      if (parts.length !== 3) return null;

      var date = new Date(parts[0], parts[1] - 1, parts[2]);
      date.setHours(0, 0, 0, 0);
      return date;
    }

    function formatDisplayDate(date) {
      if (!date) return '-';

      var day = date.getDate();
      var year = date.getFullYear();

      var months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];

      var monthName = months[date.getMonth()];

      return day + ' ' + monthName + ' ' + year;
    }

    function formatRentalCalendarDateShort(date) {
      if (!date) return '-';

      var months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];

      return date.getDate() + ' ' + months[date.getMonth()] + ' ' + date.getFullYear();
    }

    function formatDateProperty(date) {
      if (!date) return '';

      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');

      return year + '-' + month + '-' + day;
    }

    function getSelectedRentalPeriod() {
      var groups = document.querySelectorAll('.rental-option-group');
      var selectedValue = '';

      groups.forEach(function (group) {
        var titleEl = group.querySelector('.rental-option-group-title');
        var checked = group.querySelector('.rental-option-radio:checked');

        if (!titleEl || !checked) return;

        var groupTitle = (titleEl.textContent || '').trim().toLowerCase();
        if (groupTitle === 'rental period') {
          selectedValue = checked.value;
        }
      });

      return selectedValue;
    }

    function getRentalEndDate(startDate, rentalPeriod) {
  if (!startDate || !rentalPeriod) return null;

  var endDate = new Date(startDate.getTime());
  var period = String(rentalPeriod || '').toLowerCase();

  function getMonthDuration(value) {
    var match = String(value || '').match(/(\d+)\s*month/i);
    return match ? parseInt(match[1], 10) : 0;
  }

  function getEndDateByCalendarMonths(date, months) {
    var targetFirstDay = new Date(date.getFullYear(), date.getMonth() + months, 1);
    var targetLastDay = new Date(targetFirstDay.getFullYear(), targetFirstDay.getMonth() + 1, 0).getDate();
    var targetDay = Math.min(date.getDate(), targetLastDay);
    var result = new Date(targetFirstDay.getFullYear(), targetFirstDay.getMonth(), targetDay);

    result.setDate(result.getDate() - 1);
    return result;
  }

  var monthDuration = getMonthDuration(period);
  if (monthDuration > 0) {
    return getEndDateByCalendarMonths(startDate, monthDuration);
  }

  if (period.indexOf('1 day') !== -1) {
    endDate.setDate(endDate.getDate() + 0);
    return endDate;
  }

  if (period.indexOf('2 day') !== -1) {
    endDate.setDate(endDate.getDate() + 1);
    return endDate;
  }

  if (period.indexOf('3 day') !== -1) {
    endDate.setDate(endDate.getDate() + 2);
    return endDate;
  }

  if (period.indexOf('4 day') !== -1) {
    endDate.setDate(endDate.getDate() + 3);
    return endDate;
  }

  if (period.indexOf('5 day') !== -1) {
    endDate.setDate(endDate.getDate() + 4);
    return endDate;
  }

  if (period.indexOf('6 day') !== -1) {
    endDate.setDate(endDate.getDate() + 5);
    return endDate;
  }

  if (period.indexOf('1 week') !== -1) {
    endDate.setDate(endDate.getDate() + 6);
    return endDate;
  }

  if (period.indexOf('2 week') !== -1) {
    endDate.setDate(endDate.getDate() + 13);
    return endDate;
  }

  if (period.indexOf('3 week') !== -1) {
    endDate.setDate(endDate.getDate() + 20);
    return endDate;
  }

  return null;
}

    function validateTimingFields() {
      var deliveryValid = deliveryTimeInput && deliveryTimeInput.value;
      var returnValid = returnTimeInput && returnTimeInput.value;

      if (!deliveryValid || !returnValid) return false;

      if (selectedRentalDatesAreSameDay() && !returnTimingIsAfterSelectedDelivery(returnTimeInput.value)) {
        return false;
      }

      return true;
    }

    function clearRequiredDocumentsAttention() {
      if (requiredDocumentsPanel) {
        requiredDocumentsPanel.classList.remove('is-required-attention');
      }

      if (uploadDocumentsPanel) {
        uploadDocumentsPanel.classList.remove('is-required-attention');
      }

      if (jotformStatusNote) {
        jotformStatusNote.classList.remove('is-error');
      }
    }

    function focusRequiredDocumentsPanel() {
      if (!requiredDocumentsPanel) return;

      if (!rentalReviewStageActive) {
        setRentalReviewStage(true, { scroll: false });
      }

      if (compatibilityPanel && compatibilityPanel.open) {
        compatibilityPanel.open = false;
      }

      requiredDocumentsPanel.open = true;
      requiredDocumentsPanel.classList.add('is-required-attention');
      suppressMobileSummaryJumpForValidation();

      if (uploadDocumentsPanel) {
        uploadDocumentsPanel.classList.add('is-required-attention');
      }

      if (jotformStatusNote) {
        jotformStatusNote.textContent = 'Please upload the required documents before selecting rental.';
        jotformStatusNote.classList.remove('is-success');
        jotformStatusNote.classList.add('is-error');
      }

      window.setTimeout(function () {
        (uploadDocumentsPanel || requiredDocumentsPanel).scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 80);
    }

    function updateRentalEndInfo() {
      var startValue = startDateInput ? startDateInput.value : '';
      var startDate = parseLocalDate(startValue);
      var rentalPeriod = getSelectedRentalPeriod();
      var endDate = getRentalEndDate(startDate, rentalPeriod);
      var selectedDeliveryTime = deliveryTimeInput && deliveryTimeInput.selectedIndex > 0
        ? stripDeliveryChargeSuffix(deliveryTimeInput.options[deliveryTimeInput.selectedIndex].text)
        : '';
      var selectedReturnTime = returnTimeInput && returnTimeInput.value ? returnTimeInput.value : '';

      if (!startDate || !rentalPeriod || !endDate) {
        if (endInfoWrap) endInfoWrap.style.display = 'none';
        if (startPreview) startPreview.textContent = '-';
        if (endPreview) endPreview.textContent = '-';
        if (returnNote) returnNote.textContent = 'Schedule Delivery first';
        if (rentalPriceMobileTimingRows) rentalPriceMobileTimingRows.style.display = 'none';
        if (rentalPriceMobileStart) rentalPriceMobileStart.textContent = '-';
        if (rentalPriceMobileEnd) rentalPriceMobileEnd.textContent = '-';
        return;
      }

      if (endInfoWrap) endInfoWrap.style.display = 'block';

      if (startPreview) {
        startPreview.textContent = formatDisplayDate(startDate) + (selectedDeliveryTime ? ', ' + selectedDeliveryTime : '');
      }

      if (endPreview) {
        endPreview.textContent = formatDisplayDate(endDate) + (selectedReturnTime ? ', ' + selectedReturnTime : '');
      }

      if (returnNote) {
        returnNote.textContent = selectedReturnTime ? 'Scheduled return: ' + selectedReturnTime : (selectedDeliveryTime ? 'Select your return timeslot.' : 'Schedule Delivery first');
      }

      if (rentalPriceMobileTimingRows) {
        rentalPriceMobileTimingRows.style.display = 'block';
      }

      if (rentalPriceMobileStart) {
        rentalPriceMobileStart.textContent = formatDisplayDate(startDate) + (selectedDeliveryTime ? ', ' + selectedDeliveryTime : '');
      }

      if (rentalPriceMobileEnd) {
        rentalPriceMobileEnd.textContent = formatDisplayDate(endDate) + (selectedReturnTime ? ', ' + selectedReturnTime : '');
      }

      updateMobileSummaryJumpVisibility();
    }

    function restoreNodeToOriginalPosition(node, originalParent, originalNextSibling) {
      if (!node || !originalParent) return;

      if (node.parentNode === originalParent) {
        if (originalNextSibling && node.nextSibling === originalNextSibling) return;
        if (!originalNextSibling && node === originalParent.lastChild) return;
      }

      if (originalNextSibling && originalNextSibling.parentNode === originalParent) {
        originalParent.insertBefore(node, originalNextSibling);
      } else {
        originalParent.appendChild(node);
      }
    }

    function setReviewElementVisibility(isVisible) {
      /* Page 1 owns the Rental Summary. Page 2 owns documents + T&Cs + final submit. */
      if (documentsStepSection) documentsStepSection.hidden = !isVisible;
      if (priceBoxEl) priceBoxEl.hidden = !!isVisible;
      if (rentalTermsField) rentalTermsField.hidden = !isVisible;
      if (submitButton) submitButton.hidden = !isVisible;
      if (proceedToDocumentsWrap) proceedToDocumentsWrap.hidden = !!isVisible;
      updateRentalEditPrimaryActions();
    }

    function setRentalReviewStage(active, options) {
      options = options || {};
      rentalReviewStageActive = !!active;

      updateMobileReviewFlowLayout();
      setReviewElementVisibility(rentalReviewStageActive);

      if (rentalInfoPanels) {
        rentalInfoPanels.hidden = rentalReviewStageActive;
        rentalInfoPanels.setAttribute('aria-hidden', rentalReviewStageActive ? 'true' : 'false');
      }

      if (rentalFormWrap) {
        rentalFormWrap.hidden = rentalReviewStageActive;
        rentalFormWrap.setAttribute('aria-hidden', rentalReviewStageActive ? 'true' : 'false');
      }

      if (rentalMobileTitle) {
        rentalMobileTitle.hidden = rentalReviewStageActive;
        rentalMobileTitle.setAttribute('aria-hidden', rentalReviewStageActive ? 'true' : 'false');
      }

      if (rentalProductPage) {
        rentalProductPage.classList.toggle('is-rental-review-stage', rentalReviewStageActive);
      }

      if (mobileStandaloneReviewHost) {
        mobileStandaloneReviewHost.hidden = !rentalReviewStageActive;
        mobileStandaloneReviewHost.setAttribute('aria-hidden', rentalReviewStageActive ? 'false' : 'true');
      }

      ensureRequiredDocumentsStepLockedOpen();

      if (rentalReviewStageActive) {
        updateRentalEndInfo();
        updateTotal();
      }

      updateMobileSummaryJumpVisibility();

      if (options.scroll === false) return;

      var scrollTarget = rentalReviewStageActive
        ? (mobileStandaloneReviewHost || documentsStepSection || priceBoxEl)
        : (rentalInfoPanels || rentalFormWrap || rentalOptionsField || rentalDetails);

      if (scrollTarget && typeof scrollTarget.scrollIntoView === 'function') {
        window.setTimeout(function () {
          scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 40);
      }
    }

    function validateRentalOptionsBeforeDocuments() {
      if (!validateRequiredRentalFieldsWithPrompt()) return false;

      if (!selectedRentalOptionIsAvailable()) {
        window.alert('The selected rental item is currently unavailable. Please choose another option.');
        return false;
      }

      var duration = getSelectedRentalDurationDays();
      var pricing = getCalendarPricingBreakdown(duration, getRequestedRentalQuantity());
      if (!pricing || !pricing.valid || !pricing.components || !pricing.components.length) {
        window.alert(
          pricing && pricing.missing && pricing.missing.length
            ? 'Calendar pricing is not configured for: ' + pricing.missing.join(', ') + '.'
            : 'Unable to calculate the rental price for the selected dates. Please choose the dates again.'
        );
        return false;
      }

      return true;
    }

    function proceedToRentalDocuments() {
      if (!validateRentalOptionsBeforeDocuments()) return;
      clearRentalFieldPrompt(startDateInput);
      clearRentalFieldPrompt(deliveryTimeInput);
      clearRentalFieldPrompt(returnTimeInput);
      setRentalReviewStage(true);
    }

    function returnToRentalOptions() {
      setRentalReviewStage(false);
    }

    function getRentalWhatsAppOptionalExtras(rentalQuantity) {
      var extras = [];
      var quantity = Math.max(1, parseInt(rentalQuantity, 10) || 1);

      function addPricedExtra(label, cents) {
        var numericCents = Number(cents);
        var price = Number.isFinite(numericCents)
          ? formatMoney(numericCents * quantity)
          : '';
        extras.push(label + ': ' + (price || 'Price unavailable'));
      }

      if (memoryAddonApplied()) addPricedExtra('32GB Memory', memoryAddonCents);
      if (officeAddonApplied()) addPricedExtra('MS Office', officeAddonCents);
      if (appleMouseAddonApplied()) addPricedExtra('Apple Mouse', appleMouseAddonCents);
      if (hdmiAddonApplied()) addPricedExtra('HDMI Port', hdmiAddonCents);

      /* Cellular is priced inside the selected iPad rental variant rather than
         as a separate linked charge, so there is no standalone fee to display. */
      if (cellularAddonApplied()) {
        extras.push('Cellular: Included in Rental Fee');
      }

      if (pencilAddonApplied()) {
        var pencilLabel = selectedPencilAddonConfig && selectedPencilAddonConfig.label
          ? selectedPencilAddonConfig.label
          : 'Pencil';
        addPricedExtra(pencilLabel, pencilAddonCents);
      }

      return extras;
    }

    function buildRentalWhatsAppMessage() {
      updateRentalEndInfo();
      updateTotal();

      var selectedOption = getSelectedCompatibilityOptionText() || getSelectedProcessorText() || 'Not selected';
      var quantity = getRequestedRentalQuantity();
      var duration = getSelectedRentalDurationDays();
      var delivery = deliveryTimeInput && deliveryTimeInput.selectedIndex > 0
        ? stripDeliveryChargeSuffix(deliveryTimeInput.options[deliveryTimeInput.selectedIndex].text)
        : 'Not selected';
      var returnTiming = returnTimeInput && returnTimeInput.value
        ? returnTimeInput.value
        : 'Not selected';
      var startDate = startDateInput && startDateInput.value
        ? formatDisplayDate(parseLocalDate(startDateInput.value))
        : 'Not selected';
      var endDateValue = rentalEndDateInput ? String(rentalEndDateInput.value || '') : '';
      var endDate = endDateValue
        ? formatDisplayDate(parseLocalDate(endDateValue))
        : 'Not selected';
      var extras = getRentalWhatsAppOptionalExtras(quantity);
      var notes = rentalNotes && rentalNotes.value ? rentalNotes.value.trim() : '';

      /*
       * The product-page summary is priced per physical device. WhatsApp should
       * describe the whole requested rental group so its money values reconcile
       * with Quantity and with the cart WhatsApp total.
       *
       * Example: $150 rental + $200 deposit × quantity 2 = S$700 total.
       */
      var rentalFeeCents = Number(getBasePrice());
      var securityDepositConfig = getSecurityDepositConfig();
      var depositCents = securityDepositConfig ? Number(securityDepositConfig.cents) : NaN;

      var perDeviceTotalCents =
        rentalFeeCents
        + depositCents
        + (weekendApplied() ? Number(weekendSurchargeCents) : 0)
        + (earlyDeliveryApplied() ? Number(earlyDeliverySurchargeCents) : 0)
        + (priorityUrgentChargeApplied() ? Number(priorityUrgentChargeCents) : 0)
        + (standardUrgentChargeApplied() ? Number(standardUrgentChargeCents) : 0)
        + (standardReturnExtensionApplied() ? Number(standardReturnExtensionCents) : 0)
        + (priorityReturnExtensionApplied() ? Number(priorityReturnExtensionCents) : 0)
        + (memoryAddonApplied() ? Number(memoryAddonCents) : 0)
        + (officeAddonApplied() ? Number(officeAddonCents) : 0)
        + (appleMouseAddonApplied() ? Number(appleMouseAddonCents) : 0)
        + (hdmiAddonApplied() ? Number(hdmiAddonCents) : 0)
        + (pencilAddonApplied() ? Number(pencilAddonCents) : 0);

      var rentalFee = Number.isFinite(rentalFeeCents)
        ? formatMoney(rentalFeeCents * quantity)
        : '';
      var deposit = Number.isFinite(depositCents)
        ? formatMoney(depositCents * quantity)
        : '';
      var total = Number.isFinite(perDeviceTotalCents)
        ? formatMoney(perDeviceTotalCents * quantity)
        : '';

      var rentalDetailLines = [
        '*Rental Details*',
        'Device: ' + String(rentalPageConfig.productTitle || 'Rental'),
        'Selection: ' + selectedOption,
        'Quantity: ' + quantity
      ];

      var rentalTimingLines = [
        'Rental Start: ' + startDate + ', ' + delivery,
        'Rental End: ' + endDate + ', ' + returnTiming,
        'Rental Duration: ' + (duration > 0 ? duration + (duration === 1 ? ' day' : ' days') : 'Not selected')
      ];

      function formatWhatsAppComponentMoney(value) {
        var text = String(value || '').trim();
        if (!text) return '';
        return text.replace(/^S\$/i, '$');
      }

      function formatWhatsAppTotalMoney(value) {
        var text = String(value || '').trim();
        if (!text) return '';
        if (/^S\$/i.test(text)) return text.replace(/^s\$/i, 'S$');
        if (/^\$/.test(text)) return 'S' + text;
        if (/^SGD\s*/i.test(text)) return text.replace(/^SGD\s*/i, 'S$');
        return text;
      }

      var rentalPriceLines = [];
      if (rentalFee) rentalPriceLines.push('Rental Fee: ' + formatWhatsAppComponentMoney(rentalFee));

      function addWhatsAppChargeLine(label, cents) {
        var numericCents = Number(cents);
        if (!Number.isFinite(numericCents) || numericCents <= 0) return;
        rentalPriceLines.push(
          label + ': ' + formatWhatsAppComponentMoney(formatMoney(numericCents * quantity))
        );
      }

      if (weekendApplied()) addWhatsAppChargeLine('Weekend Surcharge', weekendSurchargeCents);
      if (priorityUrgentChargeApplied()) addWhatsAppChargeLine('Priority Urgent Delivery', priorityUrgentChargeCents);
      if (standardUrgentChargeApplied()) addWhatsAppChargeLine('Standard Urgent Delivery', standardUrgentChargeCents);
      if (earlyDeliveryApplied()) addWhatsAppChargeLine('Early Delivery', earlyDeliverySurchargeCents);
      if (standardReturnExtensionApplied()) addWhatsAppChargeLine('Return Extension', standardReturnExtensionCents);
      if (priorityReturnExtensionApplied()) addWhatsAppChargeLine('Extended-Hours Return', priorityReturnExtensionCents);

      extras.forEach(function (extraLine) {
        rentalPriceLines.push(extraLine.replace(/:\s*S\$/i, ': $'));
      });

      if (total) {
        rentalPriceLines.push('');

        if (quantity > 1 && Number.isFinite(perDeviceTotalCents)) {
          rentalPriceLines.push(
            '*Total:* ' + formatWhatsAppTotalMoney(total) +
            ' for ' + quantity + ' units' +
            ' (' + formatWhatsAppComponentMoney(formatMoney(perDeviceTotalCents)) + '/unit)'
          );
        } else {
          rentalPriceLines.push('*Total:* ' + formatWhatsAppTotalMoney(total));
        }
      }

      if (deposit) {
        rentalPriceLines.push('*Refundable Security Deposit:* ' + formatWhatsAppTotalMoney(deposit));
        rentalPriceLines.push('(refunded within 3 business days)');
      }

      var rentalFinalLines = [
        'Additional Notes: ' + (notes || 'None'),
        'Documents submitted: ' + (jotformSubmittedInput && jotformSubmittedInput.value === 'Yes' ? 'Yes' : 'No')
      ];

      return [
        'Hi Playforce! I would like to continue this rental via WhatsApp. Please Assist.',
        rentalDetailLines.join('\n'),
        rentalTimingLines.join('\n'),
        rentalPriceLines.join('\n'),
        rentalFinalLines.join('\n')
      ].filter(function (section) { return section !== ''; }).join('\n\n');
    }

    function continueRentalOnWhatsApp() {
      if (!validateRentalOptionsBeforeDocuments()) return;

      /* WhatsApp is an assisted-rental path. Documents are optional here so
         customers can ask Playforce for help before uploading verification files. */
      if (!validateTimingFields()) {
        promptFirstMissingTimingField();
        return;
      }

      var message = buildRentalWhatsAppMessage();
      var whatsappUrl = 'https://wa.me/6591151460?text=' + encodeURIComponent(message);
      window.open(whatsappUrl, '_blank', 'noopener');
    }

    function rentalEditQuickActionsAllowed() {
      return !!(
        rentalEditModeActive &&
        rentalEditDocumentsReusableConfirmed &&
        jotformSubmittedInput &&
        jotformSubmittedInput.value === 'Yes'
      );
    }

    function ensureRentalEditPageActions() {
      if (!proceedToDocumentsWrap || rentalEditPageActions) return !!rentalEditPageActions;

      var styleId = 'RentalEditPageActionsStyles';
      if (!document.getElementById(styleId)) {
        var style = document.createElement('style');
        style.id = styleId;
        style.textContent = [
          '.rental-edit-page-actions{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:12px;width:100%;}',
          '.rental-edit-page-actions[hidden]{display:none!important;}',
          '.rental-edit-page-actions .rental-submit-btn{width:100%;min-width:0;margin:0;min-height:48px;}',
          '.rental-edit-page-actions button:disabled{opacity:.6;cursor:not-allowed;}',
          '@media(max-width:520px){.rental-edit-page-actions{gap:8px;}.rental-edit-page-actions .rental-submit-btn{padding-left:10px;padding-right:10px;font-size:13px;white-space:normal;line-height:1.25;}}'
        ].join('');
        document.head.appendChild(style);
      }

      rentalEditPageActions = document.createElement('div');
      rentalEditPageActions.className = 'rental-edit-page-actions';
      rentalEditPageActions.id = 'RentalEditPageActions';
      rentalEditPageActions.hidden = true;

      rentalEditWhatsappButton = document.createElement('button');
      rentalEditWhatsappButton.type = 'button';
      rentalEditWhatsappButton.className = 'rental-submit-btn rental-whatsapp-btn rental-edit-whatsapp-btn';
      rentalEditWhatsappButton.innerHTML =
        '<span class="rental-whatsapp-btn-content">' +
          '<svg class="rental-whatsapp-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
            '<path fill="currentColor" d="M20.52 3.48A11.81 11.81 0 0 0 12.09 0C5.55 0 .23 5.32.23 11.86c0 2.09.55 4.13 1.59 5.93L.13 24l6.35-1.67a11.83 11.83 0 0 0 5.61 1.43h.01c6.54 0 11.86-5.32 11.86-11.86 0-3.17-1.22-6.15-3.44-8.42Zm-8.42 18.28h-.01a9.83 9.83 0 0 1-5.01-1.37l-.36-.21-3.77.99 1.01-3.67-.23-.38a9.84 9.84 0 1 1 8.37 4.64Zm5.4-7.36c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.76.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.64-2.04-.17-.3-.02-.46.13-.6.13-.13.3-.35.44-.52.15-.17.2-.3.3-.49.1-.2.05-.37-.02-.52-.08-.15-.67-1.61-.91-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.21 5.09 4.5.71.31 1.26.49 1.69.63.71.23 1.36.19 1.87.12.57-.08 1.75-.72 2-1.41.25-.69.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35Z"/>' +
          '</svg>' +
          '<span>Continue on WhatsApp</span>' +
        '</span>';
      rentalEditWhatsappButton.addEventListener('click', continueRentalOnWhatsApp);

      rentalEditUpdateButton = document.createElement('button');
      rentalEditUpdateButton.type = 'button';
      rentalEditUpdateButton.className = 'rental-submit-btn rental-edit-update-btn';
      rentalEditUpdateButton.textContent = 'Update Rental';
      rentalEditUpdateButton.addEventListener('click', submitRentalEditFromPageOne);

      rentalEditPageActions.appendChild(rentalEditWhatsappButton);
      rentalEditPageActions.appendChild(rentalEditUpdateButton);
      proceedToDocumentsWrap.appendChild(rentalEditPageActions);

      var loading = !!(submitButton && submitButton.disabled);
      rentalEditWhatsappButton.disabled = loading;
      rentalEditUpdateButton.disabled = loading;

      return true;
    }

    function updateRentalEditPrimaryActions() {
      if (!proceedToDocumentsWrap || !proceedToDocumentsButton) return;

      var editRequested = !!(rentalEditRequestedGroupId || rentalEditModeActive);

      if (!editRequested) {
        proceedToDocumentsButton.hidden = false;
        if (rentalEditPageActions) rentalEditPageActions.hidden = true;
        return;
      }

      ensureRentalEditPageActions();

      /* Existing-rental document state is still being verified.
         Keep the action area blank rather than flashing an incorrect
         "Proceed to Upload Documents" button. */
      if (!rentalEditDocumentValidationComplete) {
        proceedToDocumentsButton.hidden = true;
        if (rentalEditPageActions) rentalEditPageActions.hidden = true;
        return;
      }

      var showDirectEditActions = rentalEditQuickActionsAllowed();

      proceedToDocumentsButton.hidden = showDirectEditActions;

      if (rentalEditPageActions) {
        rentalEditPageActions.hidden = !showDirectEditActions;
      }
    }

    function submitRentalEditFromPageOne() {
      if (!rentalEditQuickActionsAllowed()) {
        proceedToRentalDocuments();
        return;
      }

      if (!validateRentalOptionsBeforeDocuments()) return;

      clearRentalFieldPrompt(startDateInput);
      clearRentalFieldPrompt(deliveryTimeInput);
      clearRentalFieldPrompt(returnTimeInput);

      if (!rentalForm) return;

      if (typeof rentalForm.requestSubmit === 'function') {
        rentalForm.requestSubmit();
      } else {
        rentalForm.dispatchEvent(new Event('submit', {
          bubbles: true,
          cancelable: true
        }));
      }
    }

    function ensureMobileStandaloneReviewContainers() {
      if (!rentalDetails || !rentalFormWrap) return false;

      if (!mobileStandaloneReviewHost) {
        mobileStandaloneReviewHost = document.createElement('div');
        mobileStandaloneReviewHost.className = 'rental-mobile-standalone-review';
        mobileStandaloneReviewHost.setAttribute('data-rental-mobile-review-host', 'true');
        mobileStandaloneReviewHost.hidden = true;
        mobileStandaloneReviewHost.setAttribute('aria-hidden', 'true');
      }

      if (!rentalReviewBackButton) {
        rentalReviewBackButton = document.createElement('button');
        rentalReviewBackButton.type = 'button';
        rentalReviewBackButton.className = 'rental-review-back-btn';
        rentalReviewBackButton.textContent = 'Back to Rental Options';
        rentalReviewBackButton.addEventListener('click', returnToRentalOptions);
      }

      if (!mobileFinalConfirmationCard) {
        mobileFinalConfirmationCard = document.createElement('div');
        mobileFinalConfirmationCard.className = 'rental-mobile-final-confirmation';
        mobileFinalConfirmationCard.setAttribute('data-rental-mobile-final-confirmation', 'true');
      }

      if (!rentalFinalActions) {
        rentalFinalActions = document.createElement('div');
        rentalFinalActions.className = 'rental-final-actions';
      }

      if (!rentalWhatsappButton) {
        rentalWhatsappButton = document.createElement('button');
        rentalWhatsappButton.type = 'button';
        rentalWhatsappButton.className = 'rental-submit-btn rental-whatsapp-btn';
        rentalWhatsappButton.innerHTML =
          '<span class="rental-whatsapp-btn-content">' +
            '<svg class="rental-whatsapp-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
              '<path fill="currentColor" d="M20.52 3.48A11.81 11.81 0 0 0 12.09 0C5.55 0 .23 5.32.23 11.86c0 2.09.55 4.13 1.59 5.93L.13 24l6.35-1.67a11.83 11.83 0 0 0 5.61 1.43h.01c6.54 0 11.86-5.32 11.86-11.86 0-3.17-1.22-6.15-3.44-8.42Zm-8.42 18.28h-.01a9.83 9.83 0 0 1-5.01-1.37l-.36-.21-3.77.99 1.01-3.67-.23-.38a9.84 9.84 0 1 1 8.37 4.64Zm5.4-7.36c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.76.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.64-2.04-.17-.3-.02-.46.13-.6.13-.13.3-.35.44-.52.15-.17.2-.3.3-.49.1-.2.05-.37-.02-.52-.08-.15-.67-1.61-.91-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.21 5.09 4.5.71.31 1.26.49 1.69.63.71.23 1.36.19 1.87.12.57-.08 1.75-.72 2-1.41.25-.69.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35Z"/>' +
            '</svg>' +
            '<span>Continue on WhatsApp</span>' +
          '</span>';
        rentalWhatsappButton.addEventListener('click', continueRentalOnWhatsApp);
      }

      return true;
    }

    function ensureRentalStageLayout() {
      if (!rentalFormWrap || !rentalFormWrap.parentNode || !priceBoxEl || !proceedToDocumentsWrap) return false;
      if (!ensureMobileStandaloneReviewContainers()) return false;

      var stageParent = rentalFormWrap.parentNode;

      /* Page 1 order: Step 1 form -> Rental Summary -> Proceed button. */
      if (priceBoxEl.parentNode !== stageParent || rentalFormWrap.nextElementSibling !== priceBoxEl) {
        stageParent.insertBefore(priceBoxEl, rentalFormWrap.nextSibling);
      }

      if (proceedToDocumentsWrap.parentNode !== stageParent || priceBoxEl.nextElementSibling !== proceedToDocumentsWrap) {
        stageParent.insertBefore(proceedToDocumentsWrap, priceBoxEl.nextSibling);
      }

      /* Page 2 occupies the same content position once Page 1 is hidden. */
      if (mobileStandaloneReviewHost.parentNode !== stageParent || proceedToDocumentsWrap.nextElementSibling !== mobileStandaloneReviewHost) {
        stageParent.insertBefore(mobileStandaloneReviewHost, proceedToDocumentsWrap.nextSibling);
      }

      return true;
    }

    function updateMobileReviewFlowLayout() {
      if (!priceBoxEl || !documentsStepSection || !requiredDocumentsPanel || !rentalTermsField || !submitButton) return;
      if (!ensureRentalStageLayout()) return;

      var reviewOrderIsCorrect =
        documentsStepSection.parentNode === mobileStandaloneReviewHost &&
        mobileFinalConfirmationCard.parentNode === mobileStandaloneReviewHost &&
        rentalReviewBackButton && rentalReviewBackButton.parentNode === mobileStandaloneReviewHost &&
        rentalTermsField.parentNode === mobileFinalConfirmationCard &&
        rentalFinalActions && rentalFinalActions.parentNode === mobileFinalConfirmationCard &&
        rentalWhatsappButton && rentalWhatsappButton.parentNode === rentalFinalActions &&
        submitButton.parentNode === rentalFinalActions &&
        documentsStepSection.nextElementSibling === mobileFinalConfirmationCard &&
        mobileFinalConfirmationCard.nextElementSibling === rentalReviewBackButton;

      if (!mobileReviewLayoutApplied || !reviewOrderIsCorrect) {
        mobileStandaloneReviewHost.appendChild(documentsStepSection);
        mobileStandaloneReviewHost.appendChild(mobileFinalConfirmationCard);
        mobileStandaloneReviewHost.appendChild(rentalReviewBackButton);
        mobileFinalConfirmationCard.appendChild(rentalTermsField);
        mobileFinalConfirmationCard.appendChild(rentalFinalActions);
        rentalFinalActions.appendChild(rentalWhatsappButton);
        rentalFinalActions.appendChild(submitButton);
      }

      priceBoxEl.classList.add('rental-page-one-summary');
      proceedToDocumentsWrap.classList.add('rental-page-one-proceed');
      documentsStepSection.classList.add('rental-mobile-review-documents-step');
      requiredDocumentsPanel.classList.add('rental-mobile-review-documents');
      rentalTermsField.classList.add('rental-mobile-review-terms');
      submitButton.classList.add('rental-mobile-review-submit');
      rentalWhatsappButton.classList.add('rental-mobile-review-whatsapp');
      mobileReviewLayoutApplied = true;
    }

    function updateMobileSummaryJumpVisibility() {
      if (!mobileSummaryJump || !priceBoxEl) return;

      if (rentalReviewStageActive) {
        mobileSummaryJump.classList.remove('is-visible');
        mobileSummaryJump.hidden = true;
        return;
      }

      var isMobile = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
      if (!isMobile) {
        mobileSummaryJumpSuppressedForValidation = false;
        mobileSummaryJump.classList.remove('is-visible');
        mobileSummaryJump.hidden = true;
        return;
      }

      if (mobileSummaryJumpSuppressedForValidation) {
        mobileSummaryJump.classList.remove('is-visible');
        mobileSummaryJump.hidden = true;
        return;
      }

      var summaryJumpTrigger = rentalGalleryMain || mainImage || rentalOptionsField || rentalForm;
      if (!summaryJumpTrigger) {
        mobileSummaryJump.classList.remove('is-visible');
        mobileSummaryJump.hidden = true;
        return;
      }

      var triggerRect = summaryJumpTrigger.getBoundingClientRect();
      var priceBoxRect = priceBoxEl.getBoundingClientRect();
      var rentalSummaryTitle = priceBoxEl.querySelector('.rental-price-mobile-period-title');
      var rentalSummaryTitleRect = rentalSummaryTitle
        ? rentalSummaryTitle.getBoundingClientRect()
        : null;
      var viewportHeight = window.visualViewport
        ? window.visualViewport.height
        : window.innerHeight;

      var hasFullyPassedTriggerAtTop = triggerRect.bottom <= 0;
      var rentalSummaryTitleHasFullyEnteredViewport = rentalSummaryTitleRect
        ? rentalSummaryTitleRect.bottom <= viewportHeight - 8
        : priceBoxRect.top <= viewportHeight - 8;
      var shouldShow = hasFullyPassedTriggerAtTop &&
        !rentalSummaryTitleHasFullyEnteredViewport;

      mobileSummaryJump.hidden = !shouldShow;
      mobileSummaryJump.classList.toggle('is-visible', shouldShow);
    }

    function handleMobileReviewFlowChange() {
      updateMobileReviewFlowLayout();
      window.requestAnimationFrame(updateMobileSummaryJumpVisibility);
    }

    function suppressMobileSummaryJumpForValidation() {
      var isMobile = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
      if (!isMobile || !mobileSummaryJump) return;

      mobileSummaryJumpSuppressedForValidation = true;
      mobileSummaryJump.classList.remove('is-visible');
      mobileSummaryJump.hidden = true;
    }

    function resumeMobileSummaryJumpAfterUserScroll() {
      if (!mobileSummaryJumpSuppressedForValidation) return;

      mobileSummaryJumpSuppressedForValidation = false;
      window.requestAnimationFrame(updateMobileSummaryJumpVisibility);
    }

    function handleMobileSummaryJumpScrollKey(event) {
      if (!mobileSummaryJumpSuppressedForValidation || !event) return;

      var scrollKeys = [
        'ArrowUp',
        'ArrowDown',
        'PageUp',
        'PageDown',
        'Home',
        'End',
        ' ',
        'Spacebar'
      ];

      if (scrollKeys.indexOf(event.key) !== -1) {
        resumeMobileSummaryJumpAfterUserScroll();
      }
    }

    function scrollToRentalSummary() {
      if (!priceBoxEl) return;

      var isMobile = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
      if (!isMobile) {
        priceBoxEl.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        return;
      }

      var stickyBarHeight = mobileSummaryJump && !mobileSummaryJump.hidden
        ? mobileSummaryJump.getBoundingClientRect().height
        : 0;
      var summaryTop = window.pageYOffset + priceBoxEl.getBoundingClientRect().top;
      var scrollOffset = stickyBarHeight + 12;

      window.scrollTo({
        top: Math.max(0, summaryTop - scrollOffset),
        behavior: 'smooth'
      });
    }

    function getRentalValidationScrollOffset() {
      var isMobile = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);

      var offset = isMobile ? 84 : 20;

      if (isMobile && mobileSummaryJump && !mobileSummaryJump.hidden) {
        offset += mobileSummaryJump.getBoundingClientRect().height + 12;
      }

      return offset;
    }

    function alignNativeValidationAnchor(control, visibleTarget) {
      if (!control || !visibleTarget || control === visibleTarget) return;
      if (control !== startDateInput) return;

      var anchorParent = control.parentElement;
      if (!anchorParent) return;

      var parentRect = anchorParent.getBoundingClientRect();
      var targetRect = visibleTarget.getBoundingClientRect();

      control.style.position = 'absolute';
      control.style.left = (targetRect.left - parentRect.left) + 'px';
      control.style.top = (targetRect.top - parentRect.top) + 'px';
      control.style.width = targetRect.width + 'px';
      control.style.minWidth = targetRect.width + 'px';
      control.style.height = targetRect.height + 'px';
      control.style.minHeight = targetRect.height + 'px';
      control.style.padding = '0';
      control.style.margin = '0';
      control.style.border = '0';
      control.style.opacity = '0';
      control.style.pointerEvents = 'none';
    }

    function scrollToRentalFieldAndPrompt(control, visibleTarget, message, scrollTarget) {
      if (!control) return;

      suppressMobileSummaryJumpForValidation();

      var target = visibleTarget || control;
      var scrollAnchor = scrollTarget || target;
      alignNativeValidationAnchor(control, target);
      var targetTop = window.pageYOffset + scrollAnchor.getBoundingClientRect().top;
      var scrollTop = Math.max(0, targetTop - getRentalValidationScrollOffset());

      if (typeof control.setCustomValidity === 'function') {
        control.setCustomValidity(message || 'Please select an item in the list.');
      }

      window.scrollTo({
        top: scrollTop,
        behavior: 'smooth'
      });

      window.setTimeout(function () {
        try {
          control.focus({ preventScroll: true });
        } catch (error) {
          control.focus();
        }

        if (typeof control.reportValidity === 'function') {
          control.reportValidity();
        }

        var isMobile = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
        if (isMobile) {
          window.setTimeout(function () {
            var correctedTop = window.pageYOffset + scrollAnchor.getBoundingClientRect().top;
            window.scrollTo({
              top: Math.max(0, correctedTop - getRentalValidationScrollOffset()),
              behavior: 'auto'
            });
          }, 80);
        }
      }, 360);
    }

    function clearRentalFieldPrompt(control) {
      if (control && typeof control.setCustomValidity === 'function') {
        control.setCustomValidity('');
      }
    }

    function promptRentalStartDateField() {
      if (rentalReviewStageActive) {
        setRentalReviewStage(false, { scroll: false });
      }

      var visibleDateTarget = rentalStartDateDisplay && !rentalStartDateDisplay.hidden
        ? rentalStartDateDisplay
        : startDateInput;

      scrollToRentalFieldAndPrompt(
        startDateInput,
        visibleDateTarget,
        'Please select an item in the list.',
        rentalStartDateLabel || visibleDateTarget
      );
    }

    function promptFirstMissingTimingField() {
      if (rentalReviewStageActive && (
        (deliveryTimeInput && !deliveryTimeInput.value) ||
        (returnTimeInput && !returnTimeInput.value)
      )) {
        setRentalReviewStage(false, { scroll: false });
      }

      if (deliveryTimeInput && !deliveryTimeInput.value) {
        scrollToRentalFieldAndPrompt(
          deliveryTimeInput,
          deliveryTimeInput,
          'Please select an item in the list.',
          rentalDeliveryTimeLabel || deliveryTimeInput
        );
        return false;
      }

      if (returnTimeInput && !returnTimeInput.value) {
        var returnPromptMessage = selectedRentalDatesAreSameDay() && !sameDayReturnHasAvailableSlot()
          ? 'No timing available for same-day return. Please select the next day as your return date.'
          : 'Please select an item in the list.';

        scrollToRentalFieldAndPrompt(
          returnTimeInput,
          returnTimeInput,
          returnPromptMessage,
          rentalReturnTimeLabel || returnTimeInput
        );
        return false;
      }

      clearRentalFieldPrompt(deliveryTimeInput);
      clearRentalFieldPrompt(returnTimeInput);
      return true;
    }

    function validateRequiredRentalFieldsWithPrompt() {
      if (validateDateField()) {
        promptRentalStartDateField();
        return false;
      }

      clearRentalFieldPrompt(startDateInput);
      rebuildDeliveryOptions();
      rebuildReturnOptions();

      return promptFirstMissingTimingField();
    }

    function validateDateField() {
      var selectedDate = startDateInput ? startDateInput.value : '';
      var invalid = !selectedDate || isInvalidDate(selectedDate);
      var errorMessage = invalid ? getRentalStartDateErrorMessage(selectedDate) : '';

      if (dateError) {
        dateError.textContent = errorMessage;
        dateError.hidden = !invalid || !errorMessage;
      }

      return invalid;
    }

    function getRequestedRentalQuantity() {
      var quantity = parseInt(rentalQuantityInput ? rentalQuantityInput.value : '1', 10);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }

    function setLoadingState(isLoading) {
      if (!submitButton) return;

      submitButton.disabled = isLoading;
      submitButton.classList.toggle('is-disabled', isLoading);

      if (rentalEditWhatsappButton) {
        rentalEditWhatsappButton.disabled = !!isLoading;
      }

      if (rentalEditUpdateButton) {
        rentalEditUpdateButton.disabled = !!isLoading;
        rentalEditUpdateButton.textContent = isLoading ? 'Updating Rental...' : 'Update Rental';
      }

      if (rentalEditModeActive || rentalEditRequestedGroupId) {
        if (isLoading) {
          submitButton.innerHTML =
            '<span aria-hidden="true" style="display:inline-flex;width:16px;height:16px;margin-right:9px;vertical-align:-3px;">' +
              '<svg viewBox="0 0 16 16" width="16" height="16" focusable="false" aria-hidden="true">' +
                '<circle cx="8" cy="8" r="6" fill="none" stroke="rgba(255,255,255,.35)" stroke-width="2"></circle>' +
                '<path d="M8 2a6 6 0 0 1 6 6" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round">' +
                  '<animateTransform attributeName="transform" type="rotate" from="0 8 8" to="360 8 8" dur="0.7s" repeatCount="indefinite"></animateTransform>' +
                '</path>' +
              '</svg>' +
            '</span>' +
            '<span>Updating Rental</span>';
        } else {
          submitButton.textContent = 'Update Rental';
        }
      } else {
        submitButton.textContent = isLoading ? 'Preparing Checkout...' : 'Proceed to Checkout';
      }
    }

    function postCartItems(payload) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            console.log('Shopify add-to-cart error payload:', data);
            throw new Error(data.description || data.message || JSON.stringify(data));
          }
          return data;
        });
      });
    }


    function getRentalEditCacheKey(groupId) {
      return RENTAL_EDIT_CACHE_PREFIX + String(groupId || '').trim();
    }

    function clearRentalEditCache(groupId) {
      if (!groupId) return;

      try {
        window.sessionStorage.removeItem(getRentalEditCacheKey(groupId));
      } catch (error) {}
    }

    function readRentalEditCache(groupId) {
      if (!groupId) return null;

      try {
        var raw = window.sessionStorage.getItem(getRentalEditCacheKey(groupId));
        if (!raw) return null;

        var snapshot = JSON.parse(raw);
        if (!snapshot || snapshot.version !== 1 || String(snapshot.groupId || '') !== String(groupId)) {
          clearRentalEditCache(groupId);
          return null;
        }

        var savedAt = Number(snapshot.savedAt || 0);
        if (!savedAt || Date.now() - savedAt > RENTAL_EDIT_CACHE_MAX_AGE_MS) {
          clearRentalEditCache(groupId);
          return null;
        }

        var currentProductId = Number(rentalPageConfig.productId || 0);
        var cachedProductId = Number(snapshot.productId || snapshot.mainItem && snapshot.mainItem.product_id || 0);
        if (currentProductId && cachedProductId && currentProductId !== cachedProductId) {
          return null;
        }

        return snapshot;
      } catch (error) {
        clearRentalEditCache(groupId);
        return null;
      }
    }

    function getRentalEditItemSignature(item) {
      if (!item) return '';

      var properties = item.properties || {};
      return JSON.stringify([
        Number(item.variant_id || item.id || 0),
        Math.max(1, parseInt(item.quantity, 10) || 1),
        String(properties['Rental start date'] || ''),
        String(properties['Rental end date'] || ''),
        String(properties['Rental duration'] || ''),
        String(properties['Delivery timing'] || ''),
        String(properties['Return timing'] || ''),
        String(properties['Additional notes'] || ''),
        String(properties['Connectivity'] || ''),
        String(properties['32GB addon selected'] || ''),
        String(properties['Microsoft Office addon selected'] || ''),
        String(properties['Apple Mouse optional extra selected'] || ''),
        String(properties['HDMI Port optional extra selected'] || ''),
        String(properties['Pencil optional extra selected'] || ''),
        String(properties['Documents submitted'] || ''),
        String(properties['_Document submitted at'] || properties['Document submitted at'] || ''),
        String(properties['_Document valid until'] || properties['Document valid until'] || '')
      ]);
    }

    function runRentalInitialValidationLoads(force) {
      if (rentalInitialValidationPromise && !force) {
        return rentalInitialValidationPromise;
      }

      function runTask(label, task) {
        try {
          return Promise.resolve(task()).catch(function (error) {
            console.error(label + ' error:', error);
            return null;
          });
        } catch (error) {
          console.error(label + ' error:', error);
          return Promise.resolve(null);
        }
      }

      rentalInitialValidationPromise = Promise.all([
        runTask('Initial live rental price lookup', function () {
          return loadInitialLiveVariantPrices();
        }),
        runTask('Security deposit stock lookup', function () {
          return loadSecurityDepositStockAvailability();
        }),
        runTask('Apple Mouse stock lookup', function () {
          return loadAppleMouseAddonStockAvailability(false);
        }),
        runTask('Pencil stock lookup', function () {
          return loadPencilAddonStockAvailability(false);
        }),
        runTask('Selected security deposit lead-day lookup', function () {
          return loadSelectedSecurityDepositLeadDays().then(function () {
            updateProcessorAvailabilityNote();
          });
        }),
        runTask('Processor deposit availability lookup', function () {
          return loadProcessorSecurityDepositAvailabilityLabels();
        }),
        runTask('PlayTime availability lookup', function () {
          return loadPlayTimeAvailability();
        })
      ]).then(function () {
        updateAppleMouseAddonAvailability();
        updatePencilAddonAvailability();
        preserveRestoredIpadConnectivityForEdit();
        updateAddonCards();
        updateProcessorAvailabilityNote();
        updateRentalInfoPanels();
        updateTotal();
        updateRentalEndInfo();
        return true;
      });

      return rentalInitialValidationPromise;
    }

    function fetchRentalCartForEdit(marker) {
      return fetch('/cart.js?rental_edit=' + encodeURIComponent(marker || Date.now()), {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Cache-Control': 'no-cache'
        },
        cache: 'no-store'
      }).then(function (response) {
        setTrustedNowFromResponse(response);
        if (!response.ok) {
          throw new Error('Unable to read the current rental cart.');
        }
        return response.json();
      });
    }

    function getRentalCartItemGroupId(item) {
      var properties = item && item.properties ? item.properties : {};
      return String(properties['Rental group ID'] || '').trim();
    }

    function rentalCartItemIsLinkedCharge(item) {
      var properties = item && item.properties ? item.properties : {};
      return !!(
        String(properties['Charge type'] || '').trim() ||
        String(properties['Linked rental product'] || '').trim() ||
        String(properties['Linked rental variant'] || '').trim()
      );
    }

    function getRentalEditGroupItems(cart, groupId) {
      if (!cart || !Array.isArray(cart.items) || !groupId) return [];
      return cart.items.filter(function (item) {
        return getRentalCartItemGroupId(item) === groupId;
      });
    }

    function getRentalEditMainItem(groupItems) {
      var expectedProductId = Number(rentalPageConfig.productId || 0);

      return groupItems.find(function (item) {
        if (!item || rentalCartItemIsLinkedCharge(item)) return false;
        if (!expectedProductId) return true;
        return Number(item.product_id || 0) === expectedProductId;
      }) || null;
    }

    function normaliseEditText(value) {
      return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
    }

    function cartEditGroupHasCharge(groupItems, chargeType) {
      var target = normaliseEditText(chargeType);
      return groupItems.some(function (item) {
        var properties = item && item.properties ? item.properties : {};
        return normaliseEditText(properties['Charge type']) === target;
      });
    }

    function cartEditPropertyIsYes(properties, propertyName) {
      return normaliseEditText(properties && properties[propertyName]) === 'yes';
    }

    function resolveStoredRentalTimingValue(options, storedValue, normaliser) {
      var target = normaliseEditText(storedValue);
      if (!target || !Array.isArray(options)) return '';

      var matched = options.find(function (item) {
        if (!item) return false;
        var itemValue = normaliseEditText(item.value);
        var itemText = normaliseEditText(
          typeof normaliser === 'function' ? normaliser(item.text || '') : item.text || ''
        );
        return itemValue === target || itemText === target;
      });

      return matched ? String(matched.value || '') : String(storedValue || '').trim();
    }

    function captureRentalEditSavedSchedule(mainItem, groupItems) {
      if (!mainItem) return;

      var properties = mainItem.properties || {};
      rentalEditSavedSchedule = {
        startDate: String(properties['Rental start date'] || '').trim(),
        endDate: String(properties['Rental end date'] || '').trim(),
        deliveryTime: resolveStoredRentalTimingValue(
          originalDeliveryOptions,
          properties['Delivery timing'],
          stripDeliveryChargeSuffix
        ),
        returnTime: resolveStoredRentalTimingValue(
          originalReturnOptions,
          properties['Return timing']
        ),
        priorityUrgent: cartEditGroupHasCharge(groupItems || [], 'Priority urgent delivery'),
        standardUrgent: cartEditGroupHasCharge(groupItems || [], 'Standard urgent delivery')
      };

      rentalEditScheduleTouchedByUser = false;

      /* Seed the retained values before any dependent dropdown rebuild. This
         prevents an asynchronous Edit Rental refresh from forgetting the
         cart's stored timing before it can be selected again. */
      if (rentalEditSavedSchedule.deliveryTime) {
        retainedRentalDeliveryTimeValue = rentalEditSavedSchedule.deliveryTime;
      }
      if (rentalEditSavedSchedule.returnTime) {
        retainedRentalReturnTimeValue = rentalEditSavedSchedule.returnTime;
      }
    }

    function rentalEditCartReservationStillActive() {
      if (!rentalEditModeActive || !rentalEditRequestedGroupId) return false;

      /* Edit hydration must always paint the exact configuration already saved
         in the cart before live availability rules are allowed to change it.
         This avoids an intermittent race where /cart.js arrives first, a
         same-day tier/expiry check runs during hydration, and the saved date or
         timing is cleared before the customer ever sees it. The normal live
         reservation check resumes as soon as hydration unlocks, so an expired
         cart still has to pass current availability rules before Update Rental. */
      if (rentalEditHydrating) {
        return true;
      }

      if (!rentalEditLoadedCart) {
        return false;
      }

      var expiryMs = getActiveRentalCartReservationExpiryMs(rentalEditLoadedCart);
      return !!(expiryMs && expiryMs > getTrustedNowMs());
    }

    function rentalEditPlayTimeAllowsPreservingExistingSameDay() {
      if (!rentalEditSavedSchedule) return false;
      if (rentalEditSavedSchedule.startDate !== getSingaporeTodayString()) return true;

      /* Hydration is a restore operation, not a new availability decision.
         Always paint the exact same-day configuration already stored in the
         cart while the form is locked, even if a live PlayTime response has
         already arrived. After hydration unlocks, current PlayTime rules and
         the cart reservation timer become authoritative again before the user
         can successfully update the rental. */
      if (rentalEditHydrating) return true;

      /* Outside hydration, keep the saved slot during an in-flight refresh so
         today's date does not flicker closed. Once the refresh settles, genuine
         manual/availability closures fail closed. Current-time tier cutoffs are
         intentionally ignored only while the existing 20-minute reservation is
         still active. */
      if (!playTimeStatusLoaded) return true;
      if (!playTimeConfig.loaded || !playTimeSameDayEnabled) return false;
      if (playTimeConfig.sameDayClosed) return false;
      if (playTimeConfig.weekendRentalsClosed && isWeekend(rentalEditSavedSchedule.startDate)) {
        return false;
      }

      return true;
    }

    function rentalEditSchedulePreservationActive() {
      if (
        !rentalEditModeActive ||
        rentalEditScheduleTouchedByUser ||
        !rentalEditSavedSchedule ||
        !rentalEditCartReservationStillActive() ||
        !rentalEditPlayTimeAllowsPreservingExistingSameDay()
      ) {
        return false;
      }

      var currentStart = String(startDateInput && startDateInput.value || '').trim();
      var currentEnd = String(rentalEndDateInput && rentalEndDateInput.value || '').trim();

      return !!(
        currentStart &&
        currentEnd &&
        currentStart === rentalEditSavedSchedule.startDate &&
        currentEnd === rentalEditSavedSchedule.endDate
      );
    }

    function rentalEditStoredStartDateMayRemain(dateString) {
      return !!(
        rentalEditSchedulePreservationActive() &&
        rentalEditSavedSchedule &&
        String(dateString || '') === rentalEditSavedSchedule.startDate
      );
    }

    function markRentalEditScheduleTouchedByUser() {
      if (!rentalEditModeActive || rentalEditHydrating) return;
      rentalEditScheduleTouchedByUser = true;
    }

    function setRentalOptionValueForEdit(optionPosition, optionValue) {
      if (!optionPosition || optionValue == null) return false;

      var targetValue = String(optionValue);
      var matchingInput = Array.prototype.find.call(optionInputs, function (input) {
        return input.getAttribute('data-option-position') === String(optionPosition) &&
          String(input.value) === targetValue &&
          input.getAttribute('data-internal-cellular-processor') !== 'true';
      });

      if (!matchingInput) return false;
      matchingInput.checked = true;
      return true;
    }

    function setRentalSelectFromStoredText(select, storedValue, normaliser) {
      if (!select || !storedValue) return false;

      var target = normaliseEditText(storedValue);
      var matchedOption = Array.prototype.find.call(select.options, function (option) {
        var optionValue = normaliseEditText(option.value);
        var optionText = normaliseEditText(
          typeof normaliser === 'function' ? normaliser(option.textContent || '') : option.textContent || ''
        );
        return optionValue === target || optionText === target;
      });

      if (!matchedOption || matchedOption.disabled) return false;
      select.value = matchedOption.value;
      return true;
    }

    function parseRentalDocumentTimestamp(value) {
      if (value == null || value === '') return 0;

      var numericValue = Number(value);
      if (Number.isFinite(numericValue) && numericValue > 0) {
        return numericValue;
      }

      var parsedValue = Date.parse(String(value));
      return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : 0;
    }

    function readRentalDocumentSessionTimestamp(key) {
      try {
        return parseRentalDocumentTimestamp(window.sessionStorage.getItem(key) || '');
      } catch (error) {
        return 0;
      }
    }

    function writeRentalDocumentSessionWindow(submittedAtMs, validUntilMs) {
      var submittedMs = Number(submittedAtMs || 0);
      var expiryMs = Number(validUntilMs || 0);

      if (!Number.isFinite(expiryMs) || expiryMs <= 0) return false;

      if (!Number.isFinite(submittedMs) || submittedMs <= 0 || submittedMs >= expiryMs) {
        submittedMs = Math.max(
          1,
          expiryMs - (RENTAL_DOCUMENT_VALIDITY_MINUTES * 60 * 1000)
        );
      }

      rentalDocumentSubmittedAtMs = submittedMs;
      rentalDocumentValidUntilMs = expiryMs;

      try {
        window.sessionStorage.setItem(RENTAL_DOCUMENT_SUBMITTED_AT_KEY, String(submittedMs));
        window.sessionStorage.setItem(RENTAL_DOCUMENT_VALID_UNTIL_KEY, String(expiryMs));
      } catch (error) {}

      return true;
    }

    function clearRentalDocumentSessionWindow() {
      rentalDocumentSubmittedAtMs = 0;
      rentalDocumentValidUntilMs = 0;

      try {
        window.sessionStorage.removeItem(RENTAL_DOCUMENT_SUBMITTED_AT_KEY);
        window.sessionStorage.removeItem(RENTAL_DOCUMENT_VALID_UNTIL_KEY);
      } catch (error) {}
    }

    function getRentalDocumentSubmittedAtMs() {
      if (rentalDocumentSubmittedAtMs > 0) return rentalDocumentSubmittedAtMs;

      rentalDocumentSubmittedAtMs = readRentalDocumentSessionTimestamp(
        RENTAL_DOCUMENT_SUBMITTED_AT_KEY
      );
      return rentalDocumentSubmittedAtMs;
    }

    function getRentalDocumentValidUntilMs() {
      if (!(rentalDocumentValidUntilMs > 0)) {
        rentalDocumentValidUntilMs = readRentalDocumentSessionTimestamp(
          RENTAL_DOCUMENT_VALID_UNTIL_KEY
        );
      }

      if (rentalDocumentValidUntilMs > 0 && rentalDocumentValidUntilMs <= getTrustedNowMs()) {
        clearRentalDocumentSessionWindow();
        return 0;
      }

      return rentalDocumentValidUntilMs;
    }

    function setFreshRentalDocumentWindowFromNow(nowMs) {
      var submittedAtMs = Number(nowMs || getTrustedNowMs());
      if (!Number.isFinite(submittedAtMs) || submittedAtMs <= 0) {
        submittedAtMs = Date.now();
      }

      var validUntilMs = submittedAtMs + (RENTAL_DOCUMENT_VALIDITY_MINUTES * 60 * 1000);
      writeRentalDocumentSessionWindow(submittedAtMs, validUntilMs);
      clearRentalDocumentGrace();

      return {
        submittedAtMs: submittedAtMs,
        validUntilMs: validUntilMs
      };
    }

    function recordFreshRentalDocumentSubmission() {
      /* Stamp immediately so the UI can continue without waiting on another
         request, then correct the timestamp from Shopify's Date header. */
      setFreshRentalDocumentWindowFromNow(getTrustedNowMs());

      rentalDocumentTimestampPromise = fetchRentalCartForEdit('documents-stamp-' + Date.now())
        .then(function () {
          return setFreshRentalDocumentWindowFromNow(getTrustedNowMs());
        })
        .catch(function () {
          return {
            submittedAtMs: getRentalDocumentSubmittedAtMs(),
            validUntilMs: getRentalDocumentValidUntilMs()
          };
        });

      return rentalDocumentTimestampPromise;
    }

    function getRentalDocumentWindowFromItem(item) {
      var properties = item && item.properties ? item.properties : {};
      var documentsWereSubmitted = normaliseEditText(properties['Documents submitted']) === 'yes';

      if (!documentsWereSubmitted) {
        return { submittedAtMs: 0, validUntilMs: 0, explicit: false };
      }

      var submittedAtMs = parseRentalDocumentTimestamp(
        properties['_Document submitted at'] || properties['Document submitted at'] || ''
      );
      var validUntilMs = parseRentalDocumentTimestamp(
        properties['_Document valid until'] || properties['Document valid until'] || ''
      );

      return {
        submittedAtMs: submittedAtMs,
        validUntilMs: validUntilMs,
        explicit: validUntilMs > 0
      };
    }

    function syncRentalDocumentSessionFromCart(cart, fallbackExpiryMs) {
      if (!cart || !Array.isArray(cart.items)) return false;

      var selectedWindow = null;

      cart.items.forEach(function (item) {
        if (!item || rentalCartItemIsLinkedCharge(item)) return;
        if (!getRentalCartItemGroupId(item)) return;

        var itemWindow = getRentalDocumentWindowFromItem(item);
        if (!itemWindow.explicit) return;

        if (!selectedWindow || itemWindow.validUntilMs < selectedWindow.validUntilMs) {
          selectedWindow = itemWindow;
        }
      });

      if (selectedWindow && selectedWindow.validUntilMs > 0) {
        return writeRentalDocumentSessionWindow(
          selectedWindow.submittedAtMs,
          selectedWindow.validUntilMs
        );
      }

      /* Legacy carts created before the 4-hour timestamp existed are not granted
         a fresh 4-hour window. They retain only their existing 20-minute cart
         validity, which is conservative and avoids unexpectedly extending an
         older upload. */
      var legacyExpiryMs = Number(fallbackExpiryMs || 0);
      if (legacyExpiryMs > getTrustedNowMs()) {
        return writeRentalDocumentSessionWindow(
          legacyExpiryMs - (RENTAL_DOCUMENT_VALIDITY_MINUTES * 60 * 1000),
          legacyExpiryMs
        );
      }

      return false;
    }

    function getCurrentRentalDocumentWindowForCartProperties() {
      var validUntilMs = getRentalDocumentValidUntilMs();
      if (!validUntilMs || validUntilMs <= getTrustedNowMs()) return null;

      var submittedAtMs = getRentalDocumentSubmittedAtMs();
      if (!submittedAtMs || submittedAtMs >= validUntilMs) {
        submittedAtMs = validUntilMs - (RENTAL_DOCUMENT_VALIDITY_MINUTES * 60 * 1000);
      }

      return {
        submittedAtMs: submittedAtMs,
        validUntilMs: validUntilMs
      };
    }

    function markDocumentsAsSubmittedForActiveRentalCart(message) {
      if (!jotformSubmittedInput) return false;

      jotformSubmittedInput.value = 'Yes';
      documentsReusedFromActiveRentalCart = true;

      if (requiredDocumentsHeading) {
        requiredDocumentsHeading.textContent = 'Documents Submitted';
      }
      if (requiredDocumentsStepNote) {
        requiredDocumentsStepNote.textContent = 'Already submitted for this checkout — no need to upload again';
      }
      if (jotformStatusNote) {
        jotformStatusNote.textContent = message || 'Your documents are already submitted and remain valid within the current 4-hour verification window.';
        jotformStatusNote.classList.remove('is-error');
        jotformStatusNote.classList.add('is-success');
      }
      if (uploadDocumentsPanel) {
        uploadDocumentsPanel.hidden = true;
        uploadDocumentsPanel.style.display = 'none';
      }
      if (requiredDocumentsPanel) {
        requiredDocumentsPanel.open = true;
        requiredDocumentsPanel.setAttribute('data-rental-documents-preserved', 'true');
      }

      updateRentalEditPrimaryActions();
      return true;
    }

    function restoreRequiredDocumentsUpload() {
      documentsReusedFromActiveRentalCart = false;
      rentalEditDocumentsReusableConfirmed = false;

      if (!jotformSubmittedInput || documentsSubmittedOnCurrentPage) return;

      jotformSubmittedInput.value = 'No';

      if (requiredDocumentsHeading) {
        requiredDocumentsHeading.innerHTML = 'Upload Required Documents <span class="rental-required-docs-asterisk" aria-hidden="true">*</span>';
      }
      if (requiredDocumentsStepNote) {
        requiredDocumentsStepNote.textContent = 'Upload documents for rental verification';
      }
      if (jotformStatusNote) {
        jotformStatusNote.textContent = 'Please submit the required documents for verification. All submitted documents are securely encrypted, kept confidential, and used solely for rental verification purposes.';
        jotformStatusNote.classList.remove('is-success', 'is-error');
      }
      if (uploadDocumentsPanel) {
        uploadDocumentsPanel.hidden = false;
        uploadDocumentsPanel.style.display = '';
      }
      if (requiredDocumentsPanel) {
        requiredDocumentsPanel.removeAttribute('data-rental-documents-preserved');
      }

      updateRentalEditPrimaryActions();
    }

    function resetRentalJotformForFreshUpload() {
      var jotformFrame = document.getElementById('RentalJotform');
      if (!jotformFrame) return;

      var originalSrc = String(
        jotformFrame.getAttribute('data-rental-original-src') ||
        jotformFrame.getAttribute('src') ||
        ''
      ).trim();

      if (!originalSrc) return;

      if (!jotformFrame.getAttribute('data-rental-original-src')) {
        jotformFrame.setAttribute('data-rental-original-src', originalSrc);
      }

      rentalDocumentRequiresFreshUpload = true;

      var jotformUploadWrap = jotformFrame.closest('.rental-doc-upload');
      if (jotformUploadWrap) {
        jotformUploadWrap.classList.remove('is-submitted');
      }

      jotformFrame.addEventListener('load', function handleFreshDocumentFormLoad() {
        rentalDocumentRequiresFreshUpload = false;
        jotformFrame.style.minHeight = '';
        jotformFrame.removeEventListener('load', handleFreshDocumentFormLoad);
      });

      var separator = originalSrc.indexOf('?') === -1 ? '?' : '&';
      jotformFrame.setAttribute(
        'src',
        originalSrc + separator + 'rental_reupload=' + encodeURIComponent(String(Date.now()))
      );
    }

    function expireRentalDocumentSessionForReupload() {
      documentsSubmittedOnCurrentPage = false;
      documentsReusedFromActiveRentalCart = false;
      rentalEditDocumentsReusableConfirmed = false;
      rentalDocumentTimestampPromise = null;
      clearRentalDocumentSessionWindow();
      clearRentalDocumentGrace();

      if (jotformSubmittedInput) {
        jotformSubmittedInput.value = 'No';
      }

      restoreRequiredDocumentsUpload();
      resetRentalJotformForFreshUpload();
    }

    function getRentalDocumentGraceUntilMs() {
      try {
        var graceUntilMs = Number(
          window.sessionStorage.getItem(RENTAL_DOCUMENT_GRACE_UNTIL_KEY) || 0
        );

        if (!Number.isFinite(graceUntilMs) || graceUntilMs <= getTrustedNowMs()) {
          window.sessionStorage.removeItem(RENTAL_DOCUMENT_GRACE_UNTIL_KEY);
          return 0;
        }

        return graceUntilMs;
      } catch (error) {
        return 0;
      }
    }

    function activeRentalDocumentGraceIsReusable() {
      var graceUntilMs = getRentalDocumentGraceUntilMs();
      if (!graceUntilMs) return false;

      var nowMs = getTrustedNowMs();
      var rawDocumentValidUntilMs = rentalDocumentValidUntilMs > 0
        ? rentalDocumentValidUntilMs
        : readRentalDocumentSessionTimestamp(RENTAL_DOCUMENT_VALID_UNTIL_KEY);

      if (rawDocumentValidUntilMs > 0) {
        if (rawDocumentValidUntilMs <= nowMs) {
          clearRentalDocumentSessionWindow();
          clearRentalDocumentGrace();
          return false;
        }

        return Math.min(graceUntilMs, rawDocumentValidUntilMs) > nowMs;
      }

      /* Compatibility for an already-running pre-upgrade removal grace. */
      return graceUntilMs > nowMs;
    }

    function clearRentalDocumentGrace() {
      try {
        window.sessionStorage.removeItem(RENTAL_DOCUMENT_GRACE_UNTIL_KEY);
      } catch (error) {}
    }

    function getRentalCartGroupCreatedAtMs(item) {
      var groupId = getRentalCartItemGroupId(item);
      var match = groupId.match(/^rental-(\d{13})(?:-|$)/);
      var createdAtMs = match ? Number(match[1]) : 0;
      return Number.isFinite(createdAtMs) ? createdAtMs : 0;
    }

    function getActiveRentalCartReservationExpiryMs(cart) {
      if (!cart || !Array.isArray(cart.items)) return 0;

      var earliestRentalCreatedAtMs = 0;
      cart.items.forEach(function (item) {
        if (!getRentalCartItemGroupId(item)) return;
        var createdAtMs = getRentalCartGroupCreatedAtMs(item);
        if (!createdAtMs) return;
        if (!earliestRentalCreatedAtMs || createdAtMs < earliestRentalCreatedAtMs) {
          earliestRentalCreatedAtMs = createdAtMs;
        }
      });

      var groupExpiryMs = earliestRentalCreatedAtMs
        ? earliestRentalCreatedAtMs + (RENTAL_DOCUMENT_LEGACY_SESSION_MINUTES * 60 * 1000)
        : 0;

      var attributes = cart.attributes && typeof cart.attributes === 'object' ? cart.attributes : {};
      var attributeExpiryMs = Date.parse(String(attributes['Rental cart expires at'] || ''));
      if (!Number.isFinite(attributeExpiryMs)) attributeExpiryMs = 0;

      var configuredMinutes = Number(
        attributes['Rental cart expiry minutes'] || RENTAL_DOCUMENT_LEGACY_SESSION_MINUTES
      );
      if (
        Number.isFinite(configuredMinutes) &&
        configuredMinutes !== RENTAL_DOCUMENT_LEGACY_SESSION_MINUTES
      ) {
        attributeExpiryMs = 0;
      }

      if (attributeExpiryMs > 0) {
        return attributeExpiryMs;
      }

      return groupExpiryMs > 0 ? groupExpiryMs : 0;
    }

    function getActiveRentalCartDocumentExpiryMs(cart) {
      if (!cart || !Array.isArray(cart.items)) return 0;

      var earliestDocumentExpiryMs = 0;

      cart.items.forEach(function (item) {
        if (!item || rentalCartItemIsLinkedCharge(item)) return;
        if (!getRentalCartItemGroupId(item)) return;

        var itemWindow = getRentalDocumentWindowFromItem(item);
        if (!itemWindow.explicit) return;

        if (!earliestDocumentExpiryMs || itemWindow.validUntilMs < earliestDocumentExpiryMs) {
          earliestDocumentExpiryMs = itemWindow.validUntilMs;
        }
      });

      if (earliestDocumentExpiryMs > 0) {
        return earliestDocumentExpiryMs;
      }

      /* Legacy cart fallback only. This deliberately does not turn an old
         20-minute document state into a new 4-hour state. */
      return getActiveRentalCartReservationExpiryMs(cart);
    }

    function cartHasSubmittedRentalDocuments(cart) {
      if (!cart || !Array.isArray(cart.items)) return false;

      return cart.items.some(function (item) {
        if (!item || rentalCartItemIsLinkedCharge(item)) return false;
        if (!getRentalCartItemGroupId(item)) return false;
        var properties = item.properties || {};
        return normaliseEditText(properties['Documents submitted']) === 'yes';
      });
    }

    function activeRentalCartDocumentsAreReusable(cart) {
      if (!cartHasSubmittedRentalDocuments(cart)) return false;

      var expiryMs = getActiveRentalCartDocumentExpiryMs(cart);
      if (!expiryMs || expiryMs <= getTrustedNowMs()) return false;

      syncRentalDocumentSessionFromCart(cart, expiryMs);
      return true;
    }

    function initialiseActiveRentalCartDocumentReuse(existingCart) {
      if (documentsSubmittedOnCurrentPage) {
        rentalEditDocumentsReusableConfirmed = !!rentalEditModeActive;
        rentalEditDocumentValidationComplete = true;
        updateRentalEditPrimaryActions();
        return Promise.resolve(true);
      }

      var cartPromise = existingCart
        ? Promise.resolve(existingCart)
        : fetchRentalCartForEdit('documents-' + Date.now());

      return cartPromise
        .then(function (cart) {
          if (activeRentalCartDocumentsAreReusable(cart)) {
            clearRentalDocumentGrace();
            markDocumentsAsSubmittedForActiveRentalCart(
              'Documents already submitted for this checkout. They remain valid within the original 4-hour verification window.'
            );
            rentalEditDocumentsReusableConfirmed = !!rentalEditModeActive;
            rentalEditDocumentValidationComplete = true;
            updateRentalEditPrimaryActions();
            return true;
          }

          if (activeRentalDocumentGraceIsReusable()) {
            markDocumentsAsSubmittedForActiveRentalCart(
              'Documents from your previous rental are still valid during the 30-minute removal grace, within the original 4-hour verification window.'
            );
            rentalEditDocumentsReusableConfirmed = !!rentalEditModeActive;
            rentalEditDocumentValidationComplete = true;
            updateRentalEditPrimaryActions();
            return true;
          }

          rentalEditDocumentsReusableConfirmed = false;
          rentalEditDocumentValidationComplete = true;
          restoreRequiredDocumentsUpload();
          return false;
        })
        .catch(function (error) {
          console.error('Active rental document session check error:', error);

          if (activeRentalDocumentGraceIsReusable()) {
            markDocumentsAsSubmittedForActiveRentalCart(
              'Documents from your previous rental are still valid during the 30-minute removal grace, within the original 4-hour verification window.'
            );
            rentalEditDocumentsReusableConfirmed = !!rentalEditModeActive;
            rentalEditDocumentValidationComplete = true;
            updateRentalEditPrimaryActions();
            return true;
          }

          rentalEditDocumentsReusableConfirmed = false;
          rentalEditDocumentValidationComplete = true;
          restoreRequiredDocumentsUpload();
          return false;
        });
    }

    function makeRentalDocumentExpiredError() {
      var error = new Error('Your document verification has expired. Please upload the required documents again to continue.');
      error.code = 'RENTAL_DOCUMENT_SESSION_EXPIRED';
      return error;
    }

    function revalidateActiveRentalCartDocumentsBeforeSubmit() {
      if (rentalDocumentBypassTestingEnabled()) {
        return Promise.resolve(true);
      }

      if (!jotformSubmittedInput || jotformSubmittedInput.value !== 'Yes') {
        return Promise.resolve(true);
      }

      var timestampPromise = rentalDocumentTimestampPromise || Promise.resolve(null);

      return timestampPromise
        .then(function () {
          /* Fetch /cart.js even for a fresh upload so getTrustedNowMs() is
             refreshed from Shopify's Date header before the final decision. */
          return fetchRentalCartForEdit('documents-submit-' + Date.now());
        })
        .then(function (cart) {
          var nowMs = getTrustedNowMs();

          if (documentsSubmittedOnCurrentPage) {
            if (getRentalDocumentValidUntilMs() > nowMs) {
              return true;
            }

            expireRentalDocumentSessionForReupload();
            throw makeRentalDocumentExpiredError();
          }

          if (documentsReusedFromActiveRentalCart && activeRentalCartDocumentsAreReusable(cart)) {
            clearRentalDocumentGrace();
            rentalEditDocumentsReusableConfirmed = !!rentalEditModeActive;
            updateRentalEditPrimaryActions();
            return true;
          }

          if (activeRentalDocumentGraceIsReusable()) {
            rentalEditDocumentsReusableConfirmed = !!rentalEditModeActive;
            updateRentalEditPrimaryActions();
            return true;
          }

          expireRentalDocumentSessionForReupload();
          throw makeRentalDocumentExpiredError();
        });
    }

    function preserveSubmittedDocumentsForEdit(mainItem) {
      var properties = mainItem && mainItem.properties ? mainItem.properties : {};
      var documentsWereSubmitted = normaliseEditText(properties['Documents submitted']) === 'yes';
      if (!documentsWereSubmitted) return false;

      var itemWindow = getRentalDocumentWindowFromItem(mainItem);

      if (itemWindow.explicit) {
        if (itemWindow.validUntilMs <= getTrustedNowMs()) return false;
        writeRentalDocumentSessionWindow(itemWindow.submittedAtMs, itemWindow.validUntilMs);
      }

      /* A legacy cart may not contain explicit document timestamps. It is shown
         provisionally during the locked Edit Rental hydration, then the live
         cart check applies its old 20-minute limit before the form unlocks. */
      return markDocumentsAsSubmittedForActiveRentalCart(
        itemWindow.explicit
          ? 'Documents are already submitted. They remain valid within the original 4-hour verification window.'
          : 'Documents are already submitted. Their existing checkout validity is being verified.'
      );
    }

    function clearRentalEditRequestFromUrl() {
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('edit_rental');
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      } catch (error) {}
    }

    function refreshSelectedRentalConfigurationForEditFastPath() {
      updateIpadCellularModeAvailability();
      updatePencilAddonAvailability();
      updateMemoryAddonAvailability();
      applyMinimumRentalPeriodRule();
      syncRentalPeriodSelectFromRadio();
      syncRentalPeriodSelectDisabledOptions();
      syncRentalProcessorSelectFromRadio();
      syncRentalProcessorSelectDisabledOptions();
      updateSelectedCards();

      var matchedVariant = findMatchingVariant();

      if (matchedVariant) {
        variantIdInput.value = matchedVariant.id;
        var matchedLivePrice = getLiveVariantPriceCents(matchedVariant.id);
        setBasePrice(Number.isFinite(matchedLivePrice) ? matchedLivePrice : matchedVariant.price);
      } else {
        variantIdInput.value = '';
        setBasePrice(0);
      }

      refreshPlayTimeDependentUi(true);
      updateRentalInfoPanels();
    }

    function applyRentalConfigurationFromItem(mainItem, groupItems, options) {
      options = options || {};
      if (!mainItem) throw new Error('Rental item could not be identified.');

      var variantId = Number(mainItem.variant_id || mainItem.id || 0);
      var matchedVariant = allVariants.find(function (variant) {
        return Number(variant && variant.id) === variantId;
      });

      if (!matchedVariant || !Array.isArray(matchedVariant.options)) {
        throw new Error('The rental variant saved in the cart is no longer available on this product page.');
      }

      rentalEditQuantity = Math.max(1, parseInt(mainItem.quantity, 10) || 1);
      if (rentalQuantityInput) rentalQuantityInput.value = String(rentalEditQuantity);

      var processorIndex = getRentalProcessorOptionIndex();
      var restoreCellularMode = false;

      matchedVariant.options.forEach(function (optionValue, optionIndex) {
        var optionPosition = String(optionIndex + 1);
        var valueToRestore = String(optionValue || '');

        if (
          isIpadRentalPage() &&
          processorIndex === optionIndex &&
          isIpadCellularProcessorValue(valueToRestore)
        ) {
          restoreCellularMode = true;
          valueToRestore = getBaseIpadProcessorValue(valueToRestore);
        }

        setRentalOptionValueForEdit(optionPosition, valueToRestore);
      });

      var properties = mainItem.properties || {};
      captureRentalEditSavedSchedule(mainItem, groupItems || []);

      if (cellularAddonInput) {
        rentalEditRestoredCellularMode = restoreCellularMode ||
          normaliseEditText(properties['Connectivity']) === 'cellular';
        rentalEditConnectivityTouchedByUser = false;
        cellularAddonInput.checked = rentalEditRestoredCellularMode;
      }

      refreshSelectedRentalConfigurationForEditFastPath();
      preserveRestoredIpadConnectivityForEdit();

      var storedStartDate = String(properties['Rental start date'] || '').trim();
      var storedEndDate = String(properties['Rental end date'] || '').trim();

      if (startDateInput && /^\d{4}-\d{2}-\d{2}$/.test(storedStartDate)) {
        startDateInput.value = storedStartDate;

        // New calendar rentals persist their exact end date. For a legacy cart
        // rental, derive the previous period end date once so it can be edited
        // through the new date-range interface without changing its dates.
        if (!/^\d{4}-\d{2}-\d{2}$/.test(storedEndDate)) {
          var editPeriodIndex = getRentalPeriodOptionIndex();
          var legacyPeriodValue = editPeriodIndex >= 0 && matchedVariant.options
            ? String(matchedVariant.options[editPeriodIndex] || '')
            : '';
          var legacyEndDate = getRentalEndDate(parseLocalDate(storedStartDate), legacyPeriodValue);
          if (legacyEndDate) storedEndDate = formatDateProperty(legacyEndDate);
        }

        if (rentalEndDateInput && /^\d{4}-\d{2}-\d{2}$/.test(storedEndDate)) {
          rentalEndDateInput.value = storedEndDate;
        }
        setRentalStartDateDisplayText();
        updateRentalCalendarInstruction();
      }

      if (rentalNotes) {
        rentalNotes.value = String(properties['Additional notes'] || '');
      }

      rebuildDeliveryOptions();

      setRentalSelectFromStoredText(
        deliveryTimeInput,
        properties['Delivery timing'],
        stripDeliveryChargeSuffix
      );

      rebuildReturnOptions();

      if (returnTimeInput && properties['Return timing']) {
        setRentalSelectFromStoredText(returnTimeInput, properties['Return timing']);
      }

      if (memoryAddonInput) {
        memoryAddonInput.checked = cartEditPropertyIsYes(properties, '32GB addon selected') ||
          cartEditGroupHasCharge(groupItems || [], '32GB memory addon');
      }

      if (officeAddonInput) {
        officeAddonInput.checked = cartEditPropertyIsYes(properties, 'Microsoft Office addon selected') ||
          cartEditGroupHasCharge(groupItems || [], 'Microsoft Office addon');
      }

      if (appleMouseAddonInput) {
        appleMouseAddonInput.checked = cartEditPropertyIsYes(properties, 'Apple Mouse optional extra selected') ||
          cartEditGroupHasCharge(groupItems || [], 'Apple Mouse optional extra');
      }

      if (hdmiAddonInput) {
        hdmiAddonInput.checked = cartEditPropertyIsYes(properties, 'HDMI Port optional extra selected') ||
          cartEditGroupHasCharge(groupItems || [], 'HDMI Port optional extra');
      }

      if (pencilAddonInput) {
        pencilAddonInput.checked = (
          cartEditPropertyIsYes(properties, 'Pencil optional extra selected') ||
          cartEditGroupHasCharge(groupItems || [], 'Pencil optional extra')
        ) && !!selectedPencilAddonConfig;
      }

      updateAddonCards();
      updateRentalInfoPanels();
      updateRentalEndInfo();
      updateTotal();
      setRentalStartDateDisplayText();

      if (options.preserveDocuments !== false) {
        preserveSubmittedDocumentsForEdit(mainItem);
      }

      if (rentalOptionsStepTitle) {
        rentalOptionsStepTitle.textContent = 'Update Rental Options';
      }

      // The hydration lock owns this message while Edit Rental is loading, so
      // later cache/cart restores cannot replace the spinner status prematurely.
      renderRentalEditHydrationNote(rentalEditHydrating);

      return matchedVariant;
    }

    function initialiseRentalEditFastPath() {
      if (!rentalEditRequestedGroupId) return false;

      var snapshot = readRentalEditCache(rentalEditRequestedGroupId);
      if (!snapshot || !snapshot.mainItem) return false;

      try {
        rentalEditCachedSnapshot = snapshot;
        rentalEditFastPathApplied = true;
        rentalEditModeActive = true;
        rentalEditMainItem = snapshot.mainItem;
        rentalEditOriginalItems = Array.isArray(snapshot.groupItems) ? snapshot.groupItems.slice() : [];
        applyRentalConfigurationFromItem(
          snapshot.mainItem,
          rentalEditOriginalItems,
          {
            preserveDocuments: true,
            verifying: true
          }
        );
        return true;
      } catch (error) {
        console.warn('Rental edit fast cache restore failed:', error);
        rentalEditCachedSnapshot = null;
        rentalEditFastPathApplied = false;
        rentalEditModeActive = false;
        rentalEditMainItem = null;
        rentalEditOriginalItems = [];
        clearRentalEditCache(rentalEditRequestedGroupId);
        return false;
      }
    }

    function restoreRentalConfigurationFromCart(mainItem, groupItems, forceValidation) {
      try {
        applyRentalConfigurationFromItem(
          mainItem,
          groupItems,
          {
            preserveDocuments: true,
            verifying: true
          }
        );
      } catch (error) {
        return Promise.reject(error);
      }

      // Availability/pricing validation is awaited by the main Edit Rental
      // initialisation chain. Keep the form locked until that chain finishes.
      return Promise.resolve(true);
    }

    function initialiseRentalEditMode() {
      if (!rentalEditRequestedGroupId) return Promise.resolve(false);

      setLoadingState(true);

      return fetchRentalCartForEdit('load-' + Date.now())
        .then(function (cart) {
          rentalEditLoadedCart = cart;

          var groupItems = getRentalEditGroupItems(cart, rentalEditRequestedGroupId);
          var mainItem = getRentalEditMainItem(groupItems);

          if (!groupItems.length || !mainItem) {
            var missingGroupId = rentalEditRequestedGroupId;
            rentalEditRequestedGroupId = '';
            rentalEditModeActive = false;
            rentalEditDocumentValidationComplete = false;
            rentalEditOriginalItems = [];
            rentalEditMainItem = null;
            rentalEditLoadedCart = null;
            clearRentalEditCache(missingGroupId);
            clearRentalEditRequestFromUrl();
            restoreRequiredDocumentsUpload();
            setRentalEditHydrationLocked(false);
            setLoadingState(false);
            window.alert('This rental is no longer in your cart. Please configure a new rental.');
            return false;
          }

          var cachedMainItem = rentalEditCachedSnapshot && rentalEditCachedSnapshot.mainItem
            ? rentalEditCachedSnapshot.mainItem
            : null;
          var cacheDiffersFromCart = !!(
            cachedMainItem &&
            getRentalEditItemSignature(cachedMainItem) !== getRentalEditItemSignature(mainItem)
          );

          rentalEditModeActive = true;
          rentalEditOriginalItems = groupItems.slice();
          rentalEditMainItem = mainItem;

          // The fast-path cache already painted this exact cart configuration.
          // If the live cart confirms that it is unchanged, do not paint it a
          // second time: the customer may have already made a new selection.
          if (rentalEditFastPathApplied && !cacheDiffersFromCart) {
            // The cache already painted the same saved configuration. Keep it
            // locked while the live availability/pricing checks complete.
            return Promise.resolve(true);
          }

          return restoreRentalConfigurationFromCart(mainItem, groupItems, cacheDiffersFromCart)
            .then(function () { return true; });
        })
        .catch(function (error) {
          console.error('Rental edit initialisation error:', error);
          rentalEditModeActive = false;
          rentalEditLoadedCart = null;
          setRentalEditHydrationLocked(false);
          setLoadingState(false);
          window.alert(error && error.message ? error.message : 'Unable to load this rental for editing.');
          return false;
        });
    }

    function cloneRentalCartItemForRestore(item) {
      var restoreItem = {
        id: Number(item.variant_id || item.id || 0),
        quantity: Math.max(1, Number(item.quantity) || 1)
      };

      if (item.properties && typeof item.properties === 'object') {
        restoreItem.properties = Object.assign({}, item.properties);
      }

      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        var sellingPlanId = Number(item.selling_plan_allocation.selling_plan.id || 0);
        if (sellingPlanId > 0) restoreItem.selling_plan = sellingPlanId;
      }

      return restoreItem;
    }

    function removeRentalEditGroupFromCart(groupId) {
      return fetchRentalCartForEdit('remove-' + Date.now())
        .then(function (cart) {
          var updates = {};

          getRentalEditGroupItems(cart, groupId).forEach(function (item) {
            if (item && item.key) updates[item.key] = 0;
          });

          if (!Object.keys(updates).length) return cart;

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ updates: updates })
          }).then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) {
                throw new Error(data.description || data.message || 'Unable to update the rental cart.');
              }
              return data;
            });
          });
        });
    }

    function replaceRentalEditGroup(newItems) {
      if (!rentalEditModeActive || !rentalEditRequestedGroupId) {
        return postCartItems({ items: newItems });
      }

      var originalRestoreItems = [];
      var originalGroupWasRemoved = false;

      /*
       * Quantity can be changed from the cart before Edit Rental is opened.
       * Take the rollback copy from the LIVE cart immediately before replacement
       * instead of trusting an older cached/edit-load snapshot.
       */
      return fetchRentalCartForEdit('pre-replace-' + Date.now())
        .then(function (cart) {
          var liveOriginalItems = getRentalEditGroupItems(cart, rentalEditRequestedGroupId);

          if (!liveOriginalItems.length) {
            throw new Error('This rental is no longer in your cart. Please return to the bag and try again.');
          }

          originalRestoreItems = liveOriginalItems
            .map(cloneRentalCartItemForRestore)
            .filter(function (item) { return Number(item.id) > 0; });

          rentalEditOriginalItems = liveOriginalItems.slice();

          return removeRentalEditGroupFromCart(rentalEditRequestedGroupId);
        })
        .then(function () {
          originalGroupWasRemoved = true;
          return postCartItems({ items: newItems });
        })
        .catch(function (updateError) {
          /*
           * If removing the original group itself failed, do not attempt a
           * rollback/add because the original rental is still in the cart.
           */
          if (!originalGroupWasRemoved) {
            throw updateError;
          }

          if (!originalRestoreItems.length) {
            throw updateError;
          }

          return fetchRentalCartForEdit('rollback-check-' + Date.now())
            .then(function (cart) {
              var currentGroupItems = getRentalEditGroupItems(cart, rentalEditRequestedGroupId);

              /* A failed /cart/add.js can occasionally leave part of the new
                 group present. Remove only that group before restoring the exact
                 live snapshot captured above. */
              if (!currentGroupItems.length) return null;
              return removeRentalEditGroupFromCart(rentalEditRequestedGroupId);
            })
            .then(function () {
              return postCartItems({ items: originalRestoreItems });
            })
            .then(function () {
              var rollbackError = new Error('Unable to update the rental. Your original rental has been restored in the cart.');
              rollbackError.originalUpdateError = updateError;
              throw rollbackError;
            })
            .catch(function (rollbackFailure) {
              if (
                rollbackFailure &&
                rollbackFailure.message === 'Unable to update the rental. Your original rental has been restored in the cart.'
              ) {
                throw rollbackFailure;
              }

              console.error('Rental edit rollback error:', rollbackFailure);
              console.error('Original rental update error:', updateError);

              var criticalError = new Error(
                'Unable to update the rental and the original rental could not be restored automatically. Please review your cart before proceeding.'
              );
              criticalError.originalUpdateError = updateError;
              criticalError.rollbackFailure = rollbackFailure;
              throw criticalError;
            });
        });
    }

      window.addEventListener('message', function (event) {
        if (!event || !event.data) return;

        var data = event.data;
        var messageText = '';
        var jotformFrame = document.getElementById('RentalJotform');
        var jotformOrigin = String(event.origin || '');
        var isAllowedJotformOrigin = /^https:\/\/([a-z0-9-]+\.)*jotform\.com$/i.test(jotformOrigin);
        var isJotformFrameMessage = !!(
          jotformFrame &&
          event.source === jotformFrame.contentWindow &&
          isAllowedJotformOrigin
        );

        if (isJotformFrameMessage && typeof data === 'string') {
          var heightMatch = data.match(/^setHeight:(\d+)(?::.*)?$/);
          var submissionAlreadyCompleted = jotformSubmittedInput && jotformSubmittedInput.value === 'Yes';
          if (heightMatch && !submissionAlreadyCompleted) {
            var requestedHeight = parseInt(heightMatch[1], 10);
            if (Number.isFinite(requestedHeight)) {
              jotformFrame.style.height = Math.max(560, Math.min(requestedHeight, 1600)) + 'px';
            }
          }
        }

        if (typeof data === 'string') {
          messageText = data;
        } else {
          try {
            messageText = JSON.stringify(data);
          } catch (error) {
            messageText = '';
          }
        }

        var isSubmitted = isJotformFrameMessage && (
          messageText.indexOf('submission-completed') !== -1 ||
          messageText.indexOf('formID:260751691108053') !== -1 && messageText.indexOf('submission') !== -1 ||
          messageText.indexOf('thankYouPage') !== -1
        );

        if (isSubmitted) {
          if (rentalDocumentRequiresFreshUpload) return;

          var firstDocumentCompletionSignal = !documentsSubmittedOnCurrentPage;
          documentsSubmittedOnCurrentPage = true;
          documentsReusedFromActiveRentalCart = false;

          if (firstDocumentCompletionSignal) {
            recordFreshRentalDocumentSubmission();
          }
          rentalEditDocumentsReusableConfirmed = !!rentalEditModeActive;
          rentalEditDocumentValidationComplete = true;

          if (jotformSubmittedInput) {
            jotformSubmittedInput.value = 'Yes';
          }

          updateRentalEditPrimaryActions();

          if (jotformStatusNote) {
            jotformStatusNote.textContent = 'Documents submitted successfully.';
            jotformStatusNote.classList.remove('is-error');
            jotformStatusNote.classList.add('is-success');
          }

          var jotformUploadWrap = jotformFrame ? jotformFrame.closest('.rental-doc-upload') : null;
          if (jotformUploadWrap) {
            jotformUploadWrap.classList.add('is-submitted');
          }

          if (jotformFrame) {
            jotformFrame.style.height = '430px';
            jotformFrame.style.minHeight = '0';
          }

          clearRequiredDocumentsAttention();
        }
      });

    function refreshRentalDocumentUiAfterResume() {
      if (!jotformSubmittedInput || jotformSubmittedInput.value !== 'Yes') return;
      if (!documentsSubmittedOnCurrentPage && !documentsReusedFromActiveRentalCart) return;

      var rawValidUntilMs = rentalDocumentValidUntilMs > 0
        ? rentalDocumentValidUntilMs
        : readRentalDocumentSessionTimestamp(RENTAL_DOCUMENT_VALID_UNTIL_KEY);

      if (rawValidUntilMs > 0 && rawValidUntilMs <= getTrustedNowMs()) {
        expireRentalDocumentSessionForReupload();
      }
    }

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refreshRentalDocumentUiAfterResume();
    });
    window.addEventListener('focus', refreshRentalDocumentUiAfterResume);

    if (rentalTermsToggle && rentalTermsBox) {
      rentalTermsToggle.addEventListener('click', function () {
        var isHidden = rentalTermsBox.hasAttribute('hidden');

        if (isHidden) {
          rentalTermsBox.removeAttribute('hidden');
          rentalTermsToggle.textContent = 'Hide ‹';
        } else {
          rentalTermsBox.setAttribute('hidden', '');
          rentalTermsToggle.textContent = 'Terms ›';
        }
      });
    }

    if (thumbs.length && mainImage) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (item) { item.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          mainImage.src = thumb.getAttribute('data-image-src');
        });
      });
    }

    function refreshSelectedRentalConfiguration() {
      updateIpadCellularModeAvailability();
      updatePencilAddonAvailability();
      updateMemoryAddonAvailability();
      applyMinimumRentalPeriodRule();
      syncRentalPeriodSelectFromRadio();
      syncRentalPeriodSelectDisabledOptions();
      syncRentalProcessorSelectFromRadio();
      syncRentalProcessorSelectDisabledOptions();
      updateSelectedCards();

      var matchedVariant = findMatchingVariant();

      if (matchedVariant) {
        variantIdInput.value = matchedVariant.id;
        var matchedLivePrice = getLiveVariantPriceCents(matchedVariant.id);
        setBasePrice(Number.isFinite(matchedLivePrice) ? matchedLivePrice : matchedVariant.price);
      } else {
        variantIdInput.value = '';
        setBasePrice(0);
      }

      refreshPlayTimeDependentUi(true);
      loadSelectedSecurityDepositLeadDays().then(function () {
        updateProcessorAvailabilityNote();
      });
      loadSelectedVariantAndDepositPrices(false).catch(function (error) {
        console.error('Selected variant live price lookup error:', error);
        updateTotal();
      });
      updateRentalInfoPanels();
    }

    /* ============================================================
       PLAYFORCE CALENDAR RENTAL BETA
       - Customer selects a start + return date instead of a period.
       - Rental days are inclusive (10 Oct -> 10 Oct = 1 day; 10 Oct -> 11 Oct = 2 days).
       - Maximum rental duration is 90 days.
       - Shopify CAL variants are internal pricing components.
       ============================================================ */
    var CALENDAR_MAX_RENTAL_DAYS = 90;
    var CALENDAR_BASE_PERIOD_VALUE = 'CAL Base 1 Day';
    var rentalEndDateInput = document.getElementById('RentalEndDate');
    var rentalDurationPreview = document.getElementById('RentalDurationPreview');
    var rentalCalendarInstruction = document.getElementById('RentalCalendarInstruction');
    var rentalCalendarRangeSummary = document.getElementById('RentalCalendarRangeSummary');
    var rentalCalendarSelectedCost = document.getElementById('RentalCalendarSelectedCost');
    var rentalCalendarSelectedCostMobile = document.getElementById('RentalCalendarSelectedCostMobile');
    var rentalCalendarWeekendPriceNote = document.getElementById('RentalCalendarWeekendPriceNote');
    var rentalCalendarWeekendPriceNoteMobile = document.getElementById('RentalCalendarWeekendPriceNoteMobile');
    var rentalCalendarReset = document.getElementById('RentalCalendarReset');
    var rentalCalendarResetSelection = null;
    var rentalDateRangeHelp = document.getElementById('RentalDateRangeHelp');

    function ensureRentalCalendarResetSelectionButton() {
      var existing = document.getElementById('RentalCalendarResetSelection');
      var calendar = document.getElementById('RentalMobileCalendar');
      var footer = calendar ? calendar.querySelector('.rental-calendar-footer') : null;

      if (!footer) return existing || null;

      var button = existing;

      if (button) {
        button.classList.add('rental-calendar-done-icon');
      }

      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.id = 'RentalCalendarResetSelection';
        button.className = 'rental-calendar-reset-selection rental-calendar-done-icon';
        button.setAttribute('aria-label', 'Reset rental dates');
        button.setAttribute('title', 'Reset rental dates');
        footer.insertBefore(button, footer.firstChild);
      }

      button.removeAttribute('disabled');
      button.innerHTML =
        '<svg aria-hidden="true" viewBox="0 0 24 24">' +
          '<path d="M4.75 8.25V4.75H8.25"/>' +
          '<path d="M5.15 7.1A8 8 0 1 1 4.6 15.7"/>' +
        '</svg>';

      if (!button.getAttribute('data-rental-reset-bound')) {
        button.setAttribute('data-rental-reset-bound', 'true');
        button.addEventListener('click', function (event) {
          event.preventDefault();

          var hasStartDate = !!parseLocalDate(startDateInput ? startDateInput.value : '');
          var hasEndDate = !!parseLocalDate(rentalEndDateInput ? rentalEndDateInput.value : '');
          if (!hasStartDate || !hasEndDate) return;

          clearRentalCalendarRange(true);
        });
      }

      var styleId = 'RentalCalendarResetSelectionRuntimeStyles';
      if (!document.getElementById(styleId)) {
        var style = document.createElement('style');
        style.id = styleId;
        style.textContent = [
          '#RentalMobileCalendar .rental-calendar-reset-selection{',
            'grid-column:1!important;',
            'grid-row:1!important;',
            'position:static!important;',
            'top:auto!important;',
            'right:auto!important;',
            'left:auto!important;',
            'align-self:center!important;',
            'justify-self:center!important;',
            'margin:0!important;',
          '}',
          '#RentalMobileCalendar .rental-calendar-reset-selection.is-hidden{',
            'display:none!important;',
          '}',
          '#RentalMobileCalendar .rental-calendar-reset-selection svg{',
            'display:block!important;',
            'width:19px!important;',
            'height:19px!important;',
            'fill:none!important;',
            'stroke:currentColor!important;',
            'stroke-width:1.9!important;',
            'stroke-linecap:round!important;',
            'stroke-linejoin:round!important;',
          '}'
        ].join('');
        document.head.appendChild(style);
      }

      rentalCalendarResetSelection = button;
      return button;
    }

    function matchRentalCalendarResetSelectionToDoneButton(button) {
      if (!button || !rentalCalendarReset) return;

      var doneRect = rentalCalendarReset.getBoundingClientRect();
      var doneStyle = window.getComputedStyle(rentalCalendarReset);

      var width = doneRect.width > 0
        ? doneRect.width
        : parseFloat(doneStyle.width || '0');
      var height = doneRect.height > 0
        ? doneRect.height
        : parseFloat(doneStyle.height || '0');

      if (Number.isFinite(width) && width > 0) {
        button.style.setProperty('width', width + 'px', 'important');
        button.style.setProperty('min-width', width + 'px', 'important');
        button.style.setProperty('max-width', width + 'px', 'important');
        button.style.setProperty('flex-basis', width + 'px', 'important');
      }

      if (Number.isFinite(height) && height > 0) {
        button.style.setProperty('height', height + 'px', 'important');
        button.style.setProperty('min-height', height + 'px', 'important');
        button.style.setProperty('max-height', height + 'px', 'important');
      }

      [
        'boxSizing',
        'paddingTop',
        'paddingRight',
        'paddingBottom',
        'paddingLeft',
        'borderTopWidth',
        'borderRightWidth',
        'borderBottomWidth',
        'borderLeftWidth',
        'borderTopStyle',
        'borderRightStyle',
        'borderBottomStyle',
        'borderLeftStyle',
        'borderTopColor',
        'borderRightColor',
        'borderBottomColor',
        'borderLeftColor',
        'borderTopLeftRadius',
        'borderTopRightRadius',
        'borderBottomRightRadius',
        'borderBottomLeftRadius',
        'backgroundColor',
        'boxShadow',
        'color'
      ].forEach(function (propertyName) {
        var cssValue = doneStyle[propertyName];
        if (!cssValue) return;

        var cssPropertyName = propertyName.replace(/[A-Z]/g, function (letter) {
          return '-' + letter.toLowerCase();
        });

        button.style.setProperty(cssPropertyName, cssValue, 'important');
      });
    }

    function syncRentalCalendarResetSelectionButton(startDate) {
      var button = ensureRentalCalendarResetSelectionButton();
      if (!button) return;

      var endDate = parseLocalDate(
        rentalEndDateInput ? rentalEndDateInput.value : ''
      );
      var showReset = !!(startDate && endDate);

      button.classList.toggle('is-hidden', !showReset);
      button.setAttribute('aria-hidden', showReset ? 'false' : 'true');

      if (showReset) {
        matchRentalCalendarResetSelectionToDoneButton(button);
      }
    }

    var CALENDAR_PRICING_TIERS = [
      { key: 'base', label: 'Base 1 Day', minDay: 1, maxDay: 1, quantityDays: 1, matcher: /\bcal\s*(?:\|\s*)?base\s*1\s*day\b/i },
      { key: 'days2to7', label: 'Days 2-7', minDay: 2, maxDay: 7, quantityDays: 6, matcher: /\bcal\s*(?:\|\s*)?days?\s*2\s*[-–]\s*7\b/i },
      { key: 'days8to14', label: 'Days 8-14', minDay: 8, maxDay: 14, quantityDays: 7, matcher: /\bcal\s*(?:\|\s*)?days?\s*8\s*[-–]\s*14\b/i },
      { key: 'days15to30', label: 'Days 15-30', minDay: 15, maxDay: 30, quantityDays: 16, matcher: /\bcal\s*(?:\|\s*)?days?\s*15\s*[-–]\s*30\b/i },
      { key: 'days31to60', label: 'Days 31-60', minDay: 31, maxDay: 60, quantityDays: 30, matcher: /\bcal\s*(?:\|\s*)?days?\s*31\s*[-–]\s*60\b/i },
      { key: 'days61to90', label: 'Days 61-90', minDay: 61, maxDay: 90, quantityDays: 30, matcher: /\bcal\s*(?:\|\s*)?days?\s*61\s*[-–]\s*90\b/i }
    ];

    function getCalendarPricingTierConfig(periodValue) {
      var value = String(periodValue || '').trim();
      return CALENDAR_PRICING_TIERS.find(function (tier) {
        return tier.matcher.test(value);
      }) || null;
    }

    function getCalendarPeriodOptionIndex() {
      return getRentalOptionIndexFromSelect(rentalPeriodSelect);
    }

    function ensureCalendarBasePricingPeriodSelection() {
      if (!rentalPeriodSelect) return false;

      var periodPosition = getRentalPeriodSelectPosition();
      var baseOption = Array.prototype.find.call(rentalPeriodSelect.options, function (option) {
        return getCalendarPricingTierConfig(option.value) &&
          getCalendarPricingTierConfig(option.value).key === 'base';
      });
      var baseRadio = Array.prototype.find.call(optionInputs, function (input) {
        var tier = getCalendarPricingTierConfig(input.value);
        return input.getAttribute('data-option-position') === periodPosition && tier && tier.key === 'base';
      });

      if (!baseOption && !baseRadio) return false;

      Array.prototype.forEach.call(optionInputs, function (input) {
        if (input.getAttribute('data-option-position') !== periodPosition) return;
        input.checked = input === baseRadio;
        var card = input.closest('.rental-option-card');
        if (card) {
          card.hidden = true;
          card.style.display = 'none';
          card.setAttribute('aria-hidden', 'true');
        }
      });

      if (baseOption) rentalPeriodSelect.value = baseOption.value;
      return true;
    }

    // The beta never exposes or applies legacy minimum-period choices.
    applyMinimumRentalPeriodRule = function () {
      return false;
    };

    ensureLegacyRentalPeriodSelection = function () {
      ensureCalendarBasePricingPeriodSelection();
    };

    handleRentalPeriodSelectChange = function () {
      ensureCalendarBasePricingPeriodSelection();
    };

    getSelectedRentalPeriod = function () {
      return CALENDAR_BASE_PERIOD_VALUE;
    };

    getSelectedModelRentalPeriodVariants = function () {
      var periodIndex = getCalendarPeriodOptionIndex();
      var selectedOptions = getSelectedOptions();
      if (periodIndex < 0) return [];

      var records = [];

      allVariants.forEach(function (variant) {
        if (!variant || !Array.isArray(variant.options)) return;

        var tier = getCalendarPricingTierConfig(variant.options[periodIndex]);
        if (!tier) return;

        var matchesSelectedModel = variant.options.every(function (optionValue, index) {
          if (index === periodIndex) return true;
          var selectedValue = selectedOptions[index];
          return selectedValue != null && optionValue === selectedValue;
        });

        if (!matchesSelectedModel) return;

        var variantId = normaliseVariantId(variant.id);
        if (!variantId) return;

        records.push({
          variant: variant,
          variantId: variantId,
          period: String(variant.options[periodIndex] || ''),
          tier: tier,
          days: tier.maxDay
        });
      });

      records.sort(function (a, b) {
        return a.tier.minDay - b.tier.minDay;
      });

      return records;
    };

    getSelectedModelRentalPeriodVariantIds = function () {
      return getSelectedModelRentalPeriodVariants().map(function (record) {
        return record.variantId;
      });
    };

    function getCalendarPricingRecordByKey(tierKey) {
      return getSelectedModelRentalPeriodVariants().find(function (record) {
        return record.tier && record.tier.key === tierKey;
      }) || null;
    }

    function getCalendarPricingRecordCents(record) {
      if (!record) return null;
      var livePrice = getLiveVariantPriceCents(record.variantId);
      if (Number.isFinite(livePrice)) return livePrice;
      return parseLiveVariantPriceCents(record.variant);
    }

    function addRentalCalendarDays(date, days) {
      if (!date) return null;
      var result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      result.setHours(0, 0, 0, 0);
      result.setDate(result.getDate() + Number(days || 0));
      return result;
    }

    function getRentalCalendarDurationDays(startDate, endDate) {
      if (!startDate || !endDate) return 0;
      var startUtc = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
      var endUtc = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
      var difference = Math.round((endUtc - startUtc) / 86400000);
      return difference >= 0 ? difference + 1 : 0;
    }

    function getSelectedRentalDurationDays() {
      var startDate = parseLocalDate(startDateInput ? startDateInput.value : '');
      var endDate = parseLocalDate(rentalEndDateInput ? rentalEndDateInput.value : '');
      return getRentalCalendarDurationDays(startDate, endDate);
    }

    function formatRentalDurationDays(duration) {
      var days = Math.max(0, parseInt(duration, 10) || 0);
      return days + (days === 1 ? ' day' : ' days');
    }

    function calendarRentalRangeIsComplete() {
      var duration = getSelectedRentalDurationDays();
      return duration >= 1 && duration <= CALENDAR_MAX_RENTAL_DAYS;
    }

    function getCalendarRentalPeriodLabel(tier, durationDays) {
      if (!tier) return '';

      var duration = Math.max(1, parseInt(durationDays, 10) || 1);
      var startDay = Math.max(1, parseInt(tier.minDay, 10) || 1);
      var endDay = Math.min(duration, Math.max(startDay, parseInt(tier.maxDay, 10) || startDay));

      if (startDay === 1 && endDay === 1) return 'Day 1';
      if (startDay === endDay) return 'Day ' + startDay;

      return 'Days ' + startDay + '–' + endDay;
    }

    function getCalendarPricingBreakdown(durationDays, rentalQuantity) {
      var duration = Math.max(0, parseInt(durationDays, 10) || 0);
      var deviceQuantity = Math.max(1, parseInt(rentalQuantity, 10) || 1);
      var components = [];
      var totalCentsPerDevice = 0;
      var missing = [];

      if (duration < 1 || duration > CALENDAR_MAX_RENTAL_DAYS) {
        return { valid: false, durationDays: duration, totalCentsPerDevice: 0, components: [], missing: ['date range'] };
      }

      CALENDAR_PRICING_TIERS.forEach(function (tier) {
        var daysChargedPerDevice = 0;

        if (tier.key === 'base') {
          daysChargedPerDevice = 1;
        } else if (duration >= tier.minDay) {
          daysChargedPerDevice = Math.min(duration, tier.maxDay) - tier.minDay + 1;
        }

        if (daysChargedPerDevice <= 0) return;

        var record = getCalendarPricingRecordByKey(tier.key);
        var unitPriceCents = getCalendarPricingRecordCents(record);

        if (!record || !Number.isFinite(unitPriceCents)) {
          missing.push(tier.label);
          return;
        }

        var shopifyQuantity = tier.key === 'base'
          ? deviceQuantity
          : daysChargedPerDevice * deviceQuantity;
        var componentTotalPerDevice = tier.key === 'base'
          ? unitPriceCents
          : unitPriceCents * daysChargedPerDevice;

        totalCentsPerDevice += componentTotalPerDevice;
        components.push({
          tier: tier,
          record: record,
          unitPriceCents: unitPriceCents,
          daysChargedPerDevice: daysChargedPerDevice,
          shopifyQuantity: shopifyQuantity,
          totalCentsPerDevice: componentTotalPerDevice
        });
      });

      return {
        valid: missing.length === 0,
        durationDays: duration,
        totalCentsPerDevice: totalCentsPerDevice,
        components: components,
        missing: missing
      };
    }

    function getRentalCalendarReturnDatePreviewCents(startDate, returnDate) {
      if (!startDate || !returnDate || returnDate < startDate) return null;

      var duration = getRentalCalendarDurationDays(startDate, returnDate);
      if (duration < 1 || duration > CALENDAR_MAX_RENTAL_DAYS) return null;

      var pricing = getCalendarPricingBreakdown(duration, 1);
      if (!pricing.valid || !Number.isFinite(pricing.totalCentsPerDevice)) {
        return null;
      }

      var previewTotal = pricing.totalCentsPerDevice;
      var startDateString = formatDateProperty(startDate);

      if (isWeekend(startDateString)) {
        if (!Number.isFinite(weekendSurchargeCents)) return null;
        previewTotal += weekendSurchargeCents;
      }

      return previewTotal;
    }

    function updateRentalCalendarSelectedCost(startDate, endDate) {
      if (!rentalCalendarSelectedCost && !rentalCalendarSelectedCostMobile) return;

      /*
        A blocked-start warning is deliberate user feedback. Keep it visible
        through calendar renders, hover previews, price refreshes and other UI
        updates until the customer actually chooses a valid new Start Date.
      */
      if (renderPlayTimeBlockedStartWarning()) {
        return;
      }

      clearPlayTimeBlockedStartWarning();

      var duration = getRentalCalendarDurationDays(startDate, endDate);
      var previewCentsPerDevice = getRentalCalendarReturnDatePreviewCents(startDate, endDate);

      if (duration < 1 || duration > CALENDAR_MAX_RENTAL_DAYS || !Number.isFinite(previewCentsPerDevice)) {
        if (rentalCalendarSelectedCost) {
          rentalCalendarSelectedCost.textContent = '';
          rentalCalendarSelectedCost.hidden = true;
        }
        if (rentalCalendarSelectedCostMobile) {
          rentalCalendarSelectedCostMobile.textContent = '';
          rentalCalendarSelectedCostMobile.hidden = true;
        }
        return;
      }

      var deviceQuantity = typeof getRequestedRentalQuantity === 'function'
        ? Math.max(1, getRequestedRentalQuantity())
        : 1;
      var totalRentalCents = previewCentsPerDevice * deviceQuantity;
      var quantityText = deviceQuantity > 1
        ? ' (' + deviceQuantity + ' devices)'
        : '';
      var desktopCostText =
        'Rental cost' + quantityText + ': ' + formatMoney(totalRentalCents);
      var mobileCostText =
        'Rental cost for ' + duration + (duration === 1 ? ' day' : ' days') +
        quantityText + ': ' + formatMoney(totalRentalCents);

      var includesWeekendSurcharge = !!(startDate && isWeekend(formatDateProperty(startDate)));

      function renderCalendarRentalCost(target, costText) {
        if (!target) return;

        target.textContent = '';
        target.appendChild(document.createTextNode(costText));

        if (includesWeekendSurcharge) {
          var weekendLabel = document.createElement('span');
          weekendLabel.className = 'rental-calendar-selected-cost-weekend rental-calendar-selected-cost-weekend--new-line';
          weekendLabel.textContent = 'Weekend surcharge included';
          target.appendChild(weekendLabel);
        }

        target.hidden = false;
      }

      renderCalendarRentalCost(rentalCalendarSelectedCost, desktopCostText);
      renderCalendarRentalCost(rentalCalendarSelectedCostMobile, mobileCostText);
    }

    function appendRentalCalendarReturnPrice(dayButton, dayDate, selectedStartDate, maxReturnDate) {
      if (!dayButton || !dayDate || !selectedStartDate) return;
      if (dayDate < selectedStartDate) return;
      if (maxReturnDate && dayDate > maxReturnDate) return;

      var previewCents = getRentalCalendarReturnDatePreviewCents(selectedStartDate, dayDate);
      if (!Number.isFinite(previewCents)) return;

      var priceEl = document.createElement('span');
      priceEl.className = 'rental-calendar-price-preview';
      priceEl.textContent = '$' + String(Math.round(previewCents / 100));
      priceEl.setAttribute('aria-hidden', 'true');

      dayButton.classList.add('has-price-preview');

      if (
        isWeekend(formatDateProperty(selectedStartDate)) &&
        formatDateProperty(dayDate) === formatDateProperty(selectedStartDate)
      ) {
        dayButton.classList.add('has-weekend-surcharge-preview');
      }
      dayButton.appendChild(priceEl);

      var currentAriaLabel = String(dayButton.getAttribute('aria-label') || '').trim();
      var priceAriaText = 'total rental fee ' + formatMoney(previewCents);

      if (isWeekend(formatDateProperty(selectedStartDate))) {
        priceAriaText += ', including weekend surcharge';
      }

      dayButton.setAttribute(
        'aria-label',
        currentAriaLabel
          ? currentAriaLabel + '; ' + priceAriaText
          : formatDateProperty(dayDate) + '; ' + priceAriaText
      );
    }

    function setCalendarPricePendingState(text) {
      var message = text || 'Select Rental Period';
      if (basePriceEl) {
        basePriceEl.setAttribute('data-base-price', '0');
        basePriceEl.textContent = message;
      }
      if (rentalChargesTotalEl) {
        rentalChargesTotalEl.textContent = message === 'Select Rental Period' ? '' : message;
      }
      if (totalPriceEl) {
        totalPriceEl.textContent = message === 'Select Rental Period' ? '' : message;
      }
      if (mobileSummaryJumpRentalCost) mobileSummaryJumpRentalCost.textContent = '—';
    }

    function updateCalendarSecurityDepositDisplay() {
      updateSecurityDepositSummaryIndicator();

      var securityDepositConfig = getSecurityDepositConfig();
      var securityDepositCents = securityDepositConfig
        ? securityDepositConfig.cents
        : null;

      if (securityDepositValueEl) {
        securityDepositValueEl.textContent = Number.isFinite(securityDepositCents)
          ? formatMoney(securityDepositCents)
          : 'Loading…';
      }

      if (mobileSummaryJumpDeposit) {
        mobileSummaryJumpDeposit.textContent = Number.isFinite(securityDepositCents)
          ? formatMoney(securityDepositCents)
          : 'Loading…';
      }
    }

    var legacyRentalUpdateTotal = updateTotal;
    updateTotal = function () {
      var duration = getSelectedRentalDurationDays();

      /*
       * Deposit is tied to the currently selected device, not to whether the
       * customer has chosen rental dates yet. Always refresh it first so the
       * initial page shows the first selected option's real deposit instead of
       * the old $400 placeholder.
       */
      updateCalendarSecurityDepositDisplay();

      if (duration < 1 || duration > CALENDAR_MAX_RENTAL_DAYS) {
        /*
         * No rental period yet:
         * - keep the rental price itself in the pending "Select Rental Period" state
         * - still render any selected optional extras immediately
         * - include those extras + the refundable security deposit in Total
         *
         * The legacy summary updater already handles addon rows/prices correctly.
         * With base price held at 0 here, it can safely calculate the pre-period
         * subtotal without inventing a rental fee.
         */
        setCalendarPricePendingState('Select Rental Period');
        updateBasePriceLabel();
        legacyRentalUpdateTotal();

        /* legacyRentalUpdateTotal must not replace the pending rental-price text. */
        if (basePriceEl) {
          basePriceEl.setAttribute('data-base-price', '0');
          basePriceEl.textContent = 'Select Rental Period';
        }

        updateRentalCalendarSelectedCost(null, null);
        return;
      }

      var pricing = getCalendarPricingBreakdown(duration, 1);
      if (!pricing.valid) {
        setCalendarPricePendingState(pricing.missing.length ? 'Pricing unavailable' : 'Loading…');
        updateBasePriceLabel();
        return;
      }

      setBasePrice(pricing.totalCentsPerDevice);
      updateBasePriceLabel();
      legacyRentalUpdateTotal();
      updateRentalCalendarSelectedCost(
        parseLocalDate(startDateInput ? startDateInput.value : ''),
        parseLocalDate(rentalEndDateInput ? rentalEndDateInput.value : '')
      );
    };

    applySelectedRentalVariantLivePrice = function () {
      updateTotal();
    };

    refreshUiAfterLiveVariantPrices = function () {
      ensureCalendarBasePricingPeriodSelection();
      syncRentalPeriodSelectFromRadio();
      syncRentalProcessorSelectFromRadio();
      syncRentalProcessorSelectDisabledOptions();
      updateSelectedCards();
      syncLiveVariantPriceRows();
      rebuildDeliveryOptions();
      updateRentalEndInfo();
      updateTotal();

      if (
        startDateInput &&
        startDateInput.value &&
        rentalMobileCalendar &&
        !rentalMobileCalendar.hidden
      ) {
        renderRentalMobileCalendar();
      }
    };

    updateBasePriceLabel = function (selectedText) {
      if (!basePriceLabelEl) return;
      var labelText = (selectedText || getSelectedCompatibilityOptionText() || '').trim();
      var duration = getSelectedRentalDurationDays();
      var labelPrefix = duration >= 1 && duration <= CALENDAR_MAX_RENTAL_DAYS
        ? duration + ' Day Rental'
        : 'Rental Price';
      basePriceLabelEl.textContent = labelText ? labelPrefix + ' - ' + labelText : labelPrefix;
    };

    function getRentalDateRangeInvalidReason() {
      var startValue = startDateInput ? startDateInput.value : '';
      var endValue = rentalEndDateInput ? rentalEndDateInput.value : '';
      var startReason = getRentalStartDateInvalidReason(startValue);

      if (startReason) return startReason;
      if (!endValue) return 'missing-end';

      var startDate = parseLocalDate(startValue);
      var endDate = parseLocalDate(endValue);
      if (!startDate || !endDate) return 'invalid-range';
      if (endDate < startDate) return 'too-short';

      var duration = getRentalCalendarDurationDays(startDate, endDate);
      if (duration < 1) return 'too-short';
      if (duration > CALENDAR_MAX_RENTAL_DAYS) return 'too-long';

      return '';
    }

    function getRentalDateRangeErrorMessage() {
      var reason = getRentalDateRangeInvalidReason();
      var startMessage = getRentalStartDateErrorMessage(startDateInput ? startDateInput.value : '');

      if (reason === 'missing-end') return 'Please choose a return date.';
      if (reason === 'too-short') return 'Return date cannot be before the rental start date.';
      if (reason === 'too-long') return 'Maximum rental period is 90 days. Please choose an earlier return date.';
      if (reason === 'invalid-range') return 'Please choose a valid rental start and return date.';
      return startMessage || '';
    }

    validateDateField = function () {
      var reason = getRentalDateRangeInvalidReason();
      var invalid = !!reason;
      var errorMessage = invalid ? getRentalDateRangeErrorMessage() : '';

      if (dateError) {
        dateError.textContent = errorMessage;
        dateError.hidden = !invalid || !errorMessage;
      }
      return invalid;
    };

    var legacyRefreshRentalStartDateMinimum = refreshRentalStartDateMinimum;
    refreshRentalStartDateMinimum = function (clearInvalidValue) {
      var minimum = legacyRefreshRentalStartDateMinimum(clearInvalidValue);
      if (rentalEndDateInput && (!startDateInput || !startDateInput.value)) {
        rentalEndDateInput.value = '';
      }
      return minimum;
    };

    var legacyRejectInvalidRentalStartDateSelection = rejectInvalidRentalStartDateSelection;
    rejectInvalidRentalStartDateSelection = function () {
      var rejected = legacyRejectInvalidRentalStartDateSelection();
      if (rejected && rentalEndDateInput) rentalEndDateInput.value = '';
      return rejected;
    };

    function formatScheduleDate(date) {
      if (!date) return '';

      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      return date.getDate() + ' ' + months[date.getMonth()] + ' ' + date.getFullYear();
    }

    function updateScheduleTimeslotLabels() {
      var startDate = parseLocalDate(startDateInput ? startDateInput.value : '');
      var endDate = parseLocalDate(rentalEndDateInput ? rentalEndDateInput.value : '');

      if (rentalDeliveryTimeLabel) {
        rentalDeliveryTimeLabel.textContent = startDate
          ? 'Schedule Delivery for ' + formatScheduleDate(startDate)
          : 'Schedule Delivery';
      }

      if (rentalReturnTimeLabel) {
        rentalReturnTimeLabel.textContent = endDate
          ? 'Schedule Return for ' + formatScheduleDate(endDate)
          : 'Schedule Return';
      }
    }

    setRentalStartDateDisplayText = function () {
      var startDate = parseLocalDate(startDateInput ? startDateInput.value : '');
      var endDate = parseLocalDate(rentalEndDateInput ? rentalEndDateInput.value : '');
      var duration = getRentalCalendarDurationDays(startDate, endDate);

      if (rentalStartDateDisplayText) {
        if (!startDate) {
          rentalStartDateDisplayText.textContent = 'Select rental start and return dates';
        } else if (!endDate) {
          rentalStartDateDisplayText.textContent = formatRentalCalendarDateShort(startDate) + ' → Select return date';
        } else {
          rentalStartDateDisplayText.textContent = formatRentalCalendarDateShort(startDate) + ' - ' +
            formatRentalCalendarDateShort(endDate) + ' (' + duration + (duration === 1 ? ' Day)' : ' Days)');
        }
      }

      updateScheduleTimeslotLabels();
      updateRentalCalendarMobileSelectionSummary();
      updateRentalCalendarWeekendPriceNote(startDate);

      if (rentalCalendarReset) rentalCalendarReset.hidden = !(startDate && endDate);
      syncRentalCalendarResetSelectionButton(startDate);
    };

    function updateRentalCalendarWeekendPriceNote(startDate) {
      // Weekend surcharge messaging is now integrated directly into the
      // rental-cost line on both desktop and mobile, so the legacy standalone
      // weekend notes stay hidden to avoid duplicate messaging.
      if (rentalCalendarWeekendPriceNote) {
        rentalCalendarWeekendPriceNote.hidden = true;
      }

      if (rentalCalendarWeekendPriceNoteMobile) {
        rentalCalendarWeekendPriceNoteMobile.hidden = true;
      }
    }

    function updateRentalCalendarInstruction() {
      if (!rentalCalendarInstruction && !rentalCalendarRangeSummary) return;

      var startDate = parseLocalDate(startDateInput ? startDateInput.value : '');
      var endDate = parseLocalDate(rentalEndDateInput ? rentalEndDateInput.value : '');
      var duration = getRentalCalendarDurationDays(startDate, endDate);

      updateRentalCalendarWeekendPriceNote(startDate);

      if (!startDate) {
        if (rentalCalendarInstruction) {
          rentalCalendarInstruction.textContent = '';
          rentalCalendarInstruction.hidden = true;
        }
        if (rentalCalendarRangeSummary) rentalCalendarRangeSummary.textContent = 'Click to select start date.';
        updateRentalCalendarSelectedCost(null, null);
      } else if (!endDate) {
        if (rentalCalendarInstruction) {
          rentalCalendarInstruction.textContent = '';
          rentalCalendarInstruction.hidden = true;
        }
        if (rentalCalendarRangeSummary) rentalCalendarRangeSummary.textContent = 'Click to select return date.';
        updateRentalCalendarSelectedCost(null, null);
      } else {
        if (rentalCalendarInstruction) {
          rentalCalendarInstruction.textContent = '';
          rentalCalendarInstruction.hidden = true;
        }
        if (rentalCalendarRangeSummary) {
          rentalCalendarRangeSummary.textContent =
            formatRentalCalendarDateShort(startDate) + ' - ' +
            formatRentalCalendarDateShort(endDate) + ' (' +
            duration + (duration === 1 ? ' Day)' : ' Days)');
        }
        updateRentalCalendarSelectedCost(startDate, endDate);
      }

      if (rentalCalendarReset) rentalCalendarReset.hidden = !(startDate && endDate);
      syncRentalCalendarResetSelectionButton(startDate);
      updateRentalCalendarMobileSelectionSummary();
    }

    function clearRentalCalendarRange(keepCalendarOpen) {
      markRentalEditScheduleTouchedByUser();
      rentalCalendarReturnReselectMode = false;
      rentalCalendarStartReselectMode = false;
      if (startDateInput) startDateInput.value = '';
      if (rentalEndDateInput) rentalEndDateInput.value = '';
      if (dateError) dateError.hidden = true;
      setRentalStartDateDisplayText();
      updateRentalCalendarInstruction();
      rentalMobileCalendarViewDate = null;
      renderRentalMobileCalendar();
      rebuildDeliveryOptions();
      updateRentalEndInfo();
      updateTotal();
      if (!keepCalendarOpen) setRentalMobileCalendarOpen(false);
    }

    prepareRentalCalendarView = function () {
      refreshRentalStartDateMinimum(true);
      var selectedStart = parseLocalDate(startDateInput ? startDateInput.value : '');
      var calendarDefaultDate = selectedStart || parseLocalDate(getTomorrowString());
      var startMaxDate = parseLocalDate(getRentalStartDateMaxString());

      if (calendarDefaultDate && startMaxDate && !selectedStart && calendarDefaultDate > startMaxDate) {
        calendarDefaultDate = startMaxDate;
      }

      rentalMobileCalendarViewDate = getMonthStart(calendarDefaultDate);
    };

    function rentalCalendarSupportsHoverPreview() {
      return !!(
        window.matchMedia &&
        window.matchMedia('(hover: hover) and (pointer: fine)').matches
      );
    }

    function clearRentalCalendarHoverPreview() {
      if (!rentalMobileCalendarGrid) return;

      var previewButtons = rentalMobileCalendarGrid.querySelectorAll(
        '.rental-mobile-calendar-day.is-hover-range, .rental-mobile-calendar-day.is-hover-end'
      );

      Array.prototype.forEach.call(previewButtons, function (button) {
        button.classList.remove('is-hover-range', 'is-hover-end');
      });
    }

    function previewRentalCalendarEndDate(hoverDate) {
      if (!rentalCalendarSupportsHoverPreview() || !hoverDate || !rentalMobileCalendarGrid) return;

      var selectedStartDate = parseLocalDate(startDateInput ? startDateInput.value : '');
      var selectedEndDate = parseLocalDate(rentalEndDateInput ? rentalEndDateInput.value : '');

      if (!selectedStartDate || selectedEndDate) {
        clearRentalCalendarHoverPreview();
        return;
      }

      var latestEndDate = addRentalCalendarDays(selectedStartDate, CALENDAR_MAX_RENTAL_DAYS - 1);
      if (hoverDate < selectedStartDate || hoverDate > latestEndDate) {
        clearRentalCalendarHoverPreview();
        updateRentalCalendarInstruction();
        return;
      }

      clearRentalCalendarHoverPreview();

      var dayButtons = rentalMobileCalendarGrid.querySelectorAll('.rental-mobile-calendar-day[data-date]');
      Array.prototype.forEach.call(dayButtons, function (button) {
        var buttonDate = parseLocalDate(button.getAttribute('data-date') || '');
        if (!buttonDate || buttonDate < selectedStartDate || buttonDate > hoverDate) return;
        if (button.classList.contains('is-disabled')) return;

        button.classList.add('is-hover-range');
        if (sameCalendarDay(buttonDate, hoverDate)) {
          button.classList.add('is-hover-end');
        }
      });

      if (rentalCalendarRangeSummary) {
        var previewDuration = getRentalCalendarDurationDays(selectedStartDate, hoverDate);
        rentalCalendarRangeSummary.textContent =
          formatRentalCalendarDateShort(selectedStartDate) + ' - ' +
          formatRentalCalendarDateShort(hoverDate) + ' (' +
          previewDuration + (previewDuration === 1 ? ' Day)' : ' Days)');
      }
      updateRentalCalendarSelectedCost(selectedStartDate, hoverDate);
    }

    renderRentalMobileCalendar = function () {
      if (!useCustomRentalDatePicker || !startDateInput || !rentalMobileCalendarGrid || !rentalMobileCalendarTitle) return;

      var preserveMobileScroll = !!(
        rentalCalendarMobileFullscreenMode() &&
        rentalMobileCalendar &&
        !rentalMobileCalendar.hidden
      );
      var preservedMobileScrollTop = preserveMobileScroll
        ? rentalMobileCalendar.scrollTop
        : 0;
      var preservedMobileAnchorDate = '';
      var preservedMobileAnchorTop = null;

      if (preserveMobileScroll) {
        var activeCalendarElement = document.activeElement;
        if (
          activeCalendarElement &&
          rentalMobileCalendarGrid.contains(activeCalendarElement) &&
          activeCalendarElement.classList &&
          activeCalendarElement.classList.contains('rental-mobile-calendar-day')
        ) {
          preservedMobileAnchorDate = activeCalendarElement.getAttribute('data-date') || '';
          preservedMobileAnchorTop = activeCalendarElement.getBoundingClientRect().top;
        }
      }

      var minStartDate = parseLocalDate(getTomorrowString());
      var maxStartDate = parseLocalDate(getRentalStartDateMaxString());
      var selectedStartDate = parseLocalDate(startDateInput.value);
      var selectedEndDate = parseLocalDate(rentalEndDateInput ? rentalEndDateInput.value : '');
      var selectingEnd = !!(
        selectedStartDate &&
        !rentalCalendarStartReselectMode &&
        (!selectedEndDate || rentalCalendarReturnReselectMode)
      );
      var selectingNewStart = !!(
        rentalCalendarStartReselectMode ||
        (
          selectedStartDate &&
          selectedEndDate &&
          !rentalCalendarReturnReselectMode
        )
      );
      var returnSelectionMaxDate = selectingEnd
        ? addRentalCalendarDays(selectedStartDate, CALENDAR_MAX_RENTAL_DAYS - 1)
        : null;
      var viewMaxDate = selectingEnd ? returnSelectionMaxDate : maxStartDate;

      /* If an existing return date is already beyond the latest allowed
         START date, keep that month visible so the completed range can still
         be displayed. It is visible as an old return date, not selectable as
         a new start date. */
      if (selectedEndDate && viewMaxDate && selectedEndDate > viewMaxDate) {
        viewMaxDate = selectedEndDate;
      }

      var minMonthStart = getMonthStart(minStartDate);
      var maxMonthStart = getMonthStart(viewMaxDate);
      var preferredDate = selectedStartDate || minStartDate;
      var monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];

      function createRentalCalendarDayButton(dayDate) {
        dayDate.setHours(0, 0, 0, 0);

        var dayDateString = formatDateProperty(dayDate);
        var isStart = selectedStartDate && sameCalendarDay(dayDate, selectedStartDate);
        var isEnd = selectedEndDate && sameCalendarDay(dayDate, selectedEndDate);
        var isInRange = !!(
          selectedStartDate && selectedEndDate &&
          dayDate > selectedStartDate && dayDate < selectedEndDate
        );
        var invalidReason = '';

        if (selectingEnd) {
          if (dayDate < selectedStartDate) {
            invalidReason = 'before-start';
          } else if (returnSelectionMaxDate && dayDate > returnSelectionMaxDate) {
            invalidReason = 'over-90-days';
          }
        } else {
          invalidReason = getRentalStartDateInvalidReason(dayDateString);
        }

        var disabled = !!invalidReason;
        var explicitlyBlockedDate = !selectingEnd &&
          isDateWithinPlayTimeBlockedRange(dayDateString);
        var dayButton = document.createElement('button');
        dayButton.type = 'button';
        dayButton.className = 'rental-mobile-calendar-day';
        dayButton.setAttribute('data-date', dayDateString);

        var dayNumberEl = document.createElement('span');
        dayNumberEl.className = 'rental-calendar-date-number';
        dayNumberEl.textContent = String(dayDate.getDate());

        dayButton.appendChild(dayNumberEl);

        if (isInRange) dayButton.classList.add('is-in-range');
        if (isStart) dayButton.classList.add('is-selected', 'is-range-start');
        if (isEnd) dayButton.classList.add('is-selected', 'is-range-end');

        if (selectingEnd && isStart && !disabled) {
          dayButton.classList.add('is-same-day-return-option');
          dayButton.title = 'Click to use as the same-day return date';
        }

        if (selectingEnd && rentalCalendarSupportsHoverPreview()) {
          dayButton.addEventListener('mouseenter', function () {
            if (disabled) {
              clearRentalCalendarHoverPreview();
              updateRentalCalendarInstruction();
              return;
            }
            previewRentalCalendarEndDate(dayDate);
          });

          dayButton.addEventListener('focus', function () {
            if (!disabled) previewRentalCalendarEndDate(dayDate);
          });
        }

        if (disabled) {
          var explainUnavailableToday = !selectingEnd &&
            dayDateString === getSingaporeTodayString() &&
            [
              'same-day-closed',
              'same-day-unavailable',
              'same-day-manually-closed',
              'same-day-cutoff',
              'weekend-same-day-cutoff',
              'weekend-closed'
            ].indexOf(invalidReason) !== -1;

          dayButton.setAttribute('aria-disabled', 'true');

          var preserveCompletedRangeAppearance = !!(
            selectingNewStart &&
            (isStart || isEnd || isInRange)
          );

          if (!preserveCompletedRangeAppearance) {
            dayButton.classList.add('is-disabled');
          }

          if (explicitlyBlockedDate && !preserveCompletedRangeAppearance) {
            dayButton.classList.add('is-blocked');
          }

          if (
            invalidReason === 'blocked' &&
            explicitlyBlockedDate
          ) {
            var blockedInsideExistingSelection = !!(
              preserveCompletedRangeAppearance &&
              selectingNewStart &&
              (isStart || isEnd || isInRange)
            );

            if (blockedInsideExistingSelection) {
              /*
                The date is valid as part of the customer's existing rental
                period; only using it as a NEW start date is blocked.
                Keep the normal selected-range background on desktop/mobile.
              */
              dayButton.removeAttribute('aria-disabled');
              dayButton.classList.remove('is-disabled', 'is-blocked');
              dayButton.classList.add('is-preserved-range-blocked');
            }

            dayButton.setAttribute('tabindex', '0');

            /*
              Outside an existing selected rental range, keep the normal
              unavailable styling. Inside an existing range, do NOT apply that
              faded state: the date remains valid as part of the rental period
              and is restricted only as a new Start Date.
            */
            if (!blockedInsideExistingSelection) {
              dayButton.classList.add('is-explainable-unavailable');
            } else {
              dayButton.classList.remove('is-explainable-unavailable');
            }

            dayButton.setAttribute(
              'aria-label',
              dayDateString + ' blocked out as a rental start date; click for details'
            );

            if (blockedInsideExistingSelection) {
              dayButton.title = getPlayTimeSelectedRangeBlockedStartMessage(
                dayDateString
              );
            } else {
              dayButton.title = getPlayTimeBlockedCalendarMessage(dayDateString);
            }

            /*
              A blocked start date is never selected. It remains clickable only
              to explain the operational restriction. When the blocked date is
              inside the customer's already-highlighted rental range, show the
              full blocked range (for example 8–11 Nov) so the lack of selection
              is understandable.
            */
            dayButton.addEventListener('click', function (event) {
              event.preventDefault();
              event.stopPropagation();

              showPlayTimeBlockedCalendarMessage(
                blockedInsideExistingSelection
                  ? getPlayTimeSelectedRangeBlockedStartMessage(dayDateString)
                  : getPlayTimeBlockedCalendarMessage(dayDateString)
              );
            });
          } else if (explainUnavailableToday) {
            dayButton.setAttribute('tabindex', '0');
            dayButton.classList.add('is-explainable-unavailable');
            dayButton.setAttribute('aria-label', dayDateString + ' same-day rental unavailable; click for details');
            dayButton.title = getRentalStartDateErrorMessage(dayDateString);
            dayButton.addEventListener('click', function (event) {
              event.preventDefault();
              event.stopPropagation();
              showRentalStartDateError(getRentalStartDateErrorMessage(dayDateString));
              setRentalMobileCalendarOpen(true);
            });
          } else {
            dayButton.setAttribute('tabindex', '-1');
          }
        } else {
          dayButton.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();

            if (selectingEnd) {
              if (rentalEndDateInput) rentalEndDateInput.value = dayDateString;
              rentalCalendarReturnReselectMode = false;
              rentalCalendarStartReselectMode = false;
              if (dateError) dateError.hidden = true;
              setRentalStartDateDisplayText();
              updateRentalCalendarInstruction();
              dispatchRentalInputChange(startDateInput);
              renderRentalMobileCalendar();

              return;
            }

            /* First click, or the next click after a completed range:
               start a fresh rental range from this date. */
            clearPlayTimeBlockedStartWarning();
            rentalCalendarReturnReselectMode = false;
            rentalCalendarStartReselectMode = false;
            startDateInput.value = dayDateString;
            if (rentalEndDateInput) rentalEndDateInput.value = '';
            rentalMobileCalendarViewDate = getMonthStart(dayDate);
            if (dateError) dateError.hidden = true;
            setRentalStartDateDisplayText();
            updateRentalCalendarInstruction();
            dispatchRentalInputChange(startDateInput);
            renderRentalMobileCalendar();
          });
        }

        if (selectingEnd && isStart && !disabled) {
          dayButton.setAttribute('aria-label', dayDateString + ' rental start date; click to use as the same-day return date');
        } else if (isStart) {
          dayButton.setAttribute('aria-label', dayDateString + ' rental start date');
        }

        if (isEnd) {
          dayButton.setAttribute('aria-label', dayDateString + ' rental return date');
        }

        if (selectedStartDate) {
          /* Price previews belong to the CURRENT rental's return-date window,
             not to the rules for choosing the NEXT start date.

             This is intentionally independent of `disabled`: after a range
             is completed, dates after 31 Dec may be disabled as NEW start
             dates, but they can still be valid return dates for the current
             rental and must keep showing their calculated prices. */
          var previewMaxReturnDate = addRentalCalendarDays(
            selectedStartDate,
            CALENDAR_MAX_RENTAL_DAYS - 1
          );
          appendRentalCalendarReturnPrice(
            dayButton,
            dayDate,
            selectedStartDate,
            previewMaxReturnDate
          );
        }

        return dayButton;
      }

      updateRentalCalendarInstruction();
      rentalMobileCalendarGrid.innerHTML = '';

      if (rentalCalendarMobileFullscreenMode()) {
        /* Mobile: show every relevant month in one vertically scrollable view. */
        var mobileFirstMonth = getMonthStart(minStartDate);
        var mobileLastMonth = maxMonthStart;
        var mobileMonthCursor = new Date(mobileFirstMonth.getFullYear(), mobileFirstMonth.getMonth(), 1);

        while (mobileMonthCursor <= mobileLastMonth) {
          var monthYear = mobileMonthCursor.getFullYear();
          var monthIndex = mobileMonthCursor.getMonth();
          var monthSection = document.createElement('section');
          monthSection.className = 'rental-scroll-month';
          monthSection.setAttribute('data-calendar-month', monthYear + '-' + String(monthIndex + 1).padStart(2, '0'));

          var monthTitle = document.createElement('div');
          monthTitle.className = 'rental-scroll-month-title';
          monthTitle.textContent = monthNames[monthIndex] + ' ' + monthYear;
          monthSection.appendChild(monthTitle);

          var weekdays = document.createElement('div');
          weekdays.className = 'rental-scroll-month-weekdays';
          ['S', 'M', 'T', 'W', 'T', 'F', 'S'].forEach(function (label) {
            var weekday = document.createElement('span');
            weekday.textContent = label;
            weekdays.appendChild(weekday);
          });
          monthSection.appendChild(weekdays);

          var monthGrid = document.createElement('div');
          monthGrid.className = 'rental-scroll-month-grid';

          var firstDay = new Date(monthYear, monthIndex, 1);
          var leadingEmptyDays = firstDay.getDay();
          var daysInMonth = new Date(monthYear, monthIndex + 1, 0).getDate();

          for (var blankIndex = 0; blankIndex < leadingEmptyDays; blankIndex += 1) {
            var blankCell = document.createElement('span');
            blankCell.className = 'rental-mobile-calendar-empty';
            monthGrid.appendChild(blankCell);
          }

          for (var dayNumber = 1; dayNumber <= daysInMonth; dayNumber += 1) {
            monthGrid.appendChild(createRentalCalendarDayButton(new Date(monthYear, monthIndex, dayNumber)));
          }

          monthSection.appendChild(monthGrid);
          rentalMobileCalendarGrid.appendChild(monthSection);

          mobileMonthCursor = new Date(monthYear, monthIndex + 1, 1);
        }

        /* The hidden desktop month title remains populated for accessibility. */
        rentalMobileCalendarTitle.textContent =
          monthNames[mobileFirstMonth.getMonth()] + ' ' + mobileFirstMonth.getFullYear();

        updateRentalCalendarMobileSelectionSummary();

        if (preserveMobileScroll && rentalMobileCalendar) {
          /* Rebuilding the month grid temporarily collapses its height, which
             can make the browser clamp scrollTop back to zero. Restore it
             immediately, then fine-tune against the exact date that was
             clicked/focused so that date stays in the same screen position. */
          rentalMobileCalendar.scrollTop = preservedMobileScrollTop;

          if (preservedMobileAnchorDate && preservedMobileAnchorTop !== null) {
            var restoredAnchor = rentalMobileCalendarGrid.querySelector(
              '.rental-mobile-calendar-day[data-date="' + preservedMobileAnchorDate + '"]'
            );

            if (restoredAnchor) {
              var restoredAnchorTop = restoredAnchor.getBoundingClientRect().top;
              rentalMobileCalendar.scrollTop += (restoredAnchorTop - preservedMobileAnchorTop);
            }
          }
        }

        return;
      }

      /* Desktop/tablet: retain the existing single-month navigation. */
      var desktopMinMonthStart = getMonthStart(selectingEnd && selectedStartDate ? selectedStartDate : minStartDate);

      if (!rentalMobileCalendarViewDate) {
        rentalMobileCalendarViewDate = getMonthStart(preferredDate);
      }

      rentalMobileCalendarViewDate = getMonthStart(rentalMobileCalendarViewDate);
      if (rentalMobileCalendarViewDate < desktopMinMonthStart) rentalMobileCalendarViewDate = desktopMinMonthStart;
      if (rentalMobileCalendarViewDate > maxMonthStart) rentalMobileCalendarViewDate = maxMonthStart;

      var viewYear = rentalMobileCalendarViewDate.getFullYear();
      var viewMonth = rentalMobileCalendarViewDate.getMonth();

      rentalMobileCalendarTitle.textContent = monthNames[viewMonth] + ' ' + viewYear;

      var desktopFirstDay = new Date(viewYear, viewMonth, 1);
      var desktopLeadingEmptyDays = desktopFirstDay.getDay();
      var desktopDaysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();

      for (var desktopBlankIndex = 0; desktopBlankIndex < desktopLeadingEmptyDays; desktopBlankIndex += 1) {
        var desktopBlankCell = document.createElement('span');
        desktopBlankCell.className = 'rental-mobile-calendar-empty';
        rentalMobileCalendarGrid.appendChild(desktopBlankCell);
      }

      for (var desktopDayNumber = 1; desktopDayNumber <= desktopDaysInMonth; desktopDayNumber += 1) {
        rentalMobileCalendarGrid.appendChild(
          createRentalCalendarDayButton(new Date(viewYear, viewMonth, desktopDayNumber))
        );
      }

      if (rentalMobileCalendarPrev) {
        var previousMonthStart = new Date(viewYear, viewMonth - 1, 1);
        var previousDisabled = previousMonthStart < desktopMinMonthStart;
        rentalMobileCalendarPrev.disabled = previousDisabled;
        rentalMobileCalendarPrev.classList.toggle('is-disabled', previousDisabled);
      }

      if (rentalMobileCalendarNext) {
        var nextMonthStart = new Date(viewYear, viewMonth + 1, 1);
        var nextDisabled = nextMonthStart > maxMonthStart;
        rentalMobileCalendarNext.disabled = nextDisabled;
        rentalMobileCalendarNext.classList.toggle('is-disabled', nextDisabled);
      }

      updateRentalCalendarMobileSelectionSummary();
    };

    updateRentalEndInfo = function () {
      var startDate = parseLocalDate(startDateInput ? startDateInput.value : '');
      var endDate = parseLocalDate(rentalEndDateInput ? rentalEndDateInput.value : '');
      var duration = getRentalCalendarDurationDays(startDate, endDate);
      var selectedDeliveryTime = deliveryTimeInput && deliveryTimeInput.selectedIndex > 0
        ? stripDeliveryChargeSuffix(deliveryTimeInput.options[deliveryTimeInput.selectedIndex].text)
        : '';
      var selectedReturnTime = returnTimeInput && returnTimeInput.value ? returnTimeInput.value : '';

      if (!startDate || !endDate || duration < 1 || duration > CALENDAR_MAX_RENTAL_DAYS) {
        if (endInfoWrap) endInfoWrap.style.display = 'none';
        if (startPreview) startPreview.textContent = '-';
        if (endPreview) endPreview.textContent = '-';
        if (rentalDurationPreview) rentalDurationPreview.textContent = '-';
        if (returnNote) returnNote.textContent = 'Schedule Delivery first';
        if (rentalPriceMobileTimingRows) rentalPriceMobileTimingRows.style.display = 'none';
        if (rentalPriceMobileStart) rentalPriceMobileStart.textContent = '-';
        if (rentalPriceMobileEnd) rentalPriceMobileEnd.textContent = '-';
        return;
      }

      if (endInfoWrap) endInfoWrap.style.display = 'block';
      if (startPreview) startPreview.textContent = formatDisplayDate(startDate) + (selectedDeliveryTime ? ', ' + selectedDeliveryTime : '');
      if (endPreview) endPreview.textContent = formatDisplayDate(endDate) + (selectedReturnTime ? ', ' + selectedReturnTime : '');
      if (rentalDurationPreview) rentalDurationPreview.textContent = formatRentalDurationDays(duration);
      if (returnNote) {
        if (!selectedDeliveryTime) {
          returnNote.textContent = 'Schedule Delivery first';
        } else if (selectedRentalDatesAreSameDay() && !sameDayReturnOperationallyPossible()) {
          returnNote.textContent = 'No timing available for same-day return. Please select the next day as your return date.';
        } else {
          returnNote.textContent = selectedReturnTime ? 'Scheduled return: ' + selectedReturnTime : 'Select your return timeslot.';
        }
      }
      if (rentalPriceMobileTimingRows) rentalPriceMobileTimingRows.style.display = 'block';
      if (rentalPriceMobileStart) rentalPriceMobileStart.textContent = formatDisplayDate(startDate) + (selectedDeliveryTime ? ', ' + selectedDeliveryTime : '');
      if (rentalPriceMobileEnd) rentalPriceMobileEnd.textContent = formatDisplayDate(endDate) + (selectedReturnTime ? ', ' + selectedReturnTime : '') + ' · ' + formatRentalDurationDays(duration);
      updateMobileSummaryJumpVisibility();
    };

    refreshSelectedRentalConfiguration = function () {
      updateIpadCellularModeAvailability();
      updatePencilAddonAvailability();
      updateMemoryAddonAvailability();
      ensureCalendarBasePricingPeriodSelection();
      syncRentalPeriodSelectFromRadio();
      syncRentalProcessorSelectFromRadio();
      syncRentalProcessorSelectDisabledOptions();
      updateSelectedCards();

      var matchedVariant = findMatchingVariant();
      if (matchedVariant) {
        variantIdInput.value = matchedVariant.id;
      } else {
        variantIdInput.value = '';
      }

      refreshPlayTimeDependentUi(true);
      loadSelectedSecurityDepositLeadDays().then(function () {
        updateProcessorAvailabilityNote();
      });
      loadSelectedVariantAndDepositPrices(false).catch(function (error) {
        console.error('Calendar rental live price lookup error:', error);
        updateTotal();
      });
      updateRentalInfoPanels();
      updateRentalEndInfo();
      updateTotal();
    };

    refreshSelectedRentalConfigurationForEditFastPath = function () {
      refreshSelectedRentalConfiguration();
    };

    ensureCalendarBasePricingPeriodSelection();
    setRentalStartDateDisplayText();
    updateRentalCalendarInstruction();

    ensureRentalCalendarResetSelectionButton();

    if (rentalCalendarReset) {
      rentalCalendarReset.addEventListener('click', function (event) {
        event.preventDefault();
        setRentalMobileCalendarOpen(false);
      });
    }

    if (rentalMobileCalendarClose) {
      rentalMobileCalendarClose.addEventListener('click', function (event) {
        event.preventDefault();
        setRentalMobileCalendarOpen(false);
      });
    }

    if (rentalMobileCalendarDone) {
      rentalMobileCalendarDone.addEventListener('click', function (event) {
        event.preventDefault();
        if (rentalMobileCalendarDone.disabled) return;
        setRentalMobileCalendarOpen(false);
      });
    }

    window.addEventListener('resize', function () {
      if (rentalMobileCalendar && rentalMobileCalendar.hidden) {
        document.body.classList.remove('rental-calendar-mobile-open');
      } else if (rentalMobileCalendar && !rentalMobileCalendar.hidden && !rentalCalendarMobileFullscreenMode()) {
        document.body.classList.remove('rental-calendar-mobile-open');
      } else if (rentalMobileCalendar && !rentalMobileCalendar.hidden && rentalCalendarMobileFullscreenMode()) {
        document.body.classList.add('rental-calendar-mobile-open');
      }
      updateRentalCalendarMobileSelectionSummary();
    });

    hideInternalIpadCellularProcessorOptions();
    ensureLegacyRentalPeriodSelection();
    updateIpadCellularModeAvailability();

    if (optionInputs.length) {
      optionInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          if (input.getAttribute('data-internal-cellular-processor') === 'true') return;
          refreshSelectedRentalConfiguration();

          if (
            isIpadRentalPage() &&
            input.getAttribute('data-option-position') === getRentalProcessorSelectPosition()
          ) {
            loadPencilAddonStockAvailability(false);
          }
        });
      });

      if (!rentalEditRequestedGroupId) {
        refreshSelectedRentalConfiguration();
      }
    }

    if (rentalPeriodSelect) {
      rentalPeriodSelect.addEventListener('change', handleRentalPeriodSelectChange);
    }

    if (rentalProcessorSelect) {
      
      rentalProcessorSelect.addEventListener('change', handleRentalProcessorSelectChange);

      var rentalProcessorMobileLabelMode = isRentalProcessorMobileLabelMode();

      function refreshRentalProcessorLabelsForViewport() {
        var currentMobileLabelMode = isRentalProcessorMobileLabelMode();
        if (currentMobileLabelMode === rentalProcessorMobileLabelMode) return;

        rentalProcessorMobileLabelMode = currentMobileLabelMode;
        updateProcessorAvailabilityNote();
      }

      window.addEventListener('resize', function () {
        window.requestAnimationFrame(refreshRentalProcessorLabelsForViewport);
      });

      window.addEventListener('orientationchange', function () {
        window.setTimeout(refreshRentalProcessorLabelsForViewport, 80);
      });

      updateRentalProcessorClosedDisplay();
    }

    if (startDateInput) {
      refreshRentalStartDateMinimum(true);
      setupCustomRentalDatePicker();

      function prepareRentalStartDatePicker() {
        refreshRentalStartDateMinimum(true);
        setRentalStartDateDisplayText();

        if (useCustomRentalDatePicker) {
          renderRentalMobileCalendar();
        }
      }

      function handleRentalStartDateChange() {
        markRentalEditScheduleTouchedByUser();
        clearRentalFieldPrompt(startDateInput);
        refreshRentalStartDateMinimum(false);
        var rejectedInvalidDate = rejectInvalidRentalStartDateSelection();

        setRentalStartDateDisplayText();
        validateDateField();

        if (rejectedInvalidDate && dateError) {
          dateError.hidden = false;
        }

        if (useCustomRentalDatePicker) {
          renderRentalMobileCalendar();
        }

        rebuildDeliveryOptions();
        rebuildReturnOptions();

        loadSelectedVariantAndDepositPrices(false).catch(function (error) {
          console.error('Rental date deposit price lookup error:', error);
          updateTotal();
        });

        updateTotal();
        updateRentalEndInfo();
      }

      if (useCustomRentalDatePicker) {
        if (rentalStartDateDisplay) {
          rentalStartDateDisplay.addEventListener('click', function (event) {
            event.preventDefault();
            toggleRentalStartDateCalendar();
          });
        }

        if (rentalCalendarSelectionStart) {
          rentalCalendarSelectionStart.addEventListener('click', function (event) {
            if (!rentalCalendarMobileFullscreenMode()) return;
            event.preventDefault();
            event.stopPropagation();
            enterRentalCalendarStartReselectMode();
          });

          rentalCalendarSelectionStart.addEventListener('keydown', function (event) {
            if (!rentalCalendarMobileFullscreenMode()) return;
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            enterRentalCalendarStartReselectMode();
          });
        }

        if (rentalCalendarSelectionEnd) {
          rentalCalendarSelectionEnd.addEventListener('click', function (event) {
            if (!rentalCalendarMobileFullscreenMode()) return;
            event.preventDefault();
            event.stopPropagation();
            enterRentalCalendarReturnReselectMode();
          });

          rentalCalendarSelectionEnd.addEventListener('keydown', function (event) {
            if (!rentalCalendarMobileFullscreenMode()) return;
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            enterRentalCalendarReturnReselectMode();
          });
        }

        if (rentalMobileCalendarPrev) {
          rentalMobileCalendarPrev.addEventListener('click', function () {
            changeRentalCalendarMonth(-1);
          });
        }

        if (rentalMobileCalendarNext) {
          rentalMobileCalendarNext.addEventListener('click', function () {
            changeRentalCalendarMonth(1);
          });
        }

        document.addEventListener('click', function (event) {
          if (!rentalMobileCalendar || rentalMobileCalendar.hidden) return;

          var target = event.target;
          var eventPath = typeof event.composedPath === 'function' ? event.composedPath() : [];
          var clickedCalendar = eventPath.indexOf(rentalMobileCalendar) !== -1 || rentalMobileCalendar.contains(target);
          var clickedDateButton = !!(rentalStartDateDisplay && (
            eventPath.indexOf(rentalStartDateDisplay) !== -1 || rentalStartDateDisplay.contains(target)
          ));

          if (!clickedCalendar && !clickedDateButton && !rentalCalendarMobileFullscreenMode()) {
            setRentalMobileCalendarOpen(false);
          }
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && rentalMobileCalendar && !rentalMobileCalendar.hidden) {
            setRentalMobileCalendarOpen(false);
          }
        });
      } else {
        if (window.PointerEvent) {
          startDateInput.addEventListener('pointerdown', prepareRentalStartDatePicker, { capture: true });
        } else {
          startDateInput.addEventListener('touchstart', prepareRentalStartDatePicker, { capture: true, passive: true });
        }

        startDateInput.addEventListener('focus', prepareRentalStartDatePicker);
        startDateInput.addEventListener('click', prepareRentalStartDatePicker, { capture: true });
      }

      startDateInput.addEventListener('input', handleRentalStartDateChange);
      startDateInput.addEventListener('change', handleRentalStartDateChange);
    }

    if (deliveryTimeInput) {
      deliveryTimeInput.addEventListener('change', function () {
        markRentalEditScheduleTouchedByUser();
        retainedRentalDeliveryTimeValue = String(deliveryTimeInput.value || '');

        /* An explicit manual clear of Delivery is different from a temporary
           calendar dependency state: clear Return too because it can no longer
           be validated against a chosen delivery slot. */
        if (!retainedRentalDeliveryTimeValue) {
          retainedRentalReturnTimeValue = '';
          if (returnTimeInput) returnTimeInput.value = '';
        }

        clearRentalFieldPrompt(deliveryTimeInput);
        rebuildReturnOptions();
        validateTimingFields();
        updateRentalEndInfo();
        updateTotal();
      });
    }

    if (returnTimeInput) {
      returnTimeInput.addEventListener('change', function () {
        retainedRentalReturnTimeValue = String(returnTimeInput.value || '');
        clearRentalFieldPrompt(returnTimeInput);
        validateTimingFields();
        updateRentalEndInfo();
        updateTotal();
      });
    }

    if (memoryAddonInput) {
      memoryAddonInput.addEventListener('change', function () {
        updateAddonCards();
        updateRentalInfoPanels();
        updateTotal();
      });
    }

    if (officeAddonInput) {
      officeAddonInput.addEventListener('change', function () {
        updateAddonCards();
        updateRentalInfoPanels();
        updateTotal();
      });
    }

    if (appleMouseAddonInput) {
      appleMouseAddonInput.addEventListener('change', function () {
        if (
          appleMouseAddonInput.checked &&
          !appleMouseStockCanFulfil(
            appleMouseAddonStockStatus,
            getRequestedAppleMouseQuantity()
          )
        ) {
          appleMouseAddonInput.checked = false;
        }

        updateAddonCards();
        updateTotal();
      });
    }

    if (hdmiAddonInput) {
      hdmiAddonInput.addEventListener('change', function () {
        updateAddonCards();
        updateRentalInfoPanels();
        updateTotal();
      });
    }

    if (cellularAddonInput) {
      cellularAddonInput.addEventListener('change', function () {
        if (rentalEditModeActive && !rentalEditHydrating) {
          rentalEditConnectivityTouchedByUser = true;
          rentalEditRestoredCellularMode = !!cellularAddonInput.checked;
        }

        if (
          cellularAddonInput.getAttribute('data-cellular-forced') === 'true' &&
          !cellularAddonInput.checked
        ) {
          cellularAddonInput.checked = true;
          updateAddonCards();
          return;
        }

        updateAddonCards();
        refreshSelectedRentalConfiguration();
        loadSecurityDepositStockAvailability();
      });
    }

    if (pencilAddonInput) {
      pencilAddonInput.addEventListener('change', function () {
        if (pencilAddonInput.checked && !selectedPencilAddonConfig) {
          pencilAddonInput.checked = false;
        }

        updateAddonCards();
        updateTotal();
      });
    }

    updateAppleMouseAddonAvailability();
    updateAddonCards();
    bindRentalCardTapHandlers();

    var rentalTimingRevalidatedForSubmit = false;

    function revalidateRentalTimingBeforeAdd() {
      var appleMouseWasSelected = appleMouseAddonApplied();
      var pencilWasSelected = pencilAddonApplied();

      return Promise.all([
        loadPlayTimeAvailability(),
        loadSelectedSecurityDepositLeadDays(),
        loadAppleMouseAddonStockAvailability(true),
        loadPencilAddonStockAvailability(true),
        revalidateActiveRentalCartDocumentsBeforeSubmit()
      ])
        .then(function () {
          if (!playTimeConfig.loaded) {
            throw new Error(
              'Rental availability controls are temporarily unavailable. Please try again.'
            );
          }

          if (appleMouseWasSelected && !appleMouseAddonApplied()) {
            throw new Error('Apple Mouse is no longer available. Please review Optional Extras.');
          }

          if (pencilWasSelected && !pencilAddonApplied()) {
            throw new Error('Pencil is no longer available for the selected iPad model. Please review Optional Extras.');
          }

          refreshPlayTimeDependentUi(false);
          return loadLiveVariantPrices(getRequiredLivePriceVariantIdsForCurrentSelection(), true);
        })
        .then(function () {
          refreshUiAfterLiveVariantPrices();
        });
    }

    if (rentalForm) {
      if (mobileSummaryJump) {
        mobileSummaryJump.addEventListener('click', scrollToRentalSummary);
        window.addEventListener('scroll', updateMobileSummaryJumpVisibility, { passive: true });
        window.addEventListener('touchmove', resumeMobileSummaryJumpAfterUserScroll, { passive: true });
        window.addEventListener('wheel', resumeMobileSummaryJumpAfterUserScroll, { passive: true });
        document.addEventListener('keydown', handleMobileSummaryJumpScrollKey);
        window.addEventListener('resize', handleMobileReviewFlowChange);
        if (window.visualViewport) {
          window.visualViewport.addEventListener('resize', updateMobileSummaryJumpVisibility, { passive: true });
        }
        handleMobileReviewFlowChange();
      } else {
        updateMobileReviewFlowLayout();
      }

      if (proceedToDocumentsButton) {
        proceedToDocumentsButton.addEventListener('click', proceedToRentalDocuments);
      }

      setRentalReviewStage(false, { scroll: false });

      rentalForm.addEventListener('submit', function (event) {
        event.preventDefault();

        if (!validateRequiredRentalFieldsWithPrompt()) {
          rentalTimingRevalidatedForSubmit = false;
          setLoadingState(false);
          return;
        }

        if (!rentalTimingRevalidatedForSubmit) {
          rentalTimingRevalidatedForSubmit = true;
          setLoadingState(true);

          revalidateRentalTimingBeforeAdd()
            .then(function () {
              setLoadingState(false);
              rentalForm.dispatchEvent(new Event('submit', {
                bubbles: true,
                cancelable: true
              }));
            })
            .catch(function (error) {
              console.error('Rental availability and live pricing revalidation error:', error);
              rentalTimingRevalidatedForSubmit = false;
              setLoadingState(false);
              var revalidationMessage = error && error.message
                ? String(error.message)
                : '';

              window.alert(
                revalidationMessage.indexOf('Pencil is no longer available') === 0 ||
                revalidationMessage.indexOf('Apple Mouse is no longer available') === 0 ||
                revalidationMessage.indexOf('Your previous document submission is no longer valid') === 0
                  ? revalidationMessage
                  : 'Unable to refresh the latest availability and pricing. Please try again.'
              );
            });

          return;
        }

        rentalTimingRevalidatedForSubmit = false;

        var invalid = validateDateField();
        if (invalid) {
          promptRentalStartDateField();
          return;
        }

        rebuildDeliveryOptions();
        rebuildReturnOptions();

        if (!validateTimingFields()) {
          promptFirstMissingTimingField();
          return;
        }

        if (
          (!jotformSubmittedInput || jotformSubmittedInput.value !== 'Yes') &&
          !rentalDocumentBypassTestingEnabled()
        ) {
          focusRequiredDocumentsPanel();
          return;
        }

        var needsWeekendSurcharge = weekendApplied();
        var needsEarlyDeliverySurcharge = earlyDeliveryApplied();
        var needsPriorityUrgentCharge = priorityUrgentChargeApplied();
        var needsStandardUrgentCharge = standardUrgentChargeApplied();
        var needsStandardReturnExtension = standardReturnExtensionApplied();
        var needsPriorityReturnExtension = priorityReturnExtensionApplied();
        var needsMemoryAddon = memoryAddonApplied();
        var needsOfficeAddon = officeAddonApplied();
        var needsAppleMouseAddon = appleMouseAddonApplied();
        var needsHdmiAddon = hdmiAddonApplied();
        var cellularModeSelected = cellularAddonApplied();
        var needsPencilAddon = pencilAddonApplied();
        var securityDepositConfig = getSecurityDepositConfig();

        if (!selectedRentalOptionIsAvailable()) {
          window.alert('The selected rental item is currently unavailable. Please choose another option.');
          return;
        }

        if (needsWeekendSurcharge && (!weekendSurchargeVariantId || Number(weekendSurchargeVariantId) <= 0)) {
          window.alert('Weekend surcharge variant ID has not been configured yet.');
          return;
        }

        if (needsEarlyDeliverySurcharge && (!earlyDeliveryVariantId || Number(earlyDeliveryVariantId) <= 0)) {
          window.alert('Early delivery variant ID has not been configured yet.');
          return;
        }

        if (needsPriorityUrgentCharge && (!priorityUrgentChargeVariantId || Number(priorityUrgentChargeVariantId) <= 0)) {
          window.alert('Priority urgent delivery variant ID has not been configured.');
          return;
        }

        if (needsStandardUrgentCharge && (!standardUrgentChargeVariantId || Number(standardUrgentChargeVariantId) <= 0)) {
          window.alert('Standard urgent delivery variant ID has not been configured.');
          return;
        }

        if (needsStandardReturnExtension && (!standardReturnExtensionVariantId || Number(standardReturnExtensionVariantId) <= 0)) {
          window.alert('Standard return extension variant ID has not been configured.');
          return;
        }

        if (needsPriorityReturnExtension && (!priorityReturnExtensionVariantId || Number(priorityReturnExtensionVariantId) <= 0)) {
          window.alert('Extended-Hours Return variant ID has not been configured.');
          return;
        }

        if (!securityDepositConfig.variantId || Number(securityDepositConfig.variantId) <= 0) {
          window.alert('Security deposit variant ID has not been configured for the selected option.');
          return;
        }

        if (needsMemoryAddon && (!memoryAddonVariantId || Number(memoryAddonVariantId) <= 0)) {
          window.alert('32GB addon variant ID has not been configured.');
          return;
        }

        if (needsOfficeAddon && (!officeAddonVariantId || Number(officeAddonVariantId) <= 0)) {
          window.alert('Microsoft Office addon variant ID has not been configured.');
          return;
        }

        if (needsAppleMouseAddon && (!appleMouseAddonVariantId || Number(appleMouseAddonVariantId) <= 0)) {
          window.alert('Apple Mouse optional extra variant ID has not been configured.');
          return;
        }

        if (
          needsAppleMouseAddon &&
          !appleMouseStockCanFulfil(
            appleMouseAddonStockStatus,
            getRequestedAppleMouseQuantity()
          )
        ) {
          window.alert('Apple Mouse is currently unavailable. Please review Optional Extras.');
          return;
        }

        if (needsHdmiAddon && (!hdmiAddonVariantId || Number(hdmiAddonVariantId) <= 0)) {
          window.alert('HDMI Port optional extra variant ID has not been configured.');
          return;
        }

        if (needsPencilAddon && (!pencilAddonVariantId || Number(pencilAddonVariantId) <= 0)) {
          window.alert('Pencil optional extra variant ID has not been configured.');
          return;
        }

        var missingLivePriceVariantIds = getRequiredLivePriceVariantIdsForCurrentSelection().filter(function (variantId) {
          return !Number.isFinite(getLiveVariantPriceCents(variantId));
        });

        if (missingLivePriceVariantIds.length) {
          window.alert('Unable to verify the latest Shopify price for one or more selected items. Please try again.');
          return;
        }

        securityDepositConfig = getSecurityDepositConfig();
        if (!securityDepositConfig || !Number.isFinite(securityDepositConfig.cents)) {
          window.alert('Unable to verify the latest security deposit price. Please try again.');
          return;
        }

        var rentalUnitConfig = getSelectedRentalUnitConfig();
        if (
          rentalUnitConfig &&
          (!rentalUnitConfig.variantId || Number(rentalUnitConfig.variantId) <= 0)
        ) {
          window.alert('Device reservation inventory has not been configured.');
          return;
        }

        setLoadingState(true);

        var matchedVariant = findMatchingVariant();

        if (!matchedVariant || !variantIdInput.value) {
          window.alert(
            cellularModeSelected
              ? 'The Cellular rental configuration is not available for the selected model and dates.'
              : 'The selected rental configuration is unavailable. Please choose another option.'
          );
          setLoadingState(false);
          return;
        }

        var rentalGroupId = rentalEditModeActive && rentalEditRequestedGroupId
          ? rentalEditRequestedGroupId
          : 'rental-' + Math.floor(getTrustedNowMs()) + '-' + Math.random().toString(36).slice(2, 10);
        var requestedRentalQuantity = getRequestedRentalQuantity();
        var rentalEndDateValue = rentalEndDateInput ? String(rentalEndDateInput.value || '') : '';
        var rentalDurationDays = getSelectedRentalDurationDays();
        var calendarPricing = getCalendarPricingBreakdown(rentalDurationDays, requestedRentalQuantity);

        if (!calendarPricing.valid || !calendarPricing.components.length) {
          window.alert(
            calendarPricing.missing && calendarPricing.missing.length
              ? 'Calendar pricing is not configured for: ' + calendarPricing.missing.join(', ') + '.'
              : 'Unable to calculate the rental price for the selected dates. Please choose the dates again.'
          );
          setLoadingState(false);
          return;
        }

        var documentSessionWindow = getCurrentRentalDocumentWindowForCartProperties();

        if (
          jotformSubmittedInput &&
          jotformSubmittedInput.value === 'Yes' &&
          !rentalDocumentBypassTestingEnabled() &&
          !documentSessionWindow
        ) {
          expireRentalDocumentSessionForReupload();
          window.alert('Your document verification has expired. Please upload the required documents again to continue.');
          setLoadingState(false);
          return;
        }

        var rentalProperties = {
          'Rental group ID': rentalGroupId,
          'Rental start date': startDateInput.value,
          'Rental end date': rentalEndDateValue,
          'Rental duration': rentalDurationDays + ' days',
          'Rental Period': 'Day 1',
          'Calendar pricing': 'Yes',
          'Delivery timing': deliveryTimeInput && deliveryTimeInput.selectedIndex > 0
            ? stripDeliveryChargeSuffix(deliveryTimeInput.options[deliveryTimeInput.selectedIndex].text)
            : '',
          'Return timing': returnTimeInput ? returnTimeInput.value : '',
          'Additional notes': rentalNotes ? rentalNotes.value : '',
          'Documents submitted': jotformSubmittedInput ? jotformSubmittedInput.value : 'No',
          'Security deposit amount': formatMoney(securityDepositConfig.cents)
        };

        if (documentSessionWindow) {
          rentalProperties['_Document submitted at'] = new Date(documentSessionWindow.submittedAtMs).toISOString();
          rentalProperties['_Document valid until'] = new Date(documentSessionWindow.validUntilMs).toISOString();
        }

        if (needsWeekendSurcharge) {
          rentalProperties['Weekend surcharge applied'] = 'Yes';
          rentalProperties['Weekend surcharge amount'] = formatMoney(weekendSurchargeCents);
        }

        if (needsEarlyDeliverySurcharge) {
          rentalProperties['Early delivery applied'] = 'Yes';
          rentalProperties['Early delivery amount'] = formatMoney(earlyDeliverySurchargeCents);
        }

        if (needsPriorityUrgentCharge) {
          rentalProperties['Priority urgent delivery applied'] = 'Yes';
          rentalProperties['Priority urgent delivery amount'] = formatMoney(priorityUrgentChargeCents);
        }

        if (needsStandardUrgentCharge) {
          rentalProperties['Standard urgent delivery applied'] = 'Yes';
          rentalProperties['Standard urgent delivery amount'] = formatMoney(standardUrgentChargeCents);
        }

        if (needsStandardReturnExtension) {
          rentalProperties['Standard return extension applied'] = 'Yes';
          rentalProperties['Standard return extension amount'] = formatMoney(standardReturnExtensionCents);
        }

        if (needsPriorityReturnExtension) {
          rentalProperties['Extended-Hours Return applied'] = 'Yes';
          rentalProperties['Extended-Hours Return amount'] = formatMoney(priorityReturnExtensionCents);
        }

        if (memoryAddonInput && memoryAddonInput.checked) {
          rentalProperties['32GB addon selected'] = 'Yes';
          rentalProperties['32GB addon amount'] = formatMoney(memoryAddonCents);
        }

        if (officeAddonInput && officeAddonInput.checked) {
          rentalProperties['Microsoft Office addon selected'] = 'Yes';
          rentalProperties['Microsoft Office addon amount'] = formatMoney(officeAddonCents);
        }

        if (appleMouseAddonInput && appleMouseAddonInput.checked) {
          rentalProperties['Apple Mouse optional extra selected'] = 'Yes';
          rentalProperties['Apple Mouse optional extra amount'] = formatMoney(appleMouseAddonCents);
        }

        if (hdmiAddonInput && hdmiAddonInput.checked) {
          rentalProperties['HDMI Port optional extra selected'] = 'Yes';
          rentalProperties['HDMI Port optional extra amount'] = formatMoney(hdmiAddonCents);
        }

        if (cellularModeSelected) {
          rentalProperties['Connectivity'] = 'Cellular';
        }

        if (pencilAddonInput && pencilAddonInput.checked) {
          rentalProperties['Pencil optional extra selected'] = 'Yes';
          rentalProperties['Pencil optional extra amount'] = formatMoney(pencilAddonCents);
        }

        var basePricingComponent = calendarPricing.components.find(function (component) {
          return component.tier && component.tier.key === 'base';
        });

        if (!basePricingComponent || !basePricingComponent.record || !basePricingComponent.record.variantId) {
          window.alert('The base 1-day calendar pricing variant is unavailable for the selected device.');
          setLoadingState(false);
          return;
        }

        // The main rental line represents the physical device quantity. Additional
        // calendar tier variants are linked charge lines whose Shopify quantity is
        // (days used in that tier × physical device quantity).
        variantIdInput.value = basePricingComponent.record.variantId;

        var items = [
          {
            id: Number(basePricingComponent.record.variantId),
            quantity: requestedRentalQuantity,
            properties: rentalProperties
          }
        ];

        calendarPricing.components.forEach(function (component) {
          if (!component.tier || component.tier.key === 'base') return;

          items.push({
            id: Number(component.record.variantId),
            quantity: component.shopifyQuantity,
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': basePricingComponent.record.variant ? basePricingComponent.record.variant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Rental duration': rentalDurationDays + ' days',
              'Charge type': 'Rental duration adjustment',
              'Rental Period': getCalendarRentalPeriodLabel(component.tier, rentalDurationDays),
              '_Rental quantity multiplier': String(component.daysChargedPerDevice)
            }
          });
        });

        items.push({
          id: Number(securityDepositConfig.variantId),
          quantity: requestedRentalQuantity,
          properties: {
            'Rental group ID': rentalGroupId,
            'Linked rental product': String(rentalPageConfig.productTitle || ''),
            'Linked rental variant': basePricingComponent.record.variant ? basePricingComponent.record.variant.title : '',
            'Rental start date': startDateInput.value,
            'Rental end date': rentalEndDateValue,
            'Rental duration': rentalDurationDays + ' days',
            'Charge type': 'Security deposit'
          }
        });

        if (rentalUnitConfig && rentalUnitConfig.variantId) {
          items.push({
            id: Number(rentalUnitConfig.variantId),
            quantity: requestedRentalQuantity,
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': basePricingComponent.record.variant ? basePricingComponent.record.variant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Rental duration': rentalDurationDays + ' days',
              'Charge type': 'Rental unit allocation'
            }
          });
        }

        if (needsWeekendSurcharge) {
          items.push({
            id: Number(weekendSurchargeVariantId),
            quantity: requestedRentalQuantity,
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': 'Weekend surcharge'
            }
          });
        }

        if (needsEarlyDeliverySurcharge) {
          items.push({
            id: Number(earlyDeliveryVariantId),
            quantity: requestedRentalQuantity,
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': 'Early delivery'
            }
          });
        }

        if (needsPriorityUrgentCharge) {
          items.push({
            id: Number(priorityUrgentChargeVariantId),
            quantity: requestedRentalQuantity,
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': 'Priority urgent delivery'
            }
          });
        }

        if (needsStandardUrgentCharge) {
          items.push({
            id: Number(standardUrgentChargeVariantId),
            quantity: requestedRentalQuantity,
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': 'Standard urgent delivery'
            }
          });
        }

        if (needsStandardReturnExtension) {
          items.push({
            id: Number(standardReturnExtensionVariantId),
            quantity: requestedRentalQuantity,
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': 'Standard return extension'
            }
          });
        }

        if (needsPriorityReturnExtension) {
          items.push({
            id: Number(priorityReturnExtensionVariantId),
            quantity: requestedRentalQuantity,
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': 'Extended-Hours Return'
            }
          });
        }

        if (needsMemoryAddon) {
          items.push({
            id: Number(memoryAddonVariantId),
            quantity: requestedRentalQuantity,
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': '32GB memory addon'
            }
          });
        }

        if (needsOfficeAddon) {
          items.push({
            id: Number(officeAddonVariantId),
            quantity: requestedRentalQuantity,
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': 'Microsoft Office addon'
            }
          });
        }

        if (needsAppleMouseAddon) {
          items.push({
            id: Number(appleMouseAddonVariantId),
            quantity: getRequestedAppleMouseQuantity(),
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': 'Apple Mouse optional extra'
            }
          });
        }

        if (needsHdmiAddon) {
          items.push({
            id: Number(hdmiAddonVariantId),
            quantity: requestedRentalQuantity,
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': 'HDMI Port optional extra'
            }
          });
        }

        if (needsPencilAddon) {
          items.push({
            id: Number(pencilAddonVariantId),
            quantity: getRequestedPencilQuantity(),
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': 'Pencil optional extra'
            }
          });
        }

        replaceRentalEditGroup(items)
          .then(function () {
            if (rentalEditModeActive && rentalEditRequestedGroupId) {
              clearRentalEditCache(rentalEditRequestedGroupId);
            } else {
              rentalDraftCommittedToCart = true;
              if (rentalDraftWriteTimer) window.clearTimeout(rentalDraftWriteTimer);
              rentalDraftWriteTimer = null;
              clearRentalDraft();
            }
            window.location.href = '/cart';
          })
          .catch(function (error) {
            console.error(rentalEditModeActive ? 'Rental update error:' : 'Rental add-to-cart error:', error);
            window.alert(
              error && error.message
                ? error.message
                : rentalEditModeActive
                  ? 'Unable to update the rental. Please review your cart and try again.'
                  : 'Something went wrong while adding the rental to cart.'
            );

            if (rentalEditModeActive && error && /original rental has been restored|review your cart/i.test(String(error.message || ''))) {
              window.location.href = '/cart';
            }
          })
          .finally(function () {
            setLoadingState(false);
          });
      });
    }

    /* ============================================================
       FIX 04 — UNSAVED RENTAL CONFIGURATION (PER-TAB DRAFT)
       - Isolated from Edit Rental, documents and cart reservation expiry.
       - Saves customer choices, not prices, personal notes or documents.
       - Restores only after initial live controls have been checked.
       - A successful add-to-bag clears this product's saved draft.
       ============================================================ */
    var RENTAL_DRAFT_VERSION = 1;
    var RENTAL_DRAFT_MAX_AGE_MS = 12 * 60 * 60 * 1000;
    var rentalDraftProductId = String(rentalPageConfig.productId || '');
    var rentalDraftStorageKey = rentalDraftProductId
      ? 'playforceRentalDraftV1:' + rentalDraftProductId
      : '';
    var rentalDraftReady = false;
    var rentalDraftRestorePending = !rentalEditRequestedGroupId;
    var rentalDraftUserInteractedBeforeReady = false;
    var rentalDraftCommittedToCart = false;
    var rentalDraftWriteTimer = null;

    function clearRentalDraft() {
      if (!rentalDraftStorageKey) return;
      try {
        window.sessionStorage.removeItem(rentalDraftStorageKey);
      } catch (error) {
        // Private browsing or disabled storage: the rental still works normally.
      }
    }

    function readRentalDraft() {
      if (!rentalDraftStorageKey || rentalEditRequestedGroupId) return null;
      try {
        var raw = window.sessionStorage.getItem(rentalDraftStorageKey);
        if (!raw) return null;
        if (raw.length > 12000) {
          clearRentalDraft();
          return null;
        }
        var draft = JSON.parse(raw);
        var age = Date.now() - Number(draft && draft.savedAt || 0);
        if (
          !draft || draft.version !== RENTAL_DRAFT_VERSION ||
          String(draft.productId || '') !== rentalDraftProductId ||
          !Number.isFinite(age) || age < 0 || age > RENTAL_DRAFT_MAX_AGE_MS ||
          !draft.options || typeof draft.options !== 'object' ||
          !draft.extras || typeof draft.extras !== 'object'
        ) {
          clearRentalDraft();
          return null;
        }
        return draft;
      } catch (error) {
        clearRentalDraft();
        return null;
      }
    }

    function captureRentalDraft() {
      var selectedOptions = {};
      document.querySelectorAll('.rental-option-group[data-option-position]').forEach(function (group) {
        if (group.hidden || group.getAttribute('aria-hidden') === 'true') return;
        var checked = group.querySelector('.rental-option-radio:checked');
        if (!checked || checked.disabled || checked.getAttribute('data-internal-cellular-processor') === 'true') return;
        selectedOptions[String(group.getAttribute('data-option-position'))] = String(checked.value || '');
      });

      return {
        version: RENTAL_DRAFT_VERSION,
        productId: rentalDraftProductId,
        savedAt: Date.now(),
        options: selectedOptions,
        start: String(startDateInput && startDateInput.value || ''),
        end: String(rentalEndDateInput && rentalEndDateInput.value || ''),
        delivery: String(deliveryTimeInput && deliveryTimeInput.value || ''),
        returnTime: String(returnTimeInput && returnTimeInput.value || ''),
        extras: {
          memory: !!(memoryAddonInput && memoryAddonInput.checked && !memoryAddonInput.disabled),
          office: !!(officeAddonInput && officeAddonInput.checked && !officeAddonInput.disabled),
          appleMouse: !!(appleMouseAddonInput && appleMouseAddonInput.checked && !appleMouseAddonInput.disabled),
          hdmi: !!(hdmiAddonInput && hdmiAddonInput.checked && !hdmiAddonInput.disabled),
          cellular: !!(cellularAddonInput && cellularAddonInput.checked && !cellularAddonInput.disabled),
          pencil: !!(pencilAddonInput && pencilAddonInput.checked && !pencilAddonInput.disabled)
        }
      };
    }

    function saveRentalDraftNow() {
      if (
        !rentalDraftStorageKey || rentalEditRequestedGroupId || rentalEditModeActive ||
        rentalDraftCommittedToCart || !rentalDraftReady
      ) return;
      try {
        window.sessionStorage.setItem(rentalDraftStorageKey, JSON.stringify(captureRentalDraft()));
      } catch (error) {
        // Full/disabled session storage must never block normal booking.
      }
    }

    function scheduleRentalDraftSave() {
      if (!rentalDraftReady || rentalDraftCommittedToCart || rentalEditRequestedGroupId || rentalEditModeActive) return;
      if (rentalDraftWriteTimer) window.clearTimeout(rentalDraftWriteTimer);
      rentalDraftWriteTimer = window.setTimeout(function () {
        rentalDraftWriteTimer = null;
        saveRentalDraftNow();
      }, 40);
    }

    function restoreRentalDraft(draft) {
      if (!draft || rentalDraftUserInteractedBeforeReady || rentalEditRequestedGroupId) {
        return Promise.resolve(false);
      }

      // Restore the base processor/model before restoring its optional extras.
      Object.keys(draft.options).forEach(function (position) {
        if (!/^\d+$/.test(position)) return;
        var targetValue = String(draft.options[position] || '');
        var matchingInput = Array.prototype.find.call(optionInputs, function (input) {
          var card = input.closest('.rental-option-card');
          return input.getAttribute('data-option-position') === position &&
            String(input.value) === targetValue && !input.disabled &&
            input.getAttribute('data-internal-cellular-processor') !== 'true' &&
            !(card && (card.hidden || card.getAttribute('aria-hidden') === 'true'));
        });
        if (matchingInput) matchingInput.checked = true;
      });

      // iPad Cellular is a derived mode, not a visible processor variant.
      updateIpadCellularModeAvailability();
      if (cellularAddonInput && !cellularAddonInput.disabled) {
        cellularAddonInput.checked = !!draft.extras.cellular ||
          cellularAddonInput.getAttribute('data-cellular-forced') === 'true';
      }
      refreshSelectedRentalConfiguration();

      // Deposit lead days depend on the newly restored processor/model. Await
      // this check before deciding whether the saved start is still bookable.
      return Promise.all([
        loadSelectedSecurityDepositLeadDays(),
        loadPencilAddonStockAvailability(false)
      ]).then(function () {
        if (rentalDraftUserInteractedBeforeReady) return false;

        var savedStart = String(draft.start || '');
        var savedEnd = String(draft.end || '');
        if (startDateInput) startDateInput.value = '';
        if (rentalEndDateInput) rentalEndDateInput.value = '';
        retainedRentalDeliveryTimeValue = '';
        retainedRentalReturnTimeValue = '';

        if (/^\d{4}-\d{2}-\d{2}$/.test(savedStart) && !getRentalStartDateInvalidReason(savedStart)) {
          startDateInput.value = savedStart;
          var startDate = parseLocalDate(savedStart);
          var endDate = parseLocalDate(savedEnd);
          var duration = getRentalCalendarDurationDays(startDate, endDate);
          if (
            /^\d{4}-\d{2}-\d{2}$/.test(savedEnd) && startDate && endDate &&
            endDate >= startDate && duration >= 1 && duration <= CALENDAR_MAX_RENTAL_DAYS
          ) {
            rentalEndDateInput.value = savedEnd;
          }
        }

        // Rebuild from current PlayTime availability rather than accepting a
        // previously saved (now possibly blocked) delivery or return slot.
        retainedRentalDeliveryTimeValue = String(draft.delivery || '');
        retainedRentalReturnTimeValue = String(draft.returnTime || '');
        refreshPlayTimeDependentUi(true);

        [
          [memoryAddonInput, 'memory'], [officeAddonInput, 'office'],
          [appleMouseAddonInput, 'appleMouse'], [hdmiAddonInput, 'hdmi'],
          [pencilAddonInput, 'pencil']
        ].forEach(function (entry) {
          var input = entry[0];
          if (input) input.checked = !!draft.extras[entry[1]] && !input.disabled;
        });
        updateMemoryAddonAvailability();
        updateAppleMouseAddonAvailability();
        updatePencilAddonAvailability();
        updateAddonCards();
        updateRentalInfoPanels();
        updateRentalEndInfo();
        updateTotal();
        setRentalStartDateDisplayText();
        updateRentalCalendarInstruction();
        if (useCustomRentalDatePicker) renderRentalMobileCalendar();
        loadSelectedVariantAndDepositPrices(false).catch(function (error) {
          console.error('Restored rental draft price validation error:', error);
          updateTotal();
        });
        return true;
      }).catch(function (error) {
        console.warn('Rental draft restore could not complete:', error);
        return false;
      });
    }

    function markRentalDraftUserInteraction(event) {
      if (rentalDraftReady || !event || !event.isTrusted) return;
      var target = event.target;
      var isRealChange = event.type === 'change' || event.type === 'input';
      var isCalendarSelection = event.type === 'click' && target && !!target.closest(
        '.rental-mobile-calendar-day, #RentalCalendarResetSelection'
      );
      if (isRealChange || isCalendarSelection) {
        rentalDraftUserInteractedBeforeReady = true;
      }
    }

    if (rentalForm && !rentalEditRequestedGroupId) {
      rentalForm.addEventListener('change', markRentalDraftUserInteraction, true);
      rentalForm.addEventListener('input', markRentalDraftUserInteraction, true);
      rentalForm.addEventListener('click', markRentalDraftUserInteraction, true);
      rentalForm.addEventListener('change', scheduleRentalDraftSave);
      rentalForm.addEventListener('input', scheduleRentalDraftSave);
      // The calendar Reset control updates hidden fields without dispatching
      // a change event. This also covers month/date clicks consistently.
      rentalForm.addEventListener('click', function (event) {
        if (event.target && event.target.closest('.rental-range-calendar')) {
          scheduleRentalDraftSave();
        }
      });
      window.addEventListener('pagehide', function () {
        if (rentalDraftWriteTimer) window.clearTimeout(rentalDraftWriteTimer);
        rentalDraftWriteTimer = null;
        if (rentalDraftReady) {
          saveRentalDraftNow();
        } else if (rentalDraftUserInteractedBeforeReady && !rentalDraftCommittedToCart) {
          // Customer navigated away while live checks were still running.
          // Save their actual choice instead of replacing it with the older draft.
          try {
            window.sessionStorage.setItem(rentalDraftStorageKey, JSON.stringify(captureRentalDraft()));
          } catch (error) {
            // Storage availability is optional; never block navigation.
          }
        }
      });
    }

    function initialiseRentalDraftAfterLiveValidation() {
      if (!rentalDraftRestorePending || rentalEditRequestedGroupId || rentalEditModeActive) return;
      rentalDraftRestorePending = false;
      var draft = readRentalDraft();
      Promise.resolve(draft ? restoreRentalDraft(draft) : false).then(function (restored) {
        rentalDraftReady = true;
        if (restored || rentalDraftUserInteractedBeforeReady) saveRentalDraftNow();
      }).catch(function (error) {
        console.warn('Rental draft initialisation failed:', error);
        rentalDraftReady = true;
      });
    }

    rebuildDeliveryOptions();

    window.setInterval(function () {
      if (startDateInput) {
        refreshPlayTimeDependentUi(true);
      }
    }, 60000);

    var initialSecurityDepositStockCount = hydrateInitialSecurityDepositStockAvailability();

    if (initialSecurityDepositStockCount > 0) {
      
      applySecurityDepositStockStatusToOptions();
      updateProcessorAvailabilityNote();
    }

    updateAppleMouseAddonAvailability();
    updatePencilAddonAvailability();
    updateRentalInfoPanels();
    updateTotal();
    updateRentalEndInfo();
    ensureRentalJotformFooterMask();
    ensureRequiredDocumentsStepLockedOpen();
    initialiseRentalTestControls();

    if (rentalEditRequestedGroupId) {
      // Lock before the cache fast-path paints anything. The saved rental can
      // appear immediately, but nothing is user-editable until every async
      // validation and dependent-field rebuild has completed.
      setRentalEditHydrationLocked(true);
      setLoadingState(true);
    }

    var editFastPathLoaded = initialiseRentalEditFastPath();

    if (rentalEditRequestedGroupId) {
      initialiseRentalEditMode()
        .catch(function () { return false; })
        .then(function (editLoaded) {
          if (!editLoaded || !rentalEditModeActive) return false;

          // Await all live price, stock, lead-day and PlayTime checks before
          // unlocking any Edit Rental field.
          return runRentalInitialValidationLoads(false)
            .then(function () {
              finishRentalEditHydration();
              return true;
            });
        })
        .then(function () {
          return initialiseActiveRentalCartDocumentReuse(rentalEditLoadedCart);
        })
        .catch(function (error) {
          console.error('Rental edit hydration error:', error);
          setRentalEditHydrationLocked(false);
          setLoadingState(false);
          return false;
        });
    } else {
      runRentalInitialValidationLoads(false)
        .then(initialiseRentalDraftAfterLiveValidation)
        .catch(function (error) {
          console.warn('Rental draft live availability check failed:', error);
          initialiseRentalDraftAfterLiveValidation();
        });
      initialiseActiveRentalCartDocumentReuse();
    }
  })();
